export const it = {
    "name": "Italian",
    "flagCode": "it",
    "locale": "it-IT",
    "project": {
        "name": "QUp New CC "
    },
    "MigrationBanner": {
        "title": "Next-Generation Command Center",
        "subtitle": "Esplora la nuova dashboard e completa la migrazione entro il %{deadline}.",
        "tryNow": "Prova ora",
        "dismiss": "Chiudi"
    },

    "Sidebar": {
        "Product_Discovery": "Scoperta del Prodotto",
        "Setting": "Impostazioni",
        "Map": "Mappa",
        "Cue": "Elenco Manuale",
        "Invoice": "Fattura",
        "Supplier": "Fornitore",
        "Vehicle": "Veicolo",
        "Merchant": "Commerciante",
        "ImportBookings": "Importa Prenotazioni di Trasporto",
        "ImportDeliveryBookings": "Prenotazioni di Consegna Import",
        "Trip": "Viaggio",
        "New_booking": "Nuova Prenotazione",
        "City": "Città",
        "Chauffeur": "Trasporto",
        "Delivery": "Consegna",
        "Shuttle": "Navetta",
        "Intercity": "Intercity",
        "Customer": "Clienti",
        "Driver": "Autisti",
        "REPORTS": "Rapporti",
        "Corporate": "Aziendale",
        "mDispatcher": "mDispatcher",
        "Reservation": "Calendario",
        "withdrawalRequest": "Richieste di prelievo",
        "Driver_Settlement": "Pagamenti autista",
        "Dashboard": "Analisi",
        "SmartData": "Dati intelligenti",
        "Smart_Data": "Dati intelligenti",
        "Campaign_Builder": "Costruttore di campagne",
        "Company_operator": "Operatore aziendale",
        "Queuing_area": "Area di attesa",
        "Withdrawal_Requests": "Richieste di prelievo",
        "pickUp": "Pick up",
        "dropOff": "Consegna",
        "SignUpNotifications": "Notifiche di Iscrizione",
        "Payout": "Pagamento",
        "Payout_label": "Pagamento",
        "Invoice_Setting": "Fattura",
        "payout": {
            "payoutDriver": "Pagamento del conducente",
            "payoutMerchant": "Pagamento al commerciante",
            "payoutSupplier": "Pagamento Fornitore",
            "Pay_To_Driver": "Paga ai conducenti",
            "payoutDriverHistory": "Storico dei pagamenti del conducente",
            "Pay_To_Merchant": "Paga ai Commercianti",
            "Payout_History_For_Merchant": "Storico Pagamenti Merchant",
            "Pay_To_Supplier": "Pagamento ai Fornitori",
            "payoutSupplierHistory": "Storico dei pagamenti ai fornitori",
            "Driver_Payout": "Pagamento del conducente",
            "Supplier_Payout": "Pagamento Fornitore",
            "Merchant_Payout": "Pagamento al commerciante"
        },
        "number_of_records_to_export": "Numero di record da esportare",
        "export": "Esporta",
        "Airline": "Compagnia aerea",
        "driverPayout": {
            "Pay_to_driver": "Paga ai conducenti",
            "Payout_history": "Storico dei pagamenti"
        },
        "Reports": {
            "Driver_Referral_history": "Il conducente riferisce il cliente",
            "Driver_refers_Pax": "Driver",
            "Refund": "Rimborso",
            "Driver_refers_Pax_Customers": "Clienti",
            "Driver_refers_Pax_Bookings": "Prenotazioni",
            "Driver_refers_customer_Drivers": "Il conducente si riferisce al cliente (Conducenti)",
            "Driver_refers_customer_Customers": "Il conducente si riferisce al cliente (Clienti)",
            "Driver_refers_customer_Bookings": "Il conducente si riferisce al cliente (Prenotazioni)",
            "Passenger_refers_Passengers": "Il cliente si riferisce al cliente",
            "Driver_refers_drivers_Referrer": "Il conducente si riferisce ai conducenti (Riferente)",
            "Deletion_request": "Richiesta di eliminazione",
            "Driver_refers_drivers_Referee": "Driver si riferisce ai conducenti (Arbitro)",
            "Supplier_Wallet": "Portafoglio Fornitore",
            "Driver_refers_Driver": "Il conducente si riferisce al conducente",
            "Driver_refers_driver_Referrer": "Riferente",
            "Driver_refers_driver_Referee": "Arbitro",
            "Referral_history": "Storia dei riferimenti",
            "Booking_details": "Dettagli prenotazione",
            "Financial": "Finanziario",
            "Financial_driver": "Autisti",
            "Financial_fleet": "Flotta",
            "Financial_company": "Azienda",
            "Financial_Driver": "Finanziario (Autisti)",
            "Financial_Fleet": "Finanziario (Flotta)",
            "Financial_Company": "Finanziario (Azienda)",
            "Financial_fleet_profit": "Profitto della flotta",
            "Financial_Company_Tooltip": "Rapporto sui guadagni netti dei conducenti, raggruppati per società",
            "Financial_Driver_ToolTip": "Rapporto sul guadagno netto di ciascun autista",
            "Financial_Fleet_Profit_ToolTip": "Utile della flotta",
            "Driver_activity": "Attività autista",
            "Revenue_Summary": "Riepilogo dei ricavi",
            "Revenue_fleet": "Flotta",
            "Revenue_driver": "Autisti",
            "Revenue_monthly": "Mensile",
            "Revenue_Summary_Fleet": "Sommario entrate (Flotta)",
            "Revenue_Summary_Driver": "Sommario entrate (Autisti)",
            "Revenue_Summary_Monthly": "Sommario entrate (Mensile)",
            "Total_adjustment": "Totale Adeguamento",
            "Promotion": "Promozione",
            "Incident_Cancellation": "Incidenti & Cancellazioni",
            "Booking_logs": "Registri di prenotazione",
            "Rating": "votazioni",
            "Thumbs_rating": "votazioni",
            "Stars_rating": "Voti dell'autista",
            "Operator_logs": "Registri operatore",
            "Daily": "Giornaliero",
            "Daily_Driver": "Autista giornaliero",
            "Daily_Car": "Vettura giornaliera",
            "Daily_Driver_Car": "Vettura con Autista Giornaliero ",
            "mDispatcher": "mDispatcher",
            "Corporate": "Aziendale",
            "Driver_login_status": "Status registrazione dell'autista",
            "Car_activity": "Attività della vettura",
            "Partner": "Partner",
            "Prepaid_top_up": "Prepagato aziendale",
            "Affiliation": "Affiliazione",
            "Affiliation_penalty_compensation": "Penale/Compensazione",
            "Affiliation_payout_history": "Storia degli insediamenti",
            "Affiliation_bookings": "Prenotazioni",
            "Booking_summary": "Riepilogo prenotazione",
            "Cash_Wallet": "Portafoglio in contante",
            "Credit_Wallet": "Portafoglio di credito",
            "Driver_wallet": "Portafoglio conducente",
            "Driver_Deposit": "Deposito vettura",
            "Driver_cash_wallet": "Portafoglio Cash",
            "Driver_Deposit_old": "Deposito vettura",
            "Document_expiry": "Il documento scade",
            "Settlement": "Accordo",
            "Unapproved_Driver": "autista non approvato",
            "Approved_Driver": "Autista approvato",
            "Pay_to_driver": "Paga all'autista",
            "Settlement_history": "Storico pagamenti",
            "Withdrawal_History": "Ritiro del conducente",
            "creditWalletTooltip": "Il conducente deposita sul portafoglio di credito",
            "Incomplete_payment": "pagamento incompleto",
            "Driver_withdrawal": "Ritiro del conducente",
            "Incident_&_Cancellation": "Incidente e Cancellazione",
            "Passenger_wallet": "Incident & Cancellation",
            "Accept_Cancel_rate": "Acceptance/Cancellation rate",
            "Acceptance/Cancellation_rate": "Acceptance/Cancellation rate",
            "driverDepositTooltip": "Il conducente deposita sul portafoglio di credito",
            "Customer_quest": "Quest",
            "First_will_win": "Il primo vincerà",
            "Largest_will_win": "Il più grande vincerà",
            "redeemed": "Codice #",
            "Code_#": "Codice #",
            "Quests": "Quest",
            "Merchant_Report": "Mercante",
            "Merchant_Financial_Report": "Finanziario",
            "Merchant_Cash_Report": "Portafoglio in contante",
            "Merchant_Credit_Report": "Portafoglio crediti",
            "Deletion_Request": "Richiesta di cancellazione",
            "Driver_Rating": "Il cliente valuta il conducente",
            "Passenger_Rating": "Il conducente valuta il cliente",
            "Company_settlement": "Accordo aziendale",
            "Export": "Storico esportazioni",
            "Third_Party_Booking": "Prenotazione di terze parti",
            "BookingDotCom": "Booking.com",
            "Third_Party_Booking_Bookingcom": "Prenotazione di Terze Parti (Booking.com)",
            "Third_Party_Booking_HolidayTaxis": "Prenotazione di Terze Parti (HolidayTaxis)",
            "Third_Party_Booking_Karhoo": "Prenotazione di Terze Parti (Karhoo)",
            "Third_Party_Booking_Hoppa": "Prenotazione di Terze Parti (Hoppa)",
            "Third_Party_Booking_Klook": "Prenotazione di Terze Parti (Klook)",
            "Third_Party_Booking_TransferZ": "Prenotazione di Terze Parti (TransferZ)",
            "supplierWallet": "Portafoglio Fornitore"
        },
        "Settings": {
            "Block_Passenger": "Blocca Passeggero",
            "Fleet_info": "Informazioni flotta",
            "Product_Discovery": "Scoperta del Prodotto",
            "Surchage_Policy": "Politica di sovrapprezzo",
            "RateLegacy": "Tariffa (Legacy)",
            "Driver": "Driver",
            "Merchant": "Commerciante",
            "Calendar": "Calendario",
            "Socaial": "Socaial",
            "Quest": "Quest",
            "Referral": "Riferimento",
            "Addon_Template": "Add-On Template",
            "Social": "Sociale",
            "Shift": "Shift",
            "Rate_Templates": "Modelli di Tariffa",
            "Supplier_Plan": "Piano Fornitore",
            "Vehicle_Lead_Time": "Tempo di consegna del veicolo",
            "Penalty_Policy": "Politica delle Penali",
            "Stripe_connect": "Stripe Connect",
            "stripe_title_connect": "Attiva il tuo account Stripe Connect per ricevere automaticamente il tuo pagamento.",
            "Payment_info": "Informazioni di fatturazione",
            "Permission": "Permesso",
            "Driver_refer_driver": "Driver riferisce driver",
            "Show_referal_history": "Mostra/nascondi la cronologia dei referral nell'app per conducenti",
            "companyTooltip": "Azienda fornitrice",
            "User": "Utilizzatore",
            "General": "Generale",
            "Regular": "Regolare",
            "Sharing": "Condivisione Stradale",
            "Flat": "Fissa",
            "Hourly": "Orario - Giornaliero",
            "Company": "Azienda",
            "Dispatch": "Assegnazione",
            "Voice_SMS": "Voce e SMS",
            "Rate": "Tariffa",
            "RateNew": "Tariffa",
            "Car": "Auto",
            "Car_type": "Tipo di macchina",
            "Car_mgmt": "Macchina mgmt",
            "Car_Make": "Costruttore e modello",
            "Meeting_Zone": "Zona Incontri",
            "Restricted_Zone": "Zona Riservata",
            "Stripe_Connect": "Stripe Connect",
            "Voice_&_SMS": "Voce e SMS",
            "Street-sharing_rate": "Tariffa di condivisione stradale",
            "Partner_type": "Tipo mDispatcher",
            "Shift_template": "Modello turno",
            "Billing_Usage": "Utilizzo di fatturazione",
            "Driver_App": "App per conducenti",
            "Shift_settings": "Impostazioni turno",
            "Operation": "Operazione",
            "Driver_Note": "Nota del conducente",
            "Promotion_code": "Codice Promozionale",
            "Point_config": "Configurazione punto",
            "Code_#": "Codice #",
            "Voucher_code": "Codice #",
            "Campaign": "Campagna",
            "Queuing_area": "Seleziona citta’",
            "Referral_code": "Il tuo codice di riferimento",
            "City": "Città",
            "category": "Categoria",
            "3rd_party_location": "Luogo di terzi",
            "Zone": "Zona",
            "App_banner": "Banner dell'app",
            "App_banner_pegasus": "App banner",
            "Flight_integration": "Integrazione volo",
            "SMS_integration": "Integrazione SMS",
            "Invoice_Setting": "Invoice",
            "Payout_Setting": "Modello di Pagamento",
            "AI_Atlas": "Atlas AI Chatbot",
            "Driver_refers_customer": "Il conducente si riferisce al cliente",
            "Pax_refers_Pax": "Il cliente riferisce il cliente",
            "Customer_refers_customer": "Il cliente riferisce un cliente",
            "Dynamic_Surcharge": "Sovrapprezzo dinamico",
            "Dynamic_Fare": "Tariffa Dinamica",
            "FlatZone": "Tariffa fissa",
            "IntercityZone": "Intercity",
            "Intercity_Zone": "Zona Intercity",
            "Intercity_Rate": "Tariffa Intercity",
            "Car_Color": "Colore dell'auto",
            "third_party_integration": "integrazione di terze parti",
            "bookingCom": "Booking.com",
            "HolidayTaxis": "HolidayTaxis",
            "Karhoo": "Karhoo",
            "Corporate": "Corporate",
            "KarhooIntegration": "Integrazione Karhoo",
            "holidaytaxis": "HolidayTaxis",
            "karhoo": "Karhoo",
            "hoppa": "Hoppa",
            "Hoppa": "Hoppa",
            "HoppaIntegration": "Integrazione Hoppa",
            "Third_Party_Integration_Hoppa": "Integrazione di terze parti (Hoppa.com)",
            "titleHoppa": "Credenziali API Hoppa",
            "noteHoppa": "Comunica con il team tecnico di Hoppa per fornirti il client e la chiave segreta per connetterti al loro sistema.",
            "titleHoppaWebhook": "Configurazione del Webhook",
            "noteHoppaWebhook": "Fornisci i parametri qui sotto per Hoppa da configurare. Queste credenziali vengono utilizzate per comunicare tra entrambe le piattaforme. Per eventuali problemi contatta il tuo fornitore tecnico.",
            "klook": "Klook",
            "Klook": "Klook",
            "KlookIntegration": "Integrazione Klook",
            "Third_Party_Integration_Klook": "Integrazione di terze parti (Klook.com)",
            "titleKlook": "Credenziali API Klook",
            "noteKlook": "Comunica con il team tecnico di Klook per fornirti il client e la chiave segreta per connetterti al loro sistema.",
            "titleKlookWebhook": "Configurazione del Webhook",
            "noteKlookWebhook": "Fornisci i parametri qui sotto per Klook da configurare. Queste credenziali vengono utilizzate per comunicare tra entrambe le piattaforme. Per eventuali problemi, contatta il tuo fornitore tecnico.",
            "transferZ": "TransferZ",
            "TransferZ": "TransferZ",
            "TransferZIntegration": "Integrazione TransferZ",
            "Third_Party_Integration_TransferZ": "Integrazione di terze parti (TransferZ.com)",
            "titleTransferZ": "Credenziali API TransferZ",
            "noteTransferZ": "Comunica con il team tecnico di TransferZ per fornirti il client e la chiave segreta per connetterti al loro sistema.",
            "titleTransferZWebhook": "Configurazione del Webhook",
            "noteTransferZWebhook": "Fornisci i parametri qui sotto per TransferZ da configurare. Queste credenziali vengono utilizzate per comunicare tra entrambe le piattaforme. Per eventuali problemi, contatta il tuo fornitore tecnico.",
            "Third_Party_Integration_Booking": "Integrazione di terze parti (Booking.com)",
            "Third_Party_Integration_HolidayTaxis": "Integrazione di terze parti (HolidayTaxis)",
            "Third_Party_Integration_Karhoo": "Integrazione di terze parti (Karhoo.com)",
            "Third_Party_Integration_Mozio": "Integrazione di terze parti (Mozio.com)",
            "invoiceBranding": "Branding della Fattura",
            "invoiceLogo": "Logo della Fattura",
            "invoiceColor": "Colore della fattura",
            "payoutBranding": "Branding del Pagamento",
            "titleInvoice": "Personalizza le informazioni dell'intestazione e del piè di pagina della tua azienda.",
            "titlePayout": "Personalizza le informazioni dell'intestazione e del piè di pagina della tua azienda.",
            "titleheader": "Titolo Intestazione",
            "descriptionHeader": "Descrizione Intestazione",
            "placehodelHeader": "Ad esempio, aggiungi i dettagli dell'azienda come email, numero di telefono, indirizzo, numero di partita IVA, ecc.",
            "titleFooter": "Titolo del piè di pagina",
            "placehodelFooter": "Ad esempio, aggiungi informazioni sul bonifico bancario, o qualsiasi politica ecc.",
            "descriptionFooter": "Descrizione del piè di pagina",
            "defaultEmailMessage": "Messaggio Email Predefinito",
            "placeholderEmailMessage": "L'importo sarà trasferito sul tuo conto utilizzando il tuo metodo di pagamento preferito. Non esitare a contattarci a <email> se hai domande.\n\nGrazie per i servizi forniti. Non vediamo l'ora di una ulteriore collaborazione di successo.\n\nCordiali saluti,  \nTeam Good Journey\n\nSe non viene ricevuta alcuna obiezione entro sette giorni, la fattura auto-emessa è considerata approvata.",
            "titleBookingCom": "Credenziali API di Booking.com",
            "noteBookingCom": "Comunica con il team tecnico di booking.com per fornirti il client e la chiave segreta per connetterti al loro sistema.",
            "clientKey": "Chiave del Cliente",
            "placeHolderClientKey": "Inserisci la chiave del cliente",
            "secretKey": "Chiave Segreta",
            "placeHolderSecretKey": "Inserisci il segreto del cliente",
            "titleBookingComWebhook": "Configurazione del Webhook",
            "noteBookingComWebhook": "Fornisci i parametri qui sotto per booking.com da configurare. Queste credenziali vengono utilizzate per comunicare tra entrambe le piattaforme. Per eventuali problemi, contatta il tuo fornitore tecnico.",
            "webhook": "URL del Webhook della Flotta",
            "clientId": "Chiave Client Flotta",
            "clientSecret": "Chiave Segreta della Flotta",
            "driver_app": "App per conducenti",
            "Jobs_tab": "Tab Lavori",
            "Email_config": "Configurazione email",
            "Driver_fields": "Campi del driver",
            "Driver_document": "Documento del driver",
            "Selected": "Selezionato",
            "API_Management": "Gestione delle API",
            "Penalty_Policy_Customer": "Politica di Penalità per i Clienti",
            "Penalty_Policy_Supplier": "Politica delle Penali per i Fornitori",
            "Stop_Sales": "Fermare le vendite",
            "RestrictedZone": "Zona Riservata",
            "MeetingZone": "Zona Incontri",
            "block_passenger": "Blocca Passeggero",
            "Billing_usage": "Utilizzo di fatturazione"
        }
    },
    "welcome": {
        "next": "Next",
        "getStarted": "Get Started",
        "step1": {
            "title": "Product Discovery",
            "description": "Welcome to Good Journey! Access all the products included in your plan, such as the <span class=\"highlight-white\">Driver App, Customer Web Booker</span> and more.",
            "button": "Learn more"
        },
        "step2": {
            "title": "Introducing Fleet Wallet",
            "description": "Once you reach your free allowance, any additional overage will check your fleet wallet to deduct per additional request.",
            "moreInfo": "💡 Maintain a positive balance, check usage and transaction reports here."
        },
        "step3": {
            "title": "Never Miss a Beat",
            "description": "You can setup <span class=\"highlight-white\">Automated Top-up</span> to ensure no service disruption on top of usage.",
            "description2": "This ensures your drivers stay on the road and your data keeps flowing, no matter how busy things get."
        },
        "step4": {
            "title": "Getting Started",
            "description": "We’re thrilled to have you onboard! Check out our <span class=\"highlight-white\">Guides & Tutorials</span> section to master the platform and get the most out of your fleet management tools."
        }
    },
    "productDiscovery": {
        "title": "Scoperta del Prodotto",
        "fleetCode": "Codice Flotta",
        "fleetCodeDescription": "È richiesto agli autisti che utilizzano l'app globale per autisti di inserire questo codice prima di accedere.",
        "description": "Esplora e attiva gli strumenti che alimentano la tua flotta. Accedi all'App per i conducenti, all'App per i clienti, al Portale di prenotazione web e alle App Partner Booker — tutte progettate per semplificare le operazioni, connettersi con i passeggeri e far crescere la tua attività.",
        "web": "Web",
        "ios": "iOS",
        "android": "Android",
        "guide": "Guide",
        "gallery": "Galleria",
        "downloadLinks": "Link per il download",
        "customize": "Impostazioni",
        "base": "Base di conoscenza",
        "base_description": "La tua guida tutto-in-uno per la piattaforma. Esplora tutorial passo-passo, FAQ e migliori pratiche per padroneggiare prenotazioni, spedizioni, pagamenti e altro ancora.",
        "base_allowed": {
            "platform_guides": "Guide della piattaforma",
            "step_by_step_tutorials": "Tutorial passo-passo",
            "faqs_troubleshooting": "FAQ e Risoluzione dei Problemi",
            "best_practices": "Best Practices",
            "product_releases_updates": "Rilascio e Aggiornamenti del Prodotto"
        },
        "driver_app": "App per conducenti",
        "driver_app_description": "Fornisci ai tuoi autisti un'app per gestire i lavori, completare le corse e aggiornare le prenotazioni senza sforzo.",
        "driver_app_allowed": {
            "booking_notifications": "Notifiche di Prenotazione",
            "trip_management": "Gestione dei Viaggi",
            "navigate_realtime_tracking": "Navigazione e Tracciamento in Tempo Reale",
            "inapp_communication_support": "Comunicazione e Supporto In-App",
            "track_driver_earnings": "Monitora i guadagni del conducente",
            "driver_signup_link": "Link di registrazione per i conducenti"
        },
        "passenger_app": "App Passeggero",
        "passenger_app_description": "Prenota e gestisci i viaggi con facilità. L'App Passeggero offre un'esperienza premium per i viaggiatori — dalla prenotazione istantanea agli aggiornamenti in tempo reale — garantendo comfort, affidabilità e controllo in ogni fase.",
        "passenger_app_allowed": {
            "seamless_ride_booking": "Prenotazione di Viaggi Senza Soluzioni di Continuità",
            "realtime_tracking_notifications": "Tracciamento in Tempo Reale & Notifiche",
            "inapp_communication": "Comunicazione in-app",
            "flexible_payment_receipts": "Pagamenti e Ricevute Flessibili",
            "ride_history_favorites": "Storico corse e Preferiti"
        },
        "web_driver_app": "App Web per Driver",
        "web_driver_app_description": "Dai ai subappaltatori e ai conducenti partner un modo semplice per accettare e gestire i lavori senza installare un'app. L'App Web per Conducenti funziona direttamente nel browser — perfetta per conducenti occasionali o partner che utilizzano i propri sistemi, con notifiche inviate via email, SMS o avvisi web.",
        "web_driver_app_allowed": {
            "job_access_via_web_link": "Accesso al lavoro tramite link web",
            "trip_management": "Gestione dei Viaggi",
            "notifications_email_sms_web": "Notifiche tramite Email/SMS/Web",
            "navigation_status_updates": "Navigazione e Aggiornamenti di Stato",
            "simple_lightweight": "Simple e Leggero",
            "signup_link": "Link di registrazione per conducenti"
        },
        "web_passenger_app": "App di Prenotazione Web",
        "web_passenger_app_description": "Consenti ai tuoi clienti e partner di prenotare corse direttamente dal tuo sito web. L'app Web Booking è progettata per trasferimenti aeroportuali, servizi di autista e prenotazioni on-demand, offrendo a OTAs, hotel e agenti di viaggio un modo semplice per connettere i viaggiatori con la tua flotta.",
        "web_passenger_app_allowed": {
            "embed_anywhere": "Incorpora Ovunque",
            "create_ride_bookings": "Crea Prenotazioni di Viaggio",
            "seamless_web_experience": "Esperienza Web Senza Soluzioni di Continuità",
            "partner_ready": "Pronto per i partner",
            "customer_friendly_checkout": "Checkout Amichevole per il Cliente"
        },
        "concierge_booker": "Concierge Booker",
        "concierge_booker_description": "Una semplice app web per partner e personale — dai concierge degli hotel e valet ai baristi e ospiti dei ristoranti — per creare corse per i loro ospiti in pochi clic. Ogni utente ha il proprio accesso, può prenotare per conto dei viaggiatori e monitorare le commissioni guadagnate.",
        "concierge_booker_allowed": {
            "quick_guest_booking": "Prenotazioni Veloci per Ospiti",
            "individual_user_login": "Accessi Utente Individuali",
            "commission_tracking": "Tracciamento Commissioni",
            "easy_web_access": "Accesso Web Facile",
            "partner_friendly_setup": "Impostazione Amichevole per i Partner"
        },
        "gojo_api": "Good Journey API",
        "gojo_api_description": "Costruisci con fiducia. Accedi al nostro portale per sviluppatori per esplorare le referenze API, le guide all'integrazione e i flussi di lavoro di esempio per prenotazioni, spedizioni, pagamenti e altro ancora.",
        "gojo_api_allowed": {
            "comprehensive_api_reference": "Riferimenti API Completi",
            "integration_guides": "Guide all'integrazione",
            "sandbox_testing_tools": "Strumenti di Sandbox e Testing"
        },
        "gojo_canvas": "Good Journey Canvas",
        "gojo_canvas_description": "Progetta e personalizza la tua esperienza con la super-app. Good Journey Canvas ti offre il pieno controllo creativo per gestire menu, moduli di consegna, promozioni e layout della schermata principale — tutto da un'unica interfaccia semplice.",
        "gojo_canvas_allowed": {
            "menu_management": "Gestione Menu",
            "custom_delivery_forms": "Moduli di Consegna Personalizzati",
            "super_app_home_builder": "Super-App Costruttore di Case",
            "promotion_advertising": "Promozioni e Pubblicità",
            "flexible_content_management": "Gestione dei Contenuti Flessibile"
        },
        "gojo_chatbot": "Buon Viaggio AI Chat Bot",
        "gojo_chatbot_description": "Prenota corse con una semplice conversazione. L'assistente chat alimentato dall'IA aiuta clienti, partner o personale a creare prenotazioni istantaneamente — digitando richieste, parlando in modo naturale o persino caricando itinerari.",
        "gojo_chatbot_allowed": {
            "conversational_booking": "Prenotazione Conversazionale",
            "file_itinerary_uploads": "Caricamento File & Itinerario",
            "multi_channel_access": "Accesso Multi-Canale",
            "smart_suggestions": " suggerimenti intelligenti",
            "operator_assistance": "Assistenza all'Operatore"
        },
        "concierge_booker_web_setting": "Impostazioni - Concierge Booker",
        "pax_app_setting": "Impostazioni - App Passeggero",
        "driver_app_setting": "Impostazioni - App Globale per Driver",
        "pax_web_setting": "Impostazioni - App di Prenotazione Web",
        "driver_web_setting": "Impostazioni - App Web Driver",
        "save": "Salva",
        "cancel": "Annulla",
        "themes": "Temi",
        "links": "Collegamenti",
        "ios_driver_app": "App Driver iOS",
        "android_driver_app": "App del Driver Android",
        "gallery_driver_app": "App del Driver della Galleria",
        "ios_pax_app": "App Passeggero iOS",
        "android_pax_app": "App Passeggero Android",
        "gallery_pax_app": "App Passeggero Gallery",
        "light_mode": "Modalità Chiara",
        "dark_mode": "Modalità Scura",
        "primary_color": "Colore Primario",
        "secondary_color": "Colore Secondario",
        "longName": "PWA Nome Esteso",
        "shortName": "Nome breve PWA",
        "adsTracking": "Tracciamento Annunci",
        "googleId": "ID Tag di Google",
        "metaId": "ID Pixel Meta",
        "customUrl": "Link per la prenotazione",
        "partnerLink": "Link Web Partner",
        "webBookingSettings": "Impostazioni di Prenotazione Web",
        "enableBookNow": "Prenotazioni Ora",
        "enableBookLater": "Prenotazioni successive",
        "enableGuestCheckout": "Checkout Ospite",
        "icon192": "Icona App PWA (192x192)",
        "icon512": "Icona App PWA (512x512)",
        "icon192Driver": "Icona App PWA (192x192)",
        "icon512Driver": "Icona App PWA (512x512)",
        "pax_app": "App passeggeri",
        "default": "Predefinito",
        "customized": "Personalizzato",
        "html": "HTML",
        "quoteSettings": "Quote Settings",
        "about": "Informazioni",
        "email": "Supporto email",
        "enablePhone": "Numero di telefono",
        "phone": "",
        "policy": "Collegamento all'Informativa sulla Privacy",
        "termOfUse": "Termini di utilizzo del link",
        "site": "Sito web",
        "logoDriverIOS": "Logo - IOS",
        "logoDriverAndroid": "Logo - Android",
        "htmlUrl": "file HTML",
        "Update_fail": "Si sono verificati errori",
        "Update_success": "Le impostazioni sono state aggiornate con successo",
        "driverSignUp": "Link di registrazione per conducenti",
        "customUrlDriver": "Link dell'app Web per i conducenti"
    },
    "APIKeySetting": {
        "APIKey": "Chiavi API",
        "APIKey_title": "Non condividere la tua chiave API con altri, né esporla nel browser o in altro codice lato client. Per proteggere la sicurezza del tuo account, Good Journey potrebbe anche disabilitare automaticamente qualsiasi chiave API che abbiamo scoperto essere stata esposta pubblicamente.",
        "newKeyBtn": "Crea nuova chiave",
        "updateApplication": "Aggiorna Applicazione",
        "RegisterApp": "Registrare una nuova applicazione",
        "RegisterBtn": "Registrare l'Applicazione",
        "appDescription": "Descrizione dell'app",
        "webhookUrl": "Webhook Endpoint",
        "appName": "Nome dell'App",
        "clientKey": "Chiave del Cliente",
        "secretKey": "Chiave Segreta",
        "hostedEndPoint": "Endpoint ospitati",
        "maxEndpoints": "Puoi avere un massimo di 5 endpoint",
        "addEndpoint": "Aggiungi Endpoint",
        "updateEndpoint": "Aggiorna Endpoint",
        "ManageWebhooks": "Gestisci Webhook",
        "CreateWebhook": "Crea webhook",
        "subscriptionID": "ID abbonamento",
        "webhookURL": "URL del Webhook",
        "signingSecret": "Segreto di firma",
        "eventsToSend": "Eventi da inviare",
        "listeningFor": "Ascoltando per",
        "assignedDriver": "Autista assegnato",
        "bookingStatus": "Stato della prenotazione",
        "driverLocation": "Posizione del conducente",
        "titleSigningSecret": "Questo segreto è fornito dal tuo partner. Se per qualsiasi motivo il segreto è stato compromesso, puoi aggiornare il segreto o eliminare il web hook.",
        "notUsingHTTPS": "L'URL del webhook non utilizza HTTPS.",
        "invalidURL": "L'URL del webhook non è valido.",
        "clientType": "Tipo di Cliente",
        "individual": "Individuale",
        "corporate": "Corporate",
        "signingSecretLength": "La chiave di firma deve essere lunga almeno 30 caratteri.",
        "bookingCreated": "Prenotazione Creata",
        "partner": "Partner",
        "fleetManager": "Responsabile della flotta",
        "apiProvider": "Fornitore API",
        "selectAPITitle": "Seleziona l'API che desideri integrare",
        "isAutoAccept": "Accettazione automatica della prenotazione",
        "isAutoAcceptPA": "Accettazione automatica della modifica in sospeso",
        "assignedVehicle": "Veicolo Assegnato"
    },
    "messages": {
        "credits": {
            "406": "Azione fallita",
            "407": "Azione fallita",
            "416": "Il coupon è stato utilizzato",
            "417": "Il tuo account non é attivo. Contatta la nostra amministrazione",
            "418": "Ci sono stati errori durante il pagamento",
            "419": "Il codice promozionale non è valido!",
            "420": "Questo codice promozionale è stato utilizzato per un'altra corsa. Si prega di usarne un altro.",
            "421": "Numero carta invalido",
            "422": "Data di scadenza invalida.",
            "429": "Cap invalido.",
            "430": "Il codice postale AVS non combacia",
            "431": "Codice postale AVS non verificato",
            "432": "CVV invalido.",
            "433": "CVV non combacia",
            "434": "CVV non verificato",
            "435": "L’emittente CVV non partecipa",
            "436": "La tua carta é stata rifiutata",
            "437": "Insufficient funds. Please check your balance!",
            "439": "CVV non trattato",
            "441": "Nessun dato CVV dall’emittente",
            "443": "Nessun dato dall’emittente/banknet switch",
            "445": "Sistema AVS incapace di processare",
            "446": "La banca emittente non supporta AVS",
            "447": "Errore, AVS non supportato per la tua attività",
            "448": "Questa carta é stata bloccata in seguito a numerosi tentativi di pagamento infruttuosi. Per favore cambia mezzo di pagamento o riprova piu’ tardi",
            "452": "La tua carta é stata rifiutata. Per favore inserisci un’altra carta di credito registrata nella stessa zona del tuo numero di telefono [numero#]",
            "453": "Questo payment.gateway non è supportato",
            "454": "L’indirizzo AVS non combacia",
            "455": "Codice postale e indirizzo AVS non combaciano",
            "458": "Autentica fallita",
            "459": "Le carte bancarie non supportano",
            "461": "Questa scheda non è supportata",
            "462": "Nome del titolare della carta non valido",
            "463": "Il codice di verifica non è valido",
            "464": "La Banca non supporta la generazione e l'invio del codice di verifica.",
            "470": "Si prega di inserire l'indirizzo email del viaggiatore prima di creare una prenotazione con carta di credito.",
            "474": "Si prega di inserire il nome del viaggiatore prima di creare una prenotazione con carta di credito.",
            "475": "Il numero di telefono è obbligatorio",
            "476": "L'importo non è valido",
            "524": "Fondi insufficienti. L'account non aveva fondi sufficienti per coprire l'importo della transazione.",
            "911": "Non siamo in grado di autenticare il tuo metodo di pagamento. Si prega di scegliere un metodo di pagamento diverso e riprovare.",
            "2000": "Non procedere al pagamento",
            "2001": "Fondi insufficienti. L'account non aveva fondi sufficienti per coprire l'importo della transazione.",
            "2002": "Limite superato",
            "2003": "Limite di Attività del Titolare della Carta Superato",
            "2004": "Carta scaduta",
            "2005": "Numero di Carta di Credito Non Valido",
            "2006": "Data di scadenza non valida",
            "2007": "Nessun Account",
            "2008": "Errore nella lunghezza dell'account della carta",
            "2009": "Nessun Emittente",
            "2010": "Emittente della carta ha rifiutato il CVV",
            "2011": "Autorizzazione vocale richiesta. La banca del titolare della carta richiede che il commerciante chiami per ottenere un codice di autorizzazione speciale al fine di completare questa transazione.",
            "2012": "Processore Rifiutato - Possibile Carta Persa",
            "2013": "Processore rifiutato - Possibile carta rubata",
            "2014": "Processore Rifiutato - Frode Sospettata",
            "2015": "Transazione Non Consentita",
            "2016": "Transazione Duplicata",
            "2017": "Fatturazione del titolare della carta interrotta",
            "2018": "Titolare della carta ha bloccato tutte le fatturazioni",
            "2019": "Transazione non valida",
            "2020": "Violazione",
            "2021": "Violazione della Sicurezza",
            "2022": "Rifiutato - Carta aggiornata disponibile",
            "2023": "Il processore non supporta questa funzionalità",
            "2024": "Tipo di carta non abilitato",
            "2025": "Errore di Configurazione - Commerciante",
            "2026": "ID commerciante non valido",
            "2027": "Errore di Configurazione - Importo",
            "2028": "Errore di configurazione - Gerarchia",
            "2029": "Errore di configurazione - Carta",
            "2030": "Errore di Configurazione - Terminale",
            "2031": "Errore di crittografia",
            "2032": "Supplemento Non Consentito",
            "2033": "Dati incoerenti",
            "2034": "Nessuna azione intrapresa",
            "2035": "Approvazione Parziale Per Importo Nella Versione Gruppo III",
            "2036": "L'autorizzazione non è stata trovata per effettuare il reverso",
            "2037": "Già invertito",
            "2038": "Processore rifiutato. La banca del cliente non è disposta ad accettare la transazione, è necessario contattare la propria banca per ulteriori dettagli.",
            "2039": "Codice di autorizzazione non valido",
            "2040": "Negozio non valido",
            "2041": "Rifiutato - Richiesta di Approvazione",
            "2042": "ID Clienti non valido",
            "2043": "Errore - Non riprovare, contattare l'emittente",
            "2044": "Rifiutato - Chiama l'emittente",
            "2045": "Numero del commerciante non valido",
            "2046": "Rifiutato. La banca del cliente non è disposta ad accettare la transazione, è necessario contattare la propria banca per ulteriori dettagli.",
            "2047": "Chiama l'emittente. Ritira la carta. Questo errore indica che la carta è stata segnalata come persa o rubata dal titolare della carta.",
            "2048": "Importo non valido",
            "2049": "Numero SKU non valido",
            "2050": "Piano di credito non valido",
            "2051": "Il numero della carta di credito non corrisponde al metodo di pagamento",
            "2052": "Acquisto di Livello III Non Valido",
            "2053": "Carta segnalata come persa o rubata",
            "2054": "L'importo della revoca non corrisponde all'importo dell'autorizzazione",
            "2055": "Numero di Divisione Transazione Non Valido",
            "2056": "L'importo della transazione supera il limite di divisione della transazione",
            "2057": "L'emittente o il titolare della carta ha imposto una restrizione sulla carta",
            "2058": "Commerciante non abilitato a MasterCard SecureCode.",
            "2060": "Verifica dell'indirizzo e codice di sicurezza della carta non riusciti",
            "2061": "Dati di transazione non validi",
            "2062": "Importo fiscale non valido",
            "2064": "Codice valuta non valido",
            "2078": "Dati di pagamento sicuri non validi",
            "2080": "Credenziali utente non valide",
            "3000": "Rete del processore non disponibile - Riprova",
            "4001": "Transazione Rifiutata",
            "4006": "L'importo di cattura ha superato il limite consentito",
            "81703": "La carta di credito non viene accettata da questo conto commerciale",
            "81706": "CVV richiesto",
            "81707": "CVV deve essere di 3 o 4 cifre",
            "81709": "Data di scadenza richiesta.",
            "81710": "Data di scadenza invalida.",
            "81714": "E’ richiesto il numero della carta di credito.",
            "81715": "Numero della carta di credito invalido.",
            "81716": "Il numero della carta di credito deve essere di 12-19 cifre",
            "81717": "Il numero di carta di credito non é accettato come numero di test",
            "81718": "Il numero di carta di credito non puo’ essere aggiornato su carta non supportata quando é associato ad abbonamenti.",
            "81723": "Nome del titolare della carta troppo lungo. Al massimo 175 lettere",
            "81809": "Il codice postale non puo’ contenere piu’ di 9 lettere o numeri",
            "81813": "Il codice postale puo’ contenere solo lettere, numeri, spazi, tratti",
            "91722": "Mezzo di pagamento token richiesto.",
            "91723": "Aggiornamento Token invalido.",
            "91730": "Verifica non supportata da questo conto commerciale",
            "91734": "Tipo di carta di credito non accettato da questo conto commerciale",
            "91738": "Il mezzo di pagamento specificato non é con carta di credito",
            "91745": "Parametri invalidi per aggiornare carta di credito.",
            "91826": "Codice postale invalido. Il codice postale é una serie di 5 o 9 cifre eventualmente separate da spazi",
            "-1": "Questo conto cliente é stato disattivato. Per favore contatta la nostra amministrazione"
        },
        "reBookingMsg": {
            "303": "L’orario selezionato deve essere successivo all’orario presente!",
            "304": "Prenotazione non trovata",
            "500": "Alcune informazioni della prenotazione sono scorrette. Per favore verifica e riprova"
        },
        "promoMsg": {
            "304": "TIl codice promozionale non é valido",
            "306": "Codice promozionale non valido. Sembra che la promozione sia applicata ad altre zone.",
            "413": "Spiacenti, questo codice promozionale non é disponibile al momento",
            "414": "Il codice promozionale non é valido",
            "415": "Il codice promozionale non é valido",
            "416": "Questo codice promozionale é già stato usato..",
            "419": "Spiacenti, questo codice promozionale non é disponibile al momento",
            "420": "Spiacenti, hai raggiunto il limite di utilizzo della promozione",
            "421": "Spiacente, questo codice promozionale ha raggiunto il limite di validità ",
            "422": "Questo codice promozionale non puo’ essere utilizzato dal tuo conto",
            "423": "Spiacenti, hai raggiunto il limite di fondi della promozione ",
            "424": "Codice promozionale non valido. Sembra che la promozione sia applicabile solo ai clienti referenziati.",
            "425": "Questo codice promozionale ha raggiunto il limite di utilizzo giornaliero.",
            "426": "Hai raggiunto il limite di utilizzo promozionale per giorno.",
            "427": "Impossibile applicare il codice promozionale. Il profilo di questo cliente è incompleto.",
            "428": "Questo cliente ha utilizzato il codice promozionale mensile.",
            "430": "Hai esaurito i tuoi codici promozionali annuali.",
            "431": "Il codice promozionale non può essere utilizzato per questo metodo di pagamento.",
            "432": "Questo importo della tariffa non è idoneo per il codice promozionale.",
            "433": "Il codice promozionale non è utilizzabile nel momento selezionato.",
            "434": "Mi dispiace, hai raggiunto il tuo budget promozionale limitato.",
            "phoneInvalid": "Per favore inserisci il numero di telefono del passeggero prima di applicare il codice promozionale"
        },
        "updateBookingMsg": {
            "303": "Aggiornamento della prenotazione fallito. Per favore riprova",
            "304": "Prenotazione non trovata",
            "pickUpTime": "L’orario selezionato deve essere successivo all’orario presente!",
            "pickup": "Non ci sono servizi di prenotazione disponibili in quest’area",
            "destination": "Alcune informazioni della prenotazione sono scorrette. Per favore verifica e riprova!",
            "dispatchType": "Alcune informazioni della prenotazione sono scorrette. Per favore verifica e riprova!"
        },
        "sessionExpired": {
            "403": "Sei stato disconnesso perché il tuo account è stato utilizzato da un altro dispositivo o la tua sessione è scaduta."
        },
        "not_found": {
            "404": "La pagina che hai richiesto non è stata trovata"
        },
        "booking": {
            "303": "L’orario selezionato deve essere successivo all’orario presente!!",
            "304": "Prenotazione non trovata",
            "305": "Prenotazione annullata o completata da Booking.com; si prega di rifiutare il lavoro per rimuoverlo dalla coda.",
            "306": "Nessuna tariffa assegnata al tipo di auto selezionato. Per applicare una tariffa a qualsiasi tipo di auto, si prega di andare su Impostazioni > Auto > Tipo di auto.",
            "307": "Impossibile aggiornare la prenotazione. Per favore riprova più tardi.",
            "407": "Tipo di tariffa ko supporta posizione extra",
            "500": "Alcune informazioni della prenotazione sono scorrette. Per favore verifica e riprova",
            "upgroup_success": "La prenotazione è stata separata con successo",
            "Please_Select_driver": "Seleziona il driver",
            "assign_driver_vehicle_success": "Autista/Vettura assegnati con successo",
            "assign_driver_success": "Il conducente è stato assegnato con successo",
            "detach_driver_success": "Driver has been detach successfully",
            "detach_vehicle_success": "Vehicle has been detach successfully",
            "Group_success": "La prenotazione è stata raggruppata con successo",
            "change_supplier_success": "La prenotazione è stata cambiata fornitori con successo.",
            "change_supplier_partial": "Successo parziale: l'assegnazione batch è fallita per i seguenti viaggi (ID prenotazione) a causa di azioni in corso: {0}.",
            "detach_driver_partial": "Successo parziale: l'assegnazione in batch è fallita per i seguenti viaggi (ID prenotazione) a causa di azioni in corso: {0}.",
            "assign_driver_partial": "Successo parziale: l'assegnazione batch è fallita per i seguenti viaggi (ID prenotazione) a causa di azioni in corso: {0}.",
            "update_dispatch": "Aggiorna e Invia",
            "remove_booking_false": "Impossibile rimuovere la prenotazione",
            "remove_booking_success": "La prenotazione è stata rimossa con successo",
            "GROUP_NOT_FOUND": "Id gruppo non trovato",
            "NO_SHARING_BOOKINGS": "Puoi raggruppare le prenotazioni solo se la prenotazione del cliente consente la condivisione della corsa.",
            "DIFFERENT_CAR_TYPES": "La prenotazione che stai cercando di raggruppare ha un tipo di auto diverso",
            "LIMIT_EXCEEDED_ON_SEATS_OR_LUGGAGE": "La prenotazione non può essere raggruppata: limite di posti o bagagli superato.",
            "INVALID_CAR_TYPE": "Impossibile assegnare il conducente, controlla il sedile del veicolo del conducente e la capacità di carico dei bagagli.",
            "VALIDATION_ERROR": "Errore di convalida",
            "INTERNAL": "Errore interno del server",
            "fare_gt_zero": "La tariffa deve essere maggiore di 0!",
            "edit_total_fail": "Modifica del valore totale fallita!",
            "complete_fail": "La prenotazione non può essere completata!",
            "cancle_fail": "Qualcosa è andato storto durante la cancellazione di questa prenotazione. Per favore riprova!",
            "incident_fail": "Incidente fallito",
            "phone_invalid": "Il numero di telefono non é valido!!",
            "add_psg_fail": "Impossibile aggiungere passeggero",
            "REMOVE_RECIPIENT_DELIVERED": "Impossibile rimuovere il destinatario è stato consegnato",
            "REMOVE_LAST_ACTIVE_RECIPIENT": "Impossibile rimuovere l'ultimo destinatario attivo",
            "ORDER_HAS_BEEN_FINISHED": "L'ordine è già stato completato.",
            "end_booking_leave": "Lasciare questa pagina terminerà la tua prenotazione",
            "update_booking_fail": "Aggiornamento della prenotazione fallito. Per favore riprova",
            "EXTERNAL_ID_EXISTED": "L'ID esterno esiste già nel sistema.",
            "area_service_unavailable": "Non ci sono servizi di prenotazione disponibili in quest’area",
            "pickupSameDestination": "Indirizzo pick-up deve essere diverso dalla destinazione.",
            "time_invalid": "L’orario selezionato deve essere successivo all’orario presente!",
            "psg_inactivate": "Questo conto cliente é stato disattivato. Per favore contatta la nostra amministrazione",
            "data_incorect": "Qualcosa è andato storto. Per favore riprova più tardi.",
            "preAuthorize": "Per favore verifica il tuo conto perché l'importo di {0} é richiesto al fine di garantire la tua prenotazione",
            "booking_limited": "Spiacenti, hai raggiunto il numero massimo di prenotazioni per minuto/giorno. Per favore riprova piu’ tardi",
            "minimumBookAhead": "Il tempo di ritiro della prenotazione deve essere almeno {0} ora(e) {1} minuto(i) dal tempo attuale",
            "exDoDiffDo": "La destinazione extra deve essere diversa dalla destinazione.",
            "recurringTimeRange": "Data fuori intervallo. Puoi creare prenotazioni solo {0} mesi in anticipo. Contatta l'amministratore per eventuali problemi.",
            "recipientsLimit": "Il numero massimo di destinatari è {0}.",
            "maximumBookAhead": "L'orario della prenotazione non puo' essere piu' tardi di {0} giorno(i) dall'orario attuale",
            "Please_select_or_add_a_card": "Per favore seleziona o aggiungi una carta!!",
            "Unable_to_process_by_fare_zero": "Impossibile trattare la tua richiesta, per favore cambia tipo di vettura o tipo di prenotazione e riprova. Se hai bisogno di aiuto contatta la nostra assistenza tecnica.",
            "Can_not_connect_to_server": "Impossibile connettersi al server!",
            "Check_connection_or_contact_system_support": "Per favore verfica la tua connessione o contatta il supporto per avere aiuto!",
            "Create_new_booking_success": "Una nuova prenotazione è stata creata con successo!",
            "Create_new_recurring_booking_success": "Nuova/e prenotazione/i è stata/o creata/o con successo",
            "Update_booking_success": "Questa prenotazione é stata aggiornata con successo!",
            "addon_exceeded": "{0} quota superata.",
            "addon_exceeded_with_params": "Per favore ricarica il tuo saldo per continuare a utilizzare {0}.",
            "Booking_drop_of_success": "Scarico della prenotazione effettuato con successo",
            "Cancel_booking_success": "Questa prenotazione é stata cancellata con successo!",
            "Cancel_booking_fails": "Questa prenotazione non può essere annullata!",
            "adjust_fare_booking_success": "Fare è stato regolato con successo!",
            "adjust_fare_booking_fail": "Regolazione non riuscita!",
            "Booking_detail_not_found": "Dettaglio prenotazione non trovato!",
            "Check_promo_error": "Verifica errore codice promozionale!",
            "Invalid_format": "Formato invalido",
            "Flight_not_found": "Volo non trovato!!",
            "Add_new_credit_error": "Aggiungi nuovo errore credito!",
            "Socket_server_disconnected": "Server socket disconnesso!",
            "Please_reload_page_or_check_your_connection": "Mi dispiace. La tua richiesta non può essere elaborata. Per favore riprova.",
            "request_timeout": "Spiacente. Il timeout della tua richiesta. Per favore riprova.",
            "Check_customer_error": "Verifica errore cliente!",
            "Please_select_car_type": "Per favore seleziona tipo di macchina.",
            "DropOff_country": "Punto di consegna non disponibile per questo tipo di auto. Si prega di scegliere un altro tipo di auto o modificare il percorso.",
            "Different_Country": "Le località di ritiro e riconsegna devono essere in 2 paesi diversi.",
            "Please_enter_destination_for_ridesharing_booking": "Per favore inserisci la destinazione per una prenotazione in car pooling",
            "Extra_detination_must_be_difference_from_destination": "La destinazione aggiuntiva deve essere differente dalla destinazione attuale",
            "Pickup_address_must_be_different_from_destination": "L'indirizzo di partenza deve essere diverso da quello di destinazione",
            "Best_price": "miglior prezzo",
            "You_may_be_charged_extra_fee_if_your_trip_excceds": "Potresti pagare un extra se il tuo viaggio eccede",
            "You_may_be_charged_extra_fee_if_your_trip_excceds_with_params": "Potresti pagare un extra se il tuo viaggio eccede {0} {1}, {2} {3}",
            "Reject_booking_success": "La prenotazione è stata rifiutata con successo!",
            "Reject_fail": "Qualcosa è andato storto nel rifiutare questa prenotazione. Per favore riprova!",
            "Please_select_payment_method": "Si prega di selezionare il metodo di pagamento",
            "Driver_signed_out_or_deactivated": "Questo autista ha appena effettuato il logout o è stato disattivato",
            "reservation_booking_overlaps": "Ci scusiamo, questa prenotazione si sovrappone a un'altra che il Driver ha accettato.",
            "driver_is_not_available": "Sorry, this driver isn’t available at the requested time.",
            "seats_luggage_limit": "This booking can’t be assigned to the driver because the seats/luggage limit has been exceeded.",
            "full_capacity": "Questa prenotazione non può essere assegnata al conducente perché il viaggio ha raggiunto la sua capacità massima.",
            "marked_failed_ok": "L'ordine è stato contrassegnato come fallito.",
            "warning_markFail_lastRecipient": "Questo è l'ultimo destinatario di questa prenotazione. Se procedi a contrassegnare questo ordine come fallito, dovrai quindi completare questa prenotazione.",
            "BOOKINGS_LIMIT_EXCEEDED": "Puoi assegnare un massimo di 5 ordini a ciascun gruppo.",
            "bookingCanceled": "Prenotazione annullata o completata da Booking.com; si prega di rifiutare il lavoro per rimuoverlo dalla coda.",
            "contact_info_required": "Si prega di selezionare un profilo utente valido o crearne uno nuovo prima di procedere. In alternativa, puoi creare una prenotazione come ospite.",
            "UNSUPPORTED_ZONE": "Zone non è supportata",
            "INVALID_GUEST_PHONE_NUMBER": "Il numero di telefono del passeggero non è valido",
            "NEGATIVE_FLEET_BALANCE": "Sembra che il tuo saldo sia troppo basso per creare una nuova prenotazione. Per favore, aggiungi fondi o salda eventuali pagamenti in sospeso per procedere."
        },
        "item_no_found": "Nessun oggetto trovato.",
        "commonMessages": {
            "greater_than_0": "Per favore inserisci un valore maggiore di 0.",
            "Required_field": "Questo campo é obbligatorio",
            "bankPhone_is_required": "Il numero di telefono non è valido",
            "bankPhone": "Numero di telefono",
            "distance_from_equa_or_smaller": "La distanza “da” deve essere inferiore o uguale alla distanza “a”",
            "must_be_number": "Per favore inserisci email valida",
            "equal_or_greater_than_0": "Per favore inserisci un valore uguale o maggiore di 0.",
            "must_be_integer": "Per favore inserisci un numero intero",
            "invalid_email_format": " Per favore inserisci email valida.",
            "greater_or_equa": "Per favore inserisci un valore maggiore o uguale a {0}.",
            "value_must_between": "Per favore inserisci un numero fra {0} e {1}.",
            "large_10x_markup_price": "La tariffa modificata non dovrebbe superare 10 volte la tariffa stimata.",
            "greater_than": "Si prega di inserire un valore maggiore di {0}.",
            "less_than": "Si prega di inserire un valore inferiore a {0}.",
            "less_or_equal": "Si prega di inserire un valore minore o uguale a {0}.",
            "driver_earnings_warning": "Pagamenti offline: I guadagni del conducente non devono superare la tariffa raccolta.",
            "limit_amount": "Si prega di inserire un valore minore o uguale all'importo limite",
            "Integer_from_range": "Per favore inserisci un numero intero fra {0} - {1}",
            "integer_greater_than_0": "Si prega di inserire un numero intero maggiore di 0. (Meno di 100 con separatore percentuale e decimale è 1 carattere)",
            "Error_message": "Errore!",
            "callcenter_newbooking_message": "Nuova richiesta di prenotazione con telefono <span class='bold'>{0}</span>",
            "callcenter_existed_booking_message": "Esiste una prenotazione attiva <span class='bold'>#{0}</span> con telefono <span class='bold'>{1}</span>",
            "callcenter_close_newbooking_form_warning": "Per favore chiudi/completa la prenotazione attuale prima di ricevere una nuova richiesta dal cliente",
            "Emergency_SOS_Title": "Emergenza SOS",
            "Please_enter_a_future_date": "Si prega di inserire una data futura",
            "Card_holder_is_required": "È necessario il titolare della carta",
            "Card_number_is_required": "E’ richiesto il numero della carta di credito.",
            "Expired_date_is_required": "La data di scadenza è obbligatoria",
            "Credit_code_is_required": "Si prega di inserire il codice di credito (ultima validazione)",
            "Expired_date_is_invalid": "Data di scadenza invalida. Please enter expiration date in format mm/yy",
            "cvv_is_required": "CVV richiesto",
            "City_is_required": "La città è obbligatoria",
            "State_is_required": "È richiesto lo stato",
            "Address_is_required": "L'indirizzo è obbligatorio",
            "Zipcode_is_required": "Il codice postale è obbligatorio",
            "Country_is_required": "Il paese è obbligatorio",
            "Over_query_limit": "Google API non può essere caricata a causa di un errore temporaneo. Per favore riprova più tardi.",
            "outOfInputQueueOrder": "L'ordine # non può essere maggiore del numero totale di autisti in coda.",
            "Same_pickup_destination": "Pick-up address must be different from destination address.",
            "Max_length": "La lunghezza massima è di {0} caratteri.",
            "choose_at_least_one": "Si prega di scegliere almeno un'opzione.",
            "choose_at_least_one_intercity_schedule": "Si prega di aggiungere il programma o consentire al cliente di richiedere il proprio orario preferito.",
            "startDate_greater_than_endDate": "La data di inizio è maggiore della data di fine"
        },
        "trip": {
            "cancel_trip_success": "Questo viaggio è stato cancellato con successo!",
            "data_incorect": "Nessun conducente è stato assegnato. Seleziona un conducente dall'elenco a discesa. <br/> Se non ci sono conducenti disponibili, seleziona Auto Dispatch per assegnare in seguito.",
            "INTERNAL": "Errore interno del server.",
            "NOT_FOUND": "Viaggio non trovato o stato non valido.",
            "SAME_DRIVER": "Il cessionario deve essere diverso dall'attuale conducente.",
            "OVERLAP": "Mi dispiace, questo viaggio si sovrappone a un altro che è stato accettato da questo autista.",
            "CANNOT_ASSIGN": "Questo driver non è valido (cioè driver non trovato, non online o non connesso)."
        },
        "car_mgmt": {
            "Search_car_color": "Cerca colore auto",
            "Searching": "Cercando"
        },
        "driver_note": {
            "Search_driver_note": "Cerca nota del conducente",
            "Searching": "Cercando"
        }
    },
    "errors": {
        "303": "Utilizzatore non trovato",
        "453": "Gateway non supportato",
        "553": "Spiacente! Il cliente ha una prenotazione in corso, per favore riprova più tardi.",
        "1007": "Il periodo tra la data di inizio e la data di fine deve essere inferiore a 60 giorni!!",
        "3001": "Numero di telefono esistente",
        "3002": "Data di nascita invalida",
        "3003": "Data di scadenza della patente dell'autista invalida",
        "3004": "Autista non trovato",
        "3005": "Mancano le informazioni amministrative dell'autista (indirizzo banca, città, cap)",
        "3006": "Mancano le informazioni bancarie dell'autista (nome e tipo di conto, numero conto, numero routing, codice fiscale)",
        "3007": "Non puoi modificare questo autista mentre sta lavorando.",
        "3008": "Questo autista é attualmente connesso al sistema. Per favore chiedigli di disconnettersi per poter modificare le sue informazioni.",
        "3009": "L’autista ha accettato una o priu’ prenotazioni.Per favore assegna le prenotazioni ad altro autista(i) prima di disattivarlo.",
        "3010": "Connessione assegnazione fallita.",
        "3011": "Questo autista deve essere predisposto per essere operativo prima di essere attivato.",
        "3012": "Questo autista deve essere predisposto per essere operativo prima di essere attivato",
        "3013": "** Solo un oggetto in status inattivo puo’ essere eliminato.",
        "3014": "Alcuni campi obbligatori sono mancanti. Per favore verifica",
        "3015": "Anno di nascita invalido. Per favore verifica.",
        "3016": "Cap invalido.Per favore verifica.",
        "3017": "Provincia invalida.Per favore verifica.",
        "3018": "Nome del conto invalido.Per favore verifica.",
        "3019": "Numero routing invalido.Per favore verifica.",
        "3020": "Il giorno di nascita é obbligatorio. Per favore verifica.",
        "3021": "Il codice fiscale é invalido. Per favore verifica.",
        "3022": "Il conto bancario del conducente non può ricevere fondi.",
        "3023": "Gli autisti connessi al sistema non possono essere gestiti. Per favore riprova dopo",
        "3026": "L’autista non esiste piu’",
        "3027": "Il conto bancario dell’autista non é stato predisposto. Per favore vai nel modulo autista per impostare il conto bancario dell’autista",
        "3028": "Impossibile pagare l'autista(i) selezionati. Per favore riprova.",
        "3029": "Impossibile cancellare i dati di guadagno del conducente. Per favore riprova.",
        "3032": "Questo username esiste già nel nostro sistema. Per favore inseriscine un altro.",
        "3033": "BSB non valido. Il numero dovrebbe essere di 6 cifre nel formato xxxxxx.",
        "3036": "Captcha è richiesto",
        "3037": "Captcha non valido",
        "3039": "È richiesto l'ID del gruppo.",
        "3040": "Questo numero di telefono è già in uso da un autista %{brandName} (cioè il numero di telefono non può essere duplicato). Si prega di inserirne un altro.",
        "3041": "Il nome utente esisteva.",
        "3044": "Il documento d'identità nazionale è duplicato.",
        "3045": "Il conducente ha già un veicolo, per favore aggiorna la pagina",
        "3046": "La compagnia del veicolo e la compagnia del conducente sono diverse.",
        "4001": "Il tuo numero di targa esiste già nel sistema. Per favore inseriscine un altro",
        "4002": "Data di scadenza invalida",
        "4003": "Il veicolo deve essere disattivato prima di essere eliminato",
        "4004": "Veicolo non trovato",
        "4005": "Questo veicolo é già inattivo ",
        "4006": "Questo veicolo é in uso e non puo' essere eliminato o disattivato",
        "4007": "Il numero di targa é obbligatorio",
        "4009": "Il veicolo è in fase di assegnazione a una prenotazione.",
        "4010": "Il veicolo viene assegnato a un conducente.",
        "5001": "Azienda già esistente",
        "5004": "Azienda non trovata",
        "6001": "Modello del veicolo già esistente",
        "6004": "Modello del veicolo non trovato",
        "6005": "Modello del veicolo in uso",
        "7001": "Il tuo costruttore esiste già nel sistema .Per favore inseriscine un altro",
        "7004": "Marca del veicolo non trovata",
        "8001": "Tipo di veicolo già esistente",
        "8004": "Tipo di veicolo non trovato",
        "9001": "Itinerario a tariffa fissa già esistente",
        "9004": "Itinerario a tariffa fissa non trovato",
        "10001": "Zona già esistente",
        "10004": "Zona non trovata",
        "11001": "Zona già esistente",
        "11002": "Conflitto di Zona",
        "11003": "La zona deve essere poligonale",
        "11004": "Zona non trovata",
        "11005": "Zona in uso",
        "12001": "Casella già esistente",
        "12002": "Per favore configura SMS Twilio.",
        "12004": "Casella non trovata",
        "12005": "Non ci sono destinatari che corrispondono ai tuoi filtri. Controlla l'elenco e riprova.",
        "12006": "Nessun cliente esiste nel file.",
        "13001": "Questo codice di promozione esiste già nel sistema. Per favore inseriscine un altro.",
        "13002": "Data invalida",
        "13003": "Privato",
        "13004": "Codice promozionale non trovato",
        "13005": "Solo Nuovo Cliente",
        "13006": "Superiore al limite di quantità",
        "13007": "Superiore al limite di spesa",
        "13008": "Superiore al limite di uso",
        "13011": "Questa campagna promozionale é stata disattivata o eliminata",
        "13012": "L'intervallo di date non è valido",
        "13013": "Codice promozionale non valido. Sembra che la promozione sia applicata ad altre zone.",
        "13014": "La zona che hai selezionato è stata disattivata.",
        "14004": "Prenotazione non trovata",
        "15002": "La tua flotta é stata disattivata. Per favore contatta la nostra amministrazione",
        "15004": "Flotta non trovata",
        "16001": "Il nome della tariffa é già esistente",
        "16004": "Tariffa non trovata",
        "17001": "Nome é già esistente",
        "17004": "Tariffa pacchetto non trovata",
        "18001": "Nome é già esistente",
        "18002": "Tariffa in uso",
        "18004": "Tariffa non trovata",
        "19001": "Shift name has existed",
        "19002": "Tariffa in uso",
        "19004": "Tariffa non trovata",
        "20001": "Questo username esiste già nel nostro sistema. Per favore inseriscine un altro.",
        "20002": "Il tuo conto non é attivo. Per favore chiama la nostra Amministrazione",
        "20003": "Username o password non sono corretti. Per favore riprova",
        "20004": "Username non registrato nel sistema.",
        "20005": "Questo link é scaduto",
        "20006": "La password attuale non combacia. Per favore riprova.",
        "20007": "Utilizzatore # é già esistente",
        "20008": "Questa email esiste già nel nostro sistema. Per favore, inserisci un'altra.",
        "20012": "L'ID della flotta esiste già",
        "21001": "Il nome del tuo permesso esiste già nel sistema. Per favore inseriscine un altro..",
        "21002": "Impossibile disattivare questo permesso perché é stato attribuito ad uno o piu’ utilizzatori",
        "21003": "Ruolo attivo",
        "21004": "Ruolo non trovato",
        "22001": "Il cliente é già esistente",
        "22004": "Cliente non trovato",
        "22005": "Formato del file invalido..",
        "22006": "Il numero di telefono esiste",
        "24001": "Numero di telefono invalido",
        "25001": "Questo nome esiste già nel sistema. Si prega di inserirne un altro.",
        "25002": "Fascia oraria invalida",
        "25004": "Turno non trovato",
        "26001": "Questo nome esiste già nel sistema. Si prega di inserire un altro.",
        "26002": "Questo turno é al momento in funzione, per favore togli l’assegnazione prima di cancellarlo.",
        "26004": "Modello del turno non trovato",
        "27001": "La campagna esiste già",
        "27002": "La campagna é attiva",
        "27004": "Campagna non trovata",
        "28001": "La città esiste già",
        "28002": "La città é stata attivata",
        "28003": "La città é in uso",
        "28004": "Città non trovata",
        "29002": "Il numero di telefono esite già",
        "30001": "Area di fila non trovata",
        "30002": "Area di fila in uso",
        "30003": "Il nome della tua area di attesa esiste già nel sistema. Per favore inserisci un altro nome.",
        "30004": "L'area di attesa non deve sovrapporsi l'una con l'altra.",
        "30005": "Le coordinate dell'area di attesa non sono valide",
        "30006": "Pick-up areas are invalid",
        "31001": "Your company name has been existed on system. Please input another one.",
        "31002": "Questo username esiste già nel nostro sistema. Per favore inseriscine un altro",
        "31003": "Azienda non trovata.",
        "31004": "Utilizzatore aziendale non trovato.",
        "31005": "Solo aziende inattive possono essere eliminate..",
        "31006": "Questo telefono esiste già nel viaggiatore aziendale. Per favore inseriscine un altro.",
        "31007": "Viaggiatore aziendale non trovato.",
        "31008": "Nessuna carta trovata.",
        "31009": "Questo telefono esiste già nel sistema. Per favore inseriscine un altro.",
        "31010": "Questa azienda é stata disattivata. Per favore contatta l'amministrazione per piu' informazioni",
        "31011": "Questo viaggiatore non puo' essere attivato perché appartiene ad un conto aziendale inattivo",
        "31013": "Sembra che questo alias sia già stato preso. Prova un altro!",
        "31014": "Si prega di assegnare una tariffa per almeno un tipo di veicolo",
        "31015": "Questa email/telefono è già collegata a un altro account.",
        "31016": "Questa email/telefono è collegato a un altro account aziendale. Si prega di aggiornare il profilo o rimuovere l'utente dall'account esistente prima di assegnarlo a uno nuovo.",
        "31017": "Questa email/telefono è vuota. Si prega di inserire un'email/telefono valido.",
        "32001": "Il tuo username esiste già nel sistema. Per favore inseriscine un altro",
        "32004": "Servizio non trovato",
        "33002": "I range di tempo non devono sovrapporsi tra loro.",
        "34001": "Il codice esiste",
        "34013": "Il intervallo di date non è valido",
        "36001": "Il nome esiste",
        "39001": "Il documento è richiesto",
        "43001": "Il modello di penalità esisteva",
        "43002": "Modello di penalità non trovato",
        "44001": "Il modello di tariffa esisteva",
        "44002": "Modello di tariffa non trovato",
        "44003": "Il modello di tariffa è attualmente assegnato a un'azienda. Si prega di disassociare prima di eliminare.",
        "45001": "Politica di sovrapprezzo esistente",
        "45002": "Politica di sovrapprezzo non trovata",
        "45003": "Elemento di sovrapprezzo non trovato",
        "46001": "Il nome esiste",
        "46002": "Elemento non trovato",
        "47001": "Esistevano Stop Sales",
        "47002": "Vendite bloccate non trovate",
        "48003": "La posizione personalizzata non contiene la stessa zona",
        "49003": "Duplicare l'azienda nel pagamento",
        "49004": "Imei esiste",
        "50001": "Add-on template existed",
        "50002": "Add-on template not found",
        "50003": "Add-on service existed",
        "50004": "Add-on service not found",
        "71001": "Esisteva un sovrapprezzo dinamico",
        "71002": "Quest'area si sovrappone a un'altra. Per favore, disegnala di nuovo.",
        "71003": "Il sovrapprezzo dinamico deve essere un oggetto poligonale",
        "71004": "Supplemento dinamico non trovato",
        "72001": "Tariffa dinamica esistente",
        "72002": "Quest'area si sovrappone a un'altra. Per favore, disegnala di nuovo.",
        "72003": "Tariffa dinamica deve essere un oggetto poligonale",
        "72004": "Tariffa dinamica non trovata",
        "74001": "Zone esistenti",
        "74002": "Quest'area si sovrappone a un'altra. Per favore, disegnala di nuovo.",
        "74003": "Le zone devono essere un oggetto poligonale",
        "74004": "Zona tariffaria non trovata",
        "74005": "Zona tariffaria non trovata",
        "80001": "Banner dell'app esistente.",
        "80002": "Banner dell'app non trovato.",
        "80003": "Solo gli articoli con stato inattivo possono essere eliminati.",
        "81001": "Il caricamento del file è vuoto.",
        "81002": "Il caricamento del file ha un limite di dimensione.",
        "82002": "Qualcosa è andato storto durante l'installazione del flightaware. Per favore riprova più tardi.",
        "90001": "La zona intercity esisteva",
        "90002": "Questa area si sovrappone a un'altra. Per favore, disegnala di nuovo.",
        "90003": "La zona intercity deve essere un oggetto poligonale.",
        "90004": "Zona intercity non trovata",
        "90005": "La zona intercity è in uso",
        "91001": "La tariffa intercity esiste.",
        "91002": "La tariffa intercity è in uso",
        "91003": "Tariffa intercity non trovata",
        "92001": "Il nome della rotta esiste già",
        "92002": "Percorso non trovato",
        "92003": "Questo percorso esiste già in un altro percorso, per favore controlla e riprova.",
        "92004": "C'è un viaggio attivo su questo percorso.",
        "93001": "La nota del conducente esiste già nel sistema. Si prega di inserirne un'altra.",
        "93002": "Le note del driver sono inattive e possono essere eliminate.",
        "93003": "Nota del conducente in uso.",
        "93004": "Nota del conducente non trovata.",
        "94001": "Il nome del colore della tua auto esiste già nel sistema. Per favore, inserisci un altro.",
        "94002": "Colore dell'auto non trovato",
        "400000": "Il numero di telefono non é valido!",
        "400002": "Si è verificato un errore di convalida.",
        "400003": "Permesso negato",
        "400005": "Contenuto del file invalido",
        "400008": "Si prega di inserire il nome della zona",
        "500000": "Errore interno al sistema.",
        "500001": "Per favore configura SMS Twilio.",
        "500002": "Timeout della richiesta. Per favore riprova più tardi.",
        "500004": "Errore interno del sistema",
        "600001": "Località non trovata",
        "600002": "Queste coordinate di longitudine & Latitudine esistono già nel sistema. Per favore aggiungine altre",
        "610001": "Categoria esistente",
        "610002": "Categoria non trovata",
        "610003": "La categoria esisteva nella posizione della festa",
        "700001": "Il tipo é in uso",
        "700002": "mDispatcher non trovato",
        "700003": "Your mDispatcher type name has been existed on system. Please input another one.",
        "800000": "Questo negozio è stato assegnato a un altro account commerciante. Si prega di selezionarne un altro.",
        "800001": "Il conto bancario del commerciante non può ricevere fondi.",
        "800002": "Il conto bancario del commerciante non può ricevere fondi.",
        "limitMessage": {
            "upgrade": "Upgrade",
            "cancel": "Cancel",
            "driver": {
                "title": "Driver limit reached",
                "description": "Your current subscription allows up to %{limitation} drivers. To add more drivers, please upgrade to the higher plan."
            },
            "vehicle": {
                "title": "Vehicle limit reached",
                "description": "Your current subscription allows up to %{limitation} vehicles. To add more vehicles, please upgrade to the higher plan."
            },
            "operator": {
                "title": "Operator limit reached",
                "description": "Your current subscription allows up to %{limitation} operators. To add more operators, please upgrade to the higher plan."
            }
        },
        "31016_2": "Messaggio: Questa email/telefono è già collegato a un altro account. Si prega di contattare il proprio account manager per assistenza.",
        "undefined": "Qualcosa é andato storto con il server, per favore riprova.",
        "completeBooking": {
            "113": "Non siamo in grado di autenticare il tuo metodo di pagamento. Per favore, scegli un metodo di pagamento diverso e riprova.",
            "450": "Il saldo è insufficiente per pagare. Si prega di selezionare un altro metodo.",
            "451": "Il saldo è insufficiente per pagare. Si prega di selezionare un altro metodo.",
            "521": "Il portafoglio non ha fondi sufficienti."
        },
        "upload_file_fail": "File non valido, per favore controlla e riprova.",
        "upload_photo_fail": "File non valido, per favore controlla e riprova.",
        "missing_some_field": "Campo non valido, per favore controlla e riprova.",
        "validAddress": "Si prega di selezionare un indirizzo valido."
    },
    "statusDisplay": {
        "supplierAccepted": "Fornitore accettato",
        "pendingAmmendment": "Emendamento in sospeso",
        "supplierAllocated": "Fornitore assegnato",
        "delivery_supplierAccepted": "Fornitore accettato",
        "completedWithoutService": "Completato senza conducente",
        "confirmed": "Prenotazione confermata",
        "pending": "In attesa",
        "queue": "Assegnazione",
        "offered": "Assegnazione",
        "booked": "Autista in arrivo",
        "engaged": "P.O.B",
        "droppedOff": "Scaricato",
        "inReview": "Richiede Revisione",
        "pre": "In attesa",
        "recurrent": "Ricorrente",
        "vacant": "",
        "vacantTime": "",
        "arrived": "Arrivato e in attesa",
        "completed": "completato",
        "canceled": "cancellato",
        "noShow": "Assente",
        "driverNoShow": "Assenza del conducente",
        "action": "In attesa di trattazione",
        "incident": "Incidente",
        "pickupTimeExceeded": "Tempo scaduto",
        "canceledByCC": "Cancellato da CC",
        "canceledByPassenger": "Cancellata dal passeggero",
        "canceledByDriver": "Annullato dal pilota",
        "canceledByPartner": "Cancellata dal partner",
        "canceledBymDispatcher": "Cancellato da mDispatcher",
        "canceledByCorporateAdmin": "Cancellato dall’Amministratore dell’Azienda",
        "canceledByAPI": "Cancellato da API",
        "canceledByWebBooking": "Cancellato dalle prenotazioni online",
        "canceledByTimeout": "Cancellato per timeout",
        "accepted": "Accettato",
        "rejected": "Respinto",
        "canceledByCorpAd": "Cancellato dall’Amministratore dell’Azienda",
        "started": "Iniziato",
        "intransit": "In transito",
        "empty": "Vuoto",
        "notLive": "Parziale - non in diretta",
        "live": "Parziale - dal vivo",
        "full": "Pieno",
        "delivering": "Consegna",
        "delivery_booked": "Autista in viaggio verso il mittente",
        "delivery_arrived": "Arrivato e in attesa del mittente",
        "shopForYou_booked": "Autista in viaggio per raccogliere contante",
        "shopForYou_arrived": "Arrivato e in attesa di ritirare contante",
        "collecting": "Driver on the way to merchant",
        "confirmed_delivery": "Confermato",
        "food_booked": "Autista in viaggio verso il commerciante",
        "food_collecting": "Arrivato e in attesa di ritirare l'oggetto",
        "mart_collecting": "Arrivato e in attesa di ritirare l'oggetto",
        "otwMerchant": "Autista in viaggio verso il commerciante",
        "arrivedAndWaitingToCollectItem": "Arrivato e in attesa di ritirare l'oggetto",
        "canceledByAirlineAdmin": "Cancellato dall'Amministratore della Compagnia Aerea",
        "partialCompleted": "Parzialmente completato",
        "failed": "Fallito",
        "allocated": "Assegnato"
    },
    "tripTypes": {
        "scheduled": "Viaggi programmati",
        "requested": "Richiedi viaggi",
        "preferred": "Preferito"
    },
    "login": {
        "Username": "Username",
        "Password": "Password",
        "Remember_me": "Ricordami",
        "Forgot_your_password": "Password dimenticata",
        "Login": "Registrati"
    },
    "invoice": {
        "createBtn": "Crea fattura",
        "searchPlInvoice": "Cerca cliente, contatto, numero fattura",
        "searchPl": "Cerca bookId, nome cliente",
        "createInvoice": "Crea Fattura",
        "invoicePeriod": "Periodo di Fatturazione",
        "invoicePeriodNote": "Puoi selezionare intervalli di date da mese a mese.",
        "viewEdit": "Visualizza/Modifica",
        "billingContact": "Contatto di fatturazione",
        "memo": "Memo",
        "memoMessage": "Lascia un messaggio al cliente",
        "dueDate": "Data di scadenza",
        "updateInvoice": "Aggiorna Fattura",
        "chargeCustomer": "Addebita Cliente",
        "invoiceNumber": "Numero Fattura",
        "noItem": "No. Articoli",
        "issuedDate": "Data di emissione",
        "refId": "Rif #",
        "pickupTime": "Pick Up Time",
        "pickup": "Luogo di Ritiro",
        "destination": "Luogo di consegna",
        "customerName": "Nome del Cliente",
        "totalAmount": "Amount Due",
        "amountDue": "Importo Dovuto",
        "sendInvoice": "Invia Fattura",
        "copyInvoice": "Copia Fattura",
        "downloadPDF": "Scarica come PDF",
        "paymentLink": "Link di pagamento",
        "deleteInvoice": "Elimina Fattura",
        "onlySave": "Salva Fattura",
        "saveSend": "Salva e Invia Fattura",
        "sendEmail": "Invia Email",
        "addRecipients": "Aggiungi Destinatari",
        "editInvoice": "Modifica Fattura",
        "check": "Controlla",
        "wire": "Filo",
        "digitalWallet": "Portafoglio Digitale",
        "cash": "Contante",
        "completedTime": "Tempo Completato",
        "Status": "Stato",
        "bookingStatus": "Stato della Prenotazione",
        "chargeBtn": "Carica {0}",
        "pastDue": "Scaduto",
        "payCompleted": "Questa fattura è stata pagata con successo!",
        "Delete": "Eliminare la fattura?",
        "Delete_content": "Questa azione rimuoverà permanentemente questa fattura. Se necessario, puoi crearne una nuova per questi ordine(i).",
        "viewInvoice": "Visualizza Fattura",
        "pending": "In attesa",
        "paid": "Pagato",
        "CopyLink": "Copia Link",
        "partial": "Parziale",
        "corporatePrepaid": "Prepagato Aziendale"
    },
    "cue": {
        "bookingServiceType": "Tipo di servizio",
        "pointToPoint": "Da Punto a Punto",
        "fromAirport": "Dal Aeroporto",
        "toAirport": "Verso l'aeroporto",
        "hourly": "Orario",
        "roundTrip": "Viaggio di andata e ritorno",
        "jobVisibility": "Visibilità del lavoro",
        "jobPubic": "Pubblico",
        "jobPrivate": "Privato",
        "jobSetPubic": "Imposta Pubblico",
        "jobSetPrivate": "Imposta Privato",
        "supplierAccepted": "Fornitore accettato",
        "pendingAmmendment": "Emendamento in sospeso",
        "supplierAllocated": "Fornitore assegnato",
        "creationTime": "Tempo di creazione",
        "Pax": "Pax #",
        "Luggage": "Bagagli",
        "allocated": "Assegnato",
        "completedWithoutService": "Completato senza driver",
        "shuttle": "Navetta",
        "farmIn": "Farm In",
        "chargeCode": "Codice di Carica",
        "clientCaseMatter": "Descrizione del viaggio",
        "operatorNote": "Note interne",
        "farmOut": "Esternalizzare",
        "roaming": "Roaming",
        "FlightUpdate": "Aggiornamento Volo",
        "networkType": "Tipo di rete",
        "InHouse": "In-house",
        "External": "Esterno",
        "carHailing": "Richiesta di auto",
        "uploadBookings": "Carica Prenotazioni",
        "moreActions": "Altre Azioni",
        "rideSharing": "Condividi-viaggio",
        "Rearrange": "Riorganizza",
        "GroupId": "ID Gruppo #",
        "Active": "Attiva",
        "Finished": "Terminato",
        "Home_affiliate": "Home / Affiliato",
        "Booking_type": "Tipo prenotazione",
        "From": "Da",
        "balanceWallet": "{0}: {1} rimanenti",
        "partialWallet": "Pagamento parziale con Wallet",
        "To": "A",
        "Status": "Stato",
        "Migration_Status": "Stato di Migrazione",
        "Migrated": "migrato",
        "Select_Status": "Seleziona Stato",
        "Operator": "Operatore",
        "Car_types": "Tipi di auto",
        "Service_class": "Classe di servizio",
        "Booking_from": "Prenotato da",
        "All": "Tutto",
        "Pending": "In attesa",
        "Dispatching": "Assegnazione",
        "Waiting_for_process": "In attesa di trattazione",
        "Confirmed_reservation": "Prenotazione confermata",
        "Driver_on_the_way": "Autista in arrivo",
        "Arrived_and_waiting": "Arrivato e in attesa",
        "Passenger_on_board": "Passeggero a bordo",
        "Dropped_off": "Scaricato",
        "combobox_select": "Seleziona ...",
        "Search_here": "Cerca qui",
        "Bookingid": "Prenotazione #",
        "Pickup_Drop_Off": "Carico/ Scarico",
        "Pickup_Drop_Off_Crew": "Orario di ritiro/consegna",
        "Pickup_Drop_Off_Local_Time": "Tempo Operatore",
        "Pickup_Location_Destination": "Indirizzo di destinazione/ destinazione",
        "Passenger": "Passeggero",
        "Intercity_Route": "Percorso intercity",
        "Airport_Pickup": "Appuntamento all’aeroporto",
        "Airport_Pickup_Crew": "Aeroporto",
        "Flight_Status": "Stato",
        "Payment": "Pagamento",
        "Vehicle": "Veicolo",
        "Car_type": "Tipo di macchina",
        "Driver": "Autista",
        "Estimated_Fare": "Tariffa stimata",
        "Notes": "Note",
        "Note": "Nota",
        "Type": "genere",
        "Home": "Casa",
        "Affiliate": "Affiliato",
        "now": "Adesso",
        "reservation": "Prenotazione",
        "recurring": "Ricorrente (Trasporto)",
        "No_show": "Assente",
        "Canceled_by_CC": "Cancellata da CC",
        "Canceled_by_passenger": "Cancellata dal passeggero",
        "Canceled_by_partner": "Cancellata dal partner",
        "Canceled_by_mDispatcher": "Cancellato da mDispatcher",
        "Canceled_by_Corporate_Admin": "Cancellato dall’Amministratore dell’Azienda",
        "Canceled_by_API": "Cancellato da API",
        "canceled_By_Web_Booking": "Cancellato dalle prenotazioni online",
        "canceled_By_Time_Out": "Cancellato per timeout",
        "Canceled": "Cancellata",
        "Completed": "Completato",
        "Incident": "Incidente",
        "Payment_Method": "Mezzo di Pagamento",
        "No_Phone": "Nessun telefono",
        "VIP": "VIP",
        "Non_VIP": "Non-VIP",
        "Passenger_type": "Tipo passeggero",
        "Error_load_booking": "Impossibile caricare la prenotazione, Per favore riprova o ricarica la pagina!",
        "Edit_total_success": "Totale modificato con successo",
        "Edit_total_fail": "La tariffa totale deve essere uguale o superiore a {0}",
        "Time_out": "Tempo scaduto",
        "Ride_Service": "servizio corsa",
        "Regulation": "Regolazione",
        "Ride_Sharing": "Condividi-viaggio",
        "Unmatching": "Non abbinamento",
        "Matching": "Abbinamento",
        "all": "Tutti",
        "matching": "Abbinamento",
        "unmatching": "Non abbinamento",
        "regulation": "Regolazione",
        "Support_service": "Servizio Supporto",
        "SOS": "SOS",
        "Non_SOS": "Non-SOS",
        "Corporate": "Corporate",
        "Individual": "Singolo autista",
        "On_curb": "Trattenuto",
        "Meet_Greet": "Incontra & Saluta",
        "Close": "Vicino",
        "auto_refrest_cue": "Auto-aggiornamento ({0} secondi)",
        "Ride_type": "Tipo di corsa",
        "Edit_total_note": "Note: subtotale, spese tecniche, spese di prenotazione, tasse e mance saranno aggiornate con il cambiamento dell'importo totale",
        "Booking": "Prenotazione",
        "Edit_fare": "Modifica tariffa",
        "Adjust_price": "Regola prezzo",
        "Total": "Totale",
        "Reason": "Ragione",
        "Please_enter_reason": "Per favore inserisci motivo.",
        "Save": "Salva",
        "Cancel": "Cancella",
        "dmc": "Booking board (DMC)",
        "corp": "Tabellone prenotazioni (CTM)",
        "Zone": "Zona",
        "dropOffZone": "Zona di scarico",
        "mDispatcher": "Partner",
        "streetSharing": "Condivisione stradale",
        "Driver_No_Job_found": "In attesa di assegnazioni...",
        "expandFilter": "Filtro",
        "collapseFilter": "Nascondi filtro",
        "clearSelectedItems": "elementi selezionati Cancella",
        "Accepted": "Accettato",
        "Yes": "Si",
        "No": "No",
        "Order_accepted": "Ordine accettato",
        "Confirmed": "Confermato",
        "spotTime": "Tempo di Spot",
        "ETA": "ETA",
        "spareTime": "Tempo Libero",
        "expectedTime": "Orario di ritiro previsto",
        "Driver_on_the_way_to_sender": "Autista in viaggio verso il mittente",
        "Driver_on_the_way_to_recipient": "Autista in viaggio verso il destinatario",
        "Driver_on_the_way_to_collect_cash": "Autista in viaggio per raccogliere contante",
        "Driver_on_the_way_to_collect_goods": "Autista in viaggio per ritirare la merce",
        "Arrived_waiting_for_sender": "Arrivato e in attesa del mittente",
        "Arrived_waiting_for_recipient": "Arrivato e in attesa del destinatario",
        "Arrived_waiting_to_collect_cash": "Arrivato e in attesa di ritirare contante",
        "Arrived_waiting_to_deliver_goods": "Arrivato e in attesa di consegnare merci",
        "Delivered": "Consegna",
        "delivery": "Consegna",
        "Service": "Servizio",
        "intercity": "Intercity",
        "Transport": "Trasporto",
        "About_Sender": "Informazioni sul mittente",
        "About_Merchant": "Informazioni sul commerciante",
        "About_Recipient": "Informazioni sul destinatario",
        "photos": "Foto",
        "listOfItems": "Elenco degli articoli",
        "cashOnPickUp": "COP",
        "Package_information": "Informazioni sul pacchetto",
        "otwMerchant": "Autista in viaggio verso il commerciante",
        "arrivedAndWaitingToCollectItem": "Arrivato e in attesa di ritirare l'oggetto",
        "Save_Filter": "Salva Filtro",
        "add_favorite_filter": "Aggiungi filtro",
        "favorite_filter_name": "Nome",
        "list_favorite_filter": "Gestisci filtri",
        "favorite_filter_actions": "Azione",
        "clear_all_filters": "Rimuovi tutti i filtri",
        "Delete_Filter": "Elimina Filtro",
        "CONFIRM_DELETE_FILTER_TEMPLATE": "Sei sicuro di voler eliminare questo filtro?",
        "batchDelivery": "Consegna in lotti",
        "editFare": {
            "creditTransactionFee": "Commissioni per carte di credito",
            "preferredAdjustment": "Regolazione preferita",
            "editFareFee": "Modifica tariffe e spese",
            "markupPrice": "Prezzo di markup",
            "quotedPrice": "Prezzo quotato",
            "basicFare": "Tariffa base",
            "preferredEarning": "Guadagno preferito",
            "difference": "Differenza",
            "rushHourFee": "Supplemento",
            "serviceFee": "Servizio aggiuntivo",
            "otherFees": "Altre spese",
            "subTotal": "Subtotale",
            "airportFee": "Tariffa aeroportuale",
            "meetDriverFee": "Incontra il conducente",
            "deliveryFee": "Spese di consegna",
            "tollFee": "Tariffa del pedaggio",
            "parkingFee": "Tariffa di parcheggio",
            "gasFee": "Commissione del gas",
            "techFee": "Quota tecnologica",
            "tip": "Consiglio",
            "bookingFee": "Commissione di prenotazione",
            "tax": "Tassa",
            "promoAmount": "Importo promozionale",
            "etaFare": "Totale",
            "fleetService": "Servizio flotte",
            "Note_serviceFee": "(per modificare il servizio aggiuntivo, visita l'elenco esterno)",
            "startingFee": "Inizio",
            "moveFeeInJourney": "Movimento",
            "waitFeeInJourney": "In attesa (in viaggio)",
            "total": "Totale",
            "totalPayout": "Pagamento",
            "updatedTotal": "Totale aggiornato",
            "updatedPayout": "Payout Aggiornato",
            "profit": "Profitto",
            "extraWaitFee": "Commissione di attesa iniziale",
            "heavyTraffic": "Traffico intenso",
            totalWithoutPromo: 'Total before promo',
        },
        "partialCompleted": "Parzialmente completato",
        "failed": "Fallito",
        "Recurring": "Ricorrente #",
        "DragAndDrop": "Trascina e rilascia per riordinare le colonne.",
        "bookingCom": "Booking.com",
        "syncingCompleted": "Sincronizzazione completata",
        "groupManifest": "Manifesto di Gruppo",
        "assignSuppliers": "Assegna Fornitori",
        "viewActions": "Visualizza Azioni",
        "holidaytaxis": "HolidayTaxis",
        "karhoo": "Karhoo",
        "klook": "Klook",
        "transferZ": "TransferZ",
        "pickupTime": "Pick-up time",
        "AssignSupplier": "Assegna Fornitore",
        "sharedTransfer": "Trasferimento Condiviso (%{id})",
        "batchDeliveryGroup": "Consegna in lotti (%{id})",
        "foundersFund": "Founders Fund",
        "zeroCommission": "Zero Commissione",
        "unassignDriver": "Disassociare Autista",
        "notUnassignDriver": "Impossibile disassociare il conducente, per favore riprova",
        "notAssignDriver": "Impossibile assegnare il conducente, per favore riprova",
        "selectDriver": "Seleziona Driver",
        "unassignVehicle": "Disassociare Veicolo",
        "unassignAll": "Disassegna Tutto",
        "notUnassignAll": "Impossibile disassociare tutto, per favore riprova",
        "unassignAllSuccess": "Il veicolo e il conducente sono stati scollegati con successo.",
        "unassign_all_partial": "Successo Parziale: La disassociazione del batch è fallita per i seguenti viaggi (ID di prenotazione) a causa di azioni in corso: {0}.",
        "notUnassignVehicle": "Impossibile disassociare il veicolo, per favore riprova",
        "notAssignVehicle": "Impossibile assegnare il veicolo, per favore riprova",
        "selectVehicle": "Seleziona Veicolo",
        "confirmUnassign": "Sei sicuro di voler disassociare?",
        "printMeetingBoard": "Stampa Lavagna Riunioni",
        "needReview": "Richiede revisione"
    },
    "trip": {
        "Driver_vehicle": "Veicolo del conducente",
        "tripId": "Viaggio #",
        "tripTypes": "Tipi di viaggio",
        "Start_Time": "Orario di inizio",
        "Seats_Status": "Stato dei posti",
        "No_Of_Booking": "Numero di prenotazioni",
        "Vehicle": "Veicolo del conducente",
        "Estimated_Fare": "Fare",
        "capacityStatus": "Stato del posto",
        "Trip_Types": "Tipi di viaggio",
        "scheduled": "Viaggi programmati",
        "requested": "Richiedi viaggi",
        "preferred": "Preferito",
        "All": "Tutti",
        "Confirmed": "Confermato",
        "Started": "Iniziato",
        "In_Transit": "In transito",
        "Empty": "Vuoto",
        "Partial_not_live": "Parziale - non in diretta",
        "Partial_live": "Parziale - dal vivo",
        "Full": "Completo",
        "Error_load_trip": "Impossibile caricare il viaggio, per favore riprova o aggiorna la pagina!"
    },
    "tripDetails": {
        "Trip_ID": "Viaggio intercity",
        "DRIVER_JOB": "Informazioni sul conducente",
        "BOOKINGS": "Prenotazioni",
        "updateTrip": "Aggiorna Viaggio",
        "cancelTrip": "Annulla Viaggio",
        "note_cancel": "Si prega di assegnare tutte le prenotazioni a un altro conducente prima di annullare questo viaggio.",
        "TRIP_INFORMATION": "Info Viaggio",
        "route": "Percorso",
        "startTime": "Start Time",
        "distance": "Distanza",
        "duration": "Durata",
        "fare": "Fare",
        "cartype": "Tipo di carrozza intercity",
        "seatStatus": "Stato del posto",
        "started": "Iniziato",
        "intransit": "In transito",
        "empty": "Vuoto",
        "notLive": "Parziale - non in diretta",
        "live": "Parziale - dal vivo",
        "full": "Completo",
        "noOfBooking": "Numero di prenotazione",
        "luggage": "Bagagli",
        "nameDriver": "Nome",
        "vehicleType": "Veicolo",
        "assignDriver": "Assegna conducente",
        "pickUpAddress": "Pick up",
        "destinationAddress": "Consegna",
        "customerName": "Nome",
        "customerPhone": "Telefono",
        "customerNumber": "Posti",
        "customerLuggageNumber": "Bagagli",
        "additionalService": "Servizi aggiuntivi",
        "paymentBooking": "Pagamento",
        "note": "Nota",
        "CONFIRM_UPDATE": "conferma aggiornamento",
        "CONFIRM_UPDATE_MESSAGE": "Sei sicuro di voler aggiornare questo viaggio?",
        "Yes": "Sì",
        "No": "No",
        "Update_info": "Sì, aggiorna info"
    },
    "newbooking": {
        "Addon_driver_capability": "This assignment does not fully meet the customer’s service requirements. Missing Requirements ({0})",
        "Search_Vehicle": "Cerca veicolo",
        "rideSharing_multi_point": "È consentito solo 1 punto di prelievo e 1 punto di rilascio per la prenotazione del ride sharing.",
        "Pick_up_time": "Pick up time",
        "Drop_off_time": "Orario di consegna",
        "All_Suppliers": "Tutti i fornitori",
        "Recipient": "Destinatario",
        "All": "Tutto",
        "New_Booking": "Nuova Prenotazione",
        "GoogleMapRoute": "Google Map",
        "BOOKING_INFORMATION": "INFORMAZIONI PRENOTAZIONE",
        "TIP_PROMO": "Mancia - Promozione",
        "Pick_up": "Indirizzo di partenza",
        "instructions": "Istruzioni",
        "instructions_placeholder": "Elenca le tue istruzioni qui...",
        "Enter_a_location": "Inserisci località",
        "Enter_a_location_delivery": "Inserisci località",
        "Enter_3rd_party_location": "Inserisci localizzazione terzo",
        "Enter_a_sender": "Inserisci un Mittente",
        "Enter_a_recipient": "Inserisci un Destinatario",
        "Vehicle_Selection": "Selezione del Veicolo",
        "Destination": "Luogo appuntamento/destinazione",
        "Pickup_time": "Data e ora di partenza",
        "Note": "Nota",
        "note_for_driver": "Nota per il conducente",
        "affiliate_note": "Nota per l'affiliato",
        "affiliate_note_placeholder": "Inserisci note affiliate per gli operatori",
        "operator_note": "Inserisci note interne per gli operatori",
        "TRAVELER_INFORMATION": "INFORMAZIONI VIAGGIATORE",
        "Traveler_type": "Tipo viaggiatore",
        "Individual": "Singolo autista",
        "Corporation": "Azienda",
        "Phone_number": "Numero di telefono",
        "First_name": "Nome",
        "Last_name": "Cognome",
        "Email_address": "Indirizzo email",
        "Corp_id": "Note",
        "Manager_name": " P.IVA/Cod.Fisc",
        "Manager_email": "Codice Univoco ",
        "Cost_centre": "@PEC",
        "Department": "Ragione sociale",
        "Corp_division": "Indirizzo",
        "Tip": "Mancia",
        "Promo_code": "Codice promozionale",
        "Apply": "Applica",
        "Promo": "Promozione:",
        "DISPATCH": "Assegnazione",
        "Auto_dispatch": "Assegnazione automatica",
        "Assign_driver": "Assegna Autista",
        "FarmOut": "Farm-out",
        "Driver": "Autista",
        "Driver_Supplier": "Fornitore/Autista",
        "PAYMENT_METHOD": "MEZZO DI PAGAMENTO",
        "OPERATOR_NOTE": "Note interne",
        "TRIP_ESTIMATE": "STIMA DEL VIAGGIO",
        "Choose_a_stored_card": "Scegli una carta in memoria",
        "Choose_a_payment_method": "Scegli un metodo di pagamento",
        "Use_new_card": "Usa nuova carta",
        "Card_holder": "Nome titolare carta",
        "Card_number": "Numero carta",
        "Expired_date": "Data di sczdenza (mm/yy)",
        "ccv": "CVV",
        "Distance": "Distanza",
        "Duration": "Durata",
        "Fare": "Tariffa",
        "Route": "Strade",
        "Create": "Salva",
        "Cancel": "Cancella",
        "Meet_driver": "Incontra l’autista",
        "Airline": "Compagnia aerea",
        "Flight": "Volo #",
        "FLY_INFO": "INFORMAZIONI SUL VOLO",
        "Ride_Sharing": "Condividi-viaggio",
        "Round_trip": "Andata e ritorno",
        "Car_type": "Tipo di macchina",
        "Address": "Indirizzo",
        "City": "Città",
        "State": "Stato",
        "Zip_code": "Cap",
        "Remove": "Rimuovi",
        "Client_case_matter": "descrizione del viaggio",
        "Charge_code": "codice corsa",
        "CANCEL_BOOKING": "CLOSE BOOKING CONFIRM",
        "CANCEL_BOOKING_CONFIRM": "Vuoi lasciare questa pagina? Perdere tutti i dettagli della prenotazione.",
        "Search_here": "Cerca qui",
        "No_support_location": "Sfortunatamente il servizio non é disponibile in quest'area",
        "Closest_driver_message": "L'autista più vicino é approssimativamente a {0}",
        "No_cars_available": "Nessun mezzo disponibile in questo momento.",
        "processed_by_affiliate": "La tua richiesta verrà processata dai nostri partners affiliati",
        "FlightExample": "Volo #, e.g AA1097",
        "Yes": "Si",
        "No": "No",
        "dispatch_3rd": "Spedizione tramite terze parti",
        "Company": "Azienda",
        "Card_required": "Per favore seleziona o aggiungi una carta!!",
        "Tip_value": "N/A",
        "Calendar": "Calendario",
        "Extra_Destination": "Destinazione aggiuntiva",
        "Driver_credit_limited_balance_warning": "Il saldo dell'autista é inferiore o uguale all'importo limitato",
        "Meet_Greet_option": "Incontra & Saluta",
        "On_Curb_option": "Trattenuto",
        "Extra_Services": "Servizi aggiuntivi",
        "Addl_Services": "Add'l Services",
        "Save": "Salva",
        "Regular": "Regolare",
        "Please_fill_in_all_the_required_fields": "Si prega di compilare tutti i campi obbligatori.",
        "Route_names_not_dup": "I nomi delle route non devono essere duplicati.",
        "Please_select_weekdays": "Si prega di selezionare i giorni di ripetizione in cui si desidera che questa prenotazione si verifichi.",
        "Flat_rate": "Tariffa fissa",
        "All_company": "Tutta l'azienda",
        "Best_price": "miglior prezzo",
        "PromoTitle": "Promozione",
        "Show_more": "Mostra di più",
        "Warning_pending_payment": "Questo cliente ha un pagamento incompleto per prenotazioni passate: %{fare}",
        "Warning_outstanding_balance": "Il saldo residuo sarà applicato al termine del viaggio.",
        "Not_available": "Non disponibile",
        "Warning_assigned_rate": "Si prega di impostare e assegnare la tariffa per il tipo di auto selezionata per continuare.",
        "PaxLuggageNumber": "Numero passeggero/bagaglio",
        "paxNumber": "Passeggero",
        "luggageNumber": "Bagagli",
        "Date": "Data",
        "Single": "Singolo",
        "Recurring": "Ricorrente",
        "Date_range": "Date Range",
        "WeekDays": "Ripeti nei giorni",
        "Create_Route": "Crea Percorso",
        "Pickup_Point": "Pick-up",
        "Drag_To_Render": "Trascina e rilascia per riordinare",
        "DropOff_Point": "Punti di consegna",
        "Sender": "Mittente",
        "Recipients": "Destinatari",
        "Sender_Infomation": "Informazioni sul mittente",
        "Recipient_Infomation": "Informazioni sul destinatario",
        "Recipient_Name": "Nome del destinatario *",
        "Recipient_Phone": "Numero di telefono *",
        "Room_floor_block": "Stanza, piano e blocco (opzionale)",
        "Details": "Dettagli",
        "Package_Content": "Contenuto del pacco *",
        "Order_ID": "Ordine # (ad es. ordine shopify #)",
        "Instructions_for_driver": "Istruzioni per il conducente",
        "Cost_of_Goods": "Contrassegno (COD)",
        "Enter_amount": "Inserisci l'importo",
        "Additional_Information": "Informazioni aggiuntive",
        "Insurance": "Assicurazione",
        "Special_Care": "Cura Speciale",
        "Delivery_Fee": "Spese di consegna",
        "Item_fees": "Commissioni per articolo",
        "Tech_Fee": "Quota Tecnologica",
        "Tax": "Tassa",
        "driverNotes": "Note del conducente",
        "rejectModal": "Rifiuta prenotazione",
        "rejectModalBody": "Sei sicuro di voler rifiutare questa prenotazione?",
        "rejectButton": "Rifiuta prenotazione",
        "acceptModal": "Accetta prenotazione",
        "acceptModalBody": "Sicuro di voler accettare questa prenotazione?",
        "ConfirmedTo": "Confermato a ({0})",
        "proceedAction": "Sei sicuro di voler procedere con questa azione?",
        "acceptButton": "Accetta prenotazione",
        "denyModal": "Nega prenotazione",
        "denyModalBody": "Sicuro di voler rifiutare questa prenotazione?",
        "denyButton": "Nega prenotazione",
        "Accept_booking_success": "La prenotazione è stata accettata con successo!",
        "Deny_booking_success": "La prenotazione è stata negata con successo!",
        "adjustFare": "Regola tariffa",
        "totalFare": "Tariffa Totale",
        "Profit": "Profitto",
        "DriverEarning": "Guadagni del conducente",
        "Payout": "Pagamento",
        "totalPayout": "Pagamento totale",
        "DriverPayOut": "Driver Payout",
        "confirmReject": "Conferma Rifiuto",
        "confirmCancelMSG": "Sei sicuro di voler rifiutare questa prenotazione? Potresti incorrere in una penale da parte del tuo fornitore.",
        "reasonCancel3rd": "Motivo di rifiuto",
        "welcome_psg": "Benvenuto passeggero",
        "AmountDue": "Importo Dovuto",
        "Fleet_Company": "Flotta",
        "Search_driver_hydra": "Proveremo a trovarti un autista presto.",
        "ExternalID": "ID esterno",
        "viewRate": "Percentuale di visualizzazione",
        "PointToPoint": "Da punto a punto",
        "Offer_driver": "Offerta Autista",
        "Assign_driver_vehicle": "Assegna Autista / Veicolo",
        "notify_via_email": "Notifica il cliente via email",
        "fleetFare": "Tariffa Flotta",
        "onlySave": "Salva",
        "saveCharge": "Salva e Carica",
        "saveRefund": "Salva e Rimborso",
        "lateCancelConfirm": "Sicuro di voler completare questa prenotazione come",
        "canceledDriverConfirm": "Sei sicuro di voler annullare questa prenotazione per il conducente? Verrà applicata una penale.",
        "canceledDriverNoChargeConfirm": "Sei sicuro di voler annullare questa prenotazione per il conducente?",
        "canceledCustomerNoChargeConfirm": "Sicuro di voler contrassegnare questo cliente come un",
        "noshowDriverConfirmCharge": "Sei sicuro di voler contrassegnare il conducente come assente? Potrebbe essere applicata una penale.",
        "noshowDriverConfirmNoCharge": "Are you should you want to mark this customer as a no show?",
        "NoShowConfirm": "La politica di mancata presentazione sarà applicata.",
        "completeConfirm": "Sei sicuro di voler completare senza driver?",
        "completeChargeConfirm": "Il costo totale sarà addebitato al cliente. Il conducente non riceverà alcuna commissione da questa prenotazione.",
        "PricingPlan": "Piano di Prezzi",
        "editFerviceFees": "per modificare le tariffe di servizio, visita l'elenco esterno",
        "ungroupAll": "Separare Tutto",
        "satisfaction": "soddisfazione",
        "Reassign": "Riassegnare",
        "addNote": "Aggiungi nota",
        "noteMagicSend": "Seleziona la bacchetta magica o digita [ per accedere istantaneamente ai suggerimenti delle parole chiave di prenotazione.",
        "items": "Articoli",
        "PaidAmount": "Importo Pagato",
        "ExternalPartner": "Partner Esterno",
        "ExternalPartnerNote": "Partner indipendenti che gestiscono i propri autisti e veicoli. I pagamenti vengono gestiti direttamente con il fornitore.",
        "InHousePartner": "Partner interno",
        "InHousePartnerNote": "Gestito direttamente dalla tua flotta. I pagamenti vengono effettuati direttamente ai conducenti.",
        "Role": "Ruolo",
        "Client": "Cliente",
        "ApplyCancellation": "Applica la politica di cancellazione",
        "unassigned": "non assegnato",
        "bookingSelected": "prenotazione selezionata",
        "Update": "Aggiornamento",
        "emailInvoice": "Fattura Email",
        "Receipt": "Ricevuta",
        "addItem": "Aggiungi Articolo",
        "newCustomer": "Aggiungi Nuovo Cliente",
        "forGuest": "Prenota per l'ospite",
        "invalid_some_field": "Campo non valido, per favore controlla e riprova.",
        "ExpandCorp": "Espandi Dettagli Aziendali",
        "hideCorp": "Nascondi dettagli aziendali",
        "searchCusPlaceholder": "Cerca per nome contatto, telefono, email",
        "CorporationGuest": "Corporazione - Ospite",
        "IndividualGuest": "Individuale - Ospite",
        "passInfo": "Informazioni Passeggero",
        "noAdjustmentPickupTime": "Nessuna modifica all'orario di ritiro",
        "whenFlightArrives": "Quando il volo arriva",
        "minAfterArrival": "{0} min dopo l'arrivo del volo",
        "pickupInstructions": "Istruzioni per il ritiro",
        "selectMeetingPoint": "Seleziona il Punto di Incontro per il Ritiro",
        "durationTrip": "Durata (Ore)"
    },
    "bookingDetailLogs": {
        "recipient": "Destinatario",
        "updatedInfo": "Info aggiornate",
        "updatedField": "Campo aggiornato",
        "valueBefore": "Valore precedente",
        "valueAfter": "Valore dopo",
        "location": "Posizione",
        "etaFare": "Fare",
        "dispatchType": "Spedizione",
        "drvInfo": "Driver",
        "meetingPoint": "Punto di incontro",
        "vehicleTypeRequest": "Richiesta di Veicolo",
        "clientCaseMatter": "Descrizione del viaggio",
        "chargeCode": "Codice viaggio",
        "driverEarningType": "Tipo di Guadagno del Conducente",
        "editedDriverEarning": "Guadagno del conducente",
        "reasonEditFare": "Motivo",
        "bookingReference": "ID esterno",
        "tip": "Consiglio",
        "type": "Tipo di servizio",
        "promo": "Promo",
        "dispatch3rd": "Invia 3°",
        "rideSharing": "Condivisione di corse",
        "notes": "Note del conducente",
        "operatorNote": "Note interne",
        "welcomeMessage": "Messaggio di Benvenuto",
        "flightNumber": "Numero di Volo",
        "fullName": "Nome completo",
        "email": "Email",
        "cardMask": "Maschera della carta",
        "paymentType": "Metodo di pagamento",
        "recipients": "Destinatari",
        "sender": "Mittente",
        "pickupName": "Nome del ritiro",
        "pickupPhone": "Telefono di ritiro",
        "pickupEmail": "Email di ritiro",
        "supplierEarningType": "Tipo di pagamento",
        "editedSupplierEarning": "Valore di pagamento",
        "route": "Nome del percorso",
        "markupDifference": "Differenza di markup",
        "selectedDates": "Date Selezionate",
        "services": "Servizi di flotta",
        "destinationAddress": "Posizione di destinazione",
        "pickupAddress": "Luogo di ritiro",
        "tripType": "Tipo di viaggio",
        "pickUpTime": "Orario di ritiro",
        "paxNumber": "Passeggero",
        "luggageNumber": "Bagagli",
        "vehicle": "Veicolo",
        "minutesToArrive": "Arrivo previsto del conducente",
        "affiliateNote": "Nota Affiliato",
        "packageRateName": "Nome del pacchetto",
        "supplierCompanies": "Azienda",
        "puPoints": "Luogo di ritiro",
        "doPoints": "Posizione di destinazione",
        "promoValue": "Valore promozionale",
        "packageInfo": "Informazioni sul pacchetto",
        "orderId": "Id Ordine",
        "cashOnDelivery": "Contrassegno",
        "externalId": "Id Esterno",
        "recurring": "Ricorrente",
        "batchDelivery": "Consegna in lotti",
        "payout": "Pagamento",
        "locationDetails": "Dettagli sulla posizione",
        "name": "Nome",
        "phone": "Telefono",
        "address": "Indirizzo",
        "basicFare": "Tariffa base",
        "airportFee": "Tariffa aeroportuale",
        "bookingFee": "Commissione di prenotazione",
        "creditTransactionFee": "Commissioni per carte di credito",
        "fleetService": "Servizio flotte",
        "fleetServices": "Servizi per la flotta",
        "gasFee": "Commissione del gas",
        "meetDriverFee": "Tariffa per incontro con il conducente",
        "moveFeeInJourney": "Spese di trasloco",
        "otherFees": "Altra tassa",
        "parkingFee": "Tariffa di parcheggio",
        "promoAmount": "Importo promozionale",
        "rushHourFee": "Tariffa per l'ora di punta",
        "serviceFee": "Commissione di servizio",
        "startingFee": "Quota di iscrizione",
        "subTotal": "Subtotale",
        "tax": "Tassa",
        "techFee": "Quota tecnologica",
        "tollFee": "Tariffa di pedaggio",
        "waitFeeInJourney": "Commissione di attesa (in viaggio)",
        "psgPhone": "Telefono del passeggero",
        "totalAddonFee": "Addon fee",
        "addonServices": "Addon services"
    },
    "bookingdetail": {
        "RefreshFare": "Aggiorna tariffa",
        "noShowAction": "Azione di No-Show",
        "noShowClose": "Applica No-show e Chiudi Prenotazione",
        "noShowNotClose": "Applica No-show e Disassegna",
        "cancelAction": "Annulla azione",
        "cancelClose": "Applica Annulla e Chiudi Prenotazione",
        "cancelNotClose": "Applica Annulla e Disassegna",
        "settings": "Impostazioni",
        "updateSuccessJobVisibilitySingle": "Visibilità aggiornata con successo",
        "updateSuccessJobVisibilityMulti": "%{number} prenotazioni sono state aggiornate con successo",
        "failApi": "Qualcosa è andato storto!",
        "settingsTooltip": "Autista già assegnato o viaggio attualmente in corso.",
        "shareJobPublicly": "Condividi lavoro pubblicamente",
        "groupOder": "Ordine di gruppo",
        "ExistingGroup": "Gruppo Esistente",
        "NewGroup": "Nuovo Gruppo",
        "Search_trip": "Cerca viaggio #",
        "All": "Tutti",
        "creditTransactionFee": "Commissioni sulle carte di credito",
        "partial_payment": "Pagamento parziale",
        "Write_off_debt": "Annulla il debito",
        "Booking_detail": "Dettagli prenotazione",
        "Order_detail": "Ordine",
        "Completed_Booking": "Prenotazione completata",
        "Late_Cancel_Passenger": "Cancellazione tardiva da parte del passeggero",
        "Late_Cancel_Driver": "Cancellazione tardiva da parte del conducente",
        "No_Show_Passenger": "Passeggero non presentato",
        "No_Show_Driver": "Autista non presente",
        "Late_Cancel": "Cancellazione tardiva",
        "Cancel_Driver": "Annulla dal conducente",
        "No_Show": "Nessuna presentazione",
        "Without_driver": "Completo senza driver",
        "Complete_driver": "Completo di conducente",
        "BOOKING_INFORMATION": "INFORMAZIONI PRENOTAZIONE",
        "TIP_PROMO": "Mancia - Promozione",
        "Rearrange_Column": "Riorganizza Colonna",
        "Pick_up": "Appuntamento*",
        "Enter_a_location": "Inserisci località",
        "Destination": "Destinazione",
        "Pickup_time": "Data e ora di partenza",
        "Notes": "Note",
        "TRAVELER_INFORMATION": "INFORMAZIONI VIAGGIATORE",
        "Traveler_type": "Tipo viaggiatore",
        "Individual": "Singolo autista",
        "Corporation": "Azienda",
        "Phone_number": "Numero di Telefono",
        "First_name": "Nome",
        "Last_name": "Cognome",
        "Email_address": "Indirizzo email",
        "Corp_id": "Note",
        "Manager_name": " P.IVA/Cod.Fisc",
        "Manager_email": "Codice Univoco ",
        "Cost_centre": "@PEC",
        "Department": "Ragione sociale",
        "Corp_division": "divisione Società",
        "Tip": "Mancia",
        "Promo_code": "Codice promozionale",
        "Apply": "Applica",
        "Promo": "Promozione",
        "DISPATCH": "Assegnazione",
        "Auto_dispatch": "Assegnazione automatica",
        "Assign_driver": "Assegna autista",
        "Driver": "Autista",
        "PAYMENT_METHOD": "SELEZIONA UN TIPO DI PAGAMENTO",
        "Payment_methods": "Mezzo di Pagamento",
        "pending_payment": "Pagamento in sospeso",
        "TRIP_ESTIMATE": "STIMA DEL VIAGGIO",
        "Choose_a_stored_card": "Scegli una carta in memoria",
        "Choose_a_payment_method": "Scegli un metodo di pagamento",
        "OPERATOR_NOTE": "Note interne",
        "Use_new_card": "Usa nuova carta",
        "Card_holder": "Titolare carta",
        "Card_number": "Numero carta",
        "Expired_date": "Data di sczdenza (mm/yy)",
        "ccv": "CVV",
        "Distance": "Distanza",
        "Duration": "Durata",
        "Fare": "Tariffa",
        "Route": "Strada",
        "Meet_driver": "Incontra l’autista",
        "Airline": "Compagnia aerea",
        "Flight": "Volo",
        "FLY_INFO": "Informazioni sul volo",
        "Ride_Sharing": "Condividi-viaggio",
        "Round_trip": "Andata e ritorno",
        "Car_type": "Tipo di macchina",
        "Address": "Indirizzo",
        "City": "Città",
        "State": "Stato",
        "Zip_code": "Cap",
        "Remove": "Rimuovi",
        "New_Booking": "Nuova Prenotazione",
        "Clone_Booking": "Prenotazione Clone",
        "New_Order": "New Order",
        "ViewTrackLink": "View track link",
        "driverLink": "Collegamento driver",
        "ClickCopy": "Clicca per copiare il link",
        "meetingBoard": "Incontro \n Consiglio",
        "ViewLog": "View dispatch logs",
        "Message": "Messaggio",
        "Update_Booking": "Aggiorna Prenotazione",
        "Cancel_Booking": "Cancella Prenotazione",
        "Complete_with_payment": "Completa con pagamento",
        "Incident": "Incidente",
        "CONFIRM_CANCEL": "CONFERMI LA CANCELLAZIONE",
        "CONFIRM_CANCEL_MESSAGE": "Sei sicuro di voler cancellare la prenotazione?",
        "CONFIRM_UPDATE": "CONFERMA AGGIORNAMENTO",
        "CONFIRM_UPDATE_MESSAGE": "Sei sicuro di volere aggiornare questa prenotazione?",
        "CONFIRM_RESET_EDIT_FARE_MESSAGE": "La tua tariffa modificata è stata ripristinata, ti preghiamo di rivederla prima di continuare.",
        "Close": "Vicino",
        "Update_info": "Informazioni aggiornamento",
        "Update_info_dispatch": "Informazioni aggiornamento & assegnazione",
        "Update_info_tooltip": "Se vuoi riassegnare questa prenotazione a un nuovo autista, seleziona \"Sì, aggiorna informazioni e spedizione",
        "BOOKING": "presente",
        "DROPPED_OFF": "scaricato",
        "Payment_Type": "Tipo pagamento",
        "Total": "Totale",
        "Next": "Prossimo",
        "Pay_here": "Paga qui",
        "Complete_booking": "Completa prenotazione",
        "Complete_booking_tooltip": "Si prega di fare clic su \"Aggiorna prenotazione\" per salvare le modifiche prima di continuare.",
        "Cancel": "Cancella",
        "Back": "Indietro",
        "Tax": "Tassa",
        "Booking_fees": "Spese di prenotazione",
        "Tech_fees": "Spese tecniche",
        "Subtotal": "Subtotale",
        "Other_fees": "Altre spese",
        "Waiting_fee": "Quota di attesa",
        "Toll_fees": "Tariffe di pedaggio",
        "Heavy_traffic": "Traffico intenso",
        "Rush_hour": "Sovraccarico",
        "Basic_fare": "Tariffa base",
        "Ok": "Ok",
        "Input_reason": "Inserisci ragione",
        "Client_case_matter": "Fascicolo cliente / Descrizione del viaggio",
        "Charge_code": "Codice di carica / Codice di viaggio",
        "Enter_3rd_party_location": "Inserisci localizzazione terzo",
        "Company": "Azienda",
        "Check_promo_error": "Verifica errore codice promozionale!",
        "Add_new_credit_error": "Aggiungi nuovo errore credito!",
        "Can_not_get_fare_setting": "Impossibile ottenere impostazioni tariffa!",
        "Can_not_get_affilate_fare_setting": "Impossibile ottenere impostazioni tariffa dell'Affiliato!",
        "Can_not_check_commisson": "impossibile verificare commissione!",
        "No_flight_info": "Nessuna informazione sul volo!",
        "Socket_server_disconnected": "Server socket disconnesso!",
        "Please_reload_page_or_check_your_connection": "Mi dispiace. La tua richiesta non può essere elaborata. Per favore riprova.",
        "View_Logs": "Visualizza registri",
        "Bookingid": "Prenotazione #",
        "Calendar": "Calendario",
        "Extra_Destination": "Destinazione aggiuntiva",
        "Meet_Greet_option": "Incontra & Saluta",
        "On_Curb_option": "Trattenuto",
        "Credit_Card": "Carta di credito",
        "Charge": "Addebita",
        "No_charge": "Trattenuto = nessun addebito",
        "QR_Code_method_not_allow_error_message": "Si prega di selezionare un altro tipo di pagamento poiché il QRCode non è disponibile per pagare sul dashboard!",
        "change_payment_method_note": "Se vuoi cambiare metodo di pagamento ritorna al formulario di prenotazione.",
        "Airport_Fee": "Tariffa aeroporto",
        "Addi_service": "Servizi Supplementari",
        "Additional_Services": "Servizi Supplementari",
        "Minimum": "Minimo",
        "Search_here": "Cerca qui",
        "No_Driver_Yet": "Nessun conducente assegnato ancora",
        "Personal_Card": "Carta personale",
        "Reject_booking": "Rifiuta Prenotazione",
        "Confirm_reject": "Conferma rifiuto",
        "Confirm_reject_message": "Sei sicuro di voler rifiutare questa prenotazione?",
        "Confirm_reject_booking_with_charge": "Ti verrà addebitato il {0}% della tariffa quotata in base alla nostra politica di cancellazione. Sei sicuro di voler rifiutare questa prenotazione?",
        "Yes": "Si",
        "No": "No",
        "shortTrip": "breve viaggio",
        "Add_new_card": "Aggiungi carta",
        "Require_customer_info": "Inserisci le informazioni del cliente per continuare.",
        "Require_corp_info": "Si prega di inserire le informazioni aziendali per continuare.",
        "Require_corp_customer_info": "È necessario fornire informazioni sull'utente per creare una nuova carta.",
        "confirm_force_overlap": "Conferma",
        "confirm_force_overlap_message": "Questa prenotazione si sovrappone alle prenotazioni accettate dal conducente. Sei sicuro di volerla assegnare a questo conducente?",
        "select": "Seleziona",
        "PICKUP_TIME_RANGE": "Ritiro stimato alle {0}",
        "food": "Cibo",
        "mart": "Mart",
        "Order_summary": "Riepilogo dell'Ordine",
        "addOnPrice": "Prezzo rettificato",
        "applicableFee": "Totale (applicabile)",
        "itemValue": "Valore dell'oggetto",
        "promotion_note_paymentMethod": "Questo ordine sta applicando un codice promozionale con metodo di pagamento limitato: %{method}.",
        "promotion_note_minimum_fare": "Questo ordine sta applicando un codice promozionale con tariffa minima limitata: %{fare}.",
        "promotion_note_schedules": "Questo ordine sta applicando un codice promozionale con tempo di ritiro limitato.",
        "edited_fare_note": "Questi sono i registri di adeguamento delle tariffe solo per riferimento. Si prega di visitare i rapporti per controllare la tariffa e la commissione finali.",
        "view_good_receipt": "Visualizza ricevuta merci",
        "confirmRemoveGroupTransport": "Sicuro di voler rimuovere la prenotazione attuale da questo manifesto?",
        "confirmRemoveGroupDelivery": "Sei sicuro di voler rimuovere la prenotazione attuale da questo gruppo?",
        "confirmUngroupTransport": "Sei sicuro di voler dissociare tutte le prenotazioni da questo manifesto?",
        "confirmUngroupDelivery": "Sei sicuro di voler dissociare tutte le prenotazioni da questo gruppo?",
        "view_delivery_receipt": "Visualizza foto di consegna",
        "select_time": "Seleziona ora",
        "InputReason": "Motivo di input",
        "viewOrder": "Visualizza ordine",
        "markFailed": "Contrassegna come fallito",
        "corporateName": "Nome dell'azienda",
        "sendMessage": "Invia Messaggio",
        "AmountDueBefore": "Importo Dovuto Prima",
        "AmountDueAfter": "Importo Dovuto Dopo",
        "chargeCustomer": "Addebita Cliente",
        "pending": "Non Pagato",
        "refundPayment": "Rimborsa Cliente",
        "refundableAmount": "Importo rimborsabile",
        "refundReason": "Aggiungi motivo di rimborso",
        "refundBtn": "Rimborso {0}",
        "partial": "Parziale",
        "paid": "Pagato",
        "ViewPaymentLogs": "View payment logs",
        "pmActivity": "Attività di Pagamenti",
        "paidStatus": "Stato pagato",
        "paymentLog": "Registro dei pagamenti",
        "extraWaitFee": "Commissione di attesa iniziale",
        "extraWaitTime": "Tempo di attesa (Iniziale)",
        "copied": "Copiato",
        "warnningCancelCorporate": "Si prega di notare che potrebbe essere addebitato un importo in conformità con la nostra politica di cancellazione.",
        "customerAdjustments": "Regolazioni del Cliente",
        "customerAdjustmentsTooltip": "Regolazioni del Cliente",
        "supplierDriverAdjustments": "Regolazioni Fornitore/Autista",
        "updateSummary": "Riepilogo Aggiornamento",
        "orderDetails": "Dettagli dell'Ordine",
        "saveAndSendEmail": "Salva e Invia Ricevuta Elettronica",
        "pastDetacted": "Prenotazione Passata Rilevata",
        "pastDetactedContent": "Stai per creare una prenotazione nel passato",
        "DriverSupplier": "Autista/Fornitore",
        "supplierCancelCharge": "Attenzione: Penale di Cancellazione",
        "supplierCancelNoCharge": "Conferma Cancellazione",
        "supplierCancelChargeBody": "Sei sicuro di voler annullare la prenotazione?",
        "willChargedPenalty": "Ti verrà addebitata una penale di {0}.",
        "noChargedPenalty": "Questa è una cancellazione gratuita, non verrà addebitata alcuna penale.",
        "errorGetToken": "Impossibile ottenere il token, per favore riprova più tardi",
        "unlinkFlight": "Disconnetti Volo",
        "unlinkFlightBody": "Attenzione! Cambiare l'orario di ritiro disconnetterà i dettagli del volo e rimuoverà il numero del volo."
    },
    "map": {
        "AWS_map_hint": "Suggerimento: Premi Invio o Esc per terminare il disegno.",
        "Apple_map_hint": "Suggerimento: Premi e tieni premuto per trascinare e ridimensionare il poligono.",
        "Enter_a_location": "Inserisci una località",
        "All_company": "Tutta l'azienda",
        "All_cars": "Tutte le macchine",
        "Show_all_cars": "Mostra tutte le auto",
        "Hide_all_cars": "Nascondi tutte le auto",
        "Vacant": "Libero",
        "Dispatching": "Assegnazione",
        "Driver_on_the_way": "Autista in arrivo",
        "Arrived_and_waiting": "Arrivato e in attesa",
        "P_O_B": "P.A.B.",
        "Dropped_off": "Scaricato",
        "Waiting_for_process": "In attesa di trattazione",
        "Unavailable": "Indisponibile",
        "Total_Drivers": "Totale conducenti",
        "Estimate": "Stima",
        "Destination": "Destinazione",
        "Pickup": "Indirizzo di partenza",
        "Start_point": "Punto di partenza",
        "Passenger": "Passeggeri",
        "Driver_name": "Nome autista",
        "Search_car_here": "Cerva vettura qui",
        "Error_load_booking": "Impossibile caricare la prenotazione, Per favore riprova o ricarica la pagina!",
        "Show_all": "Mostra tutto",
        "BookCardInfo": "Informazioni sulla Carta di Prenotazione",
        "drvPhoneNo": "Numero di telefono del conducente",
        "vhcPhoneNo": "Numero di telefono del veicolo",
        "driversLiveMap": "Mappa dei conducenti",
        "heatMap": "Mappa della domanda",
        "Trip": "Viaggio",
        "traffic": "Traffico",
        "bicyclingLayers": "Ciclismo",
        "layer": "Dettagli",
        "trafficBicycling": "Traffico, Ciclismo",
        "All_airline": "Tutte le compagnie aeree"
    },
    "customer": {
        "Customers": "Clienti",
        "Points": "Punti",
        "Migration_Status": "Stato di Migrazione",
        "ADD_CUSTOMER": "Aggiungi cliente",
        "EDIT_CUSTOMER": "Modifica Cliente",
        "Add": "Aggiungi",
        "Activate": "Attivare.",
        "Deactivate": "Disattivato",
        "Delete": "Elimina",
        "Import": "Importa",
        "Download_template": "Scarica il modello",
        "View_Message": "Messaggio",
        "Send_Message": "Messaggio",
        "Export_to_excel": "Esporta su excel",
        "Filter": "Filtro",
        "Apply": "Applica",
        "Clear": "Pulisci",
        "Name": "Nome",
        "Phone_Number": "Numero di telefono",
        "Email": "Email",
        "Vip": "Vip",
        "companies": "Azienda",
        "File": "Documento",
        "Number_successful_imports": "Numero di importazioni riuscite:",
        "Number_skipped": "Numero di saltati:",
        "Number_duplicate_phone_numbers": "Numero di numeri di telefono duplicati:",
        "Number_wrong_phone_numbers": "Numero di numeri di telefono errati:",
        "Corporate_Name": "Azienda",
        "Registered_From": "Registrato da",
        "Registration_Date": "Data di registrazione",
        "Registration_date_from": "Data di registrazione da ",
        "Registration_date_to": "Data di registrazione a",
        "IOS_Last_Login_Version": "IOS Versione ultima connessione",
        "Android_Last_Login_Version": "Android Versione ultima connessione",
        "Last_Active_Date": "Ultima data attiva",
        "Verification": "Verifica",
        "Support_ID": "ID di supporto",
        "Days_Since_Last_Active": "Giorni dall'ultima data attiva",
        "Completed_Bookings": "Prenotazioni completate",
        "Outstanding_amount": "Importo residuo",
        "Status": "Stato",
        "Actions": "Azioni",
        "Action": "Azioni",
        "Inactive": "Inattivo",
        "Active": "Attivo",
        "Edit": "Modifica",
        "View": "Mostra",
        "ALERT_SELECT_ACTIVATE": "Per favore seleziona cliente da attivare.",
        "ALERT_SELECT_DEACTIVATE": "Per favore seleziona cliente da disattivare.",
        "ALERT_SELECT_DELETE": "Per favore seleziona cliente da eliminare.",
        "CONFIRM_DELETE": "Sei sicuro di voler eliminare questo account? Il cliente può registrare un nuovo profilo con dati vuoti dopo la rimozione dell'account.",
        "CONFIRM_DELETE_MULTI": "Vuoi eliminare questi clienti? ** Solo i clienti che sono inattivi e non sono utilizzatori registrati della app possono essere eliminati.",
        "CONFIRM_DEACTIVATE_MULTI": "Vuoi disattivare questi clienti?",
        "CONFIRM_ACTIVATE_MULTI": "Vuoi attivare questi clienti?",
        "CONFIRM_EXPORT_TO_EXCEL": "Sei sicuro di voler esportare tutti i dati come file .xlsx?",
        "Add_card_top_up_success": "La carta prepagata è stata ricaricata con successo.",
        "Add_card_success": "Carta personale aggiunta con successo!",
        "Add_customer_success": "Il Cliente é stato aggiunto con successo",
        "Update_customer_success": "Il Cliente é stato aggiornato con successo",
        "Deleted_customer_success": "Il cliente è stato eliminato con successo",
        "Create_customer_fail": "Impossibile creare cliente",
        "Update_customer_fail": "Impossibile aggiornare cliente",
        "ERROR_EXISTED_PHONE": "Questo telefono esiste già nel sistema. Per favore inseriscine un altro.",
        "ERROR_INPUT_FIRSTNAME": "Per favore inserisci nome.",
        "ERROR_INPUT_PHONE": "Per favore inserisci numero di telefono.",
        "ERROR_INPUT_VALIDPHONE": "Per favore inserisci un numero di telefono valido.",
        "ERROR_INPUT_VALIDEMAIL": "Per favore inserisci una email valida.",
        "CONFIRM_DELETE_CARD": "Sei sicuro di voler cancellare queste carte?",
        "First_name": "Nomee",
        "Last_name": "Cognome",
        "Phone_number": "Numero di telefono",
        "Email_address": "Indirizzo email",
        "Notes": "Appunti",
        "Account": " Conto",
        "Card_management": "Gestione carta",
        "Home": "Casa",
        "Affiliate": "Affiliato",
        "SHOW_PERSONAL_CARD": "mostra carta personale",
        "ADD_PERSONAL_CARD": "Aggiungi carta personale",
        "SHOW_mDISPATCHER_CARD": "MOSTRA CARTA mDISPATCHER",
        "ADD_mDISPATCHER_CARD": "Aggiungi carta mdispatcher",
        "Personal_card": "Carta personale",
        "mDispatcher_card": "Carta mDispatcher",
        "Card_holder": "Titolare carta ",
        "Card_number": "Numero carta",
        "Credit_type": "Tipo di credito",
        "Credit_code": "Codice di credito",
        "Sms_verification": "Verifica SMS",
        "Sms_verification_placeholder": "Inserisci il codice di verifica",
        "Expired_date": "Data scadenza ",
        "CVV": "CVV",
        "Address": "Indirizzo",
        "Country": "Paese",
        "City": "Città",
        "State": "Stato",
        "Zip_code": "Cap",
        "postal_code": "Codice postale",
        "Required_fields": "Campi obbligatori",
        "Cancel": "Cancella",
        "Save": "Salva",
        "ERROR_INPUT_CARD_HOLDER": "Per favore inserisci titolare carta",
        "ERROR_INPUT_CARD_NUMBER": "Per favore inserisci numero carta",
        "ERROR_INPUT_EXPIRED_DATE": "Per favore inserisci data di scadenza",
        "ERROR_VAILD_EXPIRED_DATE": "Data di scadenza invalida.",
        "ERROR_INPUT_CVV": "Per favore inserisci CVV",
        "ERROR_INPUT_ADDRESS": "Per favore inserisci l'indirizzo",
        "ERROR_INPUT_CITY": "Per favore inserisci nome città",
        "ERROR_INPUT_ZIPCODE": "Per favore inserisci cap",
        "ERROR_INPUT_COUNTRY": "Seleziona paese",
        "Info_edit_error": "Errore!",
        "Gender": "Genere",
        "Select_Gender": "Seleziona",
        "Select_Idtype": "Select",
        "Male": "Maschio",
        "Female": "Femmina",
        "Other": "Altro",
        "Date_of_birth": "Data di Nascita",
        "Street_address": "Indirizzo",
        "Select_Zone": "Seleziona Zona",
        "ERROR_GET_GATEWAYS": "ERRORE !!! Ottieni Gateway",
        "Require_email": "Per favore inserisci email prima di aggiungere una nuova carta",
        "Require_lastName": "Per favore inserisci cognome prima di aggiungere la nuova carta",
        "Require_phone_number": "Per favore inserisci il numero di telefono del viaggiatore prima di fare una prenotazione con carta di credito",
        "IMPORT_CUSTOMER_SUCCESS": "Clienti importati con successo",
        "No_card": "Nessuna carta trovata.",
        "No_Support": "L'aggiunta di una nuova carta non é supportata in quest'area",
        "Card_Management": "Gestione carta",
        "Emergency_contacts": "Contatti di emergenza",
        "DETAIL_CUSTOMER": "Dettagli Cliente",
        "Select_Country": "Seleziona città",
        "Customer_ID": "Carta di identità # Carta di identità nazionale #",
        "Credit_balance": "Saldo credito",
        "required_email_payment": "È richiesta l'email del cliente. Si prega di aggiornare il profilo per continuare.",
        "Yes": "Sì",
        "No": "No",
        "WriteOffDebt": "Annullare il debito",
        "selectPayment": "Si prega di selezionare un metodo di pagamento per chiudere tutte le prenotazioni che hanno un pagamento in sospeso.",
        "writeOffDebtSuccess": "Annulla il debito con successo",
        "writeOffDebtNotes": "Nota: Questa azione di cancellazione dovrebbe essere confermata solo dopo che l'importo totale in sospeso è stato pagato per intero.",
        "totalCustomer": "Clienti totali",
        "Personal_Card": "Carta personale",
        "INFO_ADD_BALANCE_SUCCESS": "Il saldo del passeggero è stato aggiornato con successo",
        "INFO_UPDATE_POINT_SUCCESS": "Il punto passeggero è stato aggiornato con successo",
        "currency": "Valuta",
        "balance": "Bilancio",
        "changeBalance": "Cambia saldo",
        "change": "Cambia",
        "WALLET_DEPOSIT": "Portafoglio",
        "AccessDenied": "Non hai il permesso di accedere a questo modulo!",
        "referral_code": "Codice di riferimento",
        "loginMethod": "Metodo di accesso",
        "searchCustomerPlaceholder": "Cerca per nome contatto, telefono, email, azienda, ID supporto"
    },
    "importBookings": {
        "no": "No.",
        "status": "Stato",
        "pickupDate": "Data di ritiro",
        "pickup": "Indirizzo di ritiro",
        "dropoff": "Indirizzo di consegna",
        "passenger": "Passeggero",
        "phone": "Numero di telefono",
        "seats": "Posti",
        "luggages": "Bagagli",
        "rideSharing": "Carpooling",
        "flightNumber": "Numero di volo",
        "notes": "Note",
        "externalId": "ID esterno",
        "operatorNote": "Note interne",
        "clientCaseMatter": "Descrizione del viaggio",
        "chargeCode": "Codice viaggio",
        "price": "Prezzo",
        "payout": "Pagamento",
        "paymentType": "Pagamento",
        "vehicleTypeRequest": "Tipo di auto",
        "importBookings": "Importa prenotazioni",
        "corporation": "Corporazione",
        "clickOrDropCsvFile": "Clicca o trascina il file .csv",
        "importingFileForReview": "Importazione del file per la revisione...",
        "import": "Importa",
        "submit": "Invia",
        "downloadTemplate": "Scarica modello",
        "learnMore": "Scopri di più",
        "total": "Totale",
        "valid": "Valido",
        "invalid": "Non valido",
        "failed": "Fallito",
        "processing": "Elaborazione",
        "success": "Successo",
        "confirm": "Conferma",
        "confirmMessage": "gli ordini verranno creati. Sei sicuro di voler procedere?",
        "create": "Crea",
        "cancel": "Annulla",
        "close": "Chiudi",
        "leavingConfirmMessage": "Il tuo lavoro non è salvato! Sei sicuro di voler uscire?",
        "resultMessage": "${success} prenotazione/i sono state create con successo, ${failed} fallite.",
        "limitExceededBookings": "Dimensione massima del file di importazione: 100 prenotazioni",
        "delivery": {
            "no": "#",
            "pickupDate": "Data di ritiro",
            "senderName": "Nome mittente",
            "senderPhone": "Telefono del mittente",
            "senderMail": "Email del mittente",
            "senderAddress": "Indirizzo del mittente",
            "recipients": "Destinatari",
            "senderDistrictOptional": "Distritto",
            "senderLocationDetails": "Dettagli sulla posizione",
            "recipientName": "Nome del destinatario",
            "recipientPhone": "Telefono del destinatario",
            "recipientAddress": "Indirizzo del destinatario",
            "recipientDistrictOptional": "Distritto",
            "recipientLocationDetailsOptional": "Dettagli sulla posizione",
            "packageContent": "Contenuto della confezione",
            "orderNumber": "Ordine #",
            "instructions": "Istruzioni per il conducente",
            "cod": "Valore dell'oggetto COD",
            "rideShare": "Condivisione di corsa",
            "paymentType": "Tipo di pagamento",
            "carType": "Tipo di auto",
            "recipientLocationDetails": "Dettagli sulla posizione",
            "operatorNote": "Note interne",
            "rideSharing": "Consegna in lotti"
        }
    },
    "merchant": {
        "INFO_ADD_BALANCE_SUCCESS": "Il saldo del commerciante è stato aggiornato con successo",
        "ADD_MERCHANT_USER": "Aggiungi account commerciante",
        "EDIT_MERCHANT_USER": "Modifica account commerciante",
        "MERCHANT_USER_DETAILS": "Dettagli dell'account merchant",
        "CASH_WALLET": "Portafoglio in contante",
        "CREDIT_WALLET": "Portafoglio crediti",
        "ADD_MERCHANT": "Aggiungi commerciante",
        "ACCOUNT_INFO": "Informazioni sull'account",
        "BILLING_ADDRESS": "Informazioni Bancarie",
        "user": {
            "fullName": "Utente commerciante",
            "Phone_Number": "Numero di telefono",
            "Email": "Email",
            "storeName": "Commerciante",
            "status": "Stato",
            "actions": "Azione",
            "First_name": "Nome",
            "Last_name": "Cognome",
            "Select_store": "Seleziona commerciante",
            "accountHolder": "Nome del titolare dell'account",
            "First_M_Last": "Primo M. Ultimo",
            "accountNumber": "Numero di conto",
            "ibanNumber": "numero IBAN",
            "bankName": "Nome della banca",
            "IDtype": "Tipo di ID",
            "IDnumber": "ID# / IC Nazionale#",
            "routingNumber": "Numero di routing/transito/filiale",
            "checkNumber": "Numero di controllo",
            "ssn": "SSN/NI",
            "sortCode": "Codice di ordinamento",
            "transitNumber": "Numero di transito",
            "institutionNumber": "Numero di Istituzione",
            "birthDay": "Compleanno",
            "address": "Indirizzo",
            "city": "Città",
            "state": "Stato",
            "postalCode": "Codice postale",
            "beneficiaryIDIC": "ID Beneficiario# / IC#",
            "relationshipOtherName": "Relazione con altri?",
            "verificationDocumentFront": "Documento di verifica (fronte)",
            "verificationDocumentBack": "Documento di verifica (retro)",
            "Verification_document_tooltip": "Forme di identificazione accettabili: \n  - Passaporto \n  - Patente di guida \n  - Carta di soggiorno \n  - Carta d'identità \n  - Documento d'identità",
            "additionalDocumentFront": "Documento aggiuntivo (fronte)",
            "additionalDocumentBack": "Documento aggiuntivo (retro)",
            "Additional_document_tooltip": "Forme accettabili di verifica dell'indirizzo: \n  - Patente di guida \n  - Bolletta \n  - Lettera emessa dal governo \n  - Estratto conto di un'istituzione finanziaria \n  - Voce del Registro Elettorale",
            "please_select": "Si prega di selezionare",
            "commission": "Commissione",
            "ERROR_INPUT_VALIDPHONE": "Si prega di inserire un numero di telefono valido.",
            "ERROR_EXISTED_PHONE": "Questo telefono esiste già nel sistema. Si prega di inserire un altro.",
            "Activate": "Attiva",
            "Deactivate": "Disattivare",
            "ALERT_SELECT_ACTIVATE": "Seleziona l'utente da attivare.",
            "ALERT_SELECT_DEACTIVATE": "Seleziona l'utente da disattivare.",
            "CONFIRM_ACTIVATE_MULTI": "Vuoi attivare questi utenti?",
            "CONFIRM_DEACTIVATE_MULTI": "Vuoi disattivare questi utenti?",
            "RESET_PASSWORD": "Vuoi reimpostare la password?",
            "CONFIRM_RESET_PASSWORD": "Vuoi reimpostare la password?",
            "REMOVE_BANK_INFO": "Conferma rimozione informazioni bancarie",
            "CONFIRM_REMOVE_BANK_INFO": "Vuoi rimuovere le informazioni bancarie?",
            "note_account_password_default": "Nota: Per il nuovo account Merchant, la password predefinita è \"12345678",
            "Cash_Balance": "Saldo di cassa",
            "Credit_Balance": "Saldo creditore"
        },
        "Update_merchant_user_success": "L'utente commerciante è stato aggiornato con successo",
        "Update_merchant_user_fail": "Impossibile aggiornare l'utente commerciante",
        "Create_merchant_user_success": "Nuovo utente commerciante creato con successo",
        "Create_merchant_user_fail": "Impossibile creare l'utente commerciante",
        "Update_merchant_user_status_success": "L'utente commerciante è stato aggiornato con successo",
        "Update_merchant_user_status_fail": "Impossibile aggiornare l'utente commerciante",
        "Reset_password_merchant_user_success": "Password ripristinata con successo",
        "Reset_password_merchant_user_fail": "Reset password fallito",
        "Deleted_merchant_bank_info_success": "Rimuovi le informazioni bancarie con successo",
        "Deleted_merchant_bank_info_fail": "Rimozione delle informazioni bancarie non riuscita"
    },
    "table_header": {
        "Items_per_page": "Oggetti per pagina",
        "Page": "Pagina",
        "Search_here": "Cerca qui",
        "Shown_Active": "%{start} - %{end} of %{total} mostrati ",
        "Active": "%{active} Attivo ",
        "OF": "di"
    },
    "driver": {
        "Driver": "Driver",
        "Add": "Aggiungi",
        "addDriver": "Aggiungi driver",
        "Detail": "Dettaglio",
        "detailDriver": "Dettagli del conducente",
        "addNewVehicle": "Aggiungi Veicolo",
        "serviceType": "Tipo di Servizio",
        "transport": "Trasporto",
        "delivery": "Consegna",
        "stripeConnect": "Stripe Connect",
        "stripeConnectDes": "Aggiungi un account Stripe Connect per pagamenti più facili",
        "bankAccount": "Informazioni Bancarie",
        "bankAccountDes": "Informazioni bancarie dei conducenti per gestire i pagamenti",
        "supplierComission": "Commissione Fornitore",
        "supplierComissionDes": "Set commissions the supplier earns for every complete order.",
        "fleetCommission": "Commissione Flotta/Fornitore",
        "fleetCommissionDes": "Imposta le commissioni che la flotta o il fornitore guadagna per ogni ordine completo. Se il conducente è un conducente del fornitore, la commissione verrà dedotta dai guadagni del fornitore.",
        "operationZones": "Zone di Operazione",
        "operationZonesDes": "Zone da cui i fornitori possono ricevere lavori:",
        "notes": "Note",
        "notesDes": "Note interne su questo driver:",
        "searchNotes": "Aggiungi note per il conducente",
        "marketplace": "Marketplace",
        "marketplaceDes": "Consentire ai conducenti di accettare i lavori che vogliono fare.",
        "otherSettings": "Altre impostazioni",
        "topDriver": "TOP Driver",
        "topDriverDes": "Prioritizza i migliori performer con il tag \"Top Driver\", assicurando che ricevano più corse.",
        "walletTransferBetweenDriver": "Trasferimenti di Portafoglio Tra Autisti",
        "walletTransferBetweenDriverDes": "Abilitare i conducenti a trasferire fondi direttamente nei portafogli degli altri, facilitando una facile distribuzione di crediti da parte dei leader di squadra o degli ambasciatori.",
        "rideSharing": "Condivisione di corse",
        "rideSharingDes": "Abilita i conducenti a svolgere lavori di ride-sharing. Contatta il tuo account manager per questa funzionalità avanzata.",
        "individual_vehicle": "Veicolo individuale",
        "company_vehicle": "Veicolo aziendale",
        "ContactInfo": "Informazioni di contatto",
        "name": "Nome",
        "expiryDate": "Data di scadenza",
        "action": "Azione",
        "editDocument": "Modifica Documento",
        "documentToUpload": "Documento da caricare",
        "addFiles": "Clicca o trascina il file in quest'area per caricarlo.",
        "fileSize": "Dimensione massima del file 10 MB",
        "fileSizeDes": "L'estensione del file deve essere .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip",
        "removeOldFile": "Si prega di rimuovere il file vecchio prima di caricare uno nuovo.",
        "maxLengthFiles": "Si prega di caricare un massimo di 1 file",
        "maxSizeFiles": "Si prega di caricare un file di dimensioni inferiori a 10MB",
        "typeFiles": "Si prega di caricare file di tipo .jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, .zip",
        "maxAvatarSizeFiles": "Si prega di caricare un avatar di dimensioni inferiori a 8MB",
        "IFSCCode": "Codice IFSC",
        "Drivers": "Autisti",
        "default": "Predefinito",
        "customize": "Personalizzato",
        "Activate": "Attivato",
        "Stripe_connect": "STRIPE CONNECT",
        "status_stripe": "Stato: {0}",
        "stripeConnectStatus": "Stripe Connect",
        "stripeStatus": "Stato dell'account Stripe",
        "Deactivate": "Disattivare",
        "Delete": "Cancella",
        "acceptInDay": "Numero massimo di prenotazioni che il conducente può accettare in un giorno",
        "acceptATime": "Numero totale di prenotazioni che un autista può accettare contemporaneamente",
        "Commission": "Imposta commissione flotta",
        "Title_Commission": "Imposta la commissione della flotta per tutti i conducenti",
        "Confirm_Set_Commission": "Sicuro di voler impostare questo valore di commissione per tutti i conducenti?",
        "Commission_Successfully": "La commissione del conducente è stata aggiornata con successo.",
        "Apply": "Applica",
        "Type": "genere",
        "Currency": "Valuta",
        "View_Message": "Messaggio",
        "Send_Message": "Invia Messaggio",
        "Driver_Name": "Nome autista",
        "Driver_ID": "Carta di identità # Carta di identità nazionale #",
        "Phone_Number": "Numero di telefono",
        "Driver_Type": "Tipo di Autista",
        "TOP": "TOP",
        "Company": "Azienda",
        "City": "Città",
        "Driver_License_Number": "Numero Patente Autista",
        "License_Plate": "Numero di targa",
        "Car_Type": "Tipo di macchina",
        "Zone": "Zona",
        "Registered_From": "Registrato da",
        "Registration_Date": "Data di registrazione",
        "IOS_Last_Login_Version": "IOS Versione ultima connessione",
        "Android_Last_Login_Version": "Android Versione ultima connessione",
        "Last_Active_Date": "Ultima data attiva",
        "Days_Since_Last_Active": "Giorni dall'ultima data attiva",
        "Completed_bookings": "Prenotazioni completate",
        "Status": "Stato",
        "Actions": "Azioni",
        "Action": "Azioni",
        "Inactive": "Inattivo",
        "Active": "Attiva",
        "Edit": "Modifica",
        "View": "Mostra",
        "ALERT_SELECT_ACTIVATE": "Per favore seleziona l’autista da attivare.",
        "ALERT_SELECT_DEACTIVATE": "Per favore seleziona l’autista da disattivare.",
        "ALERT_SELECT_DELETE": "Per favore seleziona l’autista da eliminare.",
        "CONFIRM_DELETE": "Vuoi eliminare questo autista?",
        "CONFIRM_DEACTIVATE_MULTI": "Sei sicuro di voler disattivare l’autista(i) selezionato(i)? Il loro contatore hardware collegato sarà ugualmente disabilitato.",
        "CONFIRM_ACTIVATE_MULTI": "DVuoi attivare questi autisti? Solo l’autista(i) predisposto per essere operativo puo’ essere attivato.",
        "CONFIRM_DELETE_MULTI": "DVuoi eliminare questi autisti? Solo un autista in status inattivo puo’ essere eliminato..",
        "CONFIRM_REMOVE_BANKING_INFOR": "Sei sicuro di voler rimuovere le informazioni bancarie?",
        "REMOVE_BANKING_INFOR": "Rimuovi informazioni bancarie",
        "ADD_DRIVER": "Aggiungi autista",
        "Avatar": "Avatar",
        "Individual_Driver": "Singolo autista",
        "Owner_Operator": "Operatore Proprietario",
        "deliveryCompany": "Consegna - Veicolo aziendale",
        "deliveryIndividual": "Consegna - Veicolo individuale",
        "CONTACT_INFO": "Informazioni di contatto",
        "Home_address": "Indirizzo Casa",
        "Username": "Nome utente",
        "First_name": "Nome",
        "Last_name": "Cognome",
        "Phone_number": "Numero di Telefono",
        "Email_address": "Indirizzo email",
        "Select_city": "Seleziona citta’",
        "State": "Stato",
        "Zip_code": "Cap",
        "Date_of_birth": "Data di Nascita",
        "placeholderDate": "gg/mm/aaaa",
        "City_driver_want_to_drive": "Il conducente della città vuole guidare",
        "Driver_license_number": "Numero Patente Autista",
        "Driver_license_state": "Stato Patente Autista/Province",
        "Driver_license_expiry": "La Patente dell’Autista Scade",
        "FOR_INSPECTOR": "Per ispettore",
        "Document": "Documento",
        "Document_Id": "ID documento",
        "Link": "Collegamento",
        "Notes": "Note",
        "UPLOAD_DOCUMENT": "Carica documento",
        "Click_here_to_download": "Clicca qui per scaricare.",
        "Click_here_to_view": "Clicca per visualizzare",
        "EXTENSION_REQUIREMENT": "L’estensione del documento deve essere jpg, .jpeg, .png, .doc, .docx, .xls, .xlsx, .pdf, .7z, .rar, e di taglia inferiore a 5Mb.",
        "Invalid_file": "Documento invalido",
        "File_size_larger_than_5Mb": "La taglia del file deve essere maggiore di 5Mb",
        "BANK_ACCOUNT": "Conto bancario",
        "Name_of_bank": "Nome della banca",
        "Name_of_account": "Nome del conto",
        "First_M_Last": "Primo M. Ultimo",
        "RTBnumber": "Numero di routing/transito/filiale",
        "bankName": "Nome della banca",
        "Select_a_bank": "Seleziona una banca",
        "Account_number": "Numero del conto",
        "IBAN_number": "Numero IBAN",
        "Check_number": "Numero di controllo",
        "Swift_code_number": "Numero codice swift",
        "SSNNI": "SSN/ NI",
        "sortCode": "Codice di ordinamento",
        "Verification_document": "Documento di verifica (fronte)",
        "Additional_document": "Documento aggiuntivo (fronte)",
        "Verification_document_back": "Documento di verifica (retro)",
        "Additional_document_back": "Documento aggiuntivo (retro)",
        "others": "Altro",
        "signedW9Form": "KB",
        "driverLicense": "Patente",
        "Verification_document_tooltip": "Forme accettabili per l'identificazione: \n  - Passaporto \n  - Patente di guida \n  - Carta di soggiorno \n  - Carta d'identità \n  - Documento d'identità",
        "Additional_document_tootip": "Forme accettabili di verifica dell'indirizzo: \n  - Patente di guida \n  - Bolletta \n  - Lettera emessa dal governo \n  - Estratto conto di un'istituzione finanziaria \n  - Voce del Registro Elettorale",
        "isBankAccountOwner": "È questo il tuo account?",
        "yes": "Sì",
        "no": "No",
        "beneficiary_name": "Nome del Beneficiario",
        "beneficiary_idic": "ID/IC del beneficiario",
        "relationship": "Relazione",
        "select_relationship": "Seleziona lo stato della relazione",
        "spouse": "Coniuge",
        "daughterOrSon": "Figlia/Figlio",
        "brotherOrSister": "Fratello/Sorella",
        "relative": "Relativo",
        "friends": "Amici",
        "other": "Altro",
        "relationshipOtherName": "Relazione con altri?",
        "OPERATION": "OPERAZIONE",
        "CAR_INSURANCE": "Assicurazione macchina",
        "Policy_number": "Numero polizza",
        "Effective_date": "Data effettiva",
        "Expired_date": "Data di scadenza",
        "Select_company": "Seleziona azienda",
        "All_company": "Tutta l'azienda",
        "All_Car_Type": "All Car Type",
        "Car": "Auto",
        "Existing_car": "Macchina esistente",
        "New_car": "Nuova macchina",
        "License_plate": "Numero di targa",
        "Select_license_plate": "Seleziona numero di targa",
        "Select_Car_Type": "Seleziona Tipo di Macchina",
        "vehicleOwner": "Nome del proprietario del veicolo",
        "Make": "Crea",
        "Select_Car_Make": "Seleziona Un costruttore auto",
        "Model": "Modello",
        "Select_Car_Model": "Seleziona modello macchina",
        "Year": "Anno",
        "Select_Year": "Seleziona anno",
        "Color": "Colore",
        "Passengers": "Passeggeri",
        "Luggage": "Bagaglio",
        "License_expiry": "Patente scade",
        "Shift": "Turno",
        "Select_Shift_Template": "Seleziona Modello Turno",
        "Fleet_commission": "Commissione Flotta (report)",
        "Company_commission": "Commissione aziendale (rapporto)",
        "rideHailing": "Richiesta in strada",
        "intercity": "Intercity",
        "food": "Cibo",
        "mart": "Mart",
        "streetSharing": "Condivisione Stradale",
        "Shuttle": "Navetta",
        "parcel": "Pacco",
        "driverInsurance": "Assicurazione per conducenti",
        "Percentage": "Percentuale",
        "Amount": "Montante",
        "transaction": "/transazione",
        "Terminal_ID": "ID terminale",
        "Auth_key": "Chiave di autenticazione",
        "CREDIT_DEPOSIT": "Portafoglio di credito",
        "Credit_Balance": "Saldo ",
        "Balance": "Equilibrio",
        "Change_balance": "Cambia saldo",
        "Select_balance": "Seleziona saldo",
        "Adjust_amount": "Regola importo",
        "Adjust_value": "Regola valore",
        "New_balance": "Nuovo saldo",
        "New_point": "Nuovo punto",
        "Enter_reason": "Inserisci motivo",
        "ERROR_INPUT_BALANCE": "Per favore seleziona il saldo.",
        "ERROR_INPUT_AMOUNT": "Per favore inserisci valore.",
        "ERROR_INPUT_REASON": "Per favore inserisci motivo.",
        "ERROR_INPUT_VALID_AMOUNT": "Per favore inserisci un valore maggiore di 0.",
        "INFO_ADD_BALANCE_SUCCESS": "Il saldo dell'autista é stato aggiornato con successo",
        "INFO_ADD_CASH_BALANCE_SUCCESS": "Il saldo contante del driver è stato aggiornato con successo",
        "Force_meter": "Misuratore di forza",
        "Force_meter_tooltip": "L'app dell'autista deve essere connessa al contatore prima di operare. Applicato ai contatori Pulsar e Centrodyne.",
        "ERROR_EXISTED_PHONE": "Questo telefono esiste già nel sistema. Per favore inseriscine un altro.",
        "TOP_driver": "TOP driver",
        "Ride_sharing": "Condividi-viaggio",
        "Note_password": "Nota: Per il conto del nuovo autista la password provvisoria é \"12345678",
        "Required_fields": "Campi obbligatori",
        "Cancel": "Cancella",
        "Save": "Salva",
        "SaveAndInProgress": "Salva e In corso",
        "SaveAndDeactivate": "Salva e Disattiva",
        "ERROR_REQUIRE_": "Per favore inserisci ",
        "ERROR_INPUT_AVATAR": "Si prega di caricare l'avatar.",
        "ERROR_INPUT_DRIVER_TYPE": "Seleziona il tipo di driver.",
        "ERROR_INPUT_DOCUMENT": "Per favore carica",
        "ERROR_INPUT_USERNAME": "Per favore inserisci username.",
        "ERROR_INPUT_VALID_USERNAME": "Lo Username deve contenere solo lettere minuscole & numeri e deve essere lungo dai 3 ai 20 caratteri.",
        "ERROR_INPUT_PHONE": "Per favore specifica un numero di telefono valido.",
        "ERROR_INPUT_VALID_EMAIL": " Per favore inserisci email valida.",
        "ERROR_INPUT_EMAIL": "Per favore inserisci l'email.",
        "ERROR_INPUT_FIRSTNAME": "Per favore inserisci nome..",
        "ERROR_INPUT_LASTNAME": "Per favore inserisci cognome .",
        "ERROR_INPUT_ADDRESS": "Per favore inserisci indirizzo di casa..",
        "ERROR_INPUT_CITY": "Per favore inserisci nome città.",
        "ERROR_INPUT_STATE": "Per favore inserisci provincia..",
        "ERROR_INPUT_ZIPCODE": "Per favore inserisci a codice postale",
        "ERROR_INPUT_BIRTHDAY": "Per favore inserisci data di nascita .",
        "ERROR_INPUT_NAME_OF_BANK": "Per favore iserisci il nome della banca..",
        "ERROR_INPUT_NAME_OF_ACCOUNT": "Per favore inserisci nome del conto.",
        "ERROR_INPUT_ROUTING_NUMBER": "Per favore inserisci nuero routing.",
        "ERROR_INPUT_BANK_NAME": "Per favore seleziona una banca.",
        "ERROR_INPUT_ACCOUNT_NUMBER": "Per favore inserisci numero di conto",
        "ERROR_INPUT_CHECK_NUMBER": "Per favore inserisci il numero di controllo.",
        "ERROR_INPUT_SSN": "Si prega di inserire il SSN.",
        "ERROR_INPUT_DocumentId": "Si prega di inserire l'ID del documento.",
        "ERROR_INPUT_SORTCODE": "Si prega di inserire il codice di ordinamento.",
        "ERROR_INPUT_COMPANY": "Per favore seleziona azienda da attivare .",
        "ERROR_INPUT_LICENSE_PLATE": "Per favore scegli targa.",
        "ERROR_INPUT_ZONE": "Per favore seleziona zona da attivare.",
        "ERROR_INPUT_SHIFT": "Per favore seleziona turno da attivare.",
        "ERROR_ACCOUNT_NUMBER_ONLY_NUMBERS": "Questo deve contenere solo numeri",
        "ERROR_SSN_ONLY_NUMBERS": "Questo deve contenere solo numeri",
        "ERROR_SSN_LENGTH": "Il codice fiscale deve avere almeno 4 caratteri",
        "ERROR_COMMISSION_NUMBERS": "Per favore inserisci un numero valido.",
        "INFO_DEACTIVAED_SUCCESS": "L'autista é stato disattivato con successo.",
        "INFO_ACTIVAED_SUCCESS": "L'autista é stato attivato con successo.",
        "INFO_DEACTIVAED_SUCCESS_BUT_HARDWARE": "L’autista é stato disattivato ma il suo contatore hardware collegato non puo’ essere spento per ragioni inaspettate",
        "INFO_MULTIDEACTIVAED_SUCCESS": "Gli autisti {0} selezionati sono stati disattivati con successo.",
        "INFO_MULTIDEACTIVAED_HARDWARE_SUCCESS": "TGli autisti {0} selezionati sono stati disattivati con successo.  {1} Il contatore(i) connesso é stato disabilitato.",
        "INFO_MULTIDEACTIVAED_SUCCESS_BUT_HARDWARE": "Gli [3] autisti selezionati sono stati disattivati con successo. [2] contatore(i) hardware collegato disabilitato. [1] non dovute per ragioni inaspettate",
        "INFO_MULTIACTIVAED_SUCCESS": "Gli autisti {0} selezionati sono stati attivati con successo.",
        "DRIVER_UPDATE_SUCCESS": "Autista aggiornato con successo",
        "DRIVER_CREATE_SUCCESS": "Le informazioni dell'autista sono state aggiunte con successo",
        "Expiry_Date": "Data di scadenza",
        "Case_number": "Numero caso",
        "Export_to_csv": "Esporta in CSV",
        "CONFIRM_EXPORT_TO_CSV": "Sei sicuro di voler esportare tutti i dati in formato .csv?",
        "Ride_sharing_tooltip": "Car pooling é una funzionalità avanzata, per favore contatta il nostro supporto per avere maggiori informazioni.",
        "In_Review": "In revisione",
        "Reset_password_success": "Reset password successful",
        "Topup_note": "È consentito ricaricare il saldo del conducente dopo aver attivato il conducente.",
        "cash_balance": "Saldo in contanti",
        "cash_wallet": "Portafoglio in contanti",
        "total_balance": "Saldo totale",
        "total_cash_balance": "saldo di cassa totale",
        "total_credit_balance": "saldo a credito totale",
        "banking_status": "Stato bancario",
        "bankingStatus": {
            "verified": "Verificato",
            "not_verified": "Non verificato",
            "inComplete": "Incompleto",
            "connected": "Connesso",
            "disconnected": "Disconnesso"
        },
        "INVALID_FILE_SIZE": "La dimensione del file deve essere inferiore a 8Mb.",
        "totalDrivers": "Autista Totale",
        "profileStatus": "Stato del profilo",
        "profile_completed": "Profilo completato",
        "profile_incomplete": "Profilo incompleto",
        "profile_inProgress": "Profilo in corso",
        "in_review_completed": "In revisione (profilo completato)",
        "in_review_incomplete": "In revisione (profilo incompleto)",
        "in_review_inProgress": "In revisione (profilo in corso)",
        "CASH_WALLET_DEPOSIT": "Portafoglio in contante",
        "payoutSelect": "Pagamento (una notifica e un'email saranno inviate al conducente dopo il pagamento)",
        "Confirm_update_cash_balance": "Cambia Saldo Contante",
        "Confirm_update_cash_balance_msg": "Sei sicuro di voler cambiare il saldo del conducente?",
        "cashBalance": "Cash balance",
        "cashBalance_unavailable": "0,00",
        "cashBalance_active": "Attivo",
        "cashBalance_negative": "Negativo",
        "creditBalance": "Saldo credito",
        "ERROR_INPUT_DOCUMETID": "Si prega di inserire l'ID del documento.",
        "ERROR_INPUT_EXPIRYDATE": "Si prega di inserire la data di scadenza.",
        "driverType": "Tipo di driver",
        "tooltip_in_review_completed": "Invia nella posta in arrivo ai conducenti 'In revisione' che completano il loro profilo.",
        "tooltip_in_review_incomplete": "Invia nella posta in arrivo i conducenti 'In revisione' che non hanno completato il loro profilo.",
        "tooltip_in_review_inProgress": "Invia nella posta in arrivo ai conducenti 'In revisione' che completano il loro profilo ma necessitano di ulteriore verifica.",
        "tooltip_active": "Invia la casella di posta ai conducenti 'Attivi'.",
        "tooltip_inactive": "Invia messaggio nella casella di posta ai conducenti che hanno riattivato l'account.",
        "active": "Attiva",
        "inactive": "Disattivare",
        "inReviewInProgress": "In Revisione",
        "Market_place": "Marketplace",
        "Market_place_tooltip": "Consentire ai conducenti di scegliere tra prenotazioni on-demand o prenotazioni da accettare",
        "selectDriverType": "Seleziona il tipo di driver",
        "PlsSelectDriverType": "Seleziona il tipo di driver",
        "emergencyContacts": "Contatti di emergenza",
        "switchVehicle": "Cambia a qualsiasi veicolo",
        "switchVehicleNote": "Consentire al conducente di passare a qualsiasi veicolo della propria azienda fornitrice assegnata.",
        "vehicleModel": "Modello",
        "licensePlateNumber": "Targa del veicolo",
        "addVehicle": "Aggiungi Veicolo",
        "newVehicle": "Nuovo Veicolo",
        "linkVehicle": "Veicolo di collegamento",
        "modal": "Modale",
        "selectVehicle": "Seleziona Veicolo",
        "selectVehicleNote": "Abilita il conducente a selezionare o cambiare veicolo per una prenotazione.",
        "Warning_change_company": "Attenzione: Riassegnare questo conducente a un'altra azienda disconnetterà tutti i veicoli associati.",
        "searchDriverPlaceholder": "Cerca per nome, telefono, email, nome utente, targa",
        "please_select_a_name_of_bank": "Si prega di selezionare un nome di banca"
    },
    "corporate": {
        "User_Name": "Nome utente",
        "Edit_Balance": "Modifica Saldo",
        "Corporates": "Aziende",
        "Supplier": "Fornitore",
        "CarTypes": "Tipi di auto",
        "Add": "Aggiungi",
        "Balance": "Bilancio",
        "Activate": "Attivato",
        "Deactivate": "Disattivato",
        "Delete": "Cancella",
        "Company_Name": "Nome dell’azienda",
        "Admin_Name": "Nome Admin",
        "Username": "Nome utente",
        "Phone_Number": "Numero di telefono",
        "importBooking": "Capace di importare prenotazioni",
        "Email": "Email",
        "Registered_From": "Registrato da",
        "Registration_Date": "Data di registrazione",
        "Status": "Stato",
        "Actions": "Azioni",
        "Action": "Azioni",
        "Inactive": "Inattivo",
        "Active": "Attivo",
        "In_Review": "In revisione",
        "Edit": "Modifica",
        "View": "Mostra",
        "ADD_CORPORATE_CARD": "AGGIUNGI CARTA AZIENDALE",
        "selectCountry": "Seleziona Paese",
        "CONFIRM_DELETE_CARD": "Sei sicuro di voler cancellare queste carte?",
        "ALERT_SELECT_ACTIVATE": "Per favore seleziona azienda da attivare.",
        "ALERT_SELECT_DEACTIVATE": "Per favore seleziona azienda da disattivare.",
        "ALERT_SELECT_DELETE": "Per favore seleziona azienda da eliminare.",
        "CONFIRM_DELETE": "Vuoi eliminare questa azienda?",
        "CONFIRM_DELETE_USER": "Vuoi cancellare questo oggetto?",
        "CONFIRM_DEACTIVATE_MULTI": "Vuoi disattivare questi oggetti?",
        "CONFIRM_ACTIVATE_MULTI": "Vuoi attivare questi oggetti?",
        "CONFIRM_DELETE_MULTI": "DVuoi eliminare queste aziende?\n ** Solo le aziende inattive possono essere eliminate.",
        "ERROR_INPUT_PHONE": "Per favore specifica un numero di telefono valido.",
        "ERROR_INPUT_VALIDPHONE": "Per favore inserisci un numero di telefono valido.",
        "ERROR_EXISTED_PHONE": "Questo telefono esiste già nel sistema. Per favore inseriscine un altro.",
        "Account": "Conto",
        "Corp_traveler": "Viaggiatore aziendale",
        "Payment_methods": "Mezzi di pagamento",
        "Corp_operators": "Operatori",
        "Pricing": "Prezzi",
        "COMPANY_INFORMATION": "INFORMAZIONI AZIENDA",
        "Company_name": "Nome dell’azienda",
        "Company_ID": "Codice Univoco",
        "Company_address": "Indirizzo azienda",
        "Invoice_email": "email fattura",
        "Confirmation_email": "Conferma email",
        "colorCodeBooking": "Codice colore",
        "ADMIN_ACCOUNT": "CONTO ADMIN",
        "First_name": "Nome",
        "Last_name": "Cognome",
        "Commission": "Commissione",
        "commissionBooking": "Applica commissione per le prenotazioni da app/pwa",
        "Required_fields": "Campi obbligatori",
        "Save": "Registra",
        "Cancel": "Cancella",
        "Reset_password": "Resetta password",
        "Employee_Name": "Nome impiegato",
        "Created_Date": "Data creata",
        "Add_corporate_card": "Aggiungi carta aziendale",
        "Corp_Users": "Utenti Corp",
        "Pricing_Default": "Modello di Tariffa Aziendale",
        "Pricing_Discount": "Sconto percentuale (applicato solo per utenti aziendali)",
        "Markup_By_Percent": "Markup in percentuale (applicato solo per viaggiatore viaggiatore)",
        "Pricing_Discount_new": "Sconto percentuale",
        "Markup_By_Percent_new": "Markup percentuale",
        "Pricing_Add_different_rates": "Aggiungi tariffe diverse",
        "ERROR_INPUT_COMPANYNAME": "Per favore inserisci nome dell’azienda",
        "ERROR_INPUT_USERNAME": "Per favore inserisci username.",
        "ERROR_INPUT_FIRSTNAME": "Per favore inserisci nome.",
        "ERROR_INPUT_EMAIL": "Per favore inserisci email",
        "ERROR_INPUT_VALID_EMAIL": "Per favore inserisci una email valida.",
        "ERROR_INPUT_VALID_NUMBER": "Per favore inserisci un numero valido.",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "Per favore inserisci un numero fra {0} e {1}.",
        "INFO_ADD_CORPORATE_SUCCESS": "Utente {0} registrato con successo. Verifica l'indirizzo email {1} per le credenziali di accesso.",
        "INFO_UPDATE_CORPORATE_SUCCESS": "L'informazione è stata aggiornata con successo.",
        "INFO_UPDATE_PRICING_SUCCESS": "I prezzi sono stati aggiornati con successo.",
        "INFO_RESET_PASSWORD_SUCCESS": "L'account {0} è stato ripristinato con successo. Si prega di controllare l'email {1} per i dettagli delle credenziali di accesso.",
        "COMFIRM_RESET_PASSWORD": "Vuoi resettare la password?",
        "Traveler_signature": "Firma del viaggiatore",
        "Parcel_Delivery": "Abilita la consegna dei pacchi",
        "Tracking_log": "Registro di tracciamento",
        "Rating": "Valutazione",
        "Email_address": "Indirizzo email",
        "Assistant_email": "Assistente email",
        "Corp_PO": "Altro",
        "Cost_centre": "Centro costi",
        "Corp_division": "Divisione Corp",
        "Corp_id": "ID azienda",
        "Department": "Reparto",
        "Manager_email": "Codice Univoco ",
        "Manager_name": " P.IVA/Cod.Fisc",
        "Corporate_card": "Carta Aziendale",
        "Direct_invoicing": "Fatturazione diretta",
        "Corporate_Prepaid": "Prepagato dall’azienda",
        "Cash": "Contanti",
        "Car_Type_ID": "ID Tipo Veicolo",
        "App_Display_Name": "Nome visualizzato dell'app",
        "Normal_Fare": "Regolare",
        "Flat_Fare": "Tasso fisso",
        "Hourly_Daily_Rate": "Orario/ Giornaliero",
        "Delivery_Rate": "Consegna",
        "Assign_rate": "Assegna tariffa",
        "Zone": "Zona",
        "Rate": "Valuta",
        "Zone_Rate": "Zone - Tariffa",
        "Please_select_rate": "Per favore seleziona una data",
        "Paid_by": "Pagato da",
        "Enter_new_credit_card": " Inserisci nuova carta di credito ",
        "TOP_UP": "RICARICA",
        "Top_up": "Ricarica",
        "Topup_amount": "Ricarica importo",
        "Currency": "Moneta",
        "ERROR_INPUT_AMOUNT": "Per favore inserisci un importo valido.",
        "VAT_number": "partita IVA",
        "Gender": "Genere",
        "Select_Gender": "Seleziona",
        "Male": "Maschio",
        "Female": "Femmina",
        "Date_of_birth": "Data di Nascita",
        "Street_address": "Indirizzo",
        "City": "Città",
        "State": "Stato",
        "Zip_code": "Cap",
        "Country": "Paese",
        "adding_new_card": "Stai aggiungendo una nuova carta per usare il servizio in %{Nomezona} area",
        "No_Support": "L'aggiunta di una nuova vettura non é supportata in quest'area",
        "Job_title": "Posizione",
        "required_phone_number_payment": "È necessario fornire il numero di telefono dell'azienda. Si prega di aggiornare il profilo per continuare.",
        "Yes": "Si",
        "No": "No",
        "AddCardBeforeTopup": "Nessuna carta di credito trovata. Si prega di aggiungere una nuova carta per continuare.",
        "flightNumber": "Numero di volo",
        "Company_Type": "Tipo di azienda",
        "Standard": "Standard aziendale",
        "Airline": "Compagnia aerea",
        "Branding": "Branding",
        "bgImage": "Immagine di sfondo (1600x900)",
        "logoImage": "Immagine del logo",
        "aliasTitle": "Parametro Alias (URL)",
        "importChauffeurBooking": "May kakayahang mag-import ng mga booking sa transportasyon",
        "isCorporateVip": "VIP aziendale",
        "isCorporateVipToolTip": "Abilita questa impostazione per assegnare automaticamente lo stato VIP a tutti i viaggiatori aziendali al momento della creazione, puoi disattivarla per ciascun singolo utente.",
        "qrTitle": "Link di prenotazione QR Web",
        "qrNote": "Il tuo link personalizzato per la prenotazione dei partner è qui! Mostralo in modo prominente nei bar, nelle reception degli hotel, nelle camere degli ospiti e sul tuo sito web—ovunque i tuoi clienti possano aver bisogno di un passaggio o di una consegna. Considera di progettare dei totem con il tuo codice QR unico, permettendo ai clienti di scansionarlo rapidamente e facilmente per prenotare il loro viaggio!",
        "PricingLegacy": "Prezzi (Legacy)",
        "defaultTemplate": "Modello predefinito",
        "Select_Rate_Template": "Seleziona Modello di Tariffa"
    },
    "airline": {
        "Airlines": "Arilines",
        "Add": "Aggiungi",
        "Activate": "Attiva",
        "Deactivate": "Disattiva",
        "Delete": "Cancella",
        "Company_Name": "Nome dell'azienda",
        "Admin_Name": "Nome Admin",
        "Username": "Nome utente",
        "Phone_Number": "Numero di telefono",
        "Email": "Email",
        "Registered_From": "Registrato Da",
        "Registration_Date": "Data di registrazione",
        "Status": "Stato",
        "Actions": "Azioni",
        "Action": "Azione",
        "Inactive": "Inattivo",
        "Active": "Attivo",
        "In_Review": "In Revisione",
        "Edit": "Modifica",
        "View": "Visualizza",
        "ADD_CORPORATE_CARD": "Aggiungi carta aerea",
        "selectCountry": "Seleziona paese",
        "CONFIRM_DELETE_CARD": "Sei sicuro di voler eliminare queste carte?",
        "ALERT_SELECT_ACTIVATE": "Seleziona la compagnia aerea da attivare.",
        "ALERT_SELECT_DEACTIVATE": "Seleziona la compagnia aerea da disattivare.",
        "ALERT_SELECT_DELETE": "Seleziona la compagnia aerea da eliminare.",
        "CONFIRM_DELETE": "Vuoi eliminare questa compagnia aerea?",
        "CONFIRM_DELETE_USER": "Vuoi eliminare questo utente Airline?",
        "CONFIRM_DEACTIVATE_MULTI": "Sei sicuro di voler disattivare questa azienda?",
        "CONFIRM_ACTIVATE_MULTI": "Sei sicuro di voler attivare questa azienda?",
        "CONFIRM_DELETE_MULTI": "Sei sicuro di voler eliminare questa azienda?  \n** Solo le aziende inattive possono essere eliminate.",
        "ERROR_INPUT_PHONE": "Si prega di specificare un numero di telefono valido.",
        "ERROR_INPUT_VALIDPHONE": "Si prega di inserire un numero di telefono valido.",
        "ERROR_EXISTED_PHONE": "Questo telefono esiste già nel sistema. Si prega di inserire un altro.",
        "Airline": "Compagnia aerea",
        "Crew": "Equipaggio",
        "Payment_methods": "Metodi di pagamento",
        "Airline_operators": "Operatori aerei",
        "Pricing": "Prezzi",
        "COMPANY_INFORMATION": "Informazioni sull'azienda",
        "Company_name": "Nome dell'azienda",
        "Company_ID": "ID aziendale",
        "Company_address": "Indirizzo dell'azienda",
        "Invoice_email": "Email della fattura",
        "Confirmation_email": "Email di conferma",
        "colorCodeBooking": "Codice colore",
        "ADMIN_ACCOUNT": "Account amministratore",
        "First_name": "Nome",
        "Last_name": "Cognome",
        "Commission": "Commissione",
        "Required_fields": "Campi obbligatori",
        "Required_fields_crews": "Nota: Per il nuovo account Crew, la password predefinita è \"12345678",
        "Save": "Salva",
        "Cancel": "Annulla",
        "Reset_password": "Reimposta password",
        "Crew_Name": "Equipaggio",
        "Created_Date": "Data di creazione",
        "Add_corporate_card": "Aggiungi carta aerea",
        "Corp_Users": "Operatori",
        "Pricing_Default": "Predefinito",
        "Pricing_Discount": "Sconto percentuale",
        "Markup_By_Percent": "Ricarico percentuale",
        "Pricing_Add_different_rates": "Aggiungi tariffe diverse",
        "ERROR_INPUT_COMPANYNAME": "Si prega di inserire il nome dell'azienda.",
        "ERROR_INPUT_USERNAME": "Si prega di inserire il nome utente.",
        "ERROR_INPUT_FIRSTNAME": "Per favore inserisci il nome.",
        "ERROR_INPUT_EMAIL": "Per favore inserisci l'email.",
        "ERROR_INPUT_VALID_EMAIL": "Per favore inserisci un indirizzo email valido.",
        "ERROR_INPUT_VALID_NUMBER": "Si prega di inserire un numero valido",
        "ERROR_INPUT_VALID_RANGE_AMOUNT": "Si prega di inserire un valore compreso tra {0} e {1}.",
        "INFO_ADD_CORPORATE_SUCCESS": "L'account {0} è stato creato con successo.",
        "INFO_UPDATE_CORPORATE_SUCCESS": "L'informazione è stata aggiornata con successo.",
        "INFO_UPDATE_PRICING_SUCCESS": "Prezzi aggiornati con successo",
        "INFO_RESET_PASSWORD_SUCCESS": "L'account {0} è stato ripristinato con successo.",
        "COMFIRM_RESET_PASSWORD": "Vuoi reimpostare la password?",
        "Traveler_signature": "Firma del viaggiatore",
        "Tracking_log": "Registro di tracciamento",
        "Rating": "Valutazione",
        "Email_address": "Indirizzo email",
        "Assistant_email": "Email dell'assistente",
        "Corp_PO": "Corp PO",
        "Cost_centre": "Centro di costo",
        "Corp_division": "Divisione Corp",
        "Corp_id": "ID azienda",
        "Department": "Reparto",
        "Manager_email": "Email del manager",
        "Manager_name": "Nome del manager",
        "Corporate_card": "Carta aerea",
        "Direct_invoicing": "Fatturazione diretta",
        "Corporate_Prepaid": "Prepagato Airline",
        "Cash": "Contante",
        "Car_Type_ID": "ID Tipo di Veicolo",
        "App_Display_Name": "Nome di visualizzazione dell'app",
        "Normal_Fare": "Regolare",
        "Flat_Fare": "Tariffa Fissa",
        "Hourly_Daily_Rate": "Orario/ Giornaliero",
        "Delivery_Rate": "Consegna",
        "Assign_rate": "Assegna tariffa",
        "Zone": "Zone",
        "Rate": "Tariffa",
        "Zone_Rate": "Zone - Tariffa",
        "Please_select_rate": "Si prega di selezionare il tasso",
        "Paid_by": "Pagato da",
        "Enter_new_credit_card": "Inserisci nuova carta di credito",
        "TOP_UP": "RICARICA",
        "Top_up": "Ricarica",
        "Topup_amount": "Importo di ricarica",
        "Currency": "Valuta",
        "ERROR_INPUT_AMOUNT": "Si prega di inserire un importo valido.",
        "VAT_number": "Numero di partita IVA",
        "Gender": "Genere",
        "Select_Gender": "Seleziona",
        "Male": "Maschio",
        "Female": "Femmina",
        "Date_of_birth": "Data di nascita",
        "Street_address": "Indirizzo stradale",
        "City": "Città",
        "State": "Stato",
        "Zip_code": "Codice postale",
        "Country": "Paese",
        "adding_new_card": "Stai aggiungendo una nuova carta per utilizzare il servizio nell'area %{zoneName}",
        "No_Support": "L'aggiunta di nuove carte non è attualmente supportata in quest'area.",
        "Job_title": "Titolo del lavoro",
        "required_phone_number_payment": "Il numero di telefono dell'azienda è richiesto. Si prega di aggiornare il profilo per continuare.",
        "Yes": "Sì",
        "No": "No",
        "AddCardBeforeTopup": "Nessuna carta di credito trovata. Si prega di aggiungere una nuova carta per continuare."
    },
    "message": {
        "Add": "Aggiungi",
        "Delete": "Cancella",
        "Items_per_page": "Oggetti per pagina",
        "Page": "Pagina",
        "Search_here": "Cerca qui",
        "Shown_Active": "{0} - {1} of {2} mostrati",
        "Date": "Data",
        "Subject": "Soggetto",
        "To": "A",
        "Type": "genere",
        "Result": "Risultato",
        "Actions": "Azioni",
        "New_message": "Nuovo Messaggio",
        "MESSAGE_DETAILS": "DETTAGLI MESSAGGIO",
        "All": "Tutto",
        "Company": "Azienda",
        "Active": "Attivo",
        "In_Active": "Inattivo",
        "In_Review": "In revisione",
        "Send_to": "Invia a",
        "All_drivers": "Tutti gli autisti",
        "All_customers": "Tutti i clienti",
        "All_merchants": "Tutti i commercianti",
        "Customized_driver": "Driver personalizzato",
        "Customized_customer": "Cliente personalizzato",
        "Customized_merchant": "Commerciante personalizzato",
        "Receiver_list": "Lista Ricevente",
        "Content": "Contenuto",
        "Required_fields": "Campi obbligatori",
        "Search_driver_name_driver_phone_number": "Cerca nome autista, numero di telefono autista",
        "Search_category_name": "Cerca nome categoria",
        "Search_customer_name_customer_phone_number": "Cerca nome cliente, numero di telefono  cliente",
        "Search_merchant_name_merchant_phone_number": "Cerca nome del commerciante, numero di telefono del commerciante",
        "Search_car_type": "Cerca tipo vettura",
        "Searching": "In ricerca...",
        "No_results": "risultati",
        "Send": "Invia",
        "Cancel": "Cancella",
        "SMS_failed_Inbox_succeeded": "SMS fallito; In arrivo riuscito",
        "Failed": "Fallito",
        "Succeeded": "Riuscito",
        "CONFIRM_DELETE": "Vuoi cancellare questo messaggio?",
        "CONFIRM_DELETE_MULTI": "Vuoi cancellare questi messaggi?",
        "ALERT_SELECT_DELETE": "Per favore seleziona messaggio da cancellare",
        "ERROR_INPUT_RECEIVERLIST": "Per favore scegli almeno un autista per l’invio del messaggio",
        "ERROR_INPUT_CUSTOMER_RECEIVERLIST": "Per favore scegli almeno un clienti per l’invio del messaggio",
        "ERROR_INPUT_SUBJECT": "Per favore inserisci soggetto",
        "ERROR_INPUT_CONTENT": "Per favore inserisci contenuto",
        "ERROR_INPUT_LEAST_ONE_SUBJECT_CONTENT": "Per favore, imposta almeno una lingua per continuare",
        "ERROR_INPUT_SUBJECT_MULTI_LANGUAGE": "Si prega di inserire l'oggetto per la lingua {0}",
        "ERROR_INPUT_CONTENT_MULTI_LANGUAGE": "Si prega di inserire contenuto per la lingua {0}",
        "ERROR_INPUT_URL_MULTI_LANGUAGE": "Per favore inserisci l'URL per la lingua {0}",
        "ERROR_INPUT_TITLE_MULTI_LANGUAGE": "Per favore inserisci il titolo per la lingua {0}",
        "ERROR_INPUT_BODY_MULTI_LANGUAGE": "Si prega di inserire il corpo per la lingua {0}",
        "import_fail_success_driver": "%{success} driver(i) sono stati importati con successo, %{fail} non riusciti.",
        "import_fail_success_passenger": "%{success} cliente(i) è stato importato con successo, %{fail} non riuscito.",
        "import_fail_success_merchant": "%{success} commerciante(i) è stato importato con successo, %{fail} fallito.",
        "CONFIRM_SEND_SUCCESS": "Il tuo messaggio é stato inviato. Questo prenderà qualche minuto. Per favore attendi mentre il sistema processa la tua richiesta.",
        "Load_message_and_sms_fail": "Sono intervenuti degli errori nella fase di caricamento messaggio e dettagli SMS",
        "Update_message_and_sms_fail": "Sono intervenuti degli errori nella fase di aggiornamento messaggio e dettagli SMS",
        "Update_message_and_sms_success": "Messaggio e dettagli SMS sono stati aggiornati con successo",
        "Driver_List": "Lista autista",
        "Car_Type_List": "Lista tipo di vettura",
        "Search_vehicle_type_name": "Cerca Nome Tipo Veicolo",
        "ALERT_PROCESSING_DELETE": "La tua richiesta viene processata. Questo puo' prendere qualche secondo",
        "Customer": "Clienti",
        "Driver": "Autista",
        "StatusOfCustomer": "Stato del cliente",
        "StatusOfDriver": "Stato del driver",
        "StatusOfMerchant": "Stato del commerciante",
        "SendTo": "Invia a",
        "DownloadReceiverList": "Scarica l'elenco dei ricevitori",
        "warningInputChangeOver": "C'è una variazione relativa di oltre il 20% tra i 2 input recenti. Si prega di prendere in considerazione!",
        "NoteDownloadReveverList": "Dopo 1 mese, il download dell'elenco dei destinatari verrà disabilitato.",
        "Load_voip_fail": "Si sono verificati errori durante il caricamento dei dettagli VOIP.",
        "Update_voip_success": "I dettagli VOIP sono stati aggiornati con successo.",
        "Update_voip_fail": "Si sono verificati errori durante l'aggiornamento dei dettagli VOIP.",
        "expiryDate": "Invia a nuovo utente fino a",
        "expiryDate_placeholder": "Expiry Date (mm/dd/yyyy)",
        "NA": "N/A",
        "PleaseSelectStatusOfDriver": "Seleziona lo stato del conducente",
        "versionApp": "Versione dell'app",
        "platform": "Piattaforma",
        "contentType": "Tipo di contenuto",
        "url": "URL",
        "title": "Titolo",
        "contentId": "ContentId",
        "body": "Corpo",
        "image_notification": "Immagine",
        "platformItem": {
            "all": "Tutto",
            "iOS": "iOS",
            "android": "Android"
        },
        "comparisonVersionApp": {
            "is": "È",
            "is_not": "Non è",
            "is_one_of": "È uno dei",
            "is_not_one_of": "Non è uno di",
            "greater_or_equal": "Maggiore o uguale",
            "less_or_equal": "Minore o uguale"
        },
        "contentTypeItem": {
            "html": "HTML",
            "link": "Collegamento"
        },
        "Please_input": "Questo campo è obbligatorio"
    },
    "fleetInfo": {
        "Fleet_name": "Nome flotta",
        "Phone_number": "Numero di telefono",
        "Email_address": "Indirizzo email",
        "Country": "Paese",
        "Time_zone": "Fuso orario",
        "Address": "Indirizzo",
        "Website": "Sito web",
        "Currency": "Moneta",
        "Distance_unit": "Unità distanza",
        "Load_fleet_info_fail": "Sono intervenuti degli errori nella fase di caricamento delle informazioni della flotta"
    },
    "surchargePolicy": {
        "Surchage_Policy": "Politica di sovrapprezzo",
        "SurgePolicy": "Politica di Surge",
        "surgeType": "Tipo di sovratensione",
        "bookingTimeCoverage": "Copertura del Tempo di Prenotazione",
        "Delete_surcharge": "Sei sicuro di voler eliminare il sovrapprezzo selezionato?",
        "Delete_surcharge_item": "Sei sicuro di voler eliminare l'elemento di sovrapprezzo selezionato?",
        "Delete_surcharge_item_success": "Il sovrapprezzo è stato disattivato con successo",
        "Delete_surcharge_item_fail": "Si sono verificati errori durante la disattivazione dell'elemento di sovrapprezzo",
        "linkNewPolicy": "Collega una nuova polizza",
        "Link": "Collegamento",
        "ViewPolicy": "Visualizza Politica",
        "Unlink": "Disconnetti",
        "Create_Surcharge_Item_success": "L'elemento di sovrapprezzo è stato creato con successo",
        "Create_Surcharge_Item_fail": "Si sono verificati errori durante la creazione dell'elemento di sovrapprezzo",
        "Update_Surcharge_Item_success": "L'elemento del supplemento è stato aggiornato con successo",
        "Update_Surcharge_Item_fail": "Si sono verificati errori durante l'aggiornamento dell'elemento di sovrapprezzo",
        "single": "Giorno Singolo",
        "yearly": "Annuale",
        "weekly": "Giorno della settimana",
        "Please_select_at_least_one_day": "Si prega di selezionare almeno un giorno",
        "Booking_lead_time": "Tempo di prenotazione",
        "Start_date_must_be_before_end_date": "The start date must be before the end date"
    },
    "penaltyPolicy": {
        "penaltyPolicy": "Politica di Penalità",
        "Reservation": "Prenotazione",
        "onDemand": "On-demand",
        "noShow": "No Show",
        "driverNoShow": "Assenza del conducente",
        "freeCancellation": "Finestra di cancellazione gratuita",
        "fieldExclusions": "Campi Inclusi",
        "penaltyActive": "Annulla Livello di Durata - prima dell'orario di ritiro",
        "penaltyType": "Tipo di Penalità",
        "Compensation": "Compenso fornitore/autista",
        "Create_penalty_success": "Il modello di penalità è stato creato con successo",
        "Create_penalty_fail": "Si sono verificati errori durante la creazione del modello di penalità",
        "Update_penalty_success": "Il modello di penalità è stato aggiornato con successo",
        "Update_penalty_fail": "Si sono verificati errori durante l'aggiornamento del modello di penalità",
        "confirmDelete": "Conferma Cancellazione",
        "confirmDeleteContent": "Sei sicuro di voler eliminare questa politica di penalità? Eliminare questa politica disconnetterà da tutte le tariffe di prenotazione.",
        "Delete_success": "Il modello di penalità è stato eliminato con successo.",
        "Delete_fail": "Si sono verificati errori durante l'eliminazione del modello di penalità",
        "payoutPolicy": "Politica di Pagamento",
        "commission": "Percentuale della Penale per il Cliente",
        "commissionPayout": "Percentuale di Pagamento del Fornitore",
        "fixAmount": "Importo",
        "amount": "Importo",
        "amount_driver": "Importo",
        "percent": "Percent",
        "percent_driver": "Percentuale basata sulla tariffa",
        "basedOnPayout_driver": "Percentuale basata sul Payout",
        "percentPayout": "% di Pagamento",
        "percentFare": "% di Tariffa",
        "penaltyFee": "Penale di cancellazione",
        "commissionType": "Tipo di Comp",
        "commissionFee": "Compenso",
        "tax": "Tassa",
        "techFee": "Quota Tecnologica",
        "minute": "minuto",
        "hour": "ora",
        "setDefaultSuccess": "La politica di penalità predefinita è stata impostata con successo",
        "setDefaultFail": "Si sono verificati errori durante l'impostazione della politica di penalità predefinita"
    },
    "rateTemplates": {
        "Rate_Templates": "Modelli di Tariffa",
        "newRate": "Nuovo Modello di Tariffa",
        "placeHolderName": "Inserisci il nome del modello di tariffa",
        "Assign_Rate": "Assegna Tariffa",
        "carTypeName": "Nome Tipo Auto",
        "appDisplayName": "Nome visualizzato dell'app",
        "assign_rate_success": "Il tipo di auto è stato assegnato al tasso con successo",
        "assign_rate_fail": "Si sono verificati errori durante l'assegnazione della tariffa",
        "confirmDeleteTitle": "Conferma Cancellazione",
        "confirmDelete": "Sei sicuro di voler eliminare questo modello? Eliminare questo modello scollegarà da tutti i partner/corporazioni a cui è collegato.",
        "setDefaultSuccess": "Il modello di tasso predefinito è stato impostato con successo",
        "setDefaultFail": "Si sono verificati errori durante la configurazione del modello di tariffa predefinito",
        "Delete_rate_template_success": "Il modello di tariffa è stato eliminato con successo",
        "Delete_rate_template_fail": "Si sono verificati errori durante l'eliminazione del modello di tariffa",
        "setDefault": "Imposta come predefinito",
        "Regular": "Tariffa normale",
        "Sharing": "Tasso di Condivisione Stradale",
        "Flat": "Tariffa Fissa",
        "Hourly": "Orario/ Giornaliero",
        "Delete_default": "Se provi a eliminare il modello predefinito, non dovremmo permetterlo finché non impostano un altro tasso predefinito."
    },
    "supplierPlan": {
        "Supplier_Plan": "Piano Fornitore",
        "rateTemplate": "Schema Tariffario",
        "rateTemplateNote": "il calcolo della tariffa utilizzato per determinare l'importo pagato al conducente o fornitore.",
        "percent": "Commissione della Flotta",
        "percentNote": "la percentuale addebitata dalla flotta su ogni prenotazione.",
        "amount": "Importo Fisso",
        "amountNote": "l'importo che la flotta detrae per ogni prenotazione.",
        "supplierPenaltyId": "Politica di Penale per i Fornitori",
        "payoutType": "Tipo",
        "Select_penalty_policy": "Seleziona Politica di Penalità",
        "Select_corporate": "Seleziona Corporate",
        "Select_supplier_plan": "Seleziona Piano Fornitore",
        "Create_supplier_plan_success": "Il piano fornitore è stato creato con successo",
        "Create_supplier_plan_fail": "Si sono verificati errori durante la creazione del piano fornitore",
        "Update_supplier_plan_success": "Il piano del fornitore è stato aggiornato con successo",
        "Update_supplier_plan_fail": "Si sono verificati errori durante l'aggiornamento del piano fornitore",
        "Payout_Plan": "Piano di Pagamento",
        "Payout_Plan_note": "Imposta quanto viene pagato il fornitore.",
        "default": "Predefinito",
        "custom": "Piano Personalizzato",
        "cannotSetPayout": "Impossibile impostare il piano di pagamento per il conducente del partner esterno."
    },
    "stopSales": {
        "stopSales": "Fermare la Vendita",
        "confirm_delete": "Sei sicuro di voler eliminare questa polizza?",
        "Create_stop_sales_success": "La sospensione delle vendite è stata creata con successo.",
        "Create_stop_sales_fail": "Si sono verificati errori durante la creazione delle vendite di stop",
        "Update_stop_sales_success": "La sospensione delle vendite è stata aggiornata con successo.",
        "Update_stop_sales_fail": "Si sono verificati errori durante l'aggiornamento delle vendite bloccate",
        "Delete_success": "La sospensione delle vendite è stata eliminata con successo.",
        "Delete_fail": "Si sono verificati errori durante l'eliminazione delle vendite bloccate",
        "allVehicle": "Tutti i veicoli",
        "allZone": "Tutta la Zona"
    },
    "generalSetting": {
        "alertNotifications": {
            "title": "Notifiche di avviso",
            "emails": "Email",
            "emailsPlaceholder": "Inserisci email",
            "slack": "Canale Slack (Istruzioni)",
            "slackPlaceholder": "URL POST di Slack",
            "discord": "Canale Discord (Istruzioni)",
            "discordPlaceholder": "Entra nel canale Discord",
            "telegram": "Canale Telegram (Istruzioni)",
            "telegramPlaceholder": "Entra nel Canale Telegram"
        },
        "showFare": {
            "title": "Mostra la tariffa all'autista",
            "totalFare": "Tariffa totale",
            "estimateGross": "Stimare il guadagno lordo"
        },
        "carHailing": "Richiamo in strada",
        "regular": "Regolare",
        "cancelTimeout": "Annulla automaticamente le prenotazioni per timeout",
        "allowStripePaymentLink": "Consenti di generare il link di pagamento Stripe",
        "flat": "Piatto",
        "techFee": "Commissione tecnologica per transazione",
        "customizeLogo": "Personalizza il logo della dashboard",
        "logo": "Logo",
        "customerApp": "App del Cliente",
        "hourly": "Orario",
        "shuttle": "Navetta",
        "parcel": "Pacco",
        "freeCancelTime": "Tempi di cancellazione gratuita per giorno",
        "AM": "AM",
        "PM": "PM",
        "RUSH_HOUR": "Sovrapprezzo",
        "Name": "Nome",
        "Date": "Data",
        "Mon": "Lu",
        "Tue": "Ma",
        "Wed": "Me",
        "Thu": "Gio",
        "Fri": "Ve",
        "Sat": "Sa",
        "Sun": "Dom",
        "Time_range": "Variazioni nel tempo",
        "From": "Da",
        "To": "A",
        "Rush_hour_time_calculation": "Calcolo del tempo di sovrapprezzo",
        "Rush_hour_surcharge": "Sovrapprezzo",
        "Required_fields": "Campi obbligatori",
        "Save": "Salva",
        "Cancel": "Cancella",
        "MDISPATCHER_CANCELLATION": "CANCELLAZIONE PASSEGGERO/ MDISPATCHER/ WEB BOOKING ",
        "Book_now": "Prenota ora",
        "MDISPATCHER_CANCELLATION_TOOLTIP": "Pax / Partner / Cancellazione prenotazione web",
        "Book_now_toolTip": "La tassa di cancellazione è applicabile se le prenotazioni su richiesta vengono cancellate entro",
        "Book_later_toolTip": "La penale di cancellazione è applicabile se una prenotazione viene cancellata entro prima dell'orario di ritiro",
        "Drv_Book_now_toolTip": "La tassa di cancellazione è applicabile se le prenotazioni on-demand vengono annullate entro il tempo stabilito, a partire dal momento di accettazione.",
        "Drv_Book_later_toolTip": "La tassa di cancellazione è applicabile se le prenotazioni anticipate vengono annullate entro il tempo stabilito, prima dell'orario di ritiro previsto.",
        "Free_cancel": "Durata di cancellazione gratuita",
        "Hide_cancel_btn": "Nascondi il pulsante di annullamento dopo tempi impostati",
        "Driver_cancellation": "Cancellazione del conducente",
        "Time_day": "Volte al giorno",
        "Duration": "Durata",
        "Times": "Orari",
        "Book_later": "Prenota più tardi",
        "Intercity": "Intercity",
        "Intercity_tooltip": "La tassa di cancellazione è applicabile se una prenotazione intercity viene annullata entro il tempo stabilito, prima dell'orario di ritiro.",
        "MDISPATCHER_NO_SHOW": "ASSENTE",
        "AIRPORT_FEE": "TARIFFA AEROPORTO",
        "From_airport": "Dall’aereoporto",
        "To_airport": "All’aereoporto",
        "MEET_DRIVER": "INCONTRA L’AUTISTA",
        "On_curb": "Trattenuto",
        "Meet_Greet": "Incontra & Saluta",
        "Add": "Aggiungi",
        "Edit": "Modifica",
        "DELETE_SURCHARGE": "Elimina sovrapprezzo",
        "DELETE_SERVICE": "Elimina servizio",
        "CHANGE_APPLY_SERVICE_FEES": "Cambia le commissioni di servizio applicate",
        "DELETE_CONFIRM": "Sei sicuro di voler eliminare questi oggetti?",
        "DELETE_SURCHARGE_CONFIRM": "Sei sicuro di voler eliminare il sovrapprezzo selezionato?",
        "DELETE_ADDITIONAL_SERVICES_CONFIRM": "Sei sicuro di voler eliminare il servizio selezionato?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_CUSTOM": "Sei certo di applicare tariffe diverse per le zone separati?",
        "CHANGE_APPLY_SERVICE_FEES_CONFIRM_ALL": "Sei sicuro di voler applicare le stesse commissioni per tutte le zone?",
        "EDIT_SERVICE_FEES": "Modifica le spese di servizio",
        "EDIT_SERVICE_FEES_CONFIRM": "Sei sicuro di volere lasciare senza salvare le impostazioni per %{currentZone}?",
        "HEAVY_TRAFFIC": "TRAFFICO INTENSO",
        "Heavy_traffic_surcharge": "Sovrapprezzo traffico intenso",
        "TOLL_FEE": "Pedaggio",
        "parkingFee": "Tariffa di parcheggio",
        "gasFee": "Commissione del gas",
        "OTHER_FEES": "ALTRE SPESE",
        "Can_edit": "capace di modifica",
        "Can_add_note": "capace di aggiungere note ",
        "Other_fees_amount": "Importo altre spese",
        "TAX": "TASSE",
        "Tax_surcharge": "Sovraccarico Tassa",
        "TIP": "MANCIA",
        "Default_tip": "Mancia prestabilita",
        "RESERVATION_REMINDER": "Promemoria prenotazione",
        "Driver_app_SMS_alert_before": "Driver app - avverti prima",
        "notifyWhenDriverFailStartTrip": "Notificare l'operatore se il conducente non inizia il viaggio prima dell'orario di prelievo",
        "notifyWhenDriverFailStartTripTooltip": "Le notifiche verranno visualizzate nella sezione notifiche della piattaforma. Puoi anche configurare avvisi da inviare via email, Slack, Discord o Telegram per aggiornamenti tempestivi.",
        "notifyPaxBeforeQuote": "Notify passenger before quote expiration time",
        "Pax_app_alert_before": "Pax - app avverti prima",
        "Confirm_driver_info_via_email_before": "Inviare conferma di prenotazione via email / sms al cliente prima di",
        "Confirm_driver_info_via_email_before_hint": "Il sistema invierà una conferma di prenotazione al cliente in base all'orario impostato, prima dell'orario di ritiro.",
        "Show_request_tab_on_driver_app": "Mostra la scheda 'Richiesta' sull'app del conducente",
        "Show_preferred_tab_on_driver_app": "Mostra la scheda 'Preferita' nell'app del conducente",
        "Sound_notification": "Notifica sonora",
        "Advance_information": "Informazioni anticipate per utenti aziendali",
        "Load_general_fail": "Si sono verificati errori durante il caricamento delle impostazioni generali",
        "Update_general_success": "Le impostazioni generali sono state aggiornate con successo",
        "Update_general_fail": "Sono intervenuti degli errori nella fase di caricamento delle impostazioni generali",
        "Time_over_lap": "Le fasce orarie non devono sovrapporsi",
        "Allow_passenger_to_register_as_corp_traveler": "Consenti al passeggero di registrarsi come viaggiatore aziendale",
        "Not_Allow_Make_Booking_Without_Assign_Fare": "Non consentire al passeggero di effettuare una prenotazione se la tariffa base é = 0.00",
        "Not_Allow_show_car_type_on_cc": "Non mostrare il tipo di auto su CC se non è assegnata alcuna tariffa",
        "Disable_Direct_Invoicing_Receipt_Email": "Disabilita ricevuta fatturazione diretta",
        "Additional_services": "Modifica servizi aggiuntivi",
        "Edit_additional_services": "Modifica servizi aggiuntivi",
        "Service_Fee_By_Currencies": "Spese servizio",
        "Service_type": "Tipo di servizio",
        "Optional": "Opzionale",
        "Compulsory": "Obbligatorio",
        "Vehicle_type": "Tipo veicolo/identità",
        "Adding_additional_service_success": "Add service successfully",
        "Update_additional_service_success": "Servizio aggiornato con successo",
        "Delete_additional_service_success": "Il servizio è stato eliminato con successo",
        "Adding_additional_service_fail": "Impossibile aggiungere servizio ",
        "Update_additional_service_fail": "Impossibile aggiornare servizio",
        "Other_settings": "Altre impostazioni",
        "Operator_assign_error": "Sono intervenuti degli errori nella fase di assegnazione dell'operatore",
        "Create_surcharge_success": "Sovrapprezzo creato con successo",
        "Update_surcharge_success": "Sovrapprezzo aggiornato con successo",
        "Delete_surcharge_success": "Sovrapprezzo eliminato con successo",
        "Create_surcharge_fail": "Impossibile creare sovrapprezzo ",
        "Update_surcharge_fail": "Impossibile aggiornare sovrapprezzo ",
        "Delete_surcharge_fail": "Impossibile eliminare sovrapprezzo",
        "Get_surcharge_detail_fail": "Impossibile ottenere dettagli sovrapprezzo ",
        "Repeat": "Ripeti",
        "DayOfWeek": "Giorno della settimana",
        "SingleDay": "Giorno singolo",
        "Yearly": "Annuale",
        "Backup_phone_number": "Backup numero di telefono",
        "Backup_phone_number_hint": "Dirigi su questo numero quando autista e passeggero sono fuori dalle zone operazionali",
        "Apply_countdown_clock": "Applica conto alla rovescia",
        "No_show_duration_tooltip": "Imposta tempo di display del bottone Non presentato dopo che l'autista abbia selezionato il bottone Arrivato sull'app autista",
        "Limit_radius": "Raggio limite",
        "Limit_radius_tooltip": "Il conducente può segnalare una prenotazione come mancata presentazione entro questo raggio",
        "Limit_radius_arrive_pickup": "Limita il raggio in cui il conducente può arrivare e ritirare per la prenotazione del trasporto",
        "Booking_validation": "Validazioni di prenotazione",
        "Invalid_period_of_time": "Periodo di tempo invalido",
        "hide_Provider_Filter_From_Corporate_Board": "Nascondi il filtro del fornitore dalla bacheca aziendale",
        "customer_email_is_optional": "L'email del passeggero é opzionale sulla app passeggero",
        "disable_hourly_rate": "Disabilita la tariffa oraria quando sono disponibili sia la tariffa oraria che quella fissa",
        "customer_gender_is_compulsory": "Il genere del cliente è obbligatorio nell'app passeggeri",
        "SHOW_MAP_STATUS": "Mostra stato mappa",
        "Pay_to": "Pagare a",
        "EMERGENCY_SOS": "Emergenza S.O.S",
        "customer_address_is_compulsory": "L'indirizzo del cliente è obbligatorio nell'app passeggeri",
        "customer_id_is_compulsory": "ID # / Nazionale IC # documento del cliente è obbligatoria su Pax app",
        "allowPassengerToUploadDocument": "Lasciare passeggero per caricare ID # / Nazionale IC # documento",
        "compulsoryNationalIcDocumentInPaxApp": "ID # / Nazionale IC # documento del cliente è obbligatoria su Pax app",
        "doNotAllowAddDriverWhenNationalIdDuplicated": "Non consentire all'operatore di aggiungere un conducente quando l'ID nazionale è duplicato",
        "forceCustomerToUseLiveLocation": "Costringere il cliente a utilizzare la Posizione Live",
        "disableMarketPlace": "Disabilita il Market Place per i nuovi conducenti",
        "dontShowSecondStageImmediately": "Nascondi registrazione fase 2",
        "dontAddCarMM": "Non consentire al conducente di aggiungere nuovi marchi/modelli di auto",
        "dontEditCapability": "Do not allow Driver to edit Driver Capability",
        "compulsoryCarInsurance": "L'assicurazione auto per conducenti è obbligatoria",
        "marketPlace": "Mercato",
        "Enable": "Abilita",
        "Disable": "Disabilita",
        "showTotalFareWithoutPromotionOnDriverApp": "Mostra la tariffa totale senza promozione sull'app Driver",
        "showTotalFareWithoutPromotionOnDriverApp_hint": "- Trasporto: applica questa impostazione prima che il conducente effettui il pagamento. <br/> - Consegna e Intercity: applica questa impostazione prima che il conducente inizi il lavoro.",
        "hideFareOnPaxAppForAllCorporateBookings": "Nascondi la tariffa sull'app Pax per tutte le prenotazioni aziendali",
        "hidePaxNameAvatarOnDispatchScreen": "Nascondi le informazioni del cliente nell'app Driver prima dell'inizio del viaggio",
        "showFullCustomerNameOnDriverApp": "Mostra il nome completo del cliente nell'app Driver",
        "hideDriverLogoutBtn": "Nascondi il pulsante di disconnessione dell'autista nell'app Driver",
        "showMeetAndGreetButtonForEveryBooking": "Mostra il pulsante Meet & Greet per ogni prenotazione",
        "showEcontract": "Mostra pulsante E-Contract",
        "isShowConfirmationCode": "Mostra il codice di conferma della prenotazione",
        "showIncidentReportButton": "Pulsante Mostra Incidente",
        "inReviewStatus": "Stato in revisione",
        "inReviewStatusTooltip": "Segna una prenotazione come \"In revisione\". Il viaggio rimane attivo fino a quando l'operatore non lo chiude.",
        "incidentBtnDrvApp": "Mostra il pulsante \"Incidente\" nell'app Driver",
        "incidentBtnDrvAppTooltip": "Aggiunge un pulsante nei viaggi attivi per i conducenti per segnalare incidenti, che l'operatore può poi esaminare e chiudere.",
        "fareChangeTolerance": "Fare tolleranza cambio",
        "fareChangeToleranceTooltip": "Apportare modifiche superiori a questo % richiede l'approvazione manuale da parte dell'operatore.",
        "groupManifest": "Manifesto di Gruppo",
        "JobOrderedBy": "Ordine di lavoro da",
        "optional": "Opzionale",
        "pickupTime": "Orario di ritiro",
        "route": "Percorso",
        "settings": "impostazioni",
        "Default_value": "Valore predefinito",
        "limitTopupAmount": {
            "valueByCurrencies": "Importo di avviso",
            "minimumByCurrencies": "Importo minimo di ricarica",
            "maximumByCurrencies": "Importo massimo di ricarica",
            "title": "Importo minimo e massimo di ricarica"
        },
        "driverApp": "App per conducenti",
        "passengerApp": "App Passeggero",
        "Default_Topup_Values": "Valori di ricarica predefiniti",
        "service_fees": "Il costo del servizio",
        "commission_fleet": "Commissione Flotta Predefinita",
        "apply_all": "Lo stesso per tutte le zone operative",
        "apply_custom_zone": "Separati in ciascuna zona operativa",
        "apply": "Applica",
        "tollFeeDriverCanInput": "quantità di immissione conducente può",
        "unlimited": "Illimitato",
        "limited": "Limitato",
        "sameFee": "stessa tassa",
        "customizedAirportfee": "tassa aeroportuale su misura",
        "noteAirportFeeModal": "Nota: qualsiasi aeroporto non nella lista non verrà applicata l'aeroporto a pagamento.",
        "intercity_schedule_trip_time_range": "Per garantire l'ordine cronologico del tempo di prenotazione, si prega di assicurarsi che l'intervallo di tempo dei viaggi preferiti/richiesti sia maggiore rispetto ai viaggi programmati.",
        "airportFee": {
            "tooltipApply": "tassa aeroportuale di default sarà applicata per ogni viaggio da / per l'aeroporto di default. Se tassa aeroporto è personalizzato quindi sarà applicata nuova tassa per quel posto.",
            "titleSearchAiportZone": "Si prega di cercare l'aeroporto e aggiungere il canone",
            "airport": "Aeroporto",
            "currency": "Valuta",
            "fromAirportFee": "Da tassa aeroportuale",
            "toAirportFee": "Tariffa per l'aeroporto",
            "action": "Azioni"
        },
        "Yes": "Si",
        "No": "No",
        "tipPaymentMethod": "Payment methods available for customer to tip his/her driver after the ride",
        "allowPaxUpdateTip": "Consenti ai passeggeri di aggiornare la percentuale della mancia durante il viaggio",
        "tipDefaultValues": "Suggerimento predefinito dopo la corsa",
        "creadit": "Carta di credito (Carta personale / Carta aziendale)",
        "wallet": "Portafoglio",
        "tnGeWallet": "TnG eWallet",
        "vippseWallet": "Vipps",
        "DurationRegularBooking": "Duration (for regular bookings)",
        "googlePay": "Google Pay",
        "applePay": "Apple Pay",
        "DurationRegularBookingToolTip": "No show\" button will be displayed in after the driver taps on \"Arrived\" button on Driver app.",
        "noShowCountDown": {
            "customizedNoShow": "Personalizzazione per località particolari (ad es. Aeroporto ...)",
            "customizedNoShowTitle": "Applica la durata del conto alla rovescia per mancata presentazione per determinate località (ad es. Aeroporto ...)"
        },
        "maxWaitTime": "Tempo di attesa massimo extra",
        "maxWaitTimeToolTip": "Questo è il massimo tempo di attesa extra che verrà addebitato al cliente. Hai la flessibilità di personalizzare la tariffa per minuto nelle impostazioni della tua tariffa.",
        "maxWaitTimePlaceholder": "Tempo massimo di attesa per la carica",
        "HEAT_MAP": "Mappa della domanda",
        "heatMap": {
            "defaultMode": "Modalità predefinita",
            "radius": "Raggio",
            "intensity": "Intensità",
            "opacity": "Opacità",
            "requestedBookings": "Prenotazioni richieste",
            "activePassengers": "Passeggeri attivi",
            "completedBookings": "Prenotazioni completate",
            "timeoutBookings": "Prenotazioni di timeout",
            "tooltipRadius": "Il raggio di influenza per ogni punto dati, in pixel.",
            "tooltipIntensity": "L'intensità massima della mappa di calore.",
            "tooltipOpacity": "L'opacità della mappa di calore, espressa come un numero compreso tra 0 e 1."
        },
        "schedule_trip": "Pianifica viaggio",
        "driver_starts_trip_before_set_time": "Il conducente inizia il viaggio prima dell'orario stabilito",
        "request_trip": "Richiedi viaggio",
        "preferred_trip": "Viaggio preferito",
        "time_range": "Intervallo di tempo per la richiesta e viaggio preferito",
        "working_time": "Tempo di lavoro",
        "hour": "ora",
        "hours": "ore",
        "minutes": "minuti",
        "indicate_pickup_time_in_advance_to_customer": "Indica in anticipo l'orario di ritiro al cliente.",
        "customers_can_select_start_time_and_request_intercity_trip": "I clienti possono selezionare l'orario di inizio e richiedere un viaggio interurbano. Anche i conducenti possono creare il loro viaggio preferito con il proprio programma. Esempio: un intervallo di tempo di 1 ora consentirà a clienti e conducenti di creare un viaggio interurbano che inizia alle 8:00 - 9:00, 9:00 - 10:00 o 10:00 - 11:00.",
        "this_setting_limits_customers_to_create_request_trip_within_working_hours_only": "Questa impostazione limita i clienti a creare richieste di viaggio solo durante l'orario lavorativo.",
        "face_mask_verify": "Verifica della maschera facciale",
        "faceMask_allZones": "Tutte le zone",
        "faceMask_customized": "Zona personalizzata",
        "turn_on_verify": "Attiva la verifica",
        "force_to_wear_face_mask": "Obbligo di indossare la mascherina",
        "time_range_to_verify": "Non verificare di nuovo entro",
        "customizedFaceMaskZone": "Verifica della maschera facciale personalizzata",
        "zoneOperation": "Zona Operativa",
        "FaceMaskCustomized": "Personalizzato",
        "time": "tempo",
        "day": "giorno",
        "days": "giorni",
        "allow_driver_to_skip_verification_after": "Consenti al conducente di saltare la verifica dopo",
        "driver_need_to_verify": "Quando il conducente deve verificare",
        "open_app": "Apri l'app",
        "start_reservation": "Inizia prenotazione",
        "choose_at_least_one": "Devi selezionare almeno un'azione per continuare.",
        "face_mask_customized_fail": "Devi selezionare almeno un'azione per continuare ({0}).",
        "vehicleAgeLimit": "Limite di età del veicolo",
        "vehicleAgeLimit_years": "anni",
        "founderFund_firstBooking": "Founder's Fund: prima prenotazione solo",
        "distance_diversity": "Diversità della distanza",
        "Add_Surcharge_Distance": "Aggiungi",
        "from": "Da",
        "to": "Per",
        "surchargeValue": "Supplemento",
        "actions": "Azione",
        "please_enter_distance_range_valid": "La distanza %{name} non è valida!",
        "please_enter_distance_to": "Si prega di inserire la distanza 'A'",
        "please_enter_surchargeValue": "Si prega di inserire il costo aggiuntivo per la distanza nel range %{name}",
        "please_enter_surchargeValue_is_number": "Si prega di inserire un numero valido per \"Sovrapprezzo\" per l'intervallo di distanza %{name}",
        "Update_service_fee_success": "Le spese di servizio sono state aggiornate con successo",
        "Update_service_fee_fail": "Si sono verificati errori durante l'aggiornamento delle tariffe di servizio",
        "Update_fleet_commission_success": "La commissione predefinita della flotta è stata aggiornata con successo.",
        "Update_fleet_commission_fail": "Si sono verificati errori durante l'aggiornamento della commissione predefinita della flotta",
        "RESERVATION_POLICY": "Politica di prenotazione",
        "default_expected_pickup_time": "Tempo di ritiro previsto predefinito",
        "default_expected_pickup_time_hint": "Il valore predefinito che ti aspetti che un conducente arrivi dall'orario di ritiro.",
        "same_original_pickup_time": "Stesso orario di ritiro originale",
        "quarter_before": "15 minuti prima",
        "half_before": "30 min prima",
        "quarter_after": "15 min dopo",
        "half_after": "30 min dopo",
        "custom": "Personalizzato",
        "min_before": "min prima",
        "min_after": "min dopo",
        "TransactionFee": "Commissione di transazione",
        "creditCardPercent": "Carta di credito/ prepagata",
        "directBilling": "Fatturazione diretta",
        "externalCard": "External Card",
        "zoneIds": "Località",
        "vehicles": "Veicoli",
        "default_expected_pickup_time_airport": "Tempo di ritiro previsto predefinito (Arrivi Aeroporto)",
        "expectedPickupTooltip": "Se viene fornito un numero di volo, questo buffer predefinito verrà applicato per calcolare automaticamente l'orario di ritiro. Questo si applica solo alle prenotazioni create tramite il pannello di amministrazione."
    },
    "social": {
        "pax_app": "App passeggeri",
        "driver_app": "App per conducenti",
        "default": "Predefinito",
        "customized": "Personalizzato",
        "html": "HTML",
        "about": "Informazioni",
        "email": "Supporto via email",
        "enablePhone": "Numero di telefono",
        "phone": "",
        "policy": "Link all'Informativa sulla Privacy",
        "termOfUse": "Termini di utilizzo del link",
        "site": "Sito web",
        "logoDriverIOS": "Logo - IOS",
        "logoDriverAndroid": "Logo - Android",
        "htmlUrl": "file HTML",
        "Update_fail": "Si sono verificati errori durante l'aggiornamento dei social",
        "Update_success": "Il sociale è stato aggiornato con successo"
    },
    "user": {
        "Show_per_page": "Oggetti per pagina",
        "Page": "Pagina",
        "Search_here": "Cerca qui",
        "show_pages": "Mostra {0} - {1} di {2}",
        "Username": "Nome utente",
        "Name": "Nome",
        "Phone_number": "Numero di telefono",
        "Email": "Email",
        "Permission": "Permesso",
        "Status": "Stato",
        "Actions": "Azioni",
        "Active": "Attiva",
        "Inactive": "Inattivo",
        "Edit": "Modifica",
        "Deactivate": "Disattivato",
        "Delete": "Cancella",
        "Add": "Aggiungi",
        "ADD_USER": "Aggiungi Utilizzatore",
        "First_name": "Nome",
        "Last_name": "Cognome",
        "AgendId": "Utilizzatore #",
        "Email_address": "Indirizzo email",
        "Address": "Indirizzo",
        "Required_fields": "Campi obbligatori",
        "Save": "Salva",
        "Cancel": "Cancella",
        "EDIT_USER": "Modifica Utilizzatore",
        "Yes": "Si",
        "DELETE_USER": "ELIMINA UTILIZZATORE",
        "DETAIL_USER": "Dettagli utilizzatore",
        "DELETE_CONFIRM": "Sei sicuro di eliminare l'utilizzatore?",
        "Update_user_fail": "Sono intervenuti degli errori nella fase di aggiornamento dell'utilizzatore",
        "Update_user_success": "L'utilizzatore é stato aggiornato con successo",
        "Create_user_fail": "Sono intervenuti degli errori nella fase di creazione dell'utilizzatore",
        "Create_user_success": "Utente {0} registrato con successo. Verifica l'indirizzo email {1} per le credenziali di accesso.",
        "Load_user_fail": "Sono intervenuti degli errori nella fase di caricamento dell'utilizzatore",
        "Update_user_status_fail": "Sono intervenuti degli errori nella fase di aggiornamento status dell'utilizzatore",
        "Delete_user_fail": "Sono intervenuti degli errori nella fase di eliminazione dell'utilizzatore",
        "Delete_user_success": "L'utilizzatore é stato eliminato con successo",
        "CONFIRM_RESET_PASSWORD": "Vuoi resettare la password?",
        "RESET_PASSWORD": "Vuoi resettare la password?",
        "Reset_password": "Resetta password",
        "Select_permission": "Seleziona Permesso",
        "Reset_password_success": "Reset password successful"
    },
    "report": {
        "query": {
            "errorMessage": {
                "bookFrom": "Per favore seleziona prenotazione da",
                "paymentMethod": "Per favore seleziona il mezzo di pagamento",
                "bookingType": "Seleziona il tipo di prenotazione",
                "ratingType": "Per favore seleziona tipo di valutazione",
                "stars": "Per favore seleziona tipo di valutazione",
                "type": "genere",
                "transactionType": "Per favore seleziona tipo di transazione",
                "serviceType": "Per favore seleziona tipo di servizio.",
                "rideService": "Per favore seleziona servizio corsa",
                "invalidEmail": "Per favore inserisci un indirizzo email valido."
            },
            "search": {
                "driverReferalPax": "Cerca: Nome del conducente, Numero di telefono",
                "passengerRefersPassengers": "Cerca: Nome Cliente, Numero di Telefono",
                "driverReferalPaxDetail": "Cerca: Nome Passeggero",
                "bookingDetails": "Search: Booking ID, Operator, Customer phone, Customer name, Driver name, ID# / National IC#, License plate, Queuing area, Note, Support ID",
                "financial": "Cerca: Nome del conducente, Telefono",
                "completedTime": "Tempo Completato",
                "collectedTime": "Tempo Raccolto",
                "financialDriver": "Cerca: ID prenotazione, nome del conducente, ID# / IC nazionale#",
                "carActivity": "Cerca targa",
                "affiliation": "Cerca: ID prenotazione",
                "prepaidTopUp": "Search: Company name, Top up ID, ID transazione",
                "operatorLogs": "Cerca: Nome operatore, Nome utente, Descrizione",
                "corporate": "Cerca: ID prenotazione, Nome del conducente, Utenti aziendali, Oggetto del caso cliente, Codice di addebito",
                "bookingLogs": "Search: Booking ID, Customer name, Driver name, ID# / National IC#",
                "rating": "Search: Booking ID, Customer phone, Customer name",
                "mDispatcher": "Search: Booking ID, mDispatcher name",
                "totalAdjustment": "Cerca: ID Prenotazione",
                "incidentCancellation": "Search: Booking ID, Customer phone, Customer name",
                "acceptanceCancellationRate": "Cerca: Nome del conducente, Numero di telefono",
                "revenueDriver": "Cerca: Nome del conducente",
                "dailyDriver": "Cerca: Telefono del conducente, Nome del conducente, ID# / Numero di identificazione nazionale#",
                "dailyCar": "Cerca: Targa, Permesso",
                "dailyDriverCar": "Cerca: Telefono del conducente, Nome del conducente, ID# / Numero di identificazione nazionale, Targa",
                "driverLoginStatus": "Cerca: Telefono del conducente, Nome del conducente, ID# / Numero di identificazione nazionale, Targa",
                "bookingSummary": "Cerca: Nome operatore, Nome utente, ID prenotazione",
                "creditWallet": "Search: Company name, Driver name, Booking ID, Operator",
                "cashWallet": "Cerca: Nome della compagnia, Nome del conducente, ID prenotazione, Numero di telefono",
                "SupplierWallet": "Cerca: Nome dell'azienda, ID prenotazione",
                "settlement": "Cerca: Nome del conducente, ID# / Numero IC nazionale#",
                "driverRating": "Search: Booking ID, Customer phone, Customer name",
                "driverWithdrawal": "Driver name, Phone, Company, ID transazione, Reference #",
                "penaltyCompensation": "Cerca: ID prenotazione, Nome conducente, Nome passeggero",
                "incompletePayment": "Cerca: ID prenotazione, ID supporto, Nome cliente",
                "passengerWallet": "Search: Booking ID, Customer Name",
                "driverDeposit": "Cerca: Nome della compagnia, Nome del conducente, ID prenotazione, Operatore",
                "refund": "Search: Booking ID, Trip Id, Customer name",
                "driverRefersCustomerBookings": "Search: Referral code",
                "driverHistory": "Cerca: ID pagamento",
                "merchantHistory": "Cerca: ID Payout",
                "firstWillWin": "Cerca: nome cliente, telefono cliente, ID cliente",
                "firstWillWinDriver": "Cerca: nome del conducente, telefono del conducente, nome utente",
                "merchant": "Cerca: negozio",
                "merchantCashTransactionHistory": "Search: Booking ID, ID transazione, Merchant name",
                "merchantCreditTransactionHistory": "Search: Booking ID, ID transazione, Merchant name",
                "deleteAccountRequest": "Cerca: Telefono",
                "affiliationPayoutHistory": "Cerca: ID di pagamento",
                "thirdPartyBooking": "Cerca: Id Prenotazione, Id Esterno"
            },
            "common": {
                "all": "Tutto"
            },
            "today": "Oggi",
            "sendDownloadLink": "Indirizzo Email del Destinatario",
            "generaltingYourExcel": "Si prega di notare che la generazione del file excel potrebbe richiedere del tempo. Te lo invieremo via email non appena sarà pronto.",
            "messageSuccess": "File in corso. Riceverai un'email quando sarà pronto. Monitora il progresso o scarica direttamente da Reports/Export History.",
            "thisMonth": "Questo Mese",
            "lastMonth": "Il mese scorso",
            "past30Days": "Gli ultimi 30 giorni",
            "thisYear": "Quest’anno",
            "custom": "Personalizzato",
            "customize": "personalizzare",
            "thisWeek": "Questa settimana",
            "past7Days": "Ultimi 7 giorni",
            "weekly": "Settimanale",
            "monthly": "Mensile",
            "allTime": "Tutti i tempi",
            "tomorrow": "Domani",
            "nextWeek": "Settimana Prossima",
            "lastWeek": "Settimana scorsa",
            "nextMonth": "Il mese prossimo",
            "next7Day": "Prossimi 7 Giorni",
            "yesterday": "Ieri",
            "fromDate": "Dalla data",
            "toDate": "Alla data",
            "driver": "Autista: %{name}",
            "customer": "Cliente: %{name}",
            "referralCode": "Codice di riferimento: %{name}",
            "referer": "Referer: %{name}",
            "referee": "Arbitro: %{name}",
            "usedPromoCode": "Promozione: %{name}",
            "voucherCode": "Codice: %{name}",
            "city": "Città",
            "company": "Azienda",
            "company_report": "Azienda: %{name}",
            "companySupplier_report": "Fornitore/Azienda: %{name}",
            "supplier_report": "Fornitore: %{name}",
            "corporate_report": "Corporate: %{name}",
            "campaign_report": "Campagna: %{name}",
            "operator": "Operatore",
            "farmType": "Tipo di fattoria",
            "carLicensePlate": "Targa vettura: %{name}",
            "settlementType": "Tipo",
            "bookingService": "Tipo di rete",
            "payoutOption": "Opzione di pagamento",
            "currency": "Moneta",
            "bookingFrom": "Prenotato da",
            "Provider": "Fornitore",
            "thirdPartyAction": "Azione",
            "paymentMethod": "Mezzo di Pagamento",
            "paymentStatus": "Stato del pagamento",
            "bookingType": "Tipo prenotazione",
            "adjustPrice": "Regola prezzo",
            "intercityRoute": "Percorso intercity",
            "ratingType": "Tipo di valutazione",
            "stars": "Valutazione",
            "driverRating": "Voti dell'autista",
            "vehicleRating": "Valutazione del veicolo",
            "mDispatcherType": "Tipo mDispatcher",
            "mDispatcher": "mDispatcher name",
            "campaign": "Campagna",
            "promocode": "Codice promozionale",
            "canceledBy": "Cancellato da",
            "timezone": "Fuso orario",
            "month": "Mese",
            "year": "Anno",
            "view": "Mostra",
            "action": "Azioni",
            "status": "Stato",
            "module": "Modulo",
            "driverType": "genere",
            "vehicleType": "Tipo di macchina",
            "serviceType": "Tipo di servizio",
            "expireDate": "Data di scadenza",
            "rideSharing": "car pooling",
            "rideService": "servizio corsa",
            "transactionType": "Tipo di Transazione",
            "completeFromCC": "Completa da CC",
            "withDrawalTransactionType": "Tipo di Transazione",
            "bookingStatus": "Stato della prenotazione",
            "withdrawalStatus": "Stato",
            "originalStatus": "Stato pagamento originale",
            "currentStatus": "Stato corrente di pagamento",
            "tip": "Consiglio",
            "type": "genere",
            "userType": "Tipo di utente",
            "eventType": "Tipo di evento",
            "eventState": "Stato dell'evento",
            "eventName": "Nome dell'evento",
            "merchantType": "Tipo di commerciante",
            "merchantService": "Servizio per commercianti",
            "storeName": "Negozio",
            "merchant": "Mercante",
            "event": "Nome dell'evento: %{name}",
            "store": "Nome del negozio: %{name}",
            "selectedMerchant": "Commerciante: %{name}",
            "associatedApps": "App associate",
            "settlement": "Accordo",
            "rideServiceItem": {
                "all": "Tutto",
                "regulation": "Regolamento",
                "rideSharing": "Car pooling"
            },
            "actionItem": {
                "all": "Tutto",
                "login": "Accedi",
                "logout": "esci",
                "bookIn": "Indisponibile",
                "bookOff": "Non Disponibile",
                "deny": "Respingi",
                "ignore": "Ignora",
                "accept": "Accettato",
                "startTrip": "Sto arrivando",
                "updateBooking": "Aggiornamento",
                "arrive": "Arrivare",
                "pickup": "Carico",
                "drop": "Scarica",
                "complete": "Completato",
                "noShow": "Assente",
                "driverNoShow": "Assenza del conducente",
                "rqJob": "Assegnazione",
                "cancel": "Cancellato"
            },
            "loginStatusItem": {
                "all": "Tutto",
                "online": "connesso",
                "offline": "sconnesso"
            },
            "payoutType": "Tipo di pagamento",
            "affiliationPayoutTypeItem": {
                "auto": "Pagamento automatico",
                "manual": "Pagamento manuale"
            },
            "affiliationSettlementItem": {
                "payable": "Pagabile",
                "receivable": "Crediti"
            },
            "affiliationPaymentMethod": {
                "online": "Online",
                "directInvoicing": "Fatturazione diretta"
            },
            "payoutPaymentStatusItem": {
                "paid": "Pagato",
                "pending": "In attesa"
            },
            "farmTypeItem": {
                "all": "Tutto",
                "farmIn": "Fattoria in",
                "farmOut": "Farm out",
                "roaming": "Roaming",
                "affiliationOwner": "gruppo & proprietario affiliazione",
                "farmInAndAffiliationOwner": "Proprietario di fattoria e affiliazione",
                "farmOutAndAffiliationOwner": "Proprietario di affiliazione e subappalto"
            },
            "settlementDriverTypeItem": {
                "all": "Tutti gli autisti",
                "individual": "Singolo autista"
            },
            "shortTrip": {
                "all": "Tutto",
                "shortTrip": "Breve viaggio",
                "nonShortTrip": "Viaggio non breve"
            },
            "paymentMethodItem": {
                "B2BTerminal": "B2BTerminal",
                "webBooking": "Prenotazione online",
                "pendingPayment": "Pagamento in attesa",
                "all": "Tutto",
                "cash": "Contanti",
                "cashBySender": "Contante dal mittente",
                "cashByRecipient": "Contante per destinatario",
                "personalCard": "Carta personale",
                "corporateCard": "Carta Aziendale",
                "qrCodePayment": "Pagamento con codice QR",
                "directBilling": "Fatturazione diretta",
                "externalCard": "Carta esterna",
                "mDispatcherCard": "Carta mDispatcher",
                "corporatePrepaid": "Carta Prepagata",
                "canceled": "Cancellato",
                "noShow": "Assente",
                "driverNoShow": "Assenza del conducente",
                "incident": "Incidente",
                "fleetCard": "Carta esterna",
                "applePay": "Apple Pay",
                "creditCardExternal": "Carta di credito",
                "paxWallet": "Portafoglio",
                "tngeWallet": "TnG eWallet",
                "vippseWallet": "Vipps",
                "zainCash": "ZainCash",
                "xendit": "Xendit",
                "exAlipay": "Alipay",
                "FIB": "FIB",
                "SantimPay": "SantimPay",
                "gCash": "GCash",
                "completedWithoutService": "Completato senza driver",
                "BankOfGeorgia": "Banca di Georgia",
                "partialCompleted": "Completato Parzialmente",
                "failed": "Fallito",
                "googlePay": "Google Pay",
                "paymentLink": "Link di pagamento",
                "easyPaisa": "Easy Paisa",
                "jazzCash": "Jazz Cash",
                "samsung_pay": "Samsung Pay",
                "kakao_pay": "Kakao Pay",
                "naver_pay": "Naver Pay",
                "wechat_pay": "WeChat Pay",
                "alipay": "Alipay",
                "paynow": "PayNow",
                "grabpay": "GrabPay",
                "cashapp": "Cash App Pay"
            },
            "paymentStatusItem": {
                "all": "Tutto",
                "fullPayment": "Pagamento completo",
                "partialPayment": "Pagamento parziale",
                "pendingPayment": "In attesa di Pagamento",
                "partialRefund": "Rimborso parziale",
                "fullRefund": "Rimborso completo"
            },
            "companySettlementTypeItem": {
                "all": "Tutto",
                "fleetOweCompany": "Flotta deve azienda",
                "companyOweFleet": "Flotta debitoria dell'azienda"
            },
            "bookingStatusItem": {
                "all": "Tutto",
                "completed": "Completato",
                "incident": "Incidente",
                "paxNoShow": "PAX no show",
                "driverNoShow": "Autista non presente",
                "rejected": "Respinto",
                "canceledByTimeOut": "Cancellato per timeout",
                "canceledByTimeOutRejected": "Cancellato per timeout (rifiutato)",
                "canceledByBookingBoard": "Cancellato dal pannello di prenotazione",
                "canceledByCustomer": "Cancellato dal cliente",
                "canceledBySupplier": "Cancellato dal fornitore"
            },
            "bookingFromItem": {
                "all": "Tutto",
                "paxApp": "Pax app",
                "mDispatcher": "MDispatcher",
                "kiosk": "Kiosk",
                "cc": "Centrale di gestione",
                "webBooking": "Prenotazione online",
                "carHailing": "Chiamata al volo",
                "streetSharing": "Condivisione stradale",
                "dashboard": "Tabellone delle prenotazioni",
                "corp": "Tabellone prenotazioni (CTM)",
                "dmc": "Tabellone prenotazioni (DMC)",
                "Boost_web_link": "Potenzia link web"
            },
            "thirdPartyActionItem": {
                "all": "Tutto",
                "searched": "Cercato",
                "allocated": "Assegnato",
                "updated": "Aggiornato",
                "cancelled": "Annullato"
            },
            "bookingTypeItem": {
                "batchDelivery": "Consegna in lotti",
                "all": "Tutto",
                "now": "Adesso",
                "reservation": "Prenotazione",
                "intercity": "Intercity",
                "delivery": "Consegna",
                "shuttle": "Navetta"
            },
            "adjustPrices": {
                "all": "Tutti",
                "normalPrice": "Prezzo normale",
                "addonPrice": "Prezzo dell'addon"
            },
            "bookingServiceItem": {
                "all": "Tutto",
                "roaming": "Roaming",
                "homeFleet": "Esternalizzare",
                "localBooking": "Prenotazione locale",
                "farmIn": "Fattoria in",
                "farmInAndAffiliationOwner": "gruppo & proprietario affiliazione",
                "provideService": "Fattoria in"
            },
            "ratingTypeItem": {
                "all": "Tutto",
                "like": "Mi Piace",
                "dislike": "Non Mi Piace"
            },
            "starsItem": {
                "all": "Tutto",
                "star1": "1 Stelle",
                "star2": "2 Stelle",
                "star3": "3 Stelle",
                "star4": "4 Stelle",
                "star5": "5 Stelle"
            },
            "incidentCanceledTypes": {
                "all": "Tutti",
                "incident": "Incidente",
                "canceled": "Cancellato"
            },
            "canceledByItem": {
                "all": "Tutto",
                "CorpAD": "Amministratore Aziendale",
                "passenger": "Passeggero",
                "driver": "Autisti",
                "merchant": "Commerciante",
                "CC": "CC",
                "mDispatcher": "MDispatcher",
                "Partner": "Partners",
                "webBooking": "Prenotazione online",
                "timeout": "Timeout"
            },
            "incidentStatusItem": {
                "RESOLVED": "Risolto",
                "DISPUTED": "Conteso"
            },
            "bookingSummaryActionItem": {
                "all": "Tutto",
                "create": "Crea",
                "update": "Aggiornamento",
                "cancel": "Cancella",
                "complete": "completato",
                "incident": "Incidente"
            },
            "transactionTypeItem": {
                "DriverFees": "Driver Fees",
                "bookingAdjustment": "Regolazione della prenotazione",
                "bankAccount": "Trasferito al conto bancario",
                "sentToCustomer": "Invia al cliente",
                "receivedFromDriver": "Ricevuto dal conducente",
                "sentToDriver": "Inviato al conducente",
                "creditWallet": "Trasferito al portafoglio di credito",
                "netEarning": "Guadagno Netto",
                "referralEarning": "Guadagno da Referral",
                "all": "Tutto",
                "topUp": "Ricarica",
                "editBalance": "Modifica saldo",
                "bookingDeduction": "Detrazione di prenotazione",
                "bookingPromo": "Promozione di prenotazione",
                "topUpGCash": "Ricarica di Gcash",
                "cashWallet": "Portafoglio in contante",
                "topUpMOLPay": "Ricarica tramite Razer Pay",
                "topUpQRIS": "Ricarica tramite QRIS",
                "topUpZainCash": "Ricarica tramite ZainCash",
                "topUpXendit": "Ricarica tramite Xendit",
                "topUpalipayExternal": "Ricarica tramite Alipay",
                "topUpFIB": "Ricarica tramite FIB",
                "topUpSantimPay": "Ricarica tramite SantimPay",
                "topUpTelebirr": "Ricarica tramite Telebirr",
                "topUpKsher": "Ricarica tramite Ksher",
                "topUpWallet": "Ricarica di {0}",
                "TnG": "Ricarica tramite TnG",
                "credit": "Ricarica con carta di credito",
                "ride": "Montare",
                "tipAfterCompleted": "Tip dopo il viaggio",
                "debtWriteOff": "Condono del debito",
                "refund": "Rimborso",
                "excessOffsetAmount": "Credito di Eccedenza di Liquidità",
                "excessDeductionAmount": "Addebito di Liquidità Eccedente",
                "cashExcess": "Addebito di Eccedenza di Liquidità",
                "gateway": "Ricarica dal gateway",
                "driverTopUpForPax": "Addebito di Eccedenza di Liquidità",
                "updatedBalance": "Saldo aggiornato",
                "partialEarning": "Guadagnare",
                "payout": "Payout manual",
                "payoutManual": "Payout manuale",
                "payoutDriver": "Pagamento",
                "itemValue": "Valori degli articoli",
                "redeemVoucher": "Riscatta codice #",
                "topUpReferrer": "Ricompensa per referral",
                "driverInsurance": "Assicurazione per conducenti",
                "cancellationPenalty": "Penale di cancellazione",
                "WingBank": "Trasferimenti al conto Wingbank",
                "customerDebt": "Debito del Cliente",
                "googlePay": "Ricarica tramite Google Pay",
                "applePay": "Ricarica tramite Apple Pay",
                "samsung_pay": "Ricarica tramite Samsung Pay",
                "kakao_pay": "Ricarica tramite Kakao Pay",
                "naver_pay": "Ricarica tramite Naver Pay",
                "wechat_pay": "Ricarica tramite WeChat Pay",
                "alipay": "Ricarica tramite Alipay",
                "paynow": "Ricarica tramite PayNow",
                "grabpay": "Ricarica con GrabPay",
                "cashapp": "Ricarica tramite Cash App Pay",
                "merchantCommission": "Commissione del commerciante",
                "eWallet": "Trasferito a portafoglio elettronico esterno",
                "reversed": "Prelievo annullato",
                "driverNoShow": "Assenza del conducente",
                "noShowPenalty": "Assenza del conducente",
                "bookingEarning": "Guadagno Netto"
            },
            "moduleItem": {
                "all": "Tutto",
                "bookings": "Prenotazioni",
                "customers": "Clienti",
                "dispatch": "Assegnazione",
                "general": "Generale",
                "promotion": "Promozione",
                "quest": "Quest",
                "rate": "Valuta",
                "car": "Macchina",
                "city": "Città",
                "company": "Azienda",
                "drivers": "Autisti",
                "driverSettlement": "Pagamenti autista",
                "login": "Registrati",
                "logout": "Esci",
                "mDispatcher": "mDispatcher",
                "mDispatcherType": "Tipo mDispatcher",
                "operation": "Operazione",
                "partners": "Partner",
                "permission": "Permesso",
                "queuingArea": "Area Fila",
                "report": "Reports",
                "shift": "Turno",
                "user": "Utilizzatori",
                "voiceSms": "Voce & SMS",
                "intercityZone": "Zone (intercity)",
                "Payout": "Pagamento",
                "code#": "Codice #",
                "ApiManagement": "Gestione delle API"
            },
            "serviceTypeItem": {
                "all": "Tutto",
                "oneWay": "Senso unico",
                "fromAirport": "Dall’aereoporto",
                "toAirport": "All’aereoporto",
                "hourly": "oraria/giornaliera",
                "roundTrip": "Andata e ritorno",
                "fromAirportHourlyDaily": "Dall’aereoporto - hourly/daily",
                "fromAirportRoundTrip": "Dall’aereoporto - round trip",
                "toAirportHourlyDaily": "All’aereoporto - hourly/daily",
                "toAirportRoundTrip": "All’aereoporto - round trip"
            },
            "merchantTransactionTypeItem": {
                "all": "Tutto",
                "editBalance": "Modifica saldo",
                "payout": "Pagamento",
                "earning": "Guadagnare",
                "itemValue": "Valore dell'oggetto",
                "orderDeduction": "Detrazione dell'ordine"
            },
            "withdrawalTransactionType": {
                "WingBank": "Trasferito al conto Wingbank",
                "bankAccount": "Trasferito sul conto bancario",
                "cashWallet": "Trasferito al portafoglio in contante",
                "creditWallet": "Trasferito sul portafoglio di credito"
            },
            "payoutDriver": {
                "driversHaveBankAccount": "I conducenti hanno un conto bancario",
                "driversDontHaveBankAccount": "I conducenti non hanno un conto bancario",
                "payoutEndTime": "Orario di fine pagamento",
                "driverHaveInvalidBankAccount": "I conducenti hanno un conto bancario non valido"
            },
            "payoutMerchant": {
                "HaveBankAccount": "I commercianti hanno un conto bancario",
                "DontHaveBankAccount": "I commercianti non hanno un conto bancario",
                "HaveInvalidBankAccount": "I commercianti hanno un conto bancario non valido",
                "payoutEndTime": "Orario di fine pagamento"
            }
        },
        "error": {
            "23005": "Per le prestazioni del sistema puoi visualizzare solo report in %{interval} %{unitLabel}, per favore regola il tuo intervallo di date."
        },
        "result": {
            "idPermitType": "ID tipo",
            "noResultFound": "Nessun risultato",
            "page": "Pagina",
            "itemsPerPage": "oggetti per pagina",
            "showPages": "Mostrati %{from} - %{to} di %{total}",
            "exportToExcel": "Esporta su excel",
            "exportToCSV": "Esporta in csv",
            "exportToPaymentFile": "Esporta in file di pagamento",
            "pay": "Paga",
            "paySelected": "Pagamento selezionato",
            "payAll": "Paga tutto",
            "invalidBankAccount": "Conto bancario non valido",
            "validBankAccount": "Conto bancario valido",
            "bookingDetails": {
                "customerAdjustmentsFee": "Regolazione Cliente",
                "supplierDriverAdjustmentsFee": "Regolazione Fornitore/Autista",
                "supplierPayout": "Pagamento fornitore",
                "driverPayout": "Pagamento del conducente",
                "profit": "Profitto",
                "successSendMessage": "Il tuo messaggio è stato inviato",
                "packageName": "Nome del pacchetto",
                "transactionId": "ID transazione",
                "proofOfFailure": "Prova di Fallimento",
                "recipientsNumber": "Numero di destinatari",
                "recipientsInfo": "Informazioni sul destinatario",
                "creditTransactionFee": "Commissioni per carte di credito",
                "carTypeRequest": "Tipo di veicolo richiesto",
                "bookingId": "Prenotazione #",
                "bookingStatus": "Stato della prenotazione",
                "tripId": "Viaggio #",
                "bookFrom": "Prenotato da",
                "bookingService": "Tipo di rete",
                "bookingType": "Tipo prenotazione",
                "serviceType": "Tipo di servizio",
                "operator": "Operatore",
                "customerPhone": "Numero di telefono del passeggero",
                "customerName": "Nome passeggero",
                "customerIdNumber": "Passenger ID# / IC#",
                "corpDivision": "Divisione",
                "corpDept": "Dept\" in Italian is \"Dip.",
                "chargeCode": "Codice di addebito",
                "tripDescription": "Descrizione del viaggio",
                "rideSharing": "car pooling",
                "queueName": "Area Fila",
                "bookingTime": "Orario Prenotazione",
                "pickupTime": "Data e ora di partenza",
                "expectedPickupTime": "Orario di ritiro previsto",
                "dispatchTime": "Tempo assegnazione",
                "onBoardTime": "orario a bordo",
                "droppedOffTime": "Orario scarico passeggero",
                "onBoardDuration": "Durata a bordo",
                "dispatch": "Assegnazione #",
                "completedTime": "Tempo Completato",
                "driverName": "Nome autista",
                "driverIdPermit": "ICarta di identità # Carta di identità nazionale #",
                "driverLicenseNumber": "Numero Patente Autista",
                "companyName": "Azienda",
                "carType": "Tipo Macchina",
                "licensePlate": "Numero di targa",
                "intercityRoute": "Percorso intercity",
                "pickupLocation": "Luogo dell’appuntamento",
                "geoPickup": "Luogo dell’appuntamento lat/long",
                "extraDestination": "Destinazioni extra",
                "originDestination": "Destinazione originale",
                "originEstDistance": "Distanza est originale",
                "destination": "Destinazione",
                "geoDestination": "Destinazione lat/long",
                "pickupFrom": "Luogo di ritiro da",
                "distanceTour": "distanza P.O.B (passeggero a bordo)",
                "internalNotes": "Note interne",
                "notes": "Note",
                "basicFareCalculator": "Calcolatore tariffa base",
                "basicFare": "Tariffa base",
                "editFare": "Modifica tariffa base",
                "oldBasicFare": "Vecchia tariffa base",
                "airportFee": "tariffa aeroporto",
                "meetDriver": "Incontra l’autista",
                "rushHour": "Sovrapprezzo",
                "surchargeParameter": "Sovrapprezzo dinamico",
                "dynamicFare": "Tariffa dinamica",
                "heavyTraffic": "Traffico intenso",
                "tollFee": "Tariffa del pedaggio",
                "parkingFee": "Tariffa di parcheggio",
                "gasFee": "Commissione del gas",
                "otherFees": "Altre spese",
                "subtotal": "Subtotale",
                "subTotalFF": "Subtotale FF",
                "techFee": "Spese tecniche",
                "serviceFee": "Add'l services",
                "fleetServiceFee": "Servizi per la flotta",
                "bookingFee": "Spese di prenotazione",
                "salesTax": "Tasse vendita",
                "tipAmt": "Ammontare mancia",
                "promoCode": "Codice promozionale",
                "promoAmt": "Importo promozionale",
                "requestedTotalAmount": "OTA Price",
                "total": "Ammontare totale",
                "totalNotRounded": "Round (totale)",
                "actualReceived": "Ricevuto effettivo",
                "differenceAmt": "Differenza (ricevuta)",
                "customerDebt": "Debito del Cliente",
                "markupDifference": "Differenza di markup",
                "receivedWhenDropOff": "Ricevuto al momento della consegna",
                "refundAmount": "Importo rimborso",
                "requestedPaymentMethod": "Metodo di pagamento richiesto",
                "paidBy": "Pagato da",
                "splitPayment": "Pagamento frazionato",
                "paidByWallet": "Pagato tramite wallet",
                "paidByOtherMethod": "Pagato con altro metodo",
                "cashReceived": "Contante ricevuto",
                "transferredChangeByWallet": "Trasferisci il cambiamento tramite portafoglio",
                "returnedChangeByCash": "Restituisci il resto in contante",
                "instructions": "Istruzioni",
                "additionalServiceName": "Nome",
                "additionalServiceValue": "valore",
                "sendReceiptHeader": "",
                "sendReceipt": "Invia ricevuta",
                "send": "Invia",
                "cancel": "Cancella",
                "sentReceiptSuccess": "La ricevuta è stata inviata con successo",
                "sentReceiptFailed": "La ricevuta non può essere inviata in questo momento. Per favore riprova.",
                "coRider": "copilota",
                "coriderName": "Nome",
                "stopAddress": "Destinazione aggiuntiva",
                "stopGeo": "Lat/lon",
                "addonPrice": "Il cliente regola il prezzo",
                "oldSubTotal": "Subtotale prima dell'aggiustamento",
                "view_good_receipt": "Ricezione merci",
                "view_delivery_receipt": "Foto di consegna",
                "view": "Visualizza",
                "tipAfterCompletedDetails": "Trasferito: {0}{1}; Commissione di transazione: {0}{2}",
                "fleetMarkup": "Profitto",
                "editedDriverEarning": "Guadagno del driver modificato",
                "driverEarning": "Guadagni del conducente",
                "supplierAmount": "Guadagni del fornitore",
                "currencyISO": "Valuta",
                "pickUpZoneName": "Zona di ritiro",
                "dynamicFactor": "Tariffa dinamica (fattore)",
                "supplierEarning": "Guadagno del fornitore",
                "passengerName": "Nome del passeggero",
                "totalPayout": "Pagamento totale",
                "numberOfTrips": "Numero di viaggi",
                "psgLocation": "Posizione del passeggero (lat/lon)",
                "psgIp": "IP del passeggero",
                "DeviceImei": "IMEI del dispositivo",
                "otaDiscount": 'OTA Discount',
            },
            "financial": {
                "supplierPayout": "Pagamento fornitore",
                "driverPayout": "Pagamento del conducente",
                "profit": "Profitto",
                "currencyISO": "Valuta",
                "supplierAmount": "Guadagno del fornitore",
                "driverEarning": "Guadagni del conducente",
                "supplierEarning": "Guadagno del fornitore",
                "passengerName": "Nome del passeggero",
                "totalPayout": "Pagamento totale",
                "numberOfTrips": "Numero di viaggi",
                "driverName": "Nome Autista",
                "driverPhone": "Numero di telefono",
                "driverUserName": "Nome utente",
                "companyName": "Azienda",
                "bookingList": "Elenco prenotazioni",
                "totalFare": "Totale Tariffa w/o promozione",
                "netEarning": "Guadagno Netto",
                "showBookingList": "Mostra",
                "referralEarning": "Guadagno da referral",
                "totalEarningNet": "Guadagno totale (netto)",
                "totalEarningNetTooltip": "Denaro guadagnato dopo aver restituito tutte le commissioni alla flotta. Guadagno totale (netto) = Guadagno netto + Mancia dopo il viaggio",
                "totalEarningNetTooltipRefferal": "Denaro guadagnato dopo aver restituito tutte le commissioni alla flotta. Guadagno totale (netto) = Guadagno da referral + Guadagno netto + Mancia dopo la corsa",
                "totalEarningGross": "Guadagno totale (lordo)",
                "totalEarning": "Guadagno totale",
                "totalEarningGrossTooltip": "Denaro guadagnato dalla prenotazione delle corse e dalle mance. Guadagno totale (lordo) = Guadagno lordo + Mancia dopo la corsa",
                "totalEarningGrossTooltipRefferal": "Denaro guadagnato dalla prenotazione della tariffa e dalla mancia. Guadagno totale (lordo) = Guadagno da referral + Guadagno lordo + Mancia dopo la corsa",
                "note": "Nota",
                "shortTrip": "breve viaggio",
                "deduction": "Detrazione",
                "totalDriverEarning": "Guadagni totali dei conducenti",
                "totalDriverEarningTooltip": "Incluse le prenotazioni con pagamento sia online che offline",
                "totalDriverPayout": "Pagamento totale ai conducenti",
                "totalDriverPayoutTooltip": "Non include prenotazioni con pagamento in contante o offline"
            },
            "financialDriver": {
                "supplierAmount": "Commissione fornitore",
                "payoutType": "Tipo di pagamento",
                "date": "Data",
                "driverTipAfterCompleted": "Consiglio dopo il giro",
                "bookingId": "ID di prenotazione",
                "paidBy": "Pagato da",
                "bookFrom": "Prenotato da",
                "bookingType": "Tipo prenotazione",
                "companyName": "Azienda",
                "driverName": "Autista",
                "driverIdPermit": "Carta di identità # Carta di identità nazionale #",
                "totalFare": "Tariffa totale senza promozione",
                "subtotal": "Subtotale",
                "airportFee": "tariffa aeroporto",
                "meetDriver": "Incontra l’autista",
                "tollFee": "Pedaggio",
                "parkingFee": "Tariffa di parcheggio",
                "gasFee": "Commissione del gas",
                "rushHour": "Ore di punta",
                "transactionFee": "Commissione di transazione",
                "techFee": "Spese tecniche",
                "salesTax": "Tasse vendita",
                "tipAmt": "Ammontare mancia",
                "bookingFee": "Spese di prenotazione",
                "commission": "Commissione",
                "deduction": "Deduzione",
                "promoAmt": "Importo promo",
                "ridePayment": "Pagamento della corsa",
                "driverTax": "Tassa sui conducenti",
                "grossEarning": "Guadagno lordo",
                "driverDeduction": "Detrazione per conducenti",
                "netEarning": "Guadagno Netto",
                "payToDriver": "Paga al conducente",
                "payToFleet": "Paga alla flotta",
                "totalNotRounded": "Round (totale)",
                "fleetServiceFee": "Tariffe per i servizi della flotta",
                "editedDriverEarning": "Guadagno del driver modificato",
                "stripeFee": "Commissione Stripe",
                "currencyISO": "Valuta"
            },
            "financialCompany": {
                "companyName": "Azienda ",
                "homeFleetNetEarning": "Guadagni Netti della Flotta Domestica",
                "affiliateNetEarning": "Guadagno Netto Affiliato",
                "totalNetEarning": "Guadagno Netto Totale del Conducente",
                "status": "Stato",
                "companyAmount": "Company profit",
                "numberOfTrips": "Numero di viaggi"
            },
            "companySettlement": {
                "companyName": "Compagnia",
                "pendingSettlement": "In attesa di liquidazione",
                "viewDetails": "Visualizza dettagli",
                "settlementType": "Tipo"
            },
            "companySettlementDetails": {
                "bookId": "ID Prenotazione",
                "dateTime": "Data e ora",
                "originalPaymentStatus": "Stato di pagamento originale",
                "subTotal": "Subtotale",
                "fleetAmount": "Importo della flotta",
                "driverAmount": "Importo del conducente",
                "companyAmount": "Importo aziendale",
                "companyOweFleet": "Flotta debitoria dell'azienda",
                "fleetOweCompany": "Flotta deve azienda",
                "notes": "Note"
            },
            "financialProfit": {
                "profit": "Profitto",
                "bookingId": "Prenotazione #",
                "subTotal": "Subtotale",
                "subTotalFF": "Subtotale FF",
                "fleetCommission": "Commissione della flotta",
                "techFee": "Quota tecnologica",
                "promotion": "Promozione",
                "markupDifference": "Differenza di markup",
                "Profit": "Profitto",
                "currency": "Valuta",
                "fleetServiceFee": "Servizio flotte (presa flotte)",
                "fleetServiceFeeTooltip": "L'importo che la flotta trattiene come commissione dalle spese di servizio"
            },
            "promotion": {
                "date": "Data",
                "promoCode": "Codice Promozione",
                "users": "# Utilizzatori",
                "uses": "# Utilizzi",
                "checked": "Controllato",
                "applied": "Applicato",
                "totalPromoAmount": "Totale ammontare promozione",
                "totalReceipt": "Ricevuta Totale",
                "numberOfUsers": "Numero di utenti",
                "numberOfPromoCodeAppliance": "Numero di utilizzo del codice promozionale",
                "numberOfSuccessfulBookings": "Numero di prenotazioni riuscite",
                "numberOfCompletedBookings": "Numero di prenotazioni completate",
                "numberOfCompletedUsers": "Numero di utenti completati",
                "numberOfUsersApplyPromotion": "Numero di utenti che applicano promozione",
                "numberOfUsersApplyPromotionAndCompleteBooking": "Numero di utenti che applicano la promozione e completano la prenotazione",
                "numberOfPromoCodeApplianceTooltip": "Numero di utilizzi del codice promozionale da parte di tutti gli utenti",
                "numberOfSuccessfulBookingsTooltip": "Numero di prenotazioni create con successo con il codice promozionale",
                "numberOfCompletedBookingsTooltip": "Numero di prenotazioni completate che hanno utilizzato il codice promozionale"
            },
            "export": {
                "createdDate": "Data",
                "sessionName": "Nome della sessione",
                "download": "Scarica",
                "delete": "Elimina",
                "percent": "Percent",
                "status": "Stato",
                "name": "Nome del modulo"
            },
            "redeemed": {
                "date": "Data",
                "code": "Codice",
                "customers": "Cliente",
                "phone": "Numero di telefono",
                "value": "Valore",
                "currency": "Valuta",
                "campaignName": "Campagna"
            },
            "carActivity": {
                "plateNumber": "Targa vettura",
                "vehicleType": "Tipo di macchina",
                "companyName": "Azienda",
                "day1st": "1°",
                "day2nd": "2°",
                "day3rd": "3°",
                "day4th": "4°",
                "day5th": "5°",
                "day6th": "6°",
                "day7th": "7°",
                "day8th": "8°",
                "day9th": "nono",
                "day10th": "10°",
                "day11th": "11°",
                "day12th": "12°",
                "day13th": "13°",
                "day14th": "14°",
                "day15th": "15°",
                "day16th": "16°",
                "day17th": "17°",
                "day18th": "18°",
                "day19th": "19°",
                "day20th": "20°",
                "day21st": "21°",
                "day22nd": "22°",
                "day23rd": "23°",
                "day24th": "24°",
                "day25th": "25°",
                "day26th": "26°",
                "day27th": "27°",
                "day28th": "28°",
                "day29th": "29°",
                "day30th": "30°",
                "day31st": "31°",
                "operationDays": "Giorni operazionali",
                "activeCars": "Totale vetture attive"
            },
            "carActivityLogsTitle": "Registrazioni",
            "carActivityLogs": {
                "licensePlate": "Targa della vettura",
                "companyName": "Azienda",
                "bookingId": "ID Prenotazione",
                "driverName": "Nome Autista",
                "driverIDNumber": "Carta di identità # Carta di identità nazionale #",
                "date": "Tempo accettato",
                "bookFrom": "Prenotato da"
            },
            "affiliation": {
                "date": "Data e ora di partenza",
                "bookingId": "ID prenotazione",
                "bookingType": "Tipo prenotazione",
                "homeFleet": "Flotta domestica",
                "providerFleet": "Flotta del fornitore",
                "driver": "Autisti",
                "passenger": "Passeggero",
                "paidBy": "Pagato da",
                "airportFee": "Tariffa aeroporto",
                "meetDriver": "Incontra l’autista",
                "rushHour": "Ora di Punta",
                "tollFee": "Tariffa di pedaggio",
                "parkingFee": "Tariffa di parcheggio",
                "gasFee": "Commissione del gas",
                "heavyTraffic": "Traffico intenso",
                "otherFees": "Altre spese",
                "provider": "Fornitore",
                "basicFareProvider": "tariffa base fornitore",
                "subTotalProvider": "Sub totale fornitore",
                "techFeeProvider": "Totale spese tecniche fornitore",
                "bookingFeeProvider": "Spese di prenotazione fornitore",
                "taxValueProvider": "Valore fiscale fornitore",
                "tipProvider": "Mancia fornitore",
                "totalFareProvider": "Totale spese fornitore",
                "basicFare": "Tariffa base",
                "subtotal": "Subtotale",
                "techFee": "Spese tecniche",
                "bookingFee": "Spese di prenotazione",
                "tax": "Tasse",
                "tip": "Mancia",
                "totalFare": "Totale tariffa",
                "payoutInLocalCurrency": "Guadagni delle corse in valuta locale",
                "payoutInUSD": "Guadagni delle corse in USD",
                "fleetCommInUSD": "Commissioni flotta in euro",
                "bookingFeeInUSD": "Spese di prenotazione in euro",
                "totalPayoutInUSD": "Totale rimborso in euro",
                "subTotal": "Subtotale",
                "bookingStatus": "Stato della prenotazione",
                "vehicle": "Veicolo",
                "customerPhone": "Numero di telefono del cliente",
                "driverPhone": "Numero di telefono del conducente",
                "total": "Totale",
                "totalInUSD": "Tariffa totale (USD)",
                "supplierPayout": "Pagamento fornitore",
                "supplierPayoutInUSD": "Pagamento fornitore (USD)",
                "buyerPayout": "Commissione dell'acquirente",
                "buyerPayoutInUSD": "Commissione (USD)",
                "buyerCommission": "Commissione",
                "buyerCommissionInUSD": "Commissione (USD)",
                "receivableInUSD": "Crediti (USD)",
                "payableInUSD": "Pagabile (USD)",
                "fleetMarkupInUSD": "Profitto (USD)",
                "paymentMethod": "Metodo di pagamento",
                "paymentStatus": "Stato del pagamento"
            },
            "prepaidTopUp": {
                "date": "Data e ora",
                "topUpId": "Ricarica ID",
                "transactionId": "ID transazione",
                "name": "Nome",
                "company": "Azienda",
                "paidBy": "Pagato da",
                "amount": "Ammontare",
                "newAmount": "New Balance",
                "transactionType": "Tipo di transazione"
            },
            "operatorLogs": {
                "date": "Data",
                "operator": "Operatore",
                "username": "Nome utente",
                "module": "Modulo",
                "description": "Descrizione"
            },
            "corporate": {
                "date": "Data",
                "bookingId": "ID Prenotazione",
                "operatorName": "Operatore Corp",
                "corporateName": "Azienda",
                "corpTraveler": "Viaggiatore aziendale",
                "travelerSignature": "Firma del viaggiatore",
                "corpId": "Note",
                "corpDivision": "Indirizzo",
                "costCentre": "Centro di costo",
                "corpPO": "Altro",
                "managerName": "Nome del manager",
                "managerEmail": "Email del manager",
                "title": "Titolo",
                "department": "Reparto",
                "clientCaseMatter": "Caso cliente / Descrizione del viaggio",
                "chargeCode": "Codice di addebito / Codice di viaggio",
                "driverName": "Autista",
                "pickupLocation": "Luogo dell’appuntamento",
                "destination": "Destinazione",
                "total": "Ammontare totale",
                "subtotal": "Subtotale",
                "subTotalFF": "Subtotale FF",
                "commission": "Commissione",
                "commissionBooking": "Applica commissione per le prenotazioni da app/pwa",
                "paidBy": "Pagato da",
                "statusDisplay": "Booking status",
                "flightNumber": "Numero di volo"
            },
            "bookingLogs": {
                "bookingId": "ID Prenotazione",
                "bookingService": "Tipo di rete",
                "bookingType": "Tipo prenotazione",
                "driverName": "Autisti",
                "driverIdPermit": "Carta di identità # Carta di identità nazionale #",
                "customerName": "Passeggero",
                "pickupTime": "Data e ora di partenza",
                "onBoardTime": "Orario passeggero a bordo",
                "droppedOffTime": "Orario scarico passeggero",
                "pickupLocation": "Luogo dell’appuntamento",
                "destination": "Destinazione",
                "dispatchHistory": "Storico assegnazioni",
                "otwDistance": "Distanza O.T.W",
                "distanceTour": "Distanza P.O.B",
                "duration": "Durata",
                "paidBy": "Pagato da",
                "bookFrom": "Prenotato da",
                "map": "Mappa",
                "showDispatchHistory": "Mostra",
                "showMap": "Mostra",
                "paymentActivities": "Attività di pagamento"
            },
            "rating": {
                "date": "Data",
                "bookingId": "ID Prenotazione",
                "driverName": "Autisti",
                "driverIdPermit": "Carta di identità # Carta di identità nazionale #",
                "customerName": "Nome cliente",
                "customerPhone": "Telefono del cliente",
                "like": "Mi Piace",
                "dislike": "Non Mi Piace",
                "notes": "Commento",
                "stars": "Valutazione",
                "vehicleRating": "Valutazione del Veicolo",
                "driverRating": "Voti dell'autista",
                "plateNumber": "Numero di targa"
            },
            "mDispatcher": {
                "date": "Data",
                "bookingId": "ID Prenotazione",
                "mDispatcherName": "mDispatcher name",
                "mDispatcherType": "Tipo mDispatcher",
                "subtotal": "Subtotale",
                "commission": "Commissione",
                "paidBy": "Pagato da"
            },
            "totalAdjustment": {
                "date": "Data",
                "bookingId": "ID di prenotazione",
                "oldAmount": "Ammontare Precedente",
                "type": "Tipo",
                "markupDifference": "Differenza di markup",
                "newAmount": "Nuovo Ammontare",
                "username": "Operatore",
                "reason": "Motivo"
            },
            "incidentCancellation": {
                "date": "Data",
                "bookingId": "ID Prenotazione",
                "customerName": "Nome cliente",
                "customerPhone": "Telefono del cliente",
                "bookFrom": "Prenotato da",
                "canceledBy": "Cancellato da",
                "type": "genere",
                "reason": "Motivo",
                "reasonCode": {
                    "0": "Ho trovato un'altra opzione di viaggio",
                    "1": "Autista troppo lontano",
                    "2": "Ho inserito la posizione sbagliata",
                    "3": "Ho aspettato troppo a lungo",
                    "4": "Il conducente ha chiesto di annullare",
                    "5": "Ho cambiato i miei piani",
                    "6": "Volevo cambiare posizione",
                    "101": "La maggior parte o tutti gli articoli non sono disponibili",
                    "102": "Siamo troppo occupati in questo momento",
                    "103": "Siamo chiusi in questo momento",
                    "104": "Stiamo chiudendo presto"
                },
                "canceller": "Azzeratore",
                "incidentStatus": "Stato dell'incidente"
            },
            "acceptanceCancellationRate": {
                "companyId": "Id Azienda",
                "driverId": "Id del conducente",
                "driverName": "Nome del conducente",
                "phoneNumber": "Numero di telefono",
                "company": "Compagnia",
                "acceptanceRate": "Tasso di accettazione",
                "cancellationRate": "Tasso di cancellazione",
                "rating": "Valutazione"
            },
            "revenueFleet": {
                "date": "Data",
                "fareRevenue": "Entrate tariffa",
                "trip": "Viaggio",
                "avgFareTrip": "Tariffa media/viaggio",
                "drivers": "# Autisti",
                "avgTripPerDriver": "Strada viaggio/autista",
                "dispatcher": "# Assegnazione"
            },
            "revenueDriver": {
                "date": "Data",
                "driverName": "Autisti",
                "fareRevenue": "Entrate tariffa",
                "trip": "# Viaggio",
                "avgFareTrip": "Tariffa media/viaggio"
            },
            "revenueMonthly": {
                "month": "Mese",
                "trip": "Viaggi completati",
                "subtotal": "Subtotale",
                "tipAmt": "Consiglio",
                "techFee": "Quota tecnologica",
                "salesTax": "Tassa",
                "partnerCommission": "Commissione partner/ ODD",
                "totalFare": "Tariffa totale senza promozione",
                "netEarning": "Guadagno Netto",
                "fleetServiceFee": "Tariffe di servizio della flotta"
            },
            "dailyDriver": {
                "driverName": "Autisti",
                "driverIDPermit": "Carta di identità # Carta di identità nazionale #",
                "driverPhone": "Telefono",
                "companyName": "Azienda",
                "workingHoursOnline": "Online (ore)",
                "workingHoursAvailable": "Disponibile (ore)",
                "driverWorkingHours": "Ore di lavoro del conducente",
                "distance": "Distanza percorsa dal conducente",
                "CC_activity": "attività CC",
                "fare_summary": "attività CC",
                "workingHoursNotAvailable": "Non Disponibile (ore)",
                "workingHoursPob": "P.O.B (ore)",
                "workingHoursPobToolTip": "Durata del passeggero a bordo",
                "workingHoursAccepted": "Accettato",
                "workingHoursReject": "Respingi",
                "workingHoursIgnore": "Ignora",
                "workingHoursCancel": "Cancella",
                "completedTripsTotal": "Totale",
                "completedTripsCc": "Da CC",
                "completedTripsCarHailing": "Da chiamate al volo",
                "completedTripsStreetSharing": "Da Street Sharing",
                "completedTripsPaxApp": "Da app passeggero",
                "completedTripsWebBooking": "Da web booking",
                "completedTripsMDispatcher": "Da  mDispatcher",
                "completedTripsKiosk": "Da Kiosk",
                "completedTripsApi": "Da API",
                "ccActivityDispatchedTrips": "Viaggi assegnati",
                "ccActivityAccepted": "# Accettato",
                "ccActivityReject": "Respingi",
                "ccActivityIgnore": "Ignora",
                "ccActivityCancelByPassenger": "Cancellata dal passeggero ",
                "ccActivityCancelByDriver": "Cancellato dall'autista",
                "ccActivityCancelByCc": "Cancellata da CC",
                "ccActivityCancelByAPI": "Cancellato da API",
                "ccActivityNoShow": "Assente",
                "fareSummaryTotalCash": "Contanti",
                "fareSummaryTotalCreditCard": "Carta di credito",
                "fareSummaryTotalExternalCard": "Carta esterna",
                "fareSummaryTotalPaxWallet": "Portafoglio",
                "fareSummaryTotalDirectBilling": "Fatturazione diretta",
                "fareSummaryTotalQrCode": "codice QR",
                "fareSummaryTotalPrePaid": "Prepagato Aziendale",
                "fareSummaryTotalApplePay": "Apple Pay",
                "fareSummaryTotalTngeWallet": "TNG eWallet",
                "fareSummaryTotalVippseWallet": "Vipps",
                "fareSummaryTotal": "Totale",
                "ratingNotes": "No. note",
                "ratingDislike": "No. dislike",
                "ratingLike": "No. mi piace",
                "fareDetailsBasicFare": "Tariffa base",
                "fareDetailsAirportFee": "Tariffa aeroporto",
                "fareDetailsRushHour": "Sovrapprezzo",
                "fareDetailsHeavyTraffic": "Traffico intenso",
                "fareDetailsOtherFees": "Altre spese",
                "fareDetailsSubTotal": "Subtotale",
                "fareDetailsSubTotalFF": "Subtotale FF",
                "fareDetailsTechFee": "Spese tecniche",
                "fareDetailsBookingFee": "Spese di prenotazione",
                "fareDetailsSalesTax": "Tasse vendita",
                "fareDetailsTip": "Ammontare mancia",
                "fareDetailsPromoAmount": "Importo promozionale",
                "fareDetailsTotalAmt": "Ammontare totale",
                "availableDistance": "Disponibile",
                "otwDistance": "O.T.W",
                "otwDistanceToolTip": "Distanza in viaggio",
                "pobDistance": "P.O.B",
                "pobDistanceToolTip": "Distanza passeggero a bordo",
                "ratingStars1": "Stella n. 1",
                "ratingStars2": "No. 2 stelle",
                "ratingStars3": "N. 3 stelle",
                "ratingStars4": "N. 4 stelle",
                "ratingStars5": "No. 5 stelle",
                "ratingAvg": "Media",
                "ssnNumber": "Numero di previdenza sociale #",
                "driverEmail": "Indirizzo email",
                "driverAddress": "Indirizzo Casa",
                "fareDetailsAddonPrice": "Il cliente regola il prezzo",
                "fareDetailsOldSubTotal": "Subtotale prima dell'aggiustamento"
            },
            "dailyCar": {
                "carInfo": "Informazioni macchina",
                "fareDetails": "Dettagli tariffa",
                "completedTrips": "Viaggi completati",
                "carInfoCompanyName": "Azienda",
                "carInfoPermission": "Permesso",
                "carInfoVehiclePlateNumber": "Numero di targa",
                "carInfoVhcId": "Macchina #",
                "carInfoCarType": "Tipo di macchina",
                "completedTripsTotal": "Totale",
                "completedTripsCc": "Da CC",
                "completedTripsCarHailing": "Da chiamate al volo",
                "completedTripsStreetSharing": "Da Street Sharing",
                "completedTripsPaxApp": "Da app passeggero",
                "completedTripsWebBooking": "Da web booking",
                "completedTripsMDispatcher": "Da  mDispatcher",
                "completedTripsKiosk": "Da Kiosk",
                "completedTripsAPI": "Da API",
                "fareDetailsBasicFare": "Tariffa base",
                "fareDetailsAirportFee": "Tariffa aeroporto",
                "fareDetailsMeetDriver": "Incontra l’autista",
                "fareDetailsRushHour": "Sovrapprezzo",
                "fareDetailsHeavyTraffic": "Traffico intenso",
                "fareDetailsTollFee": "Tariffa di pedaggio",
                "fareDetailsParkingFee": "Tariffa di parcheggio",
                "fareDetailsGasFee": "Commissione del gas",
                "fareDetailsOtherFees": "Altre spese",
                "fareDetailsSubTotal": "Sub totale",
                "fareDetailsSubTotalFF": "Subtotale FF",
                "fareDetailsTechFee": "Spese tecniche",
                "fareDetailsBookingFee": "Tariffe prenotazione",
                "fareDetailsSalesTax": "Tasse vendita",
                "fareDetailsTip": "mancia",
                "fareDetailsPromoAmount": "importo promozione",
                "fareDetailsTotalAmt": "Ammontare totale",
                "fareDetailsAddonPrice": "Il cliente regola il prezzo",
                "fareDetailsOldSubTotal": "Subtotale prima dell'aggiustamento"
            },
            "dailyDriverCar": {
                "driverInfo": "Informazioni Autista",
                "driverName": "Nome autista",
                "driverIDPermit": "Carta di identità # Carta di identità nazionale #",
                "driverPhone": "Numero di telefono",
                "companyName": "Azienda",
                "actionInfo": "Azioni",
                "date": "Data",
                "action": "Azione",
                "bookingId": "ID Prenotazione",
                "carInfo": "Informazioni macchina",
                "permission": "Permesso",
                "licensePlate": "Numero di targa",
                "carId": "Macchina #",
                "carType": "Tipo di macchina"
            },
            "driverLoginStatus": {
                "driver": "Autisti",
                "driverIdPermit": "Carta di identità # Carta di identità nazionale #",
                "phone": "Numero di telefono",
                "username": "Nome utente",
                "company": "Azienda",
                "carType": "Tipo di auto",
                "licensePlate": "Targa",
                "status": "Stato"
            },
            "bookingSummary": {
                "date": "Data",
                "operator": "Operatore",
                "username": "Nome utente",
                "action": "Azioni",
                "bookingId": "ID di prenotazione"
            },
            "cashWallet": {
                "bankAccount": "Trasferito al conto bancario",
                "creditWallet": "Trasferito al portafoglio di credito",
                "tipAfterCompleted": "Tip Dopo Completato",
                "netEarning": "Guadagno Netto",
                "referralEarning": "Guadagno da Referral",
                "receiverAccount": "Conto del destinatario",
                "dateAndTime": "Data e ora",
                "driverName": "Nome autista",
                "phoneNumber": "Numero di telefono",
                "userName": "Nome utente",
                "company": "Azienda",
                "type": "genere",
                "bookingId": "Prenotazione #",
                "operator": "Operatore",
                "reason": "Ragione",
                "amount": "Importo modificato",
                "newAmount": "Nuovo saldo",
                "currency": "Moneta",
                "topUpGCashReason": "Ricarica di Gcash",
                "topUpReason": "Ricarica dalla carta di credito *{0}",
                "cashWalletReason": "Ricarica da Cash Wallet",
                "topUpMOLPayReason": "Razer Pay [ {0} ]",
                "chargedAmount": "Importo della carica",
                "differentPercent": "Sconto / Sovrapprezzo (%)",
                "operatorName": "Operatore",
                "sendPayout": "Azione",
                "sendPayoutTitle": "Reinvia email di pagamento",
                "payoutReason": "{0} (Pagamento {1} {2})"
            },
            "creditWallet": {
                "receiverType": "Tipo di ricevitore",
                "receiverName": "Nome del destinatario",
                "receiverPhone": "Numero di telefono del destinatario",
                "senderPhone": "Numero di telefono del mittente",
                "senderName": "Nome del mittente",
                "sentToCustomer": "Invia al cliente",
                "sentToDriver": "Invia al conducente",
                "dateAndTime": "Data e ora",
                "driverName": "Nome autista",
                "phoneNumber": "Numero di telefono",
                "userName": "Nome utente",
                "company": "Azienda",
                "type": "genere",
                "bookingId": "Prenotazione #",
                "operator": "Operatore",
                "reason": "Ragione",
                "amount": "Importo modificato",
                "newAmount": "Nuovo saldo",
                "currency": "Moneta",
                "transactionId": "ID transazione",
                "topUpGCashReason": "Ricarica di Gcash",
                "topUpReason": "Ricarica dalla carta di credito *{0}",
                "cashWalletReason": "Ricarica da Cash Wallet",
                "topUpMOLPayReason": "Razer Pay [ {0} ]",
                "topUpWalletReason": "{0} [ {1} ]",
                "chargedAmount": "Importo della carica",
                "differentPercent": "Sconto / Supplemento (%)",
                "cashExcessReason": "Il cliente deve pagare {0}; Contante ricevuto {1}",
                "referralEarningReason": "Il cliente {0} {1} ha completato la prima prenotazione {2}",
                "referralEarningReason_2": "Il cliente {0} {1} ha completato la prenotazione {2}",
                "insurance": "Assicurazione per conducenti"
            },
            "passengerWallet": {
                "dateTime": "Data e ora",
                "customerName": "Nome cliente",
                "phoneNumber": "Numero di telefono",
                "type": "genere",
                "bookingId": "Prenotazione #",
                "changedAmount": "Importo modificato",
                "amount": "Importo modificato",
                "newBalance": "Nuova bilancia",
                "currency": "Valuta",
                "transactionId": "ID transazione",
                "Note": "Nota",
                "credit": "Ricarica con carta di credito *{0}",
                "TnG": "Ricarica di TnG #{0}",
                "MOLPay": "Ricarica da [RazerPay - #{0}]",
                "gatewayName": "Ricarica da [{0} - #{1}]",
                "cashExcess": "Il cliente deve pagare {0}, Contante ricevuto {1}",
                "editBalance": "Modifica Saldo",
                "ride": "Ride",
                "topUp": "Ricarica",
                "topUpReferee": "Ricompensa per referral ({0})",
                "topUpReferrer": "Nuovo arbitro (#{0}): {1} ({2})"
            },
            "recipientsInfo": {
                "order": "No.",
                "orderId": "Ordine #",
                "name": "Nome del destinatario",
                "phone": "Numero di telefono del destinatario",
                "address": "Indirizzo del destinatario",
                "deliveryFee": "Spese di consegna",
                "ItemValue": "Valore dell'articolo (COD)",
                "status": "Stato",
                "Performer": "Interprete",
                "Reason": "Motivo",
                "proofOfFailure": "Prova di fallimento",
                "referenceNumber": "Numero di riferimento"
            },
            "dispatchHistory": {
                "performer": "Esecutore",
                "name": "Nome",
                "action": "Azioni",
                "date": "Data",
                "location": "Posizione del conducente",
                "estimate": "Vstima veicolo da luogo di carico",
                "passenger": "Cliente",
                "detachVehicle": "Stacca Veicolo",
                "assignVehicle": "Assegna Veicolo"
            },
            "payToDriver": {
                "driverName": "Autisti",
                "totalUnsettledTransactions": "Totale transazioni non pagate",
                "totalUnsettledAmount": "Totale importo non pagato",
                "actions": "Azioni",
                "pay": "Paga",
                "remove": "Rimuovi",
                "clearSuccess": "Il guadagno del conducente selezionato è stato cancellato con successo.",
                "clearFailed": "Impossibile cancellare i dati di guadagno del conducente. Per favore riprova.",
                "selectDriver": {
                    "title": "",
                    "body": "Per favore seleziona l'autista da pagare..",
                    "buttonTitle": "OK"
                },
                "confirmClear": {
                    "title": "",
                    "body": "Sei sicuro di voler cancellare i dati di guadagno di questo conducente? Questa azione non può essere annullata.",
                    "buttonTitle": "Sì",
                    "closeButtonText": "No"
                },
                "confirmPay": {
                    "body": "Sei sicuro di voler pagare il/i conducente/i selezionato/i?",
                    "buttonTitle": "Sì",
                    "closeButtonText": "No"
                },
                "paymentSuccessfully": "Pagamento effettuato con successo",
                "ProcessPayout": "Elaborare il pagamento"
            },
            "customerQuest": {
                "name": "Nome",
                "phoneNumber": "Numero di telefono",
                "supportId": "ID di supporto",
                "ranking": "Classifica",
                "points": "Punti",
                "numberOfReservation": "Numero di prenotazione",
                "driver": "Driver",
                "customer": "Cliente",
                "firstWillWin": "Il primo vincerà",
                "firstWillWinLuckyDraw": "Il primo vincerà (estrazione fortunata)",
                "largestWillWin": "Il più grande vincerà (classifica)",
                "qualified": "Qualificato",
                "notQualified": "Non qualificato",
                "userName": "Nome utente",
                "completedDate": "Data di completamento",
                "isQualified": "Stato",
                "ticket": "Biglietto",
                "numOfComplete": "Numero di completati",
                "bookingDistance": "Distanza P.O.B",
                "numberOfIntercity": "Numero di intercity",
                "numberOfDelivery": "Numero di consegna",
                "pleaseSelectEventName": "Si prega di selezionare il nome dell'evento.",
                "numberOfQualifiedSetting": "Numero di qualificati (impostazione): ",
                "numberOfActualQualified": "Numero di qualificati effettivi: ",
                "driverRating": "Valutazione del conducente",
                "acceptanceRating": "Indice di Accettazione",
                "cancellationRating": "Valutazione di Cancellazione",
                "period": "Periodo: "
            },
            "payoutToDriver": {
                "IFSCCode": "Codice IFSC",
                "payoutID": "ID di pagamento",
                "driverName": "Driver",
                "driverPhone": "Numero di telefono",
                "companyName": "Azienda",
                "period": "Periodo",
                "driverId": "ID# / IC Nazionale#",
                "cashWalletBalance": "Saldo del portafoglio in contante",
                "creditBalance": "Saldo credito",
                "holdAmount": "Importo di blocco",
                "minPayout": "Pagamento minimo",
                "enterMinimumPayoutAmount": "Inserisci l'importo minimo di pagamento",
                "payoutAmount": "Importo del pagamento",
                "payoutDate": "Data di pagamento",
                "actions": "Azioni",
                "pay": "Paga",
                "remove": "Rimuovi",
                "payoutEndTime": "Orario di fine pagamento",
                "clearSuccess": "L'utile del conducente selezionato è stato cancellato con successo.",
                "clearFailed": "Impossibile cancellare i dati di guadagno del conducente. Per favore riprova.",
                "amountKeepInDriverCashWallet": "Importo mantenuto nel Wallet Cash del conducente",
                "selectDriver": {
                    "title": "",
                    "body": "Seleziona il conducente da pagare.",
                    "buttonTitle": "OK"
                },
                "confirmClear": {
                    "title": "",
                    "body": "Sei sicuro di voler cancellare i dati di guadagno di questo autista? Questa azione non può essere annullata.",
                    "buttonTitle": "Sì",
                    "closeButtonText": "No"
                },
                "confirmPay": {
                    "body": "Sei sicuro di voler pagare i conducenti selezionati? <br> - Numero di conducenti: <b>%{drivers}</b> <br> - Pagamento minimo per ciascun conducente: %{currency} <b>%{min}</b> <br> - Importo trattenuto: %{currency}<b> %{hold}</b> <br> - Pagamento totale: %{currency} <b>%{total}</b>",
                    "buttonTitle": "Sì",
                    "closeButtonText": "No"
                },
                "paymentSuccessfully": "Pagamenti effettuati con successo ai conducenti",
                "paymentCompleted": "Pagamento completato: <br> - Pagamento riuscito: %{success} <br> - Fallito: %{failed} <br> - Pagamento totale riuscito: %{currency} %{total}",
                "noteSelectDrivers": "Nota: selezionare i conducenti che hanno un conto bancario per il pagamento.",
                "sendPayout": "Invia notifica di pagamento riuscito all'indirizzo email",
                "accountNumber": "Numero di conto",
                "iBanNumber": "numero IBAN",
                "accountHoldName": "Nome del titolare dell'account",
                "bankName": "Nome della banca",
                "selelctedDriverHasBeenPaid": "Il/i conducente/i selezionato/i è stato/i pagato/i",
                "selelctedDriverHasBeenFailed": "Il/La conducente selezionato/a ha fallito",
                "selelctedDriverHasBeenUpdateAsInvalid": "Il/i conducente/i selezionato/i è stato aggiornato come 'Conto bancario non valido'",
                "selelctedDriverHasBeenUpdateAsValid": "Il/i driver selezionato/i è stato aggiornato come 'Conto bancario valido'",
                "isBankAccountOwner": "Beneficiario uguale a conducente",
                "isBankAccountOwner_true": "Sì",
                "isBankAccountOwner_false": "No",
                "beneficiaryIDIC": "ID Beneficiario# / IC#",
                "bankRelationship": "Relazione",
                "bankRelationship_1": "Coniuge",
                "bankRelationship_2": "Figlia/Figlio",
                "bankRelationship_3": "Fratello/Sorella",
                "bankRelationship_4": "Relativo",
                "bankRelationship_5": "Amici",
                "bankRelationship_6": "Altro: {0}",
                "bankStatus": "Stato della Banca",
                "emailStatement": "Estratto conto email",
                "viewStatement": "Visualizza Estratto Conto",
                "downloadStatement": "Scarica come PDF",
                "emailStatementSuccess": "Dichiarazione email inviata con successo",
                "NumberDriver": "Numero di Driver",
                "NumberSupplier": "Numero di Fornitore",
                "sendMailPayout": "Invia una notifica di pagamento riuscito al seguente indirizzo email:",
                "confirmPayoutTitle": "Sicuro di voler pagare gli utenti selezionati?",
                "phoneOfBank": "Telefono della Banca"
            },
            "payoutToMerchant": {
                "payoutId": "ID di pagamento",
                "merchantName": "Nome del commerciante",
                "phone": "Numero di telefono",
                "accountNumber": "Numero di conto",
                "iBanNumber": "numero IBAN",
                "bankAccountHolder": "Nome del titolare dell'account",
                "bankName": "Nome della banca",
                "pendingAmount": "Importo in sospeso",
                "payoutAmount": "Importo del pagamento",
                "payoutDate": "Data di pagamento",
                "holdAmount": "Importo di blocco",
                "minPayout": "Pagamento minimo",
                "selelctedMerchantHasBeenPaid": "Il/i commerciante/i selezionato/i è stato/i pagato/i",
                "selelctedMerchantHasBeenFailed": "Il/i commerciante/i selezionato/i è/sono fallito/i",
                "pay": "Paga",
                "selectMerchant": {
                    "title": "Avviso",
                    "body": "Seleziona il commerciante da pagare.",
                    "buttonTitle": "OK"
                },
                "confirmPay": {
                    "body": "Sei sicuro di voler pagare i commercianti selezionati? <br> - Numero di commercianti: <b>%{merchants}</b> <br> - Pagamento minimo per ogni autista: %{currency} <b>%{min}</b> <br> - Importo in sospeso: %{currency}<b> %{hold}</b> <br> - Pagamento totale: %{currency} <b>%{total}</b>",
                    "buttonTitle": "Sì",
                    "closeButtonText": "No"
                },
                "sendPayout": "Invia notifica di pagamento riuscito all'indirizzo email",
                "HasBeenUpdateAsInvalid": "Il/i commerciante/i selezionato/i è stato aggiornato come 'Conto bancario non valido'",
                "HasBeenUpdateAsValid": "Il/i commerciante/i selezionato/i è stato aggiornato come 'Conto bancario valido'"
            },
            "payoutSupplier": {
                "selelctedSupplierHasBeenUpdateAsValid": "Il/i fornitore/i selezionato/i è stato aggiornato come 'Conto bancario valido'",
                "selelctedSupplierHasBeenUpdateAsInvalid": "Il/i fornitore/i selezionato/i è stato aggiornato come 'Conto bancario non valido'",
                "selelctedSupplierHasBeenFailed": "Il/i fornitore/i selezionato/i è/sono fallito/i",
                "selelctedSupplierHasBeenPaid": "Il/i fornitore/i selezionato/i è stato/a pagato/a",
                "confirmPay": {
                    "body": "Sei sicuro di voler pagare i fornitori selezionati? <br> - Numero di fornitori: <b>%{drivers}</b> <br> - Pagamento minimo per ciascun fornitore: %{currency} <b>%{min}</b> <br> - Importo di ritenuta: %{currency}<b> %{hold}</b> <br> - Pagamento totale: %{currency} <b>%{total}</b>",
                    "buttonTitle": "Sì",
                    "closeButtonText": "No"
                },
                "agentName": "Nome dell'agente",
                "walletBalance": "Saldo del portafoglio",
                "newAmount": "Nuovo Importo"
            },
            "settlementHistory": {
                "date": "Data",
                "driverName": "Nome Autista",
                "dateRange": "Intervallo di date",
                "totalTransaction": "Totale transazioni pagate",
                "paidAmount": "Totale importo pagato"
            },
            "settlement": {
                "driverName": "Autisti",
                "driverIdPermit": "Carta di identità # Carta di identità nazionale #",
                "totalBookings": "Prenotazione totale",
                "total": "Ammontare totale",
                "approved": "Approvato",
                "acct": "CONTO",
                "gross": "LORDO",
                "percent": 0.03,
                "net": "NETTO"
            },
            "documentExpiry": {
                "driverName": "Nome autista",
                "driverPhone": "Telefono dell'autista",
                "company": "Azienda",
                "documentName": "Nome del documento",
                "expiredDate": "Data scaduta",
                "status": "Stato",
                "statusStr": {
                    "NA": "N/D",
                    "expired": "Scaduto",
                    "active": "Attiva",
                    "expireSoon": "Scade presto"
                }
            },
            "referralDetail": {
                "bookingId": "Libro #",
                "completedDate": "Tempo Completato",
                "paidBy": "Pagato da",
                "bookFrom": "Prenotazione da",
                "driverName": "Nome del driver",
                "driverIdPermit": "ID# / IC Nazionale#",
                "companyName": "Azienda",
                "Passenger": "Passeggero",
                "Customer": "Cliente",
                "subtotal": "Subtotale",
                "subTotalFF": "Subtotale FF",
                "subtotalWithPromo": "Subtotale con promozione",
                "referralEarning": "Guadagno da Referral",
                "Amount": "Importo",
                "Note": "Nota",
                "Currency": "Valuta",
                "PercentOfSubTotal": "{0}% del subtotale",
                "max": "max {0}",
                "referrerInfo": "Il conducente si riferisce al cliente",
                "phoneReferral": "Numero di telefono del conducente",
                "driverNumber": "ID# / IC Nazionale#",
                "referralCode": "Codice di riferimento",
                "reference": "Reference"
            },
            "referralHistory": {
                "driverName": "Nome del driver",
                "phoneNumber": "Numero di telefono",
                "companyName": "Azienda",
                "referralCode": "Codice di riferimento",
                "commission": "comission",
                "expectedReferralEarning": "Attendere guadagni da referral",
                "activePaxTooltip": "Passeggeri che hanno riscattato il codice di riferimento dall'autista con almeno una prenotazione effettuata con successo.",
                "referredPaxTooltip": "Passeggeri che hanno riscattato il codice di riferimento dall'autista ma non hanno ancora effettuato alcuna prenotazione.",
                "activePax": "Totale passeggeri attivi",
                "referredPax": "Totale passeggeri riferiti",
                "detailFields": {
                    "passengerId": "ID Passeggero",
                    "passengerName": "Nome del passeggero",
                    "firstBookingDate": "1a data di prenotazione completata",
                    "firstBookingDateGMT": "Data della prima prenotazione completata (GMT)",
                    "passengerPhone": "Numero di telefono del cliente",
                    "appliedDate": "Data di riferimento",
                    "referredByDriver": "Riferito dal conducente",
                    "driverPhone": "Numero di telefono del conducente",
                    "referralCode": "Codice di riferimento"
                },
                "showDetail": "Mostra",
                "detail": "Dettaglio"
            },
            "paxReferralHistory": {
                "customerName": "Nome cliente",
                "phoneNumber": "Numero di telefono",
                "referralCode": "Codice di riferimento",
                "commission": "Commissione totale",
                "activePaxTooltip": "Passeggeri che hanno riscattato il codice di riferimento con almeno una prenotazione effettuata con successo.",
                "referredPaxTooltip": "Passeggeri che hanno riscattato il codice di riferimento ma non hanno ancora effettuato alcuna prenotazione.",
                "activePax": "Clienti attivi totali",
                "referredPax": "Totale clienti referiti",
                "detailFields": {
                    "passengerId": "ID Passeggero",
                    "passengerName": "Nome del passeggero",
                    "firstBookingDate": "Data della prima prenotazione completata",
                    "firstBookingDateGMT": "Data della prima prenotazione completata (GMT)"
                },
                "showDetail": "Mostra",
                "detail": "Dettaglio"
            },
            "driverRefersDriver": {
                "companyName": "Azienda",
                "phoneNumber": "Numero di telefono",
                "username": "Nome utente",
                "referralCode": "Codice di riferimento",
                "referrer": "Riferente",
                "numberOfReferees": "Numero di arbitri",
                "activeReferees": "Arbitri attivi",
                "referee": "Arbitro",
                "refereePhone": "Numero di telefono dell'arbitro",
                "refereeUsername": "Nome utente dell'arbitro",
                "referredDate": "Data di riferimento",
                "activatedDate": "Data di attivazione",
                "referrerByDriver": "Rimandante",
                "referrerPhone": "Numero di telefono del referente",
                "referralStatus": "Stato del referral",
                "lifeTimeBookings": "Prenotazioni a vita",
                "inReview": "In revisione",
                "activated": "Attivato"
            },
            "driverWithdrawal": {
                "transferToEWallet": "Trasferito a portafoglio elettronico esterno *{0}",
                "channelCode": "Codice canale",
                "channelName": "Nome del canale",
                "reversed": "Invertito",
                "currentBalanceTooltip": "Il saldo corrente del portafoglio in contanti del conducente prima della richiesta di prelievo",
                "paymentTime": "Tempo di pagamento",
                "requestTime": "Richiedi il tempo",
                "referenceId": "Numero di riferimento",
                "transactionId": "ID transazione",
                "description": "Descrizione",
                "transferAmount": "Importo del trasferimento",
                "currency": "Valuta",
                "approved": "Approvato",
                "rejected": "Respinto",
                "failed": "Fallito",
                "reason": "Motivo"
            },
            "penaltyCompensation": {
                "penaltyAmount": "Penale",
                "totalCollect": "Necessità di pagare in valuta locale",
                "totalCollectInUSD": "Devi pagare in euro",
                "compensationAmount": "Compensazione",
                "compensationAmountInUSD": "Compensazione (USD)",
                "penaltyReason": "Motivo della penalità",
                "estimatedPrice": "Prezzo stimato",
                "estimatedPriceInUSD": "Prezzo stimato (USD)",
                "penaltyAmountInUSD": "Penale (USD)",
                "amount": "Importo",
                "amountInUSD": "Importo (USD)"
            },
            "imcompletePayment": {
                "bookingId": "ID Prenotazione",
                "bookFrom": "Prenotazione da",
                "bookingTime": "Data/Ora Prenotazione",
                "completedTime": "Data/Ora Prenotazione Completata",
                "customerName": "Nome del cliente",
                "requestedPaymentMethod": "Metodo di pagamento richiesto",
                "originalPaymentStatus": "Stato pagamento originale",
                "currentPaymentStatus": "Stato corrente di pagamento",
                "updatedDateTime": "Aggiornamento Data / ora",
                "totalAmt": "Importo totale",
                "originalOutstandingAmount": "Consistenze originale",
                "currentOutstandingAmount": "Corrente importo in sospeso",
                "outstandingAmountPaidBy": "Consistenze A carico",
                "writeOffDebtMethod": "Importo dovuto da riscuotere da",
                "reason": "Motivo",
                "customerPhone": "Numero di telefono",
                "amountCollected": "Importo raccolto",
                "partialPaymentAmount": "Pagamento parziale al momento della consegna"
            },
            "driverDeposit": {
                "dateAndTime": "Data e ora",
                "userName": "Nome utente",
                "type": "genere",
                "newAmount": "Nuovo saldo",
                "topUpGCashReason": "Ricarica di Gcash",
                "topUpReason": "Ricarica dalla carta di credito *{0}",
                "cashWalletReason": "Ricarica da Cash Wallet",
                "topUpMOLPayReason": "Razer Pay [ {0} ]"
            },
            "refund": {
                "fullRefund": "Rimborso completo",
                "partialRefund": "Rimborso parziale",
                "tripId": "ID Viaggio",
                "route": "Percorso",
                "refundAmount": "Importo del rimborso",
                "refundTime": "Tempo di rimborso",
                "paymentStatus": "Stato del pagamento"
            },
            "merchant": {
                "store": "Negozio",
                "name": "Nome",
                "phoneNumber": "Numero di telefono",
                "bookingId": "Prenotazione #",
                "totalOrders": "Ordini totali",
                "completedOrders": "Ordini completati",
                "canceledOrders": "Ordini annullati",
                "incidentOrders": "Incidente",
                "revenue": "Entrate",
                "commission": "Commissione",
                "earning": "Guadagnare",
                "food": "Cibo",
                "mart": "Mart",
                "preferredMerchant": "Commerciante preferito",
                "regularMerchant": "Commerciante regolare",
                "companyName": "Azienda"
            },
            "merchantCashTransactionHistory": {
                "companyName": "Azienda",
                "dateTime": "Data e ora",
                "merchantUserName": "Utente commerciante",
                "merchantUserPhone": "Numero di telefono",
                "merchantUserEmail": "Email",
                "merchantName": "Commerciante",
                "transactionType": "Tipo",
                "bookId": "Prenotazione #",
                "transactionId": "ID transazione",
                "operatorName": "Operatore",
                "reason": "Motivo",
                "amount": "Importo",
                "newBalance": "Nuova bilancia",
                "currencyISO": "Valuta"
            },
            "merchantCreditTransactionHistory": {
                "dateTime": "Data e ora",
                "merchantUserName": "Utente commerciante",
                "merchantUserPhone": "Numero di telefono",
                "merchantUserEmail": "Email",
                "merchantName": "Commerciante",
                "transactionType": "Tipo",
                "bookId": "Prenotazione #",
                "transactionId": "ID transazione",
                "operatorName": "Operatore",
                "reason": "Motivo",
                "amount": "Importo",
                "newBalance": "Nuova bilancia",
                "currencyISO": "Valuta"
            },
            "deleteAccountRequest": {
                "date": "Data",
                "phone": "Telefono",
                "username": "Nome utente",
                "supportId": "ID di supporto",
                "requestFrom": "Richiesta da",
                "associatedApps": "App associate",
                "reason": "Motivo"
            },
            "affiliationPayoutHistory": {
                "payoutId": "ID pagamento",
                "dateTime": "Data e ora",
                "payoutType": "Tipo",
                "accountHolderName": "Nome del titolare dell'account",
                "bankName": "Nome della banca",
                "accountNumber": "Numero di conto",
                "totalPayout": "Pagamento totale (USD)",
                "viewDetails": "Visualizza dettagli",
                "notes": "Nota",
                "bookId": "Prenotazione #",
                "transactionType": "Tipo di transazione",
                "transactionId": "Id Transazione (trasferimento automatico)",
                "settlement": "Accordo",
                "paymentMethod": "Tipo",
                "networkType": "Tipo di rete"
            },
            "thirdPartyBooking": {
                "date": "Data",
                "bookingId": "ID Prenotazione",
                "externalId": "ID Esterno",
                "psgPhone": "Numero di telefono del passeggero",
                "psgName": "Nome del passeggero",
                "pickupLocation": "Luogo di ritiro",
                "pickupLocationLatLong": "Posizione di ritiro lat/long",
                "dropoffLocation": "Luogo di consegna",
                "dropoffLocationLatLong": "Posizione di consegna lat/long",
                "pickupTime": "Orario di ritiro",
                "numOfPassenger": "Numero di passeggeri",
                "action": "Azione"
            },
            "external": "Fornitore Esterno",
            "inHouse": "Fornitore interno",
            "negative": "Negativo",
            "positive": "Positivo",
            "supplierType": "Tipo di Fornitore",
            "supplierCompany": "Fornitore/Azienda",
            "invalidOrNoBank": "Non valido",
            "BankInfo": "Informazioni Bancarie",
            "BankStatusConnect": "Stato del Gateway",
            "payManually": "Paga Manualmente",
            "payViaGateway": "Paga tramite %{gateway}",
            "payConfirmModal_manual": "Conferma di Pagamento Manuale",
            "payConfirmModal_manual_note": "Stai per elaborare un <b>pagamento manuale</b> al %{type} selezionato. Questo aggiornerà il saldo del portafoglio di ciascun %{type} e genererà un rapporto di pagamento per l'elaborazione bancaria.",
            "payConfirmModal_auto": "Conferma di Pagamento Automatico",
            "payConfirmModal_auto_note": "Stai per elaborare <b>pagamenti automatici</b> al %{type} selezionato tramite <b>%{gateway}</b>. I pagamenti saranno inviati direttamente ai loro conti bancari registrati.",
            "Eligible": "Idoneo per pagamento automatico",
            "EligibleNote": "Solo %{value} fornitori sono idonei per il pagamento automatico. Si prega di controllare e aggiornare i dettagli del conto bancario per i fornitori rimanenti."
        }
    },
    "zoneSetting": {
        "Add": "Aggiungi",
        "Import": "Importa",
        "Name": "Nome",
        "Status": "Stato",
        "Active": "Attivo",
        "Inactive": "Inattivo",
        "Deactivate": "Disattivato",
        "Activate": "Attivato",
        "Delete": "Elimina",
        "Cancel": "Cancella",
        "Input_zone_name": "Immettere il nome della zona",
        "Save_zone": "Zona di salvataggio",
        "Clear_draw": "Estrazione chiara",
        "Edit": "Modifica",
        "Delete_zone_success": "La zona é stata eliminata con successo",
        "Delete_zone_fail": "Sono intervenuti degli errori nella fase di eliminazione della zona",
        "Update_zone_fail": "Sono intervenuti degli errori nella fase di aggiornamento della zona",
        "Update_zone_success": "La nuova zona é stata aggiornata con successo",
        "Create_zone_fail": "Sono intervenuti degli errori nella fase di creazione della zona",
        "Create_zone_success": "La nuova zona é stata creata con successo",
        "Draw_zone": "Per favore disegna la zona sulla mappa",
        "Import_zones_successful": "Importazione zone avvenuta con successo",
        "Import_zones_fail": "Impossibile importare zone ",
        "DELETE_ZONE": "Elimina Zona",
        "ZONE_CONFIRM": "Vuoi eliminare la zona?",
        "Name_zone_required": "Nome e Zona sono obbligatori!",
        "Select_file": "Seleziona file",
        "No": "No",
        "Yes": "Si",
        "Import_zones_intercity_successful": "[{0}] zona(e) è stata importata con successo, [{1}] non riuscita.",
        "Import_zones_intercity_successful_failed": "[{0}] zona(e) è stata importata con successo, [{1}] non riuscita.",
        "Flat_zone": "Zona piatta",
        "Json_file": "File Json",
        "Import_zones": "Zone di importazione",
        "timezone": "Fuso Orario"
    },
    "companySetting": {
        "DELETE_COMPANY": "ELIMINA AZIENDA",
        "DELETE_CONFIRM": "Vuoi eliminare l'azienda!",
        "DETAIL_COMPANY": "DETTAGLIO AZIENDA",
        "commissionValue": "Commissione aziendale",
        "connectStatus": "Stripe Connect",
        "connectStripe": "Collegare",
        "stripeConnectId": "ID account Stripe",
        "loginStripe": "Cruscotto",
        "disconnectStripe": "Disconnetti",
        "Yes": "Si",
        "No": "no",
        "Cancel": "Cancella",
        "EDIT_COMPANY": "Modifica azienda",
        "ADD_COMPANY": "Aggiungi azienda",
        "Name": "Nome",
        "Required_fields": "Campi obbligatori",
        "Save": "Salva",
        "Actions": "Azioni",
        "Edit": "Modifica",
        "Add": "Aggiungi",
        "Show_per_page": "oggetti per pagina",
        "Page": "Pagina",
        "show_pages": "{0} - {1} of {2} mostrati",
        "Create_company_success": "La nuova aziendda é stata creata con successo",
        "Create_company_fail": "Sono intervenuti degli errori nella fase di creazione dell'azienda",
        "Update_company_success": "L'azienda é stata aggiornata con successo",
        "Update_company_fail": "Sono intervenuti degli errori nella fase di aggiornamento dell'azienda",
        "Load_company_fail": "Sono intervenuti degli errori nella fase di caricamento dell'azienda",
        "Delete_company_success": "L'azienda é stata eliminata con successo",
        "Delete_company_fail": "Sono intervenuti degli errori nella fase di eliminazione dell'azienda",
        "hideFare": "Nascondi sempre la tariffa",
        "Broadcast_orders": "Trasmetti tutti gli ordini",
        "paymentMethodsApply": "Metodo di pagamento supportato",
        "emailsNotification": "Notifica Email",
        "CopySignUpLink": "Copia il link di registrazione",
        "operationZone": "Zona Operativa",
        "delayBroadcast": "Mostra ordine dopo",
        "releaseTime": "Tempo di rilascio",
        "advanceBookingVisibility": "Visibilità della prenotazione anticipata",
        "advanceBookingVisibilityTooltip": "Imposta il numero di giorni prima della data di ritiro in cui un fornitore può vedere la prenotazione. Questo garantisce che le prenotazioni vengano rilasciate ai conducenti in modo tempestivo, in base a ciascun fornitore."
    },
    "dispatchSetting": {
        "Cut_off_time_range": "Scadenza per le prenotazioni dopo l'orario",
        "Cut_off_time_range_tooltip": "Se la finestra di cutoff è dalle 22:00 alle 6:00, i clienti possono comunque prenotare prima delle 22:00 per ritiri dopo le 22:00. Tuttavia, se l'orario attuale è compreso tra le 22:00 e le 6:00, il primo ritiro consentito è dopo le 6:00 + tempo di preavviso.",
        "GENERAL": "GENERALE",
        "Offer_interval": "Intervallo offerta",
        "Offer_interval_merchant": "Intervallo di offerta (commerciante)",
        "Offer_interval_merchant_toolTip": "Tempo massimo per un commerciante per accettare un ordine",
        "Offer_interval_toolTip": "Tempo massimo affinché un conducente accetti una prenotazione",
        "soundMarketplace": "Suono",
        "sound": "Suono",
        "Auto_re_dispatch_interval_toolTip": "Tempo di pausa tra 2 round di spedizione",
        "Maximum_auto_dispatch_duration_toolTip": "Tempo massimo di invio di una prenotazione ai conducenti",
        "Seconds": "secondi",
        "Auto_re_dispatch_interval": "Intervallo di riassegnazione automatica",
        "Maximum_auto_dispatch_duration": "Massima durata assegnazione-automatica",
        "Time_out": "Tempo scaduto",
        "mins": "minuti",
        "minTimeBeforeReservation": "Non consentire al conducente di avviare la prenotazione prima di",
        "IN_ADVANCE": "IN ANTICIPO",
        "Assign_reservation_to_driver": "Assegna la prenotazione al conducente",
        "Dispatcher_confirms_job_for_driver": "Dispatcher confirms reservation for online driver",
        "Dispatcher_confirms_job_for_offline_driver": "Il dispatcher conferma la prenotazione per il driver offline",
        "Broadcast_orders": "Trasmetti ordini a tutte le aziende",
        "Broadcast_orders_tooltip_1": "Abilita questa impostazione se desideri semplicemente trasmettere tutti i viaggi a tutti i fornitori dell'azienda. Tieni presente che devi attivare la modalità di trasmissione nel profilo di ciascuna azienda.",
        "Minimum_book_ahead": "Prenotazione minima davanti",
        "Maximum_book_ahead": "Prenotazione massima davanti",
        "Maximum_period_recurring_oders_fleet": "Periodo massimo per ordini ricorrenti (operatore di flotta)",
        "Maximum_period_recurring_oders_corp": "Periodo massimo per ordini ricorrenti (aziendale)",
        "Day": "Giorno",
        "Week": "Settimana",
        "Month": "Mese",
        "hrs": "ore",
        "Driver_cancellation_duration": "Cancellazione durata autista",
        "Mins": "minuti",
        "Maximum_Day": "Il conducente per le prenotazioni massime può accettare in un giorno.",
        "Maximum_Accept_Reservation": "Il conducente per le prenotazioni massime può accettare alla volta.",
        "jobRTDriver": "Tempo di rilascio del lavoro al conducente (prima del ritiro)",
        "jobRTDriverDes": "Imposta quando il lavoro diventa visibile al conducente assegnato nella sua app prima dell'orario di ritiro. - ad esempio 24 ore prima del ritiro.",
        "Local_notification_before": "Notifica locale prima",
        "Dispatch_mode": "Modo di assegnazione",
        "Manual": "Manuale",
        "Immediate_auto_dispatch": "assegnazione-automatica immediata",
        "Delayed_auto_dispatch": "assegnazione-automatica ritardata",
        "Auto_dispatch_before_pickup_time": "Invio automatico prima dell'orario di ritiro",
        "Auto_Reassign_Before_Pickup_Time": "Riassegna automaticamente prima dell'orario di ritiro",
        "Auto_Reassign_Before_Pickup_Time_Tooltip": "Assegna automaticamente il lavoro se il conducente assegnato non ha iniziato il viaggio X minuti prima dell'orario di ritiro. Nota: Questo si applica solo ai conducenti fornitori interni.",
        "Required_fields": "Campi obbligatori",
        "Shuttle": "SHUTTLE",
        "Shuttle_Dispatch_mode": "Modalità di spedizione",
        "Dispatch_setting_Shuttle_Dispatch_mode_tooltip": "- Manual mode: Reservation will be saved and stayed on Cue of your Command Center under “Pending” status once reservation is created. After clicking on “Update booking” at the booking detail, reservation will be dispatched to your assigned drivers or to all drivers in case of no driver assigning. It will be integrated into driver device calendar and reminder will be available. <br>- Delayed mode:Reservation will be saved and stayed on Cue of your Command Center under “Pending” status once reservation is created. Reservation will be automatically dispatched before “time value at “Process in advance”” from pick up time to the assigned driver or the nearest available one in case of no driver assigning. <br>- Immediate auto-dispatch mode: Reservation will be automatically dispatched to all drivers once reservation is created. It will be integrated into driver device calendar and reminder will be available.",
        "Save": "Salva",
        "Process_in_advance": "Trattazione in anticipo",
        "Save_dispatch_success": "L'assegnazione é stata aggiornata con successo",
        "Save_dispatch_fail": "Sono intervenuti degli errori nella fase di aggiornamento dell'assegnazione",
        "Dispatch_setting_general_tooltip": "Applica a prenotazioni su richiesta, prenotazioni in anticipo con assegnazione automatica ritardata",
        "Dispatch_setting_Assign_reservation_to_driver_tooltip": "La prenotazione è assegnata e accettata automaticamente per il conducente quando questa opzione è attivata.",
        "Dispatch_setting_Driver_cancellation_duration_tooltip": "Durata é dall’ora dell’appuntamento alla cancellazione da parte dell’autista",
        "Dispatch_setting_Dispatch_mode_tooltip": "-- Modo manuale : una volta creata la prenotazione sarà nell’elenco della Centrale di Gestione Command con lo status “In corso”. Cliccando su “aggiorna prenotazione” nei dettagli della prenotazione, la prenotazione sarà assegnata agli autisti designati o a tutti gli autisti nel caso non siano stati designati degli autisti. Sarà integrata nel calendario dell’autista e un promemoria sarà disponibile. <br>- Modo Ritardato : La prenotazione sarà registrata e rimarrà nell’Elenco della Centrale di Gestione con lo status “In corso”. La prenotazione sarà assegnata automaticamente prima “valore tempo a “Processo in anticipo”” dall’ora dell’appuntamento all’autista assegnato o il primo disponibile in caso in cui non sia stata assegnata a nessun autista. <br>-Modo assegnazione automatica immediata: La prenotazione sarà automaticamente assegnata a tutti gli autisti una volta creata. Sarà integrata nel calendario dell’autista e un promemoria sarà disponibile.",
        "Notification_nearby_drivers_before_pickup_time": "Notifica ai conducenti vicini prima dell'orario di ritiro",
        "Dispatch_setting_Maximum_Day_tooltip": "Questo serve a limitare i conducenti dall'avere troppe prenotazioni nello stesso giorno. Applicabile per Marketplace e Intercity.",
        "Maximum_Accept_Reservation_tooltip": "Il numero di prenotazioni accettate da un conducente non può superare questo numero. Questo limita il conducente dall'accettare troppe prenotazioni contemporaneamente. Applicabile per Marketplace e Intercity.",
        "Notification_nearby_drivers_before_pickup_time_tooltip": "Se la prenotazione di un cliente non è stata accettata da nessun autista prima dell'orario stabilito, prima dell'orario di ritiro, il sistema notificherà gli autisti nelle vicinanze. Questo speriamo li incoraggi a controllare il marketplace per accettare la prenotazione.",
        "marketPlace": "PIAZZA MERCATALE",
        "howFarDriverSeeBookingMarketplace": "Fino a che punto il conducente può vedere le prenotazioni nel marketplace",
        "shortNoticeOrder": "Ordine a breve preavviso",
        "shortNoticeOrderTooltip": "Imposta il periodo di tempo per le prenotazioni da considerare urgenti e visibili a tutti i livelli immediatamente."
    },
    "voiceSMSSetting": {
        "ACCOUNT_SETTINGS": "Impostazioni conto",
        "Account_SID": "Conto SID",
        "Auth_Token": "Token Autorizzazione",
        "Application_ID": "Identità Applicazione",
        "SMS_number_1": "Numero SMS",
        "SMS_number_2": "Numero SMS 2",
        "SMS_SETTINGS": "Impostazioni SMS",
        "MASKED_PHONE_SETTINGS": "impostazioni telefono privato",
        "SMS_MARKETING_SETTINGS": "Impostazioni marketing SMS",
        "Phone_number": "Numero di telefono",
        "Save": "Salva",
        "voiceSMS": "TWILIO",
        "DRIVER_APP": "App per conducenti",
        "PASSENGER_APP": "App Passeggero",
        "allowDriverToCallCC": "Consentire al conducente di contattare il Helpdesk tramite:",
        "allowDriverToCallHelpdesk": "Consentire al conducente di contattare il servizio assistenza tramite:",
        "allowDriverToCallPassenger": "Consenti al conducente di chiamare il passeggero tramite:",
        "allowPassengerToCallCC": "Consentire al passeggero di contattare l'assistenza tramite:",
        "allowPassengerToCallHelpdesk": "Consentire al passeggero di contattare l'assistenza tramite:",
        "allowPassengerToCallDriver": "Consenti al Passeggero di chiamare il Conducente tramite:",
        "voip": "VOIP",
        "mobile": "Mobile",
        "bookingSMS": "Modello di messaggio",
        "bookingSMSTemplate": {
            "name": "Nome",
            "content": "Contenuto",
            "action": "Azione",
            "DELETE": "Elimina modello di messaggio",
            "DELETE_CONFIRM": "Sei sicuro di voler eliminare il modello di messaggio selezionato?",
            "EDIT": "Modifica il modello di messaggio",
            "ADD": "Aggiungi modello di messaggio",
            "DETAIL": "Modello di messaggio dettagliato",
            "Update_success": "Il modello di messaggio è stato aggiornato con successo.",
            "Create_success": "Il modello di messaggio è stato creato con successo",
            "Delete_success": "Il modello di messaggio è stato eliminato con successo.",
            "Delete_fail": "Si sono verificati errori durante l'eliminazione del modello di messaggio",
            "Load_fail": "Si sono verificati errori durante il caricamento del modello di messaggio",
            "Update_fail": "Si sono verificati errori durante l'aggiornamento del modello di messaggio",
            "Create_fail": "Si sono verificati errori durante la creazione del modello di messaggio"
        },
        "bookingSMSModal": {
            "title": "Aggiungi modello SMS",
            "save": "Salva",
            "cancel": "Annulla",
            "titleMessage": "Invia Messaggio",
            "template": "Modello",
            "phoneNumber": "Numero di telefono",
            "content": "Contenuto",
            "messageType": "Tipo di messaggio",
            "inbox": "Posta in arrivo",
            "sms": "SMS",
            "sendTo": "Inviato a",
            "passenger": "Passeggero",
            "driver": "Driver"
        }
    },
    "regularSetting": {
        "extraWaitTimeTooltip": "Fee to compensate the driver when he has to wait additional time for the customer till they are onboard.",
        "fareWaitTimeLater": "Fare al minuto (Prenotazione)",
        "fareWaitTimeNow": "Fare al minuto (Ora)",
        "transport": "Trasporto",
        "delivery": "Consegna",
        "Fer_Stop": "Fermata della tassa",
        "First_Stop": "Tariffa per la prima fermata",
        "Each_Stop": "Tariffa per ogni fermata extra",
        "Name": "Nome ",
        "Pay_to_driver_Cash": "Paga al Fornitore/Autista (Prenotazione in contante)",
        "Last_Update": "Ultimo aggiornamento",
        "Status": "Stato",
        "Required_fields": "Campi obbligatori",
        "Yes": "Si",
        "No": "No",
        "Cancel": "Cancella",
        "Save": "Salva",
        "Actions": "Azioni",
        "Edit": "Modifica",
        "Add": "Aggiungi",
        "Show_per_page": "oggetti per pagina",
        "Page": "Pagina",
        "show_pages": "{0} - {1} of {2} mostrati",
        "DELETE_CONFIRM": "Vuoi eliminare?",
        "ADD_REGULAR_RATE": "Aggiungi tariffa normale",
        "EDIT_REGULAR_RATE": "Modifica tariffa normale",
        "DETAIL_REGULAR_RATE": "dettagli tariffa normale",
        "DELETE_REGULAR_RATE": "ELIMINA TARIFFA BASE",
        "Delete_confirm_regular_rate": "Vuoi cancellare questo oggetto?",
        "STARTING": "In partenza",
        "Starting_Now": "In partenza (Adesso)",
        "Starting_Reservation": "In partenza (Prenotazione)",
        "FIRST_DISTANCE_FEE": "tariffa primo tragitto",
        "First_distance_fee": "Primo tratto",
        "From": "Da",
        "To": "A",
        "Fee_for_first_distance": "Tariffa per prima distanza",
        "SECOND_DISTANCE_FEE": "Tariffa per secondo tragitto",
        "Second_distance_fee": "tariffa secondo tragitto",
        "AFTER_SECOND_DISTANCE": "Dopo secondo tragitto",
        "Fee_after_second_distance": "Tariffa successiva secondo tragitto",
        "PER_MINUTE": "Per minuto",
        "Fee_per_minute": "Tariffa per minuto",
        "mi": "mi",
        "hour": "Oraria",
        "MINIMUM": "MINIMO",
        "Minimum_Now": "Minimo (Adesso)",
        "Minimum_Reservation": "Minimo (Prenotazione)",
        "PAX_MDISPATCHER_CANCELLATION": "CANCELLAZIONE PASSEGGERO/ MDISPATCHER",
        "On_demand": "Su domanda",
        "Penalty": "Penalità",
        "In_advance": "In anticipo",
        "PAX_MDISPATCHER_NO_SHOW": "PASSEGGERO/ MDISPATCHER NON SI SONO PRESENTATI",
        "Driver_cancel_demand": "Politica di cancellazione del conducente - su richiesta",
        "Driver_cancel_advance": "Politica di cancellazione del conducente - in anticipo",
        "Assign_car_type": "Assegna tipo macchina",
        "Select_car_type": "Seleziona tipo macchina",
        "Active": "Attivo",
        "Inactive": "Inattivo",
        "Deactivate": "Disattivato",
        "DELETE_FLATE_RATE": "ELIMINA TARIFFA FISSA",
        "Delete_confirm_flat_rate": "Vuoi cancellare questo oggetto?",
        "EDIT_FLAT_RATE": "Modifica tariffa fissa",
        "ADD_FLAT_RATE": "Aggiungi tariffa fissa",
        "DELETE_FLAT_RATE": "ELIMINA TARIFFA FISSA",
        "DELETE_HOURLY_RATE": "ELIMINA TARIFFA ORARIA/ GIORNALIERA",
        "Delete_confirm_hour_rate": "DVuoi cancellare questo oggetto?",
        "EDIT_HOURLY_RATE": "EDIT HOURLY/ DAILY RATE",
        "ADD_HOURLY_RATE": "ADD HOURLY/ DAILY RATE",
        "DELETE_FLAT_ROUTE": "Elimina itinerario fisso",
        "DELETE_ROUTE_CONFIRM": "Sei sicuro di eliminare l'itinerario?",
        "EDIT_ROUTE": "EDIT ROUTE",
        "ADD_ROUTE": "Aggiungi strada",
        "Route_name": "Nome strada",
        "Route_type": "Tipo di percorso",
        "Zone_to_zone": "Zona a zona",
        "Zipcode_to_zipcode": "Codice postale a codice postale",
        "First_location": "Prima località",
        "Second_location": "Seconda località",
        "First_location_zip_note": "*Note: Puoi inserire molti codici postali contemporaneamente utilizzando il simbolo ',' . Per codici consecutivi, si prega di utilizzare il simbolo '->' invece di inserirli uno per uno (es: 90001 -> 90099, 90101, 90102, 90103, 90174, 90185)",
        "Second_location_zip_note": "*Note: Puoi inserire molti codici postali contemporaneamente utilizzando il simbolo ',' . Per codici consecutivi, si prega di utilizzare il simbolo '->' invece di inserirli uno per uno (es: 90001 -> 90099, 90101, 90102, 90103, 90174, 90185)",
        "SINGLE_TRIP_SETUP": "SINGLE TRIP SETUP",
        "Route_1": "Itinerario 1 (Prima località -> Seconda località)",
        "Route_2": "Itinerario 2 (Prima località -> Seconda località)",
        "Limitation": "Limitazione",
        "Unlimited": "Illimitato",
        "Limited": "Limitato",
        "Time_coverage": "Copertura temporale",
        "Extra_time": "Tempo supplementare",
        "ROUND_TRIP_SETUP": "ROUND TRIP SETUP",
        "Round_trip": "Andata e ritorno",
        "ROUTES": "Strade",
        "Route_1_Fare": "Tariffa Percorso 1",
        "Route_2_Fare": "Tariffa Percorso 2",
        "Round_Trip_Fare": "Tariffa andata e ritorno",
        "Select_a_zone": "Seleziona zona",
        "minute": "minuto",
        "VIEW_REGULAR_RATE": "VEDI DETTAGLI TARIFFA BASE",
        "VIEW_FLAT_RATE": "VEDI TARIFFA FISSA",
        "VIEW_HOURLY_RATE": "VEDI TARIFFA ORARIA",
        "HOURLY_PACKAGE_RATE": "TARIFFA PACCHETTO ORARIO",
        "Package_name": "Nome del pacchetto",
        "Package_duration": "Durata del pacchetto",
        "PackageId": "ID pacchetto",
        "Base_rate": "Tariffa di base",
        "Distance_coverage": "Copertura di distanza",
        "Extra_duration": "Durata extra",
        "Extra_distance": "Distanza extra",
        "DELETE_HOURLY_PACKAGE": "ELIMINA PACCHETTO ORARIO",
        "DELETE_PACKAGE_CONFIRM": "Vuoi eliminare la tariffa pacchetto?",
        "EDIT_PACKAGE": "EDIT PACKAGE",
        "VIEW_PACKAGE": "VEDI DETTAGLI PACCHETTO",
        "ADD_PACKAGE": "ADD PACKAGE",
        "Fee_per_extra_duration": "Tariffa per durata extra",
        "Fee_per_extra_distance": "Tariffa per distanza extra",
        "hours": "ora(e)",
        "days": "giorno(i)",
        "Update_flat_rate_success": "La tariffa fissa é stata aggiornata con successo",
        "Update_flat_rate_fail": "Sono intervenuti degli errori nella fase di aggiornamento della tariffa fissa",
        "Created_flat_rate_success": "La tariffa fissa é stata creata con successo",
        "Created_flat_rate_fail": "Sono intervenuti degli errori nella fase di creazione della tariffa fissa",
        "Update_flat_rate_route_success": "L'itinerario a tariffa fissa é stato aggiornato con successo",
        "Update_flat_rate_route_fail": "Sono intervenuti degli errori nella fase di aggiornamento dell'itinerario a tariffa fissa",
        "Created_flat_rate_route_success": "L'itinerario a tariffa fissa é stato creato con successo",
        "Created_flat_rate_route_fail": "Sono intervenuti degli errori nella fase di creazione dell'itinerario a tariffa fissa",
        "Loading_flat_rate_fail": "Sono intervenuti degli errori nella fase di caricamento dettagli della tariffa fissa",
        "Delete_flat_rate_route_fail": "Sono intervenuti degli errori nella fase di eliminazione dell'itinerario a tariffa fissa",
        "Delete_flat_rate_success": "La tariffa fissa é stata eliminata con successo",
        "Delete_flat_rate_fail": "Sono intervenuti degli errori nella fase di eliminazione dell'itinerario a tariffa fissa",
        "Update_intercity_rate_success": "La tariffa intercity è stata aggiornata con successo",
        "Update_intercity_rate_fail": "Si sono verificati errori durante l'aggiornamento della tariffa intercity",
        "Created_intercity_rate_success": "Il tasso intercity è stato creato con successo",
        "Created_intercity_rate_fail": "Si sono verificati errori durante la creazione della tariffa intercity",
        "Update_intercity_rate_route_success": "La tariffa della rotta intercity è stata aggiornata con successo",
        "Update_intercity_rate_route_fail": "Si sono verificati errori durante l'aggiornamento del percorso della tariffa intercity",
        "Created_intercity_rate_route_success": "Il percorso della tariffa intercity è stato creato con successo",
        "Created_intercity_rate_route_fail": "Si sono verificati errori durante la creazione del percorso tariffario intercity",
        "Loading_intercity_rate_fail": "Si sono verificati errori durante il caricamento dei dettagli delle tariffe intercity",
        "Delete_intercity_rate_route_fail": "Si sono verificati errori durante l'eliminazione del percorso tariffario intercity",
        "Delete_intercity_rate_success": "La tariffa intercity è stata eliminata con successo",
        "Delete_intercity_rate_fail": "Si sono verificati errori durante l'eliminazione della tariffa intercity",
        "Update_regular_rate_success": "La tariffa base é stata aggiornata con successo",
        "Update_regular_rate_fail": "Sono intervenuti degli errori nella fase di caricamento della tariffa base",
        "Create_regular_rate_success": "La tariffa base é stata creata con successo",
        "Create_regular_rate_fail": "Sono intervenuti degli errori nella fase di creazione della tariffa base",
        "Update_hourly_rate_success": "Il tasso orario è stato aggiornato con successo",
        "Update_hourly_rate_fail": "Sono intervenuti degli errori nella fase di aggiornamento della tariffa oraria",
        "Create_hourly_rate_success": "La tariffa oraria é stata creata con successo",
        "Create_hourly_rate_fail": "Sono intervenuti degli errori nella fase di creazione della tariffa oraria",
        "Update_hourly_rate_package_success": "Il pacchetto tariffa oraria é stato aggiornato con successo ",
        "Update_hourly_rate_package_fail": "Sono intervenuti degli errori nella fase di aggiornamento del pacchetto tariffa oraria",
        "Create_hourly_rate_package_success": "Il pacchetto tariffa oraria é stato creato con successo ",
        "Create_hourly_rate_package_fail": "Sono intervenuti degli errori nella fase di creazione del pacchetto tariffa oraria",
        "Load_hourly_rate_fail": "Sono intervenuti degli errori nella fase di caricamento dettaglidella tariffa oraria",
        "Update_hourly_status": "Sono intervenuti degli errori nella fase di aggiornamento dello status della tariffa oraria",
        "Delete_hourly_fail": "Sono intervenuti degli errori nella fase di eliminazione della tariffa oraria",
        "Delete_hourly_success": "La tariffa oraria é stata eliminata con successo",
        "Loading_regular_rate_fail": "Sono intervenuti degli errori nella fase di caricamento della tariffa base",
        "Update_regular_status_fail": "Sono intervenuti degli errori nella fase di aggiornamento status della tariffa base",
        "Delete_regular_rate_success": "La tariffa base é stata eliminata con successo",
        "Delete_regular_rate_fail": "Sono intervenuti degli errori nella fase di eliminazione della tariffa base",
        "Please_go_to_Car_Type_settings": "Per favore vai nelle impostazioni del tipo veicolo per assegnare la tariffa ai tipi di veicolo",
        "Car_type_filter": "Filtro tipo macchina",
        "Delete_package_error": "Si é verificato un errore nella fase di eliminazione del pacchetto!",
        "Pax_mDispatcher_cancellation_tooltip": "Regole sulla cancellazione applicate ai passeggeri",
        "Penalty_tooltip": "Montante a carico",
        "Pax_mDispatcher_no_show_tooltip": "Regole in caso di assenza del passeggero. Questa tariffa verrà addebitata se l’autista digiterà 'Assente' quando non trova il passeggero sul luogo dell’appuntamento.",
        "detail_route": "Dettaglio percorso",
        "detail_package": "Pacchetto Dettagli",
        "THIRD_DISTANCE_FEE": "Terza tariffa di distanza",
        "AFTER_DISTANCE_FEE": "Dopo la terza tassa di distanza",
        "Loading_delivery_rate_fail": "Si sono verificati errori durante il caricamento dei dettagli del tasso di consegna",
        "Update_delivery_rate_fail": "Si sono verificati errori durante l'aggiornamento della tariffa di consegna",
        "Update_delivery_rate_success": "Il tasso di consegna è stato aggiornato con successo",
        "Created_delivery_rate_success": "Il tasso di consegna è stato creato con successo",
        "Created_delivery_rate_fail": "Si sono verificati errori durante la creazione della tariffa di consegna",
        "Starting_fee": "Quota di iscrizione",
        "First_distance": "Prima distanza",
        "Second_distance": "Seconda distanza",
        "Third_distance": "Terza distanza",
        "Fee_for_second_distance": "Tariffa per la seconda distanza",
        "Fee_for_third_distance": "Commissione per la terza distanza",
        "Fee_after_third_distance": "Commissione dopo la terza distanza",
        "Assign_rate_to_car_type": "Assegna tariffa a tipo di veicolo",
        "car_type": "Assign car type",
        "PRICE_ADJUSTABLE": "Prezzo regolabile",
        "Amount_Step": "Prezzo regolabile",
        "Tax": "Tassa",
        "TechFee": "Quota tecnologica",
        "Pay_to_driver": "Paga al Fornitore/Autista",
        "Pay_to_driver_tooltip": "Opzioni per compensare i conducenti:\n - Importo fisso: Un importo fisso che il conducente riceverà.\n - Commissione: Commissione stabilita per il conducente applicata all'importo della penale.",
        "Fix_amount": "Importo",
        "Commission": "Commissione",
        "fareFlat": "Fare flat",
        "flatRoute": "Percorso pianeggiante",
        "Mode": "Modalità",
        "speedThresholdKM": "Soglia di velocità (km/h)",
        "speedThresholdMI": "Soglia di velocità (mi/h)",
        "timeAndMileage": "Tempo e chilometraggio",
        "timeOrMileage": "Tempo o chilometraggio",
        "perDistanceKM": "Per chilometro",
        "perDistanceMI": "Per miglio",
        "perTime": "Per minuto",
        "regularRates": "Tariffe Normali",
        "newRate": "Nuova Tariffa",
        "enterName": "Inserisci il nome del tasso",
        "actualMode": "Tariffa effettiva",
        "estimatedMode": "Tariffa quotata",
        "feePerStop": "Tariffa per fermate aggiuntive",
        "extraWaitTime": "Tempo di attesa extra",
        "startingFee": "Inizio",
        "minimumFee": "Minimo",
        "minAppend": "/min",
        "kmAppend": "/km",
        "miAppend": "/mi",
        "kmhrAppend": "km/h",
        "mihrAppend": "mi/h",
        "feePerKm": "Per chilometro",
        "feePerMi": "Per miglio",
        "feeSpeedThreshold": "Soglia di velocità",
        "serviceType": "Tipo di Servizio",
        "fareMode": "Formula",
        "calculationMode": "Modalità di Calcolo",
        "timeChangeMode": "Modalità di Carica Temporale",
        "minimum_Percent_Adjust": "Minimo % dalla tariffa stimata",
        "maximum_Percent_Adjust": "Massimo % dalla tariffa stimata",
        "AllowAdjustPrice": "Consentire al cliente di modificare il prezzo",
        "Calculation": "Calcolo",
        "distanceTier": "Livello di Distanza",
        "perKm": "Tariffa per km",
        "perMi": "Fee per me",
        "flatFee": "Tariffa Fissa",
        "defaultRate": "Aliquota di default",
        "timeRange": "Intervallo di Tempo",
        "bookingType": "Tipo di Prenotazione",
        "rateDetail": "Dettaglio Tariffa",
        "subRate": "Tariffa Sub",
        "specialRates": "Tariffe Speciali",
        "surcharge": "Supplemento",
        "penalty": "Penalità",
        "basedOriginMode": "Basato sull'orario di ritiro originale",
        "basedDriverMode": "Basato sull'orario di prelievo del conducente",
        "hourlyRate": "Tariffa Oraria",
        "flat_Fare": "Tariffa Fissa",
        "flatFeeOption": "Tariffa fissa",
        "fareModeTooltip": "Il tempo o il chilometraggio si applicano solo alle tariffe dei clienti, questo non si applicherà alla tariffa di pagamento per fornitori/autisti.",
        "cloneRate": "Percentuale di clonazione",
        "rateName": "Nome Tariffa",
        "Infinity": "Infinito",
        "Fee": "Tariffa",
        "headerTile": "Inserisci il titolo dell'intestazione",
        "enterFooter": "Inserisci il titolo del piè di pagina",
        "invoiceNo": "Numero fattura",
        "paidOn": "Pagato il",
        "amountPaid": "Importo Pagato",
        "isFeePerSeatActive": "Tariffa per passeggero",
        "minSeat": "Numero minimo di passeggeri",
        "minSeatTooltip": "Questo è il numero minimo di posti da addebitare per una prenotazione.",
        "dropOffZoneIds": "Zone di Ritiro",
        "applyGeniusDiscount": "Booking.com: Applica il Sconto Genius (5%)"
    },
    "flatRateSettings": {
        "flatZoneNote": "Le zone che crei qui sono utilizzate solo per impostare le tue tariffe fisse."
    },
    "deliverySetting": {
        "Name": "Nome",
        "Last_Update": "Ultimo Aggiornamento",
        "Status": "Stato",
        "Actions": "Azioni"
    },
    "sharingSetting": {
        "EDIT_RATE": "Modifica il tasso di condivisione della strada",
        "ADD_RATE": "Aggiungi tasso di condivisione stradale",
        "VIEW_RATE": "Visualizza il tasso di condivisione della strada",
        "Name": "Nome",
        "startingFee": "Tariffa iniziale",
        "minimumFee": "Tariffa minima",
        "Update_streetSharing_rate_fail": "Si sono verificati errori durante l'aggiornamento della tariffa di condivisione stradale",
        "Update_streetSharing_rate_success": "Il tasso di condivisione della strada è stato aggiornato con successo",
        "Created_streetSharing_rate_success": "Il tasso di condivisione della strada è stato creato con successo",
        "Created_streetSharing_rate_fail": "Si sono verificati errori durante la creazione della tariffa di condivisione stradale",
        "Loading_streetSharing_rate_fail": "Si sono verificati errori durante il caricamento dei dettagli del tasso di condivisione della strada",
        "Delete_streetSharing_rate_success": "Il tasso di condivisione della strada è stato eliminato con successo",
        "Delete_streetSharing_rate_fail": "Si sono verificati errori durante l'eliminazione della tariffa di condivisione stradale",
        "Delete_streetSharing_rate": "Elimina il tasso di condivisione della strada",
        "Assign_Car": "Assegna tipo di auto"
    },
    "carTypeSetting": {
        "ID": "ID tipo di auto",
        "newService": "Nuovo Servizio",
        "editService": "Modifica Servizio",
        "serviceInfo": "Informazioni sul servizio",
        "name": "Nome",
        "namePH": "Nome del tipo di auto",
        "enterNumber": "Inserisci un numero",
        "appDisplayName": "App display name",
        "shortDescription": "Breve descrizione",
        "maxPassengers": "Passeggeri massimi",
        "maxLuggage": "Max bagagli",
        "vehiclePhoto": "Foto del Veicolo",
        "iconShowList": "Icona da mostrare nell'elenco",
        "imageShowWeb": "Immagine da mostrare sul web",
        "carPinOnMap": "PIN dell'auto sulla mappa",
        "recommendedSize": "Dimensione consigliata:",
        "serviceSetting": "Impostazioni del servizio",
        "serviceType": "Tipo di servizio",
        "reservation": "Prenotazione",
        "onDemand": "On-demand",
        "destinationSetting": "Impostazione della destinazione",
        "requireDestination": "Richiedi destinazione",
        "extraDestination": "Destinazione extra",
        "calculatorFareMode": "Calcola modalità tariffaria",
        "hideDestinationOnDemand": "On-demand",
        "meteredFare": "Tariffa a tassametro",
        "quotedFare": "Tariffa quotata",
        "availableZones": "Zone Disponibili",
        "dispatchAssociation": "Associazione di Spedizione",
        "Save": "Salva",
        "Edit": "Modifica",
        "Cancel": "Annulla",
        "validateName": "Per favore inserisci il nome",
        "validateAppDisplayName": "Please input app display name",
        "validateSelectImage": "Per favore seleziona un'immagine",
        "updateSuccess": "Aggiornamento riuscito",
        "createSuccess": "Creato con successo",
        "failApi": "Qualcosa è andato storto!",
        "validateRequire": "Si prega di specificare il numero di passeggeri e ricontrollare i bagagli."
    },
    "carSetting": {
        "Details": "Dettagli",
        "vehicleInfo": "Info Veicolo",
        "Documents": "Documenti",
        "vehicle": "Veicolo",
        "addVehicle": "Aggiungi Veicolo",
        "detailVehicle": "Dettagli del veicolo",
        "additionalVehicleTitle": "Informazioni aggiuntive sul veicolo",
        "Phone_Number_Tooltip": "Inserisci un numero di telefono specifico per il veicolo per l'uso da parte del cliente. Se non fornito, le chiamate verranno indirizzate al numero personale del conducente. Ideale per i fornitori che equipaggiano i veicoli con telefoni di contatto dedicati.",
        "discardChange": "Scarta le modifiche",
        "model_name_is_required": "Il nome del modello è obbligatorio",
        "DELETE_CAR": "ELIMINA VEICOLO",
        "DELETE_CONFIRM": "Vuoi eliminare il veicolo selezionato?",
        "Yes": "Si",
        "Cancel": "Cancella",
        "EDIT_CAR": "MODIFICA VEICOLO",
        "CREATE_CAR": "CREA VEICOLO",
        "Plate_Number": "Numero di targa",
        "Car_Type": "Tipo di macchina",
        "Select_car_type": "Seleziona tipo macchina",
        "Make": "Costruttore",
        "Select_car_make": "Seleziona costruttore",
        "Model": "Modello",
        "Select_a_car_model": "Seleziona un modello auto",
        "Year": "Anno",
        "Select_year": "Seleziona anno",
        "Hardware_Meter": "Misuratore Hardware",
        "VIN": "Seleziona anno",
        "Company": "Azienda",
        "Select_company": "Seleziona azienda",
        "Max_Passengers": "Max Passeggeri",
        "Max_Luggage": "Max Bagagli",
        "Color": "Colore",
        "License_expiry": "Patente scade",
        "Required_fields": "Campi obbligatori",
        "Save": "Salva",
        "Add": "Aggiungi",
        "Car_Model": "Modello Macchina",
        "Created_Date": "Crea data",
        "Status": "Stato",
        "Actions": "Azioni",
        "Show_per_page": "oggetti per pagina",
        "Page": "Pagina",
        "show_pages": "{0} - {1} of {2} mostrati",
        "Active": "Attiva",
        "activeVehicle": "Veicolo attivo",
        "Inactive": "Inattivo",
        "Edit": "Modifica",
        "Deactivate": "Disattivato",
        "Activate": "Attivato",
        "Delete": "Cancella",
        "Name": "Nome",
        "MODEL_LIST": "LISTA MODELLO",
        "Model_Name": "Nome modello",
        "Add_Model": "Aggiungi modello",
        "DELETE_CAR_MODEL": "ELIMINA MODELLO VEICOLO",
        "DELETE_CONFIRM_MODEL": "Vuoi eliminare il modello del veicolo?",
        "DELETE_CAR_MAKE": "Elimina marca dell'auto",
        "DELETE_CONFIRM_CAR_MAKE": "Vuoi eliminare questo marchio di auto?",
        "EDIT_CAR_MAKE": "Modifica costruttore auto",
        "CREATE_CAR_MAKE": "Aggiungi costruttore auto",
        "Assign_Rate": "Assegna tariffa",
        "ASSIGN_RATE": "ASSEGNA TARIFFA",
        "Car_type_ID": "Tipo Macchina ID",
        "App_Display_Name": "App Display Name",
        "Affiliate_car_type": "Tipo di auto affiliato",
        "Regular_rate": "Tariffa normale",
        "Zone": "Zona",
        "Rate": "Valuta",
        "Zone_Rate": "Tariffa zona",
        "Flat_Fare": "Tasso fisso",
        "Flat_Delivery": "Consegna piatta",
        "Select_flat_rate": "Seleziona tariffa fissa.",
        "Hourly_daily_rate": "Orario/ Giornaliero",
        "Dispatch_To": "Assegna a",
        "Normal_Fare": "Regolare",
        "Upload_an_image": "Carica immagine",
        "DETAIL_CAR": "DETTAGLI VEICOLO",
        "DELETE_MULTI_CAR": "Elimina vetture selezionate",
        "DELETE_MULTI_CAR_CONFIRM": "Vuoi eliminare questi veicoli, esclusivamente i veicoli inattivi possono essere eliminati?",
        "DETAIL_CAR_MAKE": "Costruttore",
        "Car_Make": "Costruttore",
        "Create_car_success": "Nuova vettura creata con successo",
        "Update_car_success": "Questa auto è stata aggiornata con successo.",
        "Update_car_fail": "Sono intervenuti degli errori nella fase di aggiornamento del tipo di vettura",
        "Create_car_fail": "Sono intervenuti degli errori nella fase di creazione della marca della vettura",
        "Load_car_fail": "Sono intervenuti degli errori nella fase di caricamento del modello della vettura",
        "Delete_car_fail": "Sono intervenuti degli errori nella fase di eliminazione della marca della vettura",
        "Delete_car_success": "La vettura é stata eliminata con successo",
        "Change_cars_status_success": "Gli status della vettura sono stati modificati con successo",
        "Change_cars_status_fail": "Sono intervenuti degli errori nella fase di cambiamento di status della vettura",
        "Delete_cars_success": "Tutte le vetture selezionate sono state eliminate con successo",
        "Delete_cars_fail": "Sono intervenuti degli errori nella fase di cambiamento eliminazione delle vetture",
        "Update_car_type_success": "Il tipo di vettura é stato aggiornato con successo",
        "Update_car_type_fail": "Sono intervenuti degli errori nella fase di aggiornamento del tipo di vettura",
        "Load_car_type_details_fail": "Ipossibile caricare i dettagli del tipo di vettura",
        "Update_car_make_fail": "Sono intervenuti degli errori nella fase di aggiornamento della marca della vettura",
        "Update_car_make_success": "La marca della vettura é stata aggiornata con successo",
        "Create_car_make_fail": "Sono intervenuti degli errori nella fase di creazione della marca della vettura",
        "Create_car_make_success": "La nuova marca della vettura é stata creata con successo",
        "Update_car_model_fail": "Sono intervenuti degli errori nella fase di aggiornamento del modello della vettura",
        "Update_car_model_success": "Il modello della vettura é stato aggiornato con successo",
        "Create_car_model_fail": "TSono intervenuti degli errori nella fase di creazione del modello della vettura",
        "Create_car_model_success": "Il nuovo modello della vettura é stato creato con successo",
        "Loading_car_model_fail": "Sono intervenuti degli errori nella fase di caricamento del modello della vettura",
        "Delete_car_make_success": "La marca della vettura é stata eliminata con successo",
        "Delete_cat_make_fail": "Sono intervenuti degli errori nella fase di eliminazione della marca della vettura",
        "Delete_regular_rate_success": "Cancellazione Tariffa base effettuata con successo",
        "Delete_regular_rate_fail": "Cancella errore tariffa base",
        "Update_status_error": "aggiorna status errore",
        "Case_number": "Numero caso",
        "Phone_Number": "Numero di telefono",
        "ERROR_INPUT_VALIDPHONE": "Per favore inserisci un numero di telefono valido..",
        "Car_type_filter": "Filtro tipo macchina",
        "No": "No",
        "Intercity_Rate": "Tariffa Intercity",
        "Select_intercity_rate": "Seleziona tariffa intercity",
        "Delivery_Rate": "Tasso di consegna",
        "Select_delivery_rate": "Seleziona il tasso di consegna",
        "vehicleOwner": "Nome del proprietario del veicolo",
        "EDIT_CAR_COLOR": "Modifica colore auto",
        "DETAIL_CAR_COLOR": "Dettaglio colore auto",
        "CREATE_CAR_COLOR": "Aggiungi colore dell'auto",
        "Car_Color": "Colore dell'auto",
        "Update_car_color_fail": "Si sono verificati errori durante l'aggiornamento del colore dell'auto.",
        "Update_car_color_success": "Il colore dell'auto è stato aggiornato con successo.",
        "Create_car_color_fail": "Si sono verificati errori durante la creazione del colore dell'auto.",
        "Create_car_color_success": "Il nuovo colore dell'auto è stato creato con successo",
        "Delete_car_color_success": "Il colore dell'auto è stato eliminato con successo.",
        "Delete_car_color_fail": "Si sono verificati errori durante l'eliminazione del colore dell'auto.",
        "DELETE_CAR_COLOR": "Elimina colore auto",
        "DELETE_CONFIRM_CAR_COLOR": "Vuoi eliminare questo colore dell'auto?",
        "sharing_Rate": "Tariffa di Condivisione Stradale",
        "bookingAffiliate": "Tipo di auto Affiliate Booking.com",
        "streetSharing": "Condivisione Stradale",
        "colorCode": "Codice colore",
        "selectColorCode": "Seleziona il codice colore"
    },
    "operationSetting": {
        "Driver": "Autisti",
        "Search_driver_name": "Cerca nome autista",
        "Company": "Azienda",
        "License_plate": "Numero di targa",
        "Select_license_plate": "Seleziona numero di targa",
        "Shift": "Turno",
        "Zone": "Zona",
        "Required_fields": "Campi obbligatori",
        "Save": "Salva",
        "No": "No.",
        "Car_Type": "Tipo Macchina",
        "Plate_Number": "Numero di targa",
        "Unassign": "Togli l’assegnazione",
        "Please_choose_driver": "Per favore scegli un autista.",
        "Please_choose_company": "Per favore scegli un’azienda.",
        "Please_license_plate": "Per favore scegli targa.",
        "Please_choose_shift": "Per favore scegli il turno.",
        "Please_choose_zone": "Per favore scegli la zona.",
        "CONFIRM_UNASSIGN": "Vuoi togliere l’assegnamento all’autista?",
        "Assign_success": "Operazione assegnata con successo",
        "Unassign_success": "L’assegnamento é stato tolto all’autista con successo."
    },
    "paymentMethod": {
        "cash": "Contante",
        "easyPaisa": "Easy Paisa",
        "jazzCash": "Jazz Cash",
        "cashBySender": "Contante dal mittente",
        "cashByRecipient": "Contante per destinatario",
        "personalCard": "Carta personale",
        "corporateCard": "Carta Aziendale",
        "qrCodePayment": "Pagamento con codice QR",
        "directBilling": "Fatturazione diretta",
        "externalCard": "Carta esterna",
        "mDispatcherCard": "Carta mDispatcher",
        "corporatePrepaid": "Carta Prepagata",
        "fleetCard": "Carta esterna",
        "applePay": "Apple Pay",
        "creditExternalCard": "Carta di credito",
        "googlePay": "Google Pay",
        "wallet": "Portafoglio",
        "BankOfGeorgia": "Banca di Georgia",
        "tnGeWalletlet": "TnG eWallet",
        "paymentMethod_1": "Contante",
        "paymentMethod_2": "Carta personale",
        "paymentMethod_3": "Carta mDispatcher",
        "paymentMethod_4": "Carta Aziendale",
        "paymentMethod_5": "Fatturazione diretta",
        "paymentMethod_6": "Carta esterna",
        "paymentMethod_7": "Carta Prepagata",
        "paymentMethod_8": "Pagamento con codice QR",
        "paymentMethod_9": "Apple Pay",
        "paymentMethod_11": "Airpay",
        "paymentMethod_12": "Carta di credito",
        "paymentMethod_13": "Portafoglio",
        "paymentMethod_14": "TnG eWallet",
        "paymentMethod_16": "Contante dal mittente",
        "paymentMethod_17": "Contante per destinatario",
        "paymentMethod_19": "Boost eWallet",
        "paymentMethod_20": "Vipps",
        "paymentMethod_21": "ZainCash",
        "paymentMethod_23": "Google Pay",
        "paymentMethod_25": "Easy Paisa",
        "paymentMethod_27": "Samsung Pay",
        "paymentMethod_28": "Kakao Pay",
        "paymentMethod_29": "Naver Pay",
        "paymentMethod_30": "WeChat Pay",
        "paymentMethod_31": "Alipay",
        "paymentMethod_32": "PayNow",
        "paymentMethod_33": "GrabPay",
        "paymentMethod_34": "Cash App Pay",
        "vippseWallet": "Vipps",
        "paymentMethod_credit": "Carta personale",
        "paymentMethod_razerPay": "RazerPay",
        "paymentMethod_gCash": "GCash",
        "paymentMethod_zainCash": "ZainCash",
        "paymentMethod_xenDit": "Xendit",
        "paymentMethod_alipayExternal": "Alipay",
        "paymentMethod_FIB": "FIB",
        "paymentMethod_SantimPay": "SantimPay",
        "paymentMethod_ksher": "Ksher",
        "paymentMethod_paydunya": "PayDunya",
        "paymentMethod_fawry": "Fawry",
        "paymentMethod_BankOfGeorgia": "Banca di Georgia",
        "paymentLink": "Link di pagamento",
        "paymentMethod_xendit": "Xendit",
        "paymentMethod_easyPaisa": "Easy Paisa",
        "paymentMethod_jazzCash": "Jazz Cash",
        "paymentMethod_flooz": "Flooz",
        "paymentMethod_tmoney": "Tmoney",
        "paymentMethod_samsung_pay": "Samsung Pay",
        "paymentMethod_kakao_pay": "Kakao Pay",
        "paymentMethod_naver_pay": "Naver Pay",
        "paymentMethod_wechat_pay": "WeChat Pay",
        "paymentMethod_alipay": "Alipay",
        "paymentMethod_paynow": "PayNow",
        "paymentMethod_grabpay": "GrabPay",
        "paymentMethod_cashapp": "Cash App Pay"
    },
    "changePassword": {
        "Change_password": "Cambia password",
        "Current_password": "Password attuale",
        "New_password": "Nuova password",
        "Confirm_password": "Conferma nuova password",
        "ERROR_INPUT_PASSWORD": "Per favore inserisci password",
        "ERROR_INPUT_VALID_PASSWORD": "PasswLa Password deve contenere almeno 8 caratteri, dei quali uno numerico ed uno speciale",
        "ERROR_INPUT_MATCH_PASSWORD": "La password non combacia. Per favore riprova.",
        "Save": "Salva",
        "Cancel": "Cancella"
    },
    "userProfile": {
        "My_account": "Il mio account",
        "Username": "Nome utente",
        "First_name": "Nome",
        "Last_name": "Cognome",
        "Phone_number": "Numero di telefono",
        "Email_address": "Indirizzo email",
        "Address": "Indirizzo email",
        "Save": "Salva",
        "Edit_profile": "Modifica profilo",
        "Change_password": "Cambia password",
        "ERROR_INPUT_USERNAME": "Per favore inserisci username.",
        "ERROR_INPUT_FIRSTNAME": "Per favore inserisci nome.",
        "ERROR_INPUT_VALID_EMAIL": "Per favore inserisci un’email valida.",
        "Required_fields": "Campi obbligatori"
    },
    "General": {
        "widgetChat": "Support / Chat",
        "searchQueuingDriver": "Cerca: Nome del conducente, Numero di telefono",
        "search": "Cerca",
        "User": "Utilizzatore",
        "My_Account": "Il mio account",
        "Product_Discovery": "Scoperta del Prodotto",
        "Sign_out": "Disconnettiti",
        "My_site": "Il mio sito",
        "Command_center": "Centrale di gestione",
        "Notifications": "Notifica",
        "Show_all": "Mostra tutto",
        "SOS_Notifications": "Notifiche SOS",
        "You_dont_have_any_message": "Non hai alcun messaggio",
        "Mon": "Lu",
        "Tue": "Ma",
        "Wed": "Me",
        "Thu": "Gio",
        "Fri": "Ve",
        "Sat": "Sa",
        "Sun": "Dom",
        "Now": "Adesso",
        "NowComplete": "Ora (Orario di Ritiro Attuale)",
        "hrs": "ore",
        "patmentMethod_1": "Contante",
        "patmentMethod_2": "Carta personale",
        "patmentMethod_3": "mDispatch card",
        "patmentMethod_4": "Carta Aziendale",
        "patmentMethod_5": "Fatturazione diretta",
        "patmentMethod_6": "Carta esterna",
        "patmentMethod_7": "Carta Prepagata",
        "patmentMethod_8": "Codice QR",
        "patmentMethod_9": "Apple Pay",
        "patmentMethod_10": "Apple Pay",
        "patmentMethod_12": "Carta di credito",
        "patmentMethod_13": "Portafoglio",
        "patmentMethod_14": "TnG eWallet",
        "patmentMethod_16": "Contante dal mittente",
        "patmentMethod_17": "Contante per destinatario",
        "patmentMethod_19": "Potenziare",
        "patmentMethod_20": "Vipps",
        "patmentMethod_23": "Google Pay",
        "patmentMethod_24": "Link di pagamento",
        "patmentMethod_25": "Easy Paisa",
        "patmentMethod_26": "Jazz Cash",
        "patmentMethod_27": "Samsung Pay",
        "patmentMethod_28": "Kakao Pay",
        "patmentMethod_29": "Naver Pay",
        "patmentMethod_30": "WeChat Pay",
        "patmentMethod_31": "Alipay",
        "patmentMethod_32": "PayNow",
        "patmentMethod_33": "GrabPay",
        "patmentMethod_34": "Cash App Pay",
        "patmentMethod_ZainCash": "ZainCash",
        "patmentMethod_Xendit": "Xendit",
        "patmentMethod_FIB": "FIB",
        "patmentMethod_SantimPay": "SantimPay",
        "patmentMethod_GCash": "GCash",
        "patmentMethod_cash": "Contante",
        "patmentMethod_credit": "Personal card",
        "patmentMethod_mDispatcher": "Partner card",
        "patmentMethod_corpCredit": "Carta Aziendale",
        "patmentMethod_directBilling": "Direct invoicing",
        "patmentMethod_fleetCard": "Scheda esterna",
        "patmentMethod_prepaid": "Prepagato Aziendale",
        "patmentMethod_QRCode": "Codice QR",
        "patmentMethod_applePay": "Apple Pay",
        "patmentMethod_easyPaisa": "Easy Paisa",
        "patmentMethod_jazzCash": "Jazz Cash",
        "patmentMethod_prePaid": "Prepagato Aziendale",
        "patmentMethod_GooglePay": "Google Pay",
        "patmentMethod_creditCardExternal": "Carta di Credito",
        "patmentMethod_exXendit": "QRIS",
        "patmentMethod_PaxWallet": "Portafoglio",
        "patmentMethod_TnGeWallet": "TnG eWallet",
        "patmentMethod_boosteWallet": "Potenziare",
        "patmentMethod_Vipps": "Vipps",
        "patmentMethod_exZainCash": "ZainCash",
        "patmentMethod_exGCash": "GCash",
        "patmentMethod_exPayTM": "PayTM",
        "patmentMethod_exFlooz": "Flooz",
        "patmentMethod_exTmoney": "Tmoney",
        "patmentMethod_exTelebirr": "GCash",
        "paymentMethod_exzainCash": "ZainCash",
        "paymentMethod_exXendit": "Xendit",
        "paymentMethod_exalipay": "Alipay",
        "paymentMethod_exFIB": "FIB",
        "paymentMethod_exSantimPay": "SantimPay",
        "patmentMethod_exKsher": "Ksher",
        "paymentMethod_paydunya": "PayDunya",
        "paymentMethod_exfawry": "Fawry",
        "patmentMethod_exBankOfGeorgia": "Banca di Georgia",
        "patmentMethod_exPayDunya": "PayDunya",
        "patmentMethod_21": "ZainCash",
        "patmentMethod_paymentLink": "Link di Pagamento",
        "patmentMethod_card": "Carta personale",
        "patmentMethod_corporateCard": "Carta aziendale",
        "patmentMethod_paxWallet": "Portafoglio",
        "patmentMethod_externalWallet": "Portafoglio Esterno",
        "patmentMethod_googlePay": "Google Pay",
        "patmentMethod_manual": "Manuale",
        "patmentMethod_samsung_pay": "Samsung Pay",
        "patmentMethod_kakao_pay": "Kakao Pay",
        "patmentMethod_naver_pay": "Naver Pay",
        "patmentMethod_wechat_pay": "WeChat Pay",
        "patmentMethod_alipay": "Alipay",
        "patmentMethod_paynow": "PayNow",
        "patmentMethod_grabpay": "GrabPay",
        "patmentMethod_cashapp": "Cash App Pay",
        "patmentMethod_online": "Pagamento con carta/online",
        "patmentMethod_check": "Controlla",
        "patmentMethod_wire": "Filo",
        "patmentMethod_digitalWallet": "Portafoglio Digitale",
        "patmentMethod_bankTransfer": "Bonifico Bancario",
        "patmentMethod_offlineMethod": "Pagamento Offline",
        "patmentAirlineMethod_5": "Direct invoicing",
        "patmentAirlineMethod_4": "Carta Aerea",
        "patmentAirlineMethod_7": "Prepagato Airline",
        "Name": "Nome",
        "Delete": "Cancella",
        "App_SOS_dialog_form_message_1": "{0} Emergenza SOS!",
        "App_SOS_dialog_form_message_2": "Ho bisogno di aiuto a",
        "App_SOS_dialog_form_message_3": "Prenotazione: {0}, Autista: {1}, Passeggero: {2}, Targa: {3} ({4})",
        "mins": "minuti",
        "Credit_Card": "Carte de crédit",
        "ALL": "Tutto",
        "NotFound": "La pagina che hai richiesto non è stata trovata.",
        "ServerError": "Qualcosa è andato storto",
        "AccessDenied": "Non hai il permesso di accedere a questo modulo!",
        "Retry": "Riprova",
        "Can_not_get_data": "Impossibile ottenere dati"
    },
    "shiftSettings": {
        "Add": "Aggiungi",
        "Show_per_page": "Oggetti per pagina",
        "Page": "Pagina",
        "Name": "Nome",
        "Time_Range": "Intervallo tempo",
        "Actions": "Azioni",
        "show_pages": "{0} - {1} of {2} mostrati",
        "Edit": "Modifica",
        "Delete": "Cancella",
        "EDIT_SHIFT_SETTING": "MODIFICA IMPOSTAZIONI TURNO",
        "ADD_SHIFT_SETTING": "AGGIUNGI IMPOSTAZIONI TURNO",
        "DETAIL_SHIFT_SETTING": "DETTAGLI IMPOSTAZIONI TURNO",
        "DELETE_SHIFT_SETTING": "ELIMINA IMPOSTAZIONI DEL TURNO",
        "Delete_confirm_shift_setting": "Vuoi cancellare questo oggetto?",
        "Required_fields": "Campi obbligatori",
        "Save": "Salva",
        "Cancel": "Cancella",
        "From": "Da",
        "To": "A",
        "Edit_shift_template": "Modifica Modello Turno",
        "Add_shift_template": "Aggiungi Modello Turno",
        "Detail_shift_template": "Dettaglio modello turno",
        "Delete_shift_template": "Elimina modello turno",
        "Delete_confirm_shift_template": "Vuoi cancellare questo oggetto?",
        "Working_time": "Orario di Lavoro",
        "Create_shift_settings_success": "Le impostazioni del nuovo turno sono state create con successo",
        "Create_shift_settings_fail": "Sono intervenuti degli errori nella fase di creazione delle impostazioni del turno",
        "Update_shift_settings_success": "Le impostazioni del turno sono state create con successo",
        "Update_shift_settings_fail": "Sono intervenuti degli errori nella fase di aggiornamento del turno",
        "Delete_shift_settings_success": "Le impostazioni del turno sono state eliminate con successo",
        "Delete_shift_settings_fail": "Sono intervenuti degli errori nella fase di eliminazione delle impostazioni del turno",
        "Create_shift_template_success": "Il modello del nuovo turno é stato creato con successo",
        "Create_shift_template_fail": "Sono intervenuti degli errori nella fase di creazione del modello del turno",
        "Update_shift_template_success": "Il modello del turno é stato creato con successo",
        "Update_shift_template_fail": "Sono intervenuti degli errori nella fase di aggiornamento del modello del turno",
        "Delete_shift_template_success": "Il modello del turno é stato eliminato con successo",
        "Delete_shift_template_fail": "Sono intervenuti degli errori nella fase di eliminazione del modello del turno",
        "Yes": "Sì",
        "No": "No"
    },
    "promotionSettings": {
        "Detail_campaign": "Dettaglio Campagna",
        "Edit_campaign": "Modifica Campagna",
        "Add_campaign": "Aggiungi Campagna",
        "Delete_campaign": "Elimina campagna",
        "Delete_confirm_campaign": "Vuoi eliminare la campagna selezionata?",
        "Add": "Aggiungi",
        "Corporate_list": "Elenco aziendale",
        "permittedCorporate": "Elenco aziendale autorizzato",
        "CorporateCustomers": "Clienti Aziendali",
        "auto_add_corporate": "Aggiungi automaticamente alla lista di promozione dell'utente aziendale",
        "Show_per_page": "oggetti per pagina",
        "Page": "Pagina",
        "Name": "Nome",
        "Actions": "Azioni",
        "Private": "Privato",
        "show_pages": "{0} - {1} of {2} mostrati",
        "Edit": "Modifica",
        "Delete": "Cancella",
        "Send_to_inbox": "Invia alla casella di posta",
        "Save": "Salva",
        "Duplicate": "Duplicare",
        "Cancel": "Cancella",
        "Required_fields": "Campi obbligatori",
        "Promotion_code": "Codice Promozionale",
        "Promotion_type": "Tipo di promozione",
        "Campaign": "Campagna",
        "Type": "genere",
        "Value": "Valuta",
        "keepMinFee": "Il costo totale dopo la promozione deve essere superiore alla tariffa minima",
        "Zone": "Zone",
        "paymentMethodsApply": "Metodi di pagamento",
        "schedules": "Programmi",
        "minimumEstFareApply": "Stima minima della tariffa totale per applicare il codice",
        "quantityLimitPerYear": "Massimo utilizzi/utente/anno",
        "termAndCondition": "Termini e condizioni",
        "Valid_from": "Valido da",
        "Valid_to": "Valido a",
        "Total_uses_user": "Totale Usi/Utilizzatore",
        "Released_quantity": "Quantità emesse",
        "Number_of_sending_inbox": "Numero della casella di invio",
        "Status": "Stato",
        "Activate": "Attivato",
        "Deactivate": "Disattivato",
        "Add_promotion_code": "Aggiungi codice promozionale",
        "Edit_promotion_code": "Modifica codeice promozionale",
        "Detail_promotion_code": "Dettaglio codice promozionale",
        "Delete_promotion_code": "Elimina codice promozionale",
        "Delete_confirm_promotion_code": "Vuoi eliminare il codice promozionale selezionato?",
        "New_customer": "Nuovo Cliente",
        "Budget_per_user": "Budget/utente (per l'intero periodo di promozione)",
        "Budget_per_user_day": "Budget/utente/giorno",
        "Budget_per_user_month": "Budget/utente/mese",
        "Budget_per_user_year": "Budget/utente/anno",
        "Unlimited": "Illimitato",
        "Limited": "Limitato",
        "Total_uses_per_user": "Totale usi/utilizzatore",
        "Send_an_in_box_automatically_to_new_customers": "Invia automaticamente un'email ai nuovi clienti",
        "Notes": "Note",
        "Public": "Pubblico",
        "Create_campaign_success": "La nuova campagna é stata creata con successo ",
        "Create_campaign_fail": "Sono intervenuti degli errori nella fase di creazione della campagna",
        "Update_campaign_success": "La campagna é stata aggiornata con successo",
        "Update_campaign_fail": "Sono intervenuti degli errori nella fase di aggiornamento della campagna",
        "Delete_campaign_success": "La campagna é stata eliminata con successo",
        "Delete_campaign_fail": "Sono intervenuti errori nella fase di eliminazione della campagna",
        "Loading_campaign_fail": "Sono intervenuti degli errori nella fase di caricamento della campagna",
        "Update_campaign_status_success": "Lo status della campagna é stato aggiornato con successo",
        "Update_campaign_status_fail": "Sono intervenuti degli errori nella fase di aggiornamento status della campagna",
        "Loading_promotion_code_fail": "Sono intervenuti errori nella fase di caricamento del codice promozionale",
        "Select_campaign": "Seleziona campagna",
        "Create_promotion_code_success": "Il nuovo codice promozionale é stato creato con successo",
        "Create_promotion_code_fail": "Sono intervenuti degli errori nella fase di creazione del codice promozionale",
        "Update_promotion_code_status_success": "Lo status del codice promozionale é stato aggiornato con successo",
        "Update_promotion_code_status_fail": "Sono intervenuti degli errori nella fase di aggiornamento status del codice promozionale",
        "Delete_promotion_code_confirmation": "Vuoi eliminare questi codici promozionali?",
        "Just_delete_inactive": "** Solo codici di promozione in status inattivo possono essere eliminati.",
        "Send_inbox_confirmation": "Sei sicuro di voler inviare questo codice promozionale alla casella di posta del passeggero?",
        "Send_inbox_success": "Il codice promozionale è stato inviato con successo.",
        "Send_inbox_fail": "Invio del codice promozionale non riuscito. Per favore riprova!",
        "Confirmation": "Conferma",
        "Delete_promotion_codes_success": "Il codice promozionale é stato elimianato con successo",
        "Delete_promotion_codes_fail": "Sono intervenuti errori nella fase di eliminazione del codice promozionale",
        "Delete_multiple_promotion_codes_success": "Il codice promozionale é stato elimianato con successo",
        "Delete_multiple_promotion_codes_fail": "Sono intervenuti errori nella fase di eliminazione dei codici promozionali",
        "Delete_promotion_code_success": "Il codice promozionale é stato elimianato con successo",
        "Delete_promotion_code_fail": "Sono intervenuti errori nella fase di eliminazione del codice promozionale",
        "Update_multiple_promotion_code_status_success": "Gli status del codice promozionale é stato aggiornato con successo",
        "Update_multiple_promotion_code_status_fail": "Sono intercorsi errori nella fase di eliminazione status del codice promozionale",
        "Search_here": "Cerca qui",
        "Please_input_campaign_name": "Per favore inserisci nome campagna",
        "Please_input_promotion_code": "Per favore inserisci codice promozionale",
        "Please_input_promotion_code_at_least_4_characters": "Per favore inserisci almeno 4 caratteri.",
        "Please_select_campaign": "Per favore seleziona campagna",
        "Please_input_value": "Per favore inserisci valuta",
        "Please_select_date": "Per favore seleziona data",
        "Please_add_schedules": "Per favore aggiungi il programma",
        "Please_add_corporate": "Si prega di aggiungere aziendale",
        "Please_choose_at_least_one_customer": "Per favore scegli almeno un cliente per l’invio del messaggio.",
        "This_campaign_name_has_been_existing_on_the_system_Please_input_another_one": "Il nome di questa campagna esiste già nel sistema. Per favore inseriscine un’altra",
        "This_promotion_code_has_been_existing_on_the_system_Please_input_another_one": "Questo codice di promozione esiste già nel sistema. Per favore inseriscine un altro.",
        "Invalid_file": "Documento invalido",
        "File_size_larger_than_5Mb": "La taglia del file é maggiore di 5Mb",
        "Import_promotions_success": "Il file é stato importato con successo",
        "Import_Promotions": "Oggetti importati",
        "Number_successful_imports": "Importa oggetti",
        "Number_skipped": "Salta oggetti",
        "File": "Documento",
        "Phone_Numbers": "numero di telefono",
        "Import_Promotion_code_success": "Il codice promozionale <b>{0}</b> è stato importato con successo",
        "Import_Promotion_code_fail": "Il codice promozionale <b>{0}</b> non è stato importato correttamente. Per favore riprova.",
        "Customer_type": "Tipo di cliente",
        "All": "Tutto",
        "Referred_customers": "Clienti referiti",
        "Common_customers": "Clienti comuni",
        "Operation_zone": "Zone operative",
        "totalUsesLimitPerDay": "Utilizzi massimi/utente/giorno",
        "quantityLimitPerDay": "Quantità massima/giorno",
        "quantityLimitPerMonth": "Quantità massima / utente / mese",
        "applyVerifiedCustomers": "Richiedi solo i clienti malesi verificati",
        "applyWhenBudgetLimit": "L'utente può applicare il codice fino a quando il budget non è esaurito.",
        "applyVerifiedCustomersTooltip": "Questa promozione è applicabile per i malesi che hanno verificato l'ID nazionale e caricato la propria carta d'identità solo sul sistema",
        "valueLimitPerUse": "Valore/uso massimo (Applicabile per app v48 e superiori)",
        "Promotion_Services": "Servizio",
        "transport": "Trasporto",
        "shuttle": "Navetta",
        "parcel": "Pacco",
        "food": "Cibo",
        "mart": "Mart",
        "intercity": "Intercity",
        "addSchedule": "Aggiungi Programma",
        "editSchedule": "Modifica Programma",
        "date": "Data",
        "Time_range": "Intervallo di tempo",
        "startTime": "Orario di inizio",
        "endTime": "Orario di fine",
        "applyForOtherDays": "Richiedi per altri giorni",
        "scheduleTimeOverlap": "Il tempo di programmazione non deve sovrapporsi l'uno con l'altro.",
        "schedule_startDate_greater_than_endDate": "La data di inizio è maggiore della data di fine",
        "scheduleTimeDuplicate": "Il tempo di programmazione non deve sovrapporsi tra loro.",
        "promoIcon": "Icona promozionale",
        "bannerImage": "Immagine banner",
        "Upload_an_image": "Carica un'immagine",
        "Click_here_to_view": "Clicca qui per visualizzare."
    },
    "quest_event": {
        "name": "Nome",
        "userType": "Tipo di Utente",
        "carType": "Tipo di auto",
        "operationZones": "Zona operativa",
        "type": "Tipo di Evento",
        "isLuckyDraw": "Estrazione Fortunata",
        "start_date": "Data di inizio",
        "end_date": "Data di fine",
        "numOfQualify": "Numero di Qualificati",
        "event_progress": "Progresso Evento",
        "isActive": "Stato",
        "Actions": "Azioni",
        "passenger": "Cliente",
        "driver": "Driver",
        "first_will_win": "Il primo vincerà",
        "largest_will_win": "Il più grande vincerà (classifica)",
        "not_start": "Non avviare",
        "active": "Attivo",
        "closed": "Chiuso",
        "event_details": "Dettagli della missione",
        "add_event": "Aggiungi Quest",
        "limited": "Limitato",
        "unlimited": "Illimitato",
        "eventImage": "Immagine dell'evento",
        "sharedImage": "Immagine Condivisa",
        "qualifiedImage": "Immagine qualificata",
        "expiredImage": "Immagine scaduta",
        "luckyDrawImage": "Immagine del Sorteggio Fortunato",
        "Upload_an_image": "Carica un'immagine",
        "Required_Image": "Estensioni immagine (.jpg, .png, .gif)",
        "ok": "OK",
        "eventId": "ID evento",
        "passengerMetric": {
            "booking_distance": "Distanza di prenotazione",
            "booking_time": "Tempo di prenotazione",
            "booking_amount_spent": "Importo prenotato speso",
            "num_of_ondemand": "Numero di on-demand",
            "num_of_reservation": "Numero di prenotazione",
            "num_of_intercity": "Numero di intercity",
            "num_of_delivery": "Numero di consegna",
            "num_of_referral": "Numero di riferimento",
            "num_of_sharing": "Numero di condivisioni",
            "topup_wallet_amount": "Importo del portafoglio di ricarica",
            "num_of_complete_wallet": "Numero di prenotazioni complete (portafoglio)",
            "num_of_complete_booking_by_referee": "Numero di prenotazioni complete (da parte dell'arbitro)",
            "number_of_complete_booking": "Numero di prenotazioni complete",
            "number_of_food_mart": "Numero di cibo / mart"
        },
        "driverMetric": {
            "booking_distance": "Distanza di lavoro",
            "booking_time": "Tempo di lavoro",
            "num_of_referral": "Numero di riferimento",
            "num_of_complete": "Numero di prenotazioni complete (cliente unico)",
            "num_of_referral_driver": "Numero di referral (driver)",
            "num_of_accept": "Numero di accettazione prenotazione",
            "num_of_receive": "Numero di prenotazione ricevuta",
            "num_of_cancel": "Numero di cancellazioni di prenotazioni da parte del conducente",
            "sum_of_rating": "Numero totale di stelle di valutazione",
            "total_rating": "Numero totale di volte di valutazione",
            "earnings_amount": "Importo degli utili",
            "num_of_complete_wallet": "Numero di prenotazioni complete (portafoglio)",
            "num_of_complete_booking_by_referee": "Numero di prenotazioni complete (da parte dell'arbitro)",
            "available_time": "Tempo online"
        },
        "Click_here_to_view": "Clicca qui per visualizzare.",
        "view": "Clicca qui per visualizzare.",
        "metricType": "Tipo",
        "task": "Compito",
        "value": "Valore",
        "quantity": "Quantità",
        "quests_list": "Missioni",
        "rankImages": "Immagine di rango (punto)",
        "qualifiedPrizeOrder": "Premi Qualificati",
        "luckyDrawPrizeOrder": "Premi della Lotteria",
        "reward": "Elemento",
        "from": "Da",
        "to": "Per",
        "image": "Immagine",
        "Add_Prize": "Aggiungi",
        "bannerText": "Testo del banner",
        "buttonText": "Testo del pulsante",
        "bannerLink": "Link del banner",
        "shortLink": "Link breve",
        "buttonLinkDesktop": "Pulsante link (Desktop)",
        "buttonLinkAndroid": "Collegamento pulsante (Android)",
        "buttonLinkiOS": "Collegamento pulsante (iOS)",
        "termsURL": "Link ai Termini e Condizioni",
        "metadataTitle": "Titolo dei metadati",
        "metadataDescription": "Descrizione dei metadati",
        "isDarkMode": "Modalità Scura",
        "isActive_details": "Attivo",
        "Required_fields": "Campi obbligatori",
        "change": "Cambia",
        "Please_input_name": "Per favore inserisci il nome",
        "Please_select_date": "Seleziona la data per favore",
        "endDate_invalid": "Data di fine non valida",
        "startDate_greater_than_endDate": "La data di inizio è maggiore della data di fine",
        "Please_input_termsURL": "Si prega di inserire il link ai Termini e Condizioni",
        "Please_input_metadataTitle": "Si prega di inserire il titolo dei metadati",
        "Please_input_metadataDescription": "Si prega di inserire la descrizione dei metadati",
        "Please_input_bannerText": "Si prega di inserire il testo del banner",
        "Please_input_buttonText": "Si prega di inserire il testo del pulsante",
        "Please_input_bannerLink": "Per favore inserisci il link del banner",
        "Please_input_shortLink": "Per favore inserisci il link breve",
        "Please_input_buttonLinkDesktop": "Per favore inserisci il link del pulsante (Desktop)",
        "Please_input_buttonLinkAndroid": "Si prega di inserire il link del pulsante (Android)",
        "Please_input_buttonLinkiOS": "Si prega di inserire il link del pulsante (iOS)",
        "the_range_1_to_5": "Si prega di inserire un valore nell'intervallo da 1 a 5 per %{name}!",
        "the_range_1_to_100": "Si prega di inserire un valore nell'intervallo da 1 a 100 per %{name}!",
        "task_is_empty": "Per favore inserisci il compito per %{name}!",
        "task_limit_50_characters": "La lunghezza massima del compito è di 50 caratteri per %{name}!",
        "please_input_points": "Si prega di inserire punti per %{name}!",
        "please_input_value": "Per favore inserisci il valore per %{name}!",
        "value_is_invalid": "%{name}, il valore deve essere un numero",
        "please_upload_image": "Si prega di caricare l'immagine per l'oggetto %{name}!",
        "rank_invalid": "Il rango %{name} non è valido!",
        "rank_invalid_to": "Il rango 'A' deve essere un numero",
        "deepLink": "Deeplink",
        "point_per_task": "Punto per compito",
        "points": "Punti",
        "points_per_some_think": "Punti per %{unit}",
        "criterias": "Criteri (opzionale)",
        "criterias_list": "Criteri",
        "criteriaType": "Tipo",
        "criteriaValue": "Valore",
        "acceptance_rating": "Valutazione di Accettazione (maggiore o uguale)",
        "cancellation_rating": "Valutazione di cancellazione (minore o uguale)",
        "driver_rating": "Valutazione del conducente (maggiore o uguale)",
        "please_upload_image_rank": "Si prega di caricare l'immagine per il rango %{name}!",
        "Update_event_success": "La quest è stata aggiornata con successo.",
        "Update_event_fail": "Si sono verificati errori durante l'aggiornamento della missione",
        "Create_event_success": "Nuova missione creata con successo",
        "Create_event_fail": "Si sono verificati errori durante la creazione della quest",
        "suspend_list": "Elenco di sospensione"
    },
    "voucherSettings": {
        "Search_here": "Cerca qui",
        "Voucher_code": "Codice #",
        "Campaign": "Campagna",
        "Type": "Tipo",
        "Value": "Valore",
        "Valid_from": "Valido da",
        "Valid_to": "Valido fino a",
        "isActive": "Stato",
        "Activate": "Attiva",
        "Deactivate": "Disattivare",
        "Actions": "Azioni",
        "Active": "Attivo",
        "Inactive": "Inattivo",
        "redeemed": "Redento",
        "expired": "Scaduto",
        "Add_Voucher_code": "Aggiungi codice",
        "Add": "Aggiungi",
        "Show_per_page": "Elementi per pagina",
        "Page": "Pagina",
        "Name": "Nome",
        "show_pages": "{0} - {1} di {2} mostrati",
        "Edit": "Modifica",
        "Delete": "Elimina",
        "Save": "Salva",
        "Duplicate": "Duplicato",
        "Cancel": "Annulla",
        "Required_fields": "Campi obbligatori",
        "Detail_voucher_code": "Dettagli Codice Voucher",
        "Delete_voucher_code": "Elimina Codice Voucher",
        "Confirmation": "Conferma",
        "Delete_confirm_voucher_code": "Vuoi eliminare il codice voucher selezionato?",
        "Delete_voucher_code_confirmation": "Vuoi eliminare questi codici voucher?",
        "Just_delete_inactive": "** Solo i codici voucher in stato inattivo possono essere eliminati.",
        "Loading_voucher_code_fail": "Si sono verificati errori durante il caricamento del codice voucher",
        "Select_campaign": "Seleziona Campagna",
        "Create_voucher_code_success": "Il nuovo codice voucher è stato creato con successo",
        "Create_voucher_code_fail": "Si sono verificati errori durante la creazione del codice voucher",
        "Update_voucher_code_status_success": "Lo stato del codice voucher è stato aggiornato con successo.",
        "Update_voucher_code_status_fail": "Si sono verificati errori durante l'aggiornamento dello stato del codice voucher",
        "Delete_voucher_codes_success": "Il codice voucher è stato eliminato con successo.",
        "Delete_voucher_codes_fail": "Si sono verificati errori durante l'eliminazione del codice voucher",
        "Delete_multiple_voucher_codes_success": "I codici voucher sono stati eliminati con successo",
        "Delete_multiple_voucher_codes_fail": "Si sono verificati errori durante l'eliminazione dei codici voucher",
        "Delete_voucher_code_success": "Il codice voucher è stato eliminato con successo",
        "Delete_voucher_code_fail": "Si sono verificati errori durante l'eliminazione del codice voucher",
        "Update_multiple_voucher_code_status_success": "Lo stato dei codici voucher è stato aggiornato con successo.",
        "Update_multiple_voucher_code_status_fail": "Si sono verificati errori durante l'eliminazione degli stati dei codici voucher",
        "Please_input_voucher_code": "Si prega di inserire il codice voucher",
        "Please_input_voucher_code_at_least_4_characters": "Si prega di inserire almeno 4 caratteri.",
        "Please_select_campaign": "Seleziona la campagna",
        "Please_input_value": "Per favore inserisci il valore",
        "Please_select_date": "Seleziona la data",
        "Invalid_file": "Il contenuto del file non è valido",
        "File_size_larger_than_5Mb": "La dimensione del file è superiore a 5Mb",
        "Import_vouchers_success": "Il file è stato importato con successo",
        "Import_vouchers": "Importa File",
        "Number_successful_imports": "Articoli importati",
        "Number_skipped": "Salta elementi",
        "File": "File",
        "Phone_Numbers": "numero di telefono/i",
        "Import_voucher_code_success": "Il codice voucher <b>{0}</b> è stato importato con successo.",
        "Import_voucher_code_fail": "Il codice voucher <b>{0}</b> non è stato importato. Per favore riprova.",
        "All": "Tutto"
    },
    "pointConfig": {
        "point_config": "Configurazione punto",
        "Convert_spent_amount_to_points": "Converti l'importo speso in punti",
        "Convert_topup_amount_to_points": "Converti l'importo del ricarico in punti",
        "Redeem_points_to_voucher": "Riscuotere punti per voucher",
        "others": "Altro",
        "Online_Payment": "Pagamento online",
        "transport": "Trasporto",
        "parcel": "Pacco",
        "food": "Cibo",
        "mart": "Mart",
        "delivery": "Consegna",
        "intercity": "Intercity",
        "applyCash": "Richiedi contante",
        "point": "Punto",
        "vourcherName": "Nome",
        "pointsToRedeem": "Punti da riscattare",
        "vourcherValue": "Valore del voucher",
        "validTime": "Tempo valido",
        "month": "Mese(i)",
        "day": "Giorno(i)",
        "termAndCondition": "Termini e condizioni",
        "Actions": "Azioni",
        "add_voucher": "Aggiungi",
        "instructionURL": "Link di istruzioni",
        "displayName": "Mostra nome sull'app super",
        "isActive": "Attivo",
        "EDIT_VOUCHER": "Aggiorna Voucher",
        "DETAIL_VOUCHER": "Dettagli del Voucher",
        "CREATE_VOUCHER": "Aggiungi Voucher",
        "update_successfully": "L'impostazione di configurazione del punto è stata aggiornata con successo",
        "Create_voucher_successfully": "Nuovo voucher creato con successo",
        "Create_voucher_fail": "Si sono verificati errori durante la creazione del voucher",
        "Update_voucher_successfully": "Il voucher è stato aggiornato con successo",
        "Update_voucher_fail": "Si sono verificati errori durante l'aggiornamento del voucher",
        "Delete_voucher_successfully": "Il voucher è stato eliminato con successo",
        "Delete_voucher_fail": "Si sono verificati errori durante l'eliminazione del voucher",
        "Confirmation": "Conferma",
        "Delete_voucher_confirmation": "Vuoi eliminare questo voucher?",
        "Please_enter_value_least_one": "Il tasso di conversione è richiesto! Imposta l'importo speso o l'importo di ricarica per continuare.",
        "Please_enter_value_is_number_spentAmount": "Si prega di inserire un importo valido nel servizio \"Converti importo speso\" \"{0}\".",
        "Please_enter_value_is_number_topUp": "Si prega di inserire un importo valido nel metodo \"Converti importo ricarica\" \"{0}\"."
    },
    "resetPassword": {
        "New_Password": "Invia Nuova Password",
        "New_Comfirm_Password": "Nuova conferma password",
        "Save": "Salva",
        "INFO_SUCCESS": "Un link per resettare la password ti é stato inviato per email",
        "TOKEN_EXPIRED": "Il tuo token per il reset della password é scaduto",
        "Back_To_Login_Page": "Torna alla pagina di registrazione"
    },
    "permission": {
        "editBooking": "Modifica le prenotazioni di farm-out",
        "companyOperator": "Operatore Aziendale",
        "Third_Party_Integration_Booking": "Integrazione di terze parti (Booking.com)",
        "Third_Party_Integration_HolidayTaxis": "Integrazione di terze parti (HolidayTaxis)",
        "supplierPermission": "Permesso del fornitore",
        "Hint_edit_booking": "Consentire alle aziende/fornitori di modificare le prenotazioni delegate dal proprietario della flotta.",
        "View": "Mostra",
        "Actions": "Azioni",
        "EditFare": "Modifica Tariffa",
        "EditDriverEarning": "Modifica Guadagno Autista",
        "EditTotal": "Modifica totale",
        "ImportBookings": "Importa Prenotazioni di Trasporto",
        "ImportDeliveryBookings": "Importazione Prenotazioni di Consegna",
        "ShowFare": "Mostra Tariffa",
        "delete_permission": "Elimina Permesso",
        "DELETE_CONFIRM": "Do you want to delete permission!",
        "Yes": "Si",
        "No": "No",
        "Cancel": "Cancella",
        "DRIVERS": "AUTISTI",
        "Driver_list": "Lista autista",
        "Enter_to_search": "Accedi alla Ricerca",
        "Permitted_driver_list": "Lista autisti autorizzati",
        "Save": "Salva",
        "CAR": "AUTO",
        "Car_list": "Lista macchina",
        "Permitted_car_list": "Lista macchine autorizzate",
        "Edit_permission": "Modifica Permesso",
        "Add_permission": "Aggiungi Permesso",
        "Detail_permission": "Dettaglio permesso",
        "Name": "Nome",
        "Driver_Car": "Autista/Auto",
        "All": "Tutto",
        "Company": "Azienda",
        "By_specific": "Per specifico",
        "Drivers": "Autisti",
        "Cars": "Veicoli",
        "Show_per_page": "Pagina",
        "Page": "Pagina",
        "show_pages": "{0} - {1} of {2} mostrati",
        "Delete": "Cancella",
        "Edit": "Modifica",
        "Status": "Stato",
        "Action": "Azioni",
        "Inactive": "Inattivo",
        "Active": "Attivo",
        "Update_status_error": "aggiorna status errore",
        "All_tooltip": "Tutti i conducenti saranno visualizzati su Mappa, Cue, Conducenti, Operazioni e Rapporti. Tutte le auto saranno visualizzate su Gestione auto.",
        "Company_tooltip": "I conducenti autorizzati in questa azienda saranno visualizzati su Mappa, Cue, Conducenti, Operazioni e Rapporti. Le auto autorizzate in questa azienda saranno visualizzate su Gestione auto.",
        "By_specific_tooltip": "I conducenti autorizzati in questo elenco saranno visualizzati su Conducenti, Operazione. Le auto autorizzate in questo elenco saranno visualizzate su Gestione auto.",
        "Full_permissions": "Permessi completi",
        "Balance": "Cambia Saldo",
        "ChangeBalance": "Cambia saldo",
        "ChangeCashBalance": "Cambia Saldo Contante",
        "TotalBalance": "Saldo Totale",
        "WriteOffDebt": "Annulla Debito",
        "topupPaxWallet": "Cambia Saldo",
        "SeFleetCommission": "Set fleet commission",
        "EditFleetCommission": "Modifica commissione flotta",
        "EditBalance": "Modifica Saldo",
        "ViewHeatMap": "Visualizza mappe di calore",
        "Delete_permission_success": "Il permesso è stato eliminato con successo",
        "Delete_permission_fail": "Si sono verificati errori durante l'eliminazione dei permessi",
        "Create_permission_fail": "Si sono verificati errori durante la creazione di nuovi permessi",
        "Create_permission_success": "Nuovo permesso creato con successo",
        "Update_permission_fail": "Si sono verificati errori durante l'aggiornamento dei permessi",
        "Update_permission_success": "Il permesso è stato aggiornato con successo",
        "No_action_selected": "Si prega di selezionare almeno un'azione nell'elenco delle azioni",
        "Required_fields": "Campi obbligatori",
        "sendSMS": "Invia Messaggio (SMS)",
        "sendInbox": "Invia Messaggio (Posta in arrivo)",
        "PayToDriver": "Visualizza 'Paga al Conducente'",
        "PayoutHistory": "Visualizza 'Storico Pagamenti'",
        "Pay": "Pilota pagato",
        "ActivateDriver": "Attiva Driver",
        "Export": "Esporta",
        "Export_csv": "Esporta .csv",
        "Street-sharing_rate": "Tariffa di condivisione stradale"
    },
    "thirdPartySettings": {
        "category": "Categoria",
        "Not_over_limit_subs": "Non puoi creare più di 10 sottolocalità",
        "Show_per_page": "Pagina",
        "Page": "Pagina",
        "show_pages": "{0} - {1} of {2} mostrati",
        "Delete": "Cancella",
        "Edit": "Modifica",
        "Status": "Stato",
        "Actions": "Azioni",
        "Action": "Azioni",
        "Inactive": "Inattivo",
        "Active": "Attivo",
        "website": "Sito web",
        "Check_Google_Address": "Verifica l'indirizzo google per latitudine & longitudine",
        "Delete_Category_success": "La categoria è stata eliminata con successo",
        "Delete_category_fail": "Si sono verificati errori durante l'eliminazione della categoria",
        "availableTime": "Tempo disponibile",
        "Please_choose_at_least_one_category": "Si prega di scegliere almeno una categoria",
        "Please_input_category_name": "Per favore inserisci il nome della categoria",
        "Create_category_success": "La categoria è stata creata con successo",
        "Create_category_fail": "Si sono verificati errori durante la creazione della categoria",
        "Update_third_party_success": "La località é stata aggiornata con successo",
        "Update_category_fail": "Si sono verificati errori durante l'aggiornamento della categoria",
        "All_Category": "Tutte le categorie",
        "Delete_Category": "Modifica categoria",
        "Edit_Category": "Modifica categoria",
        "Add_Category": "Aggiungi categoria",
        "Add_Third_Party_location": "Aggiungi",
        "Add": "Aggiungi",
        "Edit_Third_Party_location": "Inserisci localizzazione del terzo",
        "Location_Not_Found": "Località non trovata",
        "Create_third_party_success": "La località é stata creata con successo",
        "Create_third_party_fail": "Si sono verificati errori durante la creazione della posizione",
        "Update_third_party_fail": "Sono intervenuti degli errori nella fase di aggiornamento della località",
        "Alias": "Alias",
        "Address": "Indirizzo",
        "Latitude": "Latitudine",
        "Longitude": "Longitudine",
        "Please_input_address": "Per favore inserisci l'indirizzo",
        "Please_input_name": "Si prega di inserire il nome della posizione",
        "Please_input_latitude": "Per favore inserisci latitudine",
        "Please_input_longitude": "Per favore inserisci longitudine",
        "Save": "Salva",
        "Cancel": "Cancella",
        "Required_fields": "Campi obbligatori",
        "Last_update": "Ultimo aggiornamento",
        "Username": "Nome utente",
        "locationType": "LocationType",
        "single": "Posizione singola",
        "multiple": "Più posizioni",
        "AddMore": "Aggiungi di più",
        "locationList": "Elenco di posizioni",
        "instructionLink": "Link alle istruzioni",
        "location": "Posizione",
        "checkOnMap": "Controlla sulla mappa",
        "Remove": "Rimuovi",
        "all": "Tutto",
        "PU": "Pickup",
        "DO": "Drop off",
        "namePlaceholder": "ad es. Terminal 1",
        "instructionLinkPlaceholder": "Pagina HTML con istruzioni complete",
        "instructionLinkTooltip": "Inserisci un link per la pagina delle istruzioni. Il passeggero può seguire le istruzioni su questo link per trovare la posizione di ritiro.",
        "longitudePlaceholder": "108.18379690000006",
        "latitudePlaceholder": "16.0393381",
        "Error_message_lat_in_range": "La latitudine deve essere compresa fra -90.0 e 90.0",
        "Error_message_lng_in_range": "La longitudine deve essere compresa fra -180.0 e 180.0.",
        "Delete_third_party_success": "La località é stata eliminata con successo",
        "Delete_third_party_fail": "Sono intervenuti degli errori nella fase di eliminazione della località",
        "Delete_location": "Elimina posizione",
        "Note_guide": "Nota: quando cerchi sulla mappa, la tua posizione sarà rapidamente contrassegnata con un pin.",
        "PostalCode": "Codice Postale",
        "meetZonesTooltip": "Zona di Incontro: Definisce l'area che include tutti i punti di incontro designati. Utile per luoghi come gli aeroporti dove i punti di raccolta e di rilascio specifici devono essere chiaramente identificati.",
        "instructions": "Istruzioni per il ritiro",
        "pickupMode": "Tipo di Pickup",
        "tripSegment": "Segmento di viaggio",
        "buildingLevel": "Livello dell'edificio",
        "instructionType": "Tipo di Istruzione",
        "instructionUrl": "URL delle istruzioni",
        "instructionImage": "Immagini di Istruzione",
        "imageInstructions": "Istruzioni per l'immagine di ritiro",
        "addMultipleInstructions": "Aggiungi più istruzioni di ritiro.",
        "maximum3Images": "Massimo 3 immagini.",
        "image": "Immagine",
        "uploadImage": "Carica un'immagine",
        "description": "Descrizione",
        "descriptionPlaceholder": "Il nome del punto d'incontro.",
        "altText": "Testo alternativo",
        "altTextPlaceholder": "Il nome del punto d'incontro.",
        "addImage": "Aggiungi immagine",
        "imageCount": "Conteggio Immagini",
        "viewEditImages": "Visualizza/Modifica Immagini",
        "addMeetingZone": "Aggiungi zona riunione"
    },
    "city": {
        "DELETE_CITY": "Elimina città",
        "DELETE_CONFIRM": "Vuoi eliminare la città?",
        "Yes": "Si",
        "No": "No",
        "Cancel": "Cancella",
        "EDIT_CITY": "Modifica città",
        "ADD_CITY": "Aggiungi città",
        "Name": "Nome",
        "Required_fields": "Campi obbligatori",
        "Save": "Salva",
        "Add": "Aggiungi",
        "Show_per_page": "Pagina",
        "Page": "Pagina",
        "show_pages": "{0} - {1} of {2} mostrati",
        "Delete": "Elimina",
        "Edit": "Modifica",
        "DETAIL_CITY": "Dettaglio città",
        "Update_city_success": "La città è stata aggiornata con successo.",
        "Create_city_success": "La nuova città è stata creata con successo.",
        "Delete_city_success": "La città è stata eliminata con successo",
        "cityName": "Nome della città",
        "Service": "Servizio",
        "serviceTransportation": "Trasporto",
        "serviceAssistant": "Assistente",
        "serviceDelivery": "Consegna",
        "isShowDriverSignUp": "Mostra nella registrazione del fornitore",
        "note_isShowDriverSignUp": "(Richiedi il nuovo modulo di registrazione a partire dalla versione 4.6.46 e successive)"
    },
    "blockPassenger": {
        "Imei": "IMEI",
        "EditImei": "Modifica Blocco IMEI",
        "AddImei": "Aggiungi Blocco IMEI",
        "DetailImei": "Dettaglio Blocco IMEI",
        "Update_Imei_success": "Il Block IMEI è stato aggiornato con successo",
        "Update_Imei_Fail": "Si sono verificati errori durante l'aggiornamento del Block IMEI",
        "Create_Imei_success": "Il nuovo blocco IMEI è stato creato con successo",
        "Create_Imei_Fail": "Si sono verificati errori durante la creazione del Block IMEI",
        "Delete_Imei_success": "Il blocco IMEI è stato eliminato con successo",
        "Delete_Imei_fail": "Si sono verificati errori durante l'eliminazione del Blocco IMEI",
        "DELETE_IMEI": "Elimina Blocco IMEI",
        "DELETE_CONFIRM": "Sei sicuro di voler eliminare il Block IMEI selezionato?"
    },
    "jobTab": {
        "DELETE_JOBTAB": "Elimina scheda Lavori",
        "DELETE_CONFIRM": "Sei sicuro di voler eliminare la scheda Lavori selezionata?",
        "Yes": "Sì",
        "No": "No",
        "Cancel": "Annulla",
        "EDIT_JOBTAB": "Modifica scheda lavoro",
        "ADD_JOBTAB": "Aggiungi scheda Lavori",
        "Name": "Nome",
        "Required_fields": "Campi obbligatori",
        "Save": "Salva",
        "Add": "Aggiungi",
        "Show_per_page": "Elementi per pagina",
        "Page": "Pagina",
        "show_pages": "{0} - {1} di {2} mostrati",
        "Delete": "Elimina",
        "Edit": "Modifica",
        "DETAIL_JOBTAB": "Tab Lavori Dettagli",
        "Update_JOBTAB_success": "La scheda Lavori è stata aggiornata con successo.",
        "Create_JOBTAB_success": "La nuova scheda Lavori è stata creata con successo.",
        "Delete_JOBTAB_success": "La scheda Lavori è stata eliminata con successo.",
        "JOBTABName": "Nome della scheda Lavori",
        "jobsLink": "Collegamento"
    },
    "driverNote": {
        "name": "Nota del conducente",
        "DELETE": "Elimina nota del conducente",
        "DELETE_CONFIRM": "Sei sicuro di voler eliminare la Nota del Driver selezionata?",
        "EDIT": "Modifica Nota del Conducente",
        "ADD": "Aggiungi nota del conducente",
        "DETAIL": "Nota del conducente dettagliata",
        "Update_success": "La Nota del Driver è stata aggiornata con successo",
        "Create_success": "Nuova nota del conducente creata con successo",
        "Delete_success": "La nota del conducente è stata eliminata con successo.",
        "Delete_fail": "Si sono verificati errori durante l'eliminazione della nota del driver",
        "Load_fail": "Si sono verificati errori durante il caricamento della nota del driver",
        "Update_fail": "Si sono verificati errori durante l'aggiornamento della nota del driver",
        "Create_fail": "Si sono verificati errori durante la creazione della nota del driver"
    },
    "flightIntegration": {
        "Username": "Nome utente",
        "provider": "Fornitore di voli",
        "Key": "Chiave API",
        "apiKeys": "Chiavi API",
        "apiId": "ID API",
        "Save": "Salva",
        "Update_flight_integration_success": "L'integrazione del volo è stata aggiornata con successo",
        "Update_flight_integration_fail": "Si sono verificati errori durante l'aggiornamento dell'integrazione dei voli"
    },
    "smsIntegration": {
        "provider": "Fornitore SMS",
        "apiToken": "Token API",
        "subAccountId": "ID Sotto Conto",
        "senderIdSource": "ID mittente (fonte):",
        "apiKey": "Chiave API",
        "username": "Nome utente",
        "shortCode": "Codice Breve",
        "key": "Chiave",
        "webService": "Servizio web",
        "bearerToken": "Token di accesso",
        "keyId": "ID chiave",
        "email": "Email",
        "appKey": "Chiave dell'app",
        "sender": "Mittente",
        "password": "Password",
        "maskedPhone": "Numero di telefono mascherato",
        "senderId": "ID mittente",
        "webservice": "Servizio web",
        "brandname": "Nome del marchio",
        "appSecret": "Segreto dell'app",
        "consumerKey": "Chiave del consumatore",
        "requestUrl": "Url di richiesta",
        "authId": "ID di autenticazione",
        "authToken": "Token di autenticazione",
        "authKey": "Chiave di autenticazione",
        "templateId": "Id modello",
        "templateKey": "Chiave del modello",
        "phloId": "PHLO ID",
        "dlcNumber": "Numero 10DLC",
        "app_key": "Chiave dell'app",
        "api_key": "chiave API",
        "accountSID": "Account SID",
        "applicationId": "ID dell'applicazione",
        "phoneNumber": "Numero SMS 1",
        "phoneNumber2": "Numero SMS 2",
        "SenderID_1": "SenderID 1",
        "SenderID_2": "SenderID 2",
        "smsMarketingNumber": "Numero di telefono per SMS marketing",
        "updateSMSSuccess": "The sms integration has been updated successfully",
        "Deleted_success": "Il SMS è stato eliminato con successo",
        "receiverCountries": "Paesi Riceventi",
        "error": {
            "ERROR_CREATE": "Si sono verificati errori durante la creazione degli sms",
            "COUNTRY_EXISTED": "Il paese esiste già nel sistema",
            "ERROR_DELETE": "Impossibile eliminare l'SMS",
            "ERROR_UPDATE": "Impossibile aggiornare SMS"
        },
        "identifierId": "ID identificatore"
    },
    "mDispatcher": {
        "mDispatchers": "mDispatchers",
        "Active": "Attivo",
        "Inactive": "Inattivo",
        "Deactivate": "Disattivato",
        "Activate": "Attivato",
        "Delete": "Cancella",
        "Save": "Salva",
        "Edit": "Modifica",
        "ADD_MDISPATCHER": "Aggiungi mDispatcher",
        "EDIT_MDISPATCHER": "Modifica mDispatcher",
        "Phone_number": "Numero di Telefono",
        "first_name": "Nome",
        "last_name": "Cognome",
        "email": "Email",
        "address": "Indirizzo",
        "mDispatcher_type": "Tipo mDispatcher",
        "mDispatcher_type_toolTip": "Per aggiungere altri tipi di partner, vai in Impostazioni> Tipo di partner",
        "queuing_area_toolTip": "Per aggiungere più aree di accodamento, vai al menu Area di accodamento.",
        "mDispatcher": "mDispatcher",
        "card_management": "Gestione delle carte",
        "Select_mDispatcher_type": "Seleziona tipo mDispatcher",
        "Amount": "Ammontare",
        "Percent": "Percentuale",
        "Yes": "Si",
        "Required_fields": "Campi obbligatori",
        "Cancel": "Cancella",
        "commission_type": "Tipo di commissione",
        "commission_value": "Valuta commissione",
        "Name": "Nome",
        "Phone_Number": "Numero di Telefono",
        "queuing_area": "Area Fila",
        "mdispatcher_type": "Tipo mDispatcher",
        "registered_from": "Registrato da",
        "registration_date": "Data di registrazione",
        "status": "Stato",
        "actions": "Azioni",
        "Select_queue_area": "Seleziona area fila",
        "for_new_mDipatcher_account_password_default_is_password": "Per il nuovo conto mDispatcher la password provvisoria é \"12345678",
        "Create_mDispatcher_success": "Il nuovo mDipatcher é stato creato con successo",
        "Create_mDispatcher_fail": "Sono intervenuti degli errori nella fase di creazione del tipo mDispatcher",
        "Load_mDispatcher_fail": "Sono intervenuti degli errori nella fase di caricamento di mDipatcher",
        "Update_mDispatcher_success": "mDipatcher é stato aggiornato con successo",
        "Update_mDispatcher_fail": "Sono intervenuti degli errori nella fase di aggiornamento di mDipatcher",
        "Update_mDispatcher_status_success": "Lo status di mDipatcher é stato aggiornato con successo",
        "Update_mDispatcher_status_fail": "Sono intervenuti degli errori nella fase di aggiornamento degli status di mDipatcher",
        "Update_mDispatcher_statuses_success": "Lo status di mDipatcher é stato aggiornato con successo",
        "Update_mDispatcher_statuses_fail": "Sono intervenuti degli errori nella fase di aggiornamento degli status di mDipatcher",
        "Delete_mDispatcher_success": "mDipatcher é stato eliminato con successo",
        "Delete_mDispatcher_fail": "Sono intervenuti degli errori nella fase di eliminazione degli mDipatcher",
        "Delete_mDispatchers_success": "mDipatcher é stato eliminato con successo",
        "Delete_mDispatchers_fail": "Sono intervenuti degli errori nella fase di eliminazione degli mDipatcher",
        "Do_you_want_to_delete_these_mDipatchers": "Vuoi eliminare questi mDispatcher?",
        "Only_mDistcher_in_the_inactive_status_can_be_deleted": "** Solo mDispatcher in status inattivo puo’ essere eliminato.",
        "No_card": "Nessuna carta trovata.",
        "Reset_Password": "Resetta password",
        "Reset_password_success": "La password di mDipatcher é stata resettata con successo",
        "Reset_password_fail": "Sono intervenuti degli errori nella fase di reset della password di mDipatcher",
        "Do_you_want_to_reset_password": "Vuoi resettare la password ?",
        "ERROR_EXISTED_PHONE": "Questo telefono esiste già nel sistema. Per favore inseriscine un altro.",
        "ERROR_INPUT_VALIDPHONE": "Per favore inserisci un numero di telefono valido..",
        "Partner_detail": "DETAGLIO TIPO  MDISPATCHER ",
        "ALERT_SELECT_ACTIVATE": "Per favore seleziona mDispatcher per attivare.",
        "ALERT_SELECT_DEACTIVATE": "Per favore seleziona mDispatcher per disattivare",
        "CONFIRM_DEACTIVATE_MULTI": "Vuoi disattivare questi mDispatchers?",
        "CONFIRM_ACTIVATE_MULTI": "Vuoi attivare questi mDispatcher?",
        "ERROR_COMMISSION_NUMBERS": "Per favore inserisci un numero valido.",
        "No_Support": "L'aggiunta di una nuova carta non é supportata in quest'area",
        "Add": "Aggiungi",
        "Default_zone": "Zona predefinita",
        "required_email_payment": "È richiesta l'email dei partner. Si prega di aggiornare il profilo per continuare.",
        "titleGuestQR": "Link QR Partner Ospite",
        "questQRContent": "Il tuo link personalizzato per la prenotazione dei partner è qui! Mostralo in modo prominente nei bar, alle reception degli hotel, nelle camere degli ospiti e sul tuo sito web—ovunque i tuoi clienti possano aver bisogno di un passaggio o di una consegna. Considera di progettare dei totem con il tuo codice QR unico, permettendo ai clienti di scansionarlo rapidamente e facilmente per prenotare il loro viaggio!",
        "View_Guest_QR": "Visualizza QR dell'ospite"
    },
    "mDispatcherType": {
        "Name": "Nome ",
        "Required_fields": "Campi obbligatori",
        "Save": "Salva",
        "Cancel": "Cancella",
        "No": "No",
        "Add": "Aggiungi",
        "Show_per_page": "Pagina",
        "Page": "Pagina",
        "show_pages": "{0} - {1} of {2} mostrati",
        "Delete": "Elimina",
        "Edit": "Modifica",
        "DELETE_MDISPATCHER_TYPE": "Elimina tipo mDispatcher ",
        "DELETE_CONFIRM": "Sei sicuro di voler eliminare tipo mDispatcher?",
        "Yes": "Sì",
        "EDIT_MDISPATCHER_TYPE": "Modifica tipo mDispatcher ",
        "ADD_MDISPATCHER_TYPE": "Aggiungi tipo mDispatcher",
        "DETAIL_MDISPATCHER_TYPE": "DETAGLIO TIPO  MDISPATCHER ",
        "Actions": "Azioni",
        "Delete_mDispatcherType_success": "Il tipo mDispatcher é stato eliminato con successo",
        "Delete_mDispatcherType_fail": "Sono intervenuti degli errori nella fase di eliminazione del tipo mDispatcher ",
        "Load_mDispatcherType_fail": "Sono intervenuti degli errori nella fase di caricamento del tipo mDispatcher",
        "Create_mDispatcherType_success": "Il nuovo tipo mDispatcher é stato creato con successo ",
        "Create_mDispatcherType_fail": "Sono intervenuti degli errori nella fase di creazione del tipo mDispatcher",
        "Update_mDispatcherType_success": "mDispatcher aggiornato con successo",
        "Update_mDispatcherType_fail": "Sono intervenuti errori nella fase di aggiornamento del tipo mDispatcher "
    },
    "queuingArea": {
        "queuing_area_info": "Informazioni sull'area di attesa",
        "queuingDrivers": "Driver attivi",
        "Name": "Nome",
        "Required_fields": "Campi obbligatori",
        "Save": "Salva",
        "Cancel": "Cancella",
        "Yes": "Si",
        "No": "No",
        "Add": "Aggiungi",
        "Show_per_page": "oggetti per pagina",
        "Enter_to_search": "Premi invio per cercare",
        "Page": "Pagina",
        "show_pages": "Mostra {0} - {1} di {2}",
        "Delete": "Cancella",
        "Edit": "Modifica",
        "Active": "Attivo",
        "Inactive": "Inattivo",
        "Deactivate": "Disattivato",
        "Activate": "Attivato",
        "drivers": {
            "order": "Ordine",
            "Driver_name": "Nome del driver",
            "Phone_Number": "Numero di telefono",
            "driverLicenseNumber": "Targa",
            "Car_Type": "Tipo di auto",
            "checkInTime": "Orario di check-in",
            "duration": "Durata",
            "timestampScore": "Punteggio data / ora",
            "changeOrderDriver": "Cambiare ordine",
            "detailOrderDriver": "Ordine del conducente",
            "Yes": "Sì",
            "No": "No",
            "insert": "Inserire",
            "refresh": "ricaricare",
            "insertDriver": "Inserisci un driver nella coda",
            "orderDriver": "Ordine #",
            "reason": "Motivo",
            "removeDriver": "Rimuovi il driver dalla coda",
            "removeDriverConfirm": "Vuoi rimuovere questo driver dalla coda?",
            "driverNotStay": "Il driver non si trova nell'area della coda. Per favore riprova più tardi.",
            "overOrder": "L'ordine # non può essere maggiore del numero totale di conducenti in coda.",
            "noDriverFound": "Nessun driver trovato",
            "driverUpdateErrRs": "Il conducente non è nell'area di attesa. Per favore riprova più tardi.",
            "orderUpdateErrRs": "L'ordine # non può essere maggiore del numero totale di conducenti in coda.",
            "removeDriverSuccess": "Il conducente è stato rimosso con successo dall'area di attesa.",
            "removeDriverFail": "Si è verificato un errore durante la rimozione del driver dall'area della coda.",
            "operationInsertFailRs": "Il driver non esiste o non è disponibile.",
            "versionInsertFailRs": "Per applicare questa funzione, il driver deve aggiornare la sua app driver alla versione più recente",
            "queueInsertFailRs": "La coda non esiste o il driver non si trova nell'area della coda. Per favore riprova più tardi.",
            "vehicleInsertFailRs": "La coda non supporta il tipo di veicolo del conducente.",
            "orderInsertFailRs": "L'ordine # non può essere maggiore del numero totale di autisti in coda.",
            "positionInsertFailRs": "Si è verificato un errore durante l'inserimento del driver nell'area della coda.",
            "insertDriverSuccess": "Il conducente è stato inserito con successo nell'area di attesa.",
            "changeOrderSuccess": "La posizione del conducente è stata cambiata con successo.",
            "insertDriverFail": "Si è verificato un errore durante l'inserimento del driver dall'area della coda.",
            "changeOrderFail": "Si è verificato un errore durante la modifica della posizione del conducente nell'area di attesa.",
            "selectToInsert": "Cerca: Nome del conducente, Numero di telefono",
            "updateBy": "Aggiornato dall'operatore",
            "changeOrder": "Cambia ordine",
            "remove": "Rimuovi"
        },
        "keepDriverPlaceCancelNoShow": "Conservare il posto di guida quando la prenotazione viene cancellata / no-show",
        "keepDriverPlaceUnavailable": "Mantieni il posto di guida quando il conducente non è disponibile o offline",
        "range": "Intervallo della coda",
        "queueRangeTooltip": "Questo è il modo in cui i conducenti visualizzeranno il loro numero di posizione in coda sull'app driver. Ad esempio:\nImpostazione dell'intervallo di coda su 1: i conducenti vedranno la loro posizione in coda come un singolo numero: 1, 2, 3, 4, ecc.\nImpostazione dell'intervallo di coda su 5: i conducenti vedranno la loro posizione in coda come un intervallo: 1-5, 6-10, 11-15, 16-20, ecc.\nImpostazione dell'intervallo di coda su 10: i conducenti vedranno la loro posizione in coda come un intervallo: 1-10, 11-20, 21-30, 31-40, ecc. ",
        "queueCanceledTooltip": "1. In caso di annullamento o mancata presentazione del passeggero, il conducente rimarrà nella posizione più alta se il conducente ritorna in coda entro il tempo stabilito.\n2. La posizione del conducente sarà considerata prioritaria se il conducente ritorna in coda entro il tempo stabilito dopo aver completato una prenotazione di breve durata ",
        "DELETE_QUEUING_AREA": "Elimina area di fila",
        "DELETE_CONFIRM": "Vuoi eliminare l'area di fila?",
        "EDIT_QUEUING_AREA": "Modifica area fila",
        "ADD_QUEUING_AREA": "Aggiungi area fila",
        "DETAIL_QUEUING_AREA": "DetDettaglio area di fila",
        "Queuing_area": "Area Fila",
        "Address": "Indirizzo",
        "Enter_a_location": "Inserisci una località",
        "Entered_Address_is_incorrect": "Il sistema non puo’ determinare dove ti trovi . Per favore utilizza l’indirizzo suggerito da Google",
        "Not_supported_zone": "Questa area fila non é in zona supportata",
        "Active_mDispatcher_list": "Active mDispatcher list",
        "Queue_list": "Lista fila",
        "Allow_radius": "Consenti area",
        "Min_drivers_required": "# Min autisti richiesto",
        "Open_queuing_area": "Apri area fila",
        "Auto_dispatch": "Invio automatico ai conducenti in coda (non è necessario utilizzare l'app Partner)",
        "Active_car_list": "Attiva lista macchina",
        "mDispatcher": "mDispatcher",
        "Google_Address": "Indirizzo Google",
        "Status": "Stato",
        "Update_status_error": "aggiorna status errore",
        "driver_checkin_area": "Area check-in del conducente",
        "EDIT_POLYGONS": "Modifica poligoni",
        "pax_pickup_area": "Area di raccolta passeggeri",
        "pickup_area": "Area di raccolta",
        "your_chosen_polygon": "Il poligono scelto",
        "other_queues": "Altre code",
        "operation_zones": "Zone operative",
        "delete_pickup_area_confirm": "Sei sicuro di voler eliminare questa area di prelievo?",
        "delete_pickup_area": "Seleziona l'area di check-in del conducente.",
        "please_choose_driver_check_in_area": "Scegli l'area di prelievo.",
        "please_choose_pick_up_area": "Si prega di scegliere l'area di ritiro.",
        "Load_queuing_area_fail": "Sono intervenuti degli errori nella fase di caricamento dell'area di fila",
        "Create_queuingArea_success": "Area di fila aggiornata con successo",
        "Update_queuingArea_success": "Area di fila aggiornata con successo",
        "Delete_queuingArea_success": "L'area di accodamento è stata eliminata correttamente",
        "Delete_queuingArea_fail": "Si sono verificati errori durante l'eliminazione dell'area di accodamento",
        "Create_queuingArea_fail": "Si sono verificati errori durante la creazione dell'area di accodamento",
        "Load_queuingArea_fail": "Si sono verificati errori durante il caricamento dell'area di accodamento",
        "Update_queuingArea_fail": "Si sono verificati errori durante l'aggiornamento dell'area di accodamento"
    },
    "appBanner": {
        "Save": "Salva",
        "Pax_app": "Pax app",
        "Apply_to": "Applica a",
        "Please_select_view": "Seleziona visualizzazione",
        "Select_Type": "Seleziona il tipo di banner",
        "Home_view": "Vista home",
        "Other_view": "Altra vista",
        "Banner_1": "Banner #1",
        "Upload_an_image": "Nessuna immagine selezionata",
        "Action": "azione",
        "NA": "N/D",
        "Link_to_website": "Collegamento al sito web",
        "Make_a_call": "Fai una chiamata",
        "Send_an_email": "Invia un'email",
        "Banner_2": "Banner #2",
        "Banner_3": "Banner #3",
        "Driver_app": "App per conducenti",
        "pax": "Passgener App",
        "driver": "Driver App",
        "merchant": "App commerciante",
        "Name": "Nome",
        "viewType": "genere",
        "status": "Stato",
        "image": "Immagine",
        "html": "HTML",
        "Delete_Banner": "Elimina banner",
        "Delete_confirm_banner": "Sei sicuro di voler eliminare il banner selezionato?",
        "Delete_banner_success": "Il banner è stato eliminato con successo",
        "Delete_banner_fail": "Si sono verificati errori durante l'eliminazione del banner",
        "edit_banner": "Modifica Banner",
        "detail_banner": "Banner di Dettaglio",
        "create_banner": "Aggiungi Banner",
        "note_1": "* The file extension must be .jpg, .jpeg, .png, .gif and less than 8MB.",
        "note_2": "* Le immagini devono avere un rapporto di aspetto di 16:9.",
        "note_3": "* Altre visualizzazioni tra cui Posta in arrivo, Riferisci un amico, Ricevuta, La mia prenotazione, Codice promozionale, Aggiungi carta di credito/Metodi di pagamento, Profilo, In attesa di elaborazione/Prenotazione confermata, Visualizzazione completata.",
        "Update_app_banner_success": "Il banner dell'app è stato aggiornato con successo",
        "Update_app_banner_fail": "Impossibile aggiornare il banner dell'app!",
        "Create_app_banner_success": "Il banner dell'app è stato creato con successo",
        "Create_app_banner_fail": "Impossibile creare il banner dell'app!",
        "Note": "Si prega di utilizzare il file in formato .png (sfondo trasparente, dimensioni 400:200px) per migliori prestazioni dell'app.",
        "Limit_size_upload": "La dimensione del file deve essere inferiore a 8Mb.",
        "display_duration": "Durata di visualizzazione",
        "playback_settings": "Impostazioni di riproduzione",
        "display_banner_again_after": "Mostra di nuovo i banner dopo",
        "stop_display_banner_after": "Interrompi la visualizzazione del banner dopo",
        "enable_playback": "Abilita la riproduzione",
        "Update_playback_success": "Le impostazioni di riproduzione sono state aggiornate con successo",
        "Update_playback_fail": "Impossibile aggiornare le impostazioni di riproduzione!",
        "language": "Lingua",
        "single": "Singola Lingua",
        "multi": "Multi Lingue",
        "es-ES": "Spagnolo",
        "en-US": "inglese",
        "fr-FR": "Francese",
        "id-ID": "Bahasa indonesiana",
        "vi-VN": "Vietnamita",
        "ur-PK": "Urdu",
        "ms-MY": "Malesia",
        "ar-AR": "Arabo",
        "nb-NO": "Norvegese",
        "en-GB": "Inglese (Regno Unito)",
        "am-ET": "Amarico",
        "ro-RO": "Rumeno",
        "version": "Versione dell'app",
        "comparisonVersionApp": {
            "is": "È",
            "is_not": "Non è",
            "is_one_of": "È uno di",
            "is_not_one_of": "Non è uno di",
            "greater_or_equal": "Maggiore o uguale",
            "less_or_equal": "Minore o uguale"
        },
        "platform": "Piattaforma",
        "platformItem": {
            "all": "Tutto",
            "iOS": "iOS",
            "android": "Android"
        },
        "userStatus": "Stato utente",
        "Active": "Attivo",
        "Inactive": "Inattivo",
        "in_review_completed": "In revisione (profilo completato)",
        "in_review_incomplete": "In revisione (profilo incompleto)",
        "in_review_inProgress": "In revisione (profilo in corso)",
        "zones": "Zone"
    },
    "reservation": {
        "name": "Prenotazione",
        "company": "Azienda",
        "carType": "Tipo di macchina",
        "licensePlate": "Numero di targa: %{name}",
        "driver": "Autista: %{name}",
        "showAllDrivers": "Mostra tutti gli autisti",
        "available": "Indisponibile",
        "reserved": "Riservato",
        "search_holder": "Azienda, Nome autista, Tipo vettura, Targa",
        "all": "Tutti",
        "today": "Oggi",
        "thisWeek": "Questa settimana",
        "day": "Giorno",
        "week": "Settimana",
        "bookingID": "ID Prenotazione",
        "tripId": "ID Viaggio",
        "pickupTime": "Orario dell’appuntamento",
        "pickupLocation": "Luogo dell’appuntamento",
        "monday": "Lunedi'",
        "tuesday": "Martedi'",
        "wednesday": "Mercoledi'",
        "thursday": "Giovedi'",
        "friday": "Venerdi'",
        "saturday": "Sabato",
        "sunday": "Domenica",
        "overlapped": "Sovrapposto",
        "noData": "Nessun dato trovato.",
        "bookingDetails": "Dettagli prenotazione",
        "reservedHint": "La prenotazioni sono confermate",
        "availableHint": "Non ci sono prenotazioni confermate",
        "overlappedHint": "Due o piu' prenotazioni confermate sono sovrapposte"
    },
    "dashboard": {
        "API": "API",
        "cc": "CC",
        "dmc": "Tabellone prenotazioni",
        "streetSharing": "Condivisione Stradale",
        "kiosk": "Kiosk",
        "mDispatcher": "mDispatcher",
        "paxApp": "Pax App",
        "webBooking": "Prenotazione Online",
        "carHailing": "Car-Hailing",
        "acceptance": "Accettazione",
        "booking_com": "Booking.com",
        "completed": "Completato",
        "noShow": "No Show",
        "driverNoShow": "Assenza del conducente",
        "canceled": "Cancellato",
        "incident": "Incidente",
        "rate1": "1 Stella",
        "rate2": "2 Stelle",
        "rate3": "3 Stelle",
        "rate4": "4 Stelle",
        "rate5": "5 Stelle",
        "Export_to_Excel": "Esporta in Excel",
        "Profit": "Profitto",
        "day_change": "Cambio giornaliero",
        "week_change": "Cambiamento settimanale",
        "month_change": "Cambio mensile",
        "Booking_requests": "Richieste di prenotazione",
        "Complete_bookings": "Prenotazioni completate",
        "New_customers": "Nuovi clienti",
        "Booking_dashboard": "Tabellone delle prenotazioni",
        "others": "Altro",
        "Revenue_booking": "Profitto e Prenotazione Completata",
        "Profit_finish_booking": "Profitto & Prenotazione Completata",
        "Booking_request": "Richiesta di prenotazione",
        "Finished_booking": "Prenotazione completata",
        "failed": "Fallito",
        "partialCompleted": "Parzialmente completato",
        "Finished_booking_char_header": "Prenotazione completata ({0})",
        "Bookings": "Prenotazioni ({0})",
        "Ratings": "Valutazioni ({0})",
        "Daily": "Giornaliero",
        "Weekly": "Settimanale",
        "Monthly": "Mensile",
        "Total_customer": "Cliente totale {0}",
        "ProfitToolTips": "Il guadagno della flotta dopo aver escluso tutte le spese",
        "RevenueToolTips": "La flotta di denaro riceve effettivamente durante il periodo selezionato, comprese le promozioni, le deduzioni per i conducenti, le tasse, ecc.",
        "ProfitChangeToolTips": "La percentuale di variazione dei profitti della flotta rispetto al periodo precedente",
        "BookingRequestsToolTips": "Numero totale di prenotazioni e riservazioni on-demand create durante il periodo selezionato",
        "PercentageOfAcceptanceToolTips": "La percentuale di prenotazioni accettate durante il periodo selezionato",
        "BookingChangeHint": "La percentuale di variazione delle prenotazioni create rispetto al periodo precedente",
        "CompletedBookingHint": "Numero totale di prenotazioni e riservazioni on-demand completate durante il periodo selezionato",
        "PercentageOfSatisfactionHint": "La percentuale di soddisfazione durante il periodo selezionato",
        "CompleteBookingDailyChangeHint": "La percentuale di variazione delle prenotazioni completate rispetto al periodo precedente",
        "NewCustomersHint": "Numero totale di nuovi clienti registrati durante il periodo selezionato",
        "CustomerChangeHint": "Il numero e la percentuale di cambiamento dei clienti rispetto al periodo precedente",
        "TotalCustomer": "Numero totale di clienti nel sistema",
        "ProfitAndFinishedBookingHint": "Profitto e prenotazioni completate della flotta durante il periodo selezionato",
        "BookingRequestHint": "Numero totale di prenotazioni e riservazioni on-demand create durante il periodo selezionato",
        "FinishedBookingChartsHint": "Numero totale di prenotazioni e riservazioni on-demand chiuse durante il periodo selezionato, inclusi cancellazioni, no show, incidenti e completate",
        "Customer_count": "{0} conteggio clienti",
        "Revenue": "Entrate"
    },
    "referral": {
        "first_package": "1° pacchetto (cioè la prima prenotazione completata di Pax)",
        "driver_refers_to_pax": "Driver refers to Passengers",
        "driver_will_get": "Il conducente riceverà",
        "money": "Denaro",
        "amount": "Importo",
        "percent": "Percent",
        "settlement": "Commissione (% dell'importo subtotale di ogni prenotazione completata)",
        "pax_will_get": "Pax otterrà",
        "promotion_code": "Codice Promozionale",
        "select_a_promotion": "Seleziona un codice promozionale",
        "maximum": "Massimo",
        "second_package": "2° pacchetto",
        "from": "Da",
        "to": "Per",
        "After_2nd_package": "Dopo il 2° pacchetto",
        "from_end_value_of_above_package": "Dal valore dell'ultimo pacchetto sopra + 1",
        "Expiration_date": "Data di scadenza",
        "Never": "Mai",
        "Customized_date": "Data personalizzata",
        "limited": "Limitato",
        "unlimited": "Illimitato",
        "Valid_from": "Valido Da",
        "Valid_to": "Valido fino a",
        "Invitation_limit": "Invitation limit/user",
        "Status": "Stato",
        "Active": "Attivo",
        "Inactive": "Inattivo",
        "note": "* Si prega di notare che una volta attivata la campagna, qualsiasi aggiornamento sui valori delle ricompense influenzerà solo i nuovi clienti.",
        "Required_fields": "Campi obbligatori",
        "refferal_update_successfully": "L'impostazione di referral è stata aggiornata con successo",
        "distributeIncentiveToDriver": "Distribuire incentivo al conducente",
        "Immediate": "Immediato",
        "Periodic": "Periodico (Manuale)",
        "Period": "Periodo",
        "startDate": "Data di inizio",
        "nextDistributionDate": "Prossima data di distribuzione",
        "oneMonth": "1 mese",
        "threeMonth": "3 mesi",
        "sixMonth": "6 mesi",
        "passenger_refers_to_pax": "Passenger refers to Passengers",
        "referer_will_get": "Il referer riceverà",
        "referee_will_get": "L'arbitro riceverà",
        "promo": "Promozione",
        "Pax_invitation_limit": "Limite di inviti/utente",
        "promoPaidBy": "Promozione pagata da",
        "fleet": "Flotta",
        "driver": "Driver",
        "promoCode": "Codice promozionale",
        "isSendInbox": "Invia posta in arrivo",
        "isDefaultCode": "Applicazione automatica sull'app",
        "autoApplyOnWeb": "Applicazione automatica sul web",
        "isDefaultCode_hint": "Aggiungi il codice promozionale alla lista del cliente e applicalo automaticamente alla prenotazione quando il cliente crea un ordine.",
        "Actions": "Azioni",
        "add_promoCode": "Aggiungi",
        "Send_an_in_box_automatically_to_new_customers": "Invia messaggio nella casella di posta al cliente",
        "set_default_promo_code": "Applicazione automatica sull'app",
        "EDIT_PROMO_CODE": "Modifica codice promozionale",
        "DETAIL_PROMO_CODE": "Dettagli del codice promozionale",
        "CREATE_PROMO_CODE": "Crea codice promozionale",
        "DELETE_PROMO_CODE": "Elimina codice promozionale",
        "DELETE_CONFIRM_PROMO_CODE": "Vuoi eliminare questo codice promozionale?",
        "ERROR_INPUT_SOURCE": "Si prega di scegliere almeno uno."
    },
    "upload_document": {
        "NO_FILE_CHOSEN": "Nessun file scelto",
        "Limit_size_upload": "La dimensione del file supera il limite consentito di {0}Mb."
    },
    "payment_info": {
        "member_since": "Socio dal",
        "package_name": "Nome del pacchetto",
        "last_payment": "Ultimo pagamento",
        "credit_card": "Carta di credito",
        "last_digits": "Ultimi 4 cifre",
        "default": "Predefinito",
        "add_new_card": "Aggiungi carta",
        "history": "Storia",
        "transaction_date": "Data della transazione",
        "transaction_id": "ID transazione",
        "billing_cycle": "Ciclo di fatturazione",
        "amount": "Importo",
        "payment_history": "Storico fatturazione",
        "card_information": "Informazioni sulla carta",
        "card_holder": "Titolare di carta",
        "card_number": "Numero della carta",
        "expiration_date": "Data di scadenza",
        "cvv": "CVV"
    },
    "search_by": {
        "group_id": "ID Gruppo",
        "booking_id": "Prenotazione #",
        "recurring_id": "Ricorrente #",
        "ExternalID": "Esterno #",
        "tripId": "Viaggio #",
        "driver_name": "Nome autista",
        "driver_phone_number": "Numero di telefono",
        "license_plate": "Numero di targa",
        "vehicle": "Veicolo",
        "operator": "Operatore",
        "passenger_email": "Email passeggero",
        "passenger_name": "Nome passeggero",
        "passenger_phone_number": "Numero di telefono del passeggero",
        "destination": "Destinazione",
        "pick_up": "Indirizzo di partenza",
        "flight_number": "Volo #",
        "book_from": "Prenotato da",
        "note": "Nota",
        "email": "Email",
        "phone": "Telefono"
    },
    "withdrawal": {
        "transferToEWallet": "Trasferito a portafoglio elettronico esterno *{0}",
        "channelCode": "Codice di canale",
        "channelName": "Nome del canale",
        "reversed": "Invertito",
        "requestTime": "Richiedi il tempo",
        "referenceId": "Numero di riferimento",
        "driverName": "Nome del driver",
        "phoneNumber": "Numero di telefono",
        "company": "Azienda",
        "description": "Descrizione",
        "requestAmount": "richiesta importo",
        "transferAmount": "Importo del trasferimento",
        "currentBalance": "Bilancio corrente",
        "currency": "Valuta",
        "action": "Azione",
        "approve": "Approva",
        "reject": "Rifiuta",
        "transferToBankAccount": "Trasferito sul conto bancario *{0}",
        "transferToWingBank": "Trasferito a Wing bank ID *{0}",
        "transferToCreditWallet": "Trasferito sul portafoglio di credito",
        "reason": "Motivo",
        "search": "Nome del conducente, telefono, azienda, ID transazione, riferimento #",
        "message": {
            "approve": "Sei sicuro di voler pagare a questo driver un importo di {0}?",
            "approveMulti": "Sei sicuro di voler pagare i driver selezionati?",
            "approveSuccess": "La richiesta selezionata è stata pagata",
            "approveFail": "Selected request was not successful. Please try again",
            "approveMultiSuccess": "{0} su {1} richieste selezionate sono state pagate",
            "approveMultiFail": "{0} su {1} richieste selezionate non hanno avuto esito positivo. Per favore riprova",
            "buttonConfirmTitle": "Sì",
            "closeButtonText": "No",
            "pleaseInputReason": "Per favore inserisci il motivo",
            "rejectSuccess": "La richiesta del conducente è stata respinta",
            "rejectFail": "Impossibile rifiutare la richiesta selezionata."
        },
        "getDataFailure": "Impossibile ottenere dati",
        "rejectRequest": "Rifiuta richiesta"
    },
    "dynamicSurcharge": {
        "operationZone": "Zona operativa",
        "activeSurcharge": "Supplemento attivo",
        "surcharge": "Supplemento",
        "surchargeName": "nome supplemento",
        "parameter": "Parametro",
        "pickupPoint": "Zona di ritiro",
        "dropOffPoint": "Zona di scarico",
        "delete_surcharge_success": "Il sovrapprezzo è stato eliminato con successo",
        "delete_surcharge_fail": "Si sono verificati errori durante l'eliminazione del sovrapprezzo",
        "update_surcharge_fail": "Si sono verificati errori durante l'aggiornamento del sovrapprezzo",
        "update_surcharge_success": "Il sovrapprezzo è stato aggiornato con successo",
        "create_surcharge_fail": "Si sono verificati errori durante la creazione del sovrapprezzo",
        "create_surcharge_success": "Il sovrapprezzo è stato creato con successo",
        "active_surcharge_fail": "Si sono verificati errori durante l'attivazione del sovrapprezzo",
        "active_surcharge_success": "Il sovrapprezzo è stato attivato con successo",
        "deactive_surcharge_fail": "Si sono verificati errori durante la disattivazione del sovrapprezzo",
        "deactive_surcharge_success": "L'addebito è stato disattivato con successo",
        "delete_surcharge": "Elimina sovrapprezzo",
        "delete_confirm_message": "Sei sicuro di voler eliminare il sovrapprezzo selezionato?",
        "note": "*Nota: questo è quanto verrà moltiplicata la tua tariffa base. Esempio: una tariffa di $20 diventerebbe $30 quando il parametro è a 1,5x."
    },
    "dynamicFare": {
        "operationZone": "Zona operativa",
        "activeFare": "Tariffa attiva",
        "fare": "Fare",
        "fareName": "Fare nome",
        "factor": "Moltiplica per fattore",
        "fix_amount": "Importo",
        "parameter": "Parametro",
        "delete_fare_success": "Fare è stato eliminato con successo",
        "delete_fare_fail": "Si sono verificati errori durante l'eliminazione della tariffa",
        "update_fare_fail": "Si sono verificati errori durante l'aggiornamento della tariffa",
        "update_fare_success": "Fare è stato aggiornato con successo",
        "create_fare_fail": "Si sono verificati errori durante la creazione della tariffa",
        "create_fare_success": "Fare è stato creato con successo",
        "active_fare_fail": "Si sono verificati errori durante l'attivazione della tariffa",
        "active_fare_success": "Fare è stato attivato con successo",
        "deactive_fare_fail": "Si sono verificati errori durante la disattivazione della tariffa",
        "deactive_fare_success": "Fare è stato disattivato con successo",
        "delete_fare": "Elimina fare",
        "delete_confirm_message": "Sei sicuro di voler eliminare la tariffa selezionata?",
        "note": "*Nota: questo è quanto verrà moltiplicata la tua tariffa base. Esempio: una tariffa di $20 diventerebbe $30 quando il parametro è a 1.5x.",
        "note_amount": "*Nota: questo è l'importo che verrà aggiunto alla tua tariffa base. Esempio: una tariffa di $20 diventerebbe $25 quando l'importo fisso è di $5."
    },
    "notifications": {
        "search": "Ricerca Prenotazione id, external ID",
        "searchProviderName": "Nome del fornitore di ricerca",
        "statusItem": {
            "all": "Tutte le notifiche",
            "canceledByDriver": "Annullato dal pilota",
            "canceledByPartner": "Canceled by partner",
            "reservationReminder": "promemoria Prenotazione",
            "localPending": "Locale - In attesa",
            "reservationIsNotStarted": "La prenotazione non è iniziata",
            "partnerRequestsCars": "Partner richiede automobili",
            "timeout": "Timeout",
            "noShow": "Affiliato - No show",
            "driverNoShow": "Assenza del conducente",
            "affiliatePending": "Affiliato - In attesa",
            "affiliatePaymentFailed": "Affiliazione - Il pagamento non è riuscita",
            "affiliateTimeout": "Affiliato - Timeout",
            "flightApi": "API di Volo",
            "DebtWriteOff": "Cancellazione del debito",
            "driverCancelTrip": "Driver cancels trip",
            "minimumSeatRequired": "Numero minimo di posti richiesti",
            "newFarmInJobFrom3rd": "Booking.com - Nuova prenotazione",
            "canceledJobBy3rd": "Booking.com - Annullato",
            "updatedJobBy3rd": "Booking.com - Aggiornato",
            "incidentJobBy3rd": "Booking.com - Incidente",
            "newFarmInJobFromHolidayTaxis": "HolidayTaxis - Nuova prenotazione",
            "canceledJobByHolidayTaxis": "HolidayTaxis - Annullato",
            "updatedJobByHolidayTaxis": "HolidayTaxis - Aggiornato",
            "newFarmInJobFromKarhoo": "Karhoo - Nuova prenotazione",
            "canceledJobByKarhoo": "Karhoo - Annullato",
            "updatedJobByKarhoo": "Karhoo - Aggiornato",
            "newFarmInJobFromHoppa": "Hoppa - Nuova prenotazione",
            "canceledJobByHoppa": "Hoppa - Annullato",
            "updatedJobByHoppa": "Hoppa - Aggiornato",
            "newFarmInJobFromKlook": "Klook - Nuova prenotazione",
            "canceledJobByKlook": "Klook - Annullato",
            "updatedJobByKlook": "Klook - Aggiornato",
            "newFarmInJobFromTransferZ": "TransferZ - Nuova prenotazione",
            "canceledJobByTransferZ": "TransferZ - Annullato",
            "updatedJobByTransferZ": "TransferZ - Aggiornato",
            "incidentReport": "Incidente",
            "incidentAutoReport": "Necessita di revisione"
        },
        "sos": {
            "sosSearch": "Cerca ID prenotazione, nome passeggero, nome autista",
            "statusItem": {
                "all": "Tutti",
                "driver": "Driver",
                "passenger": "Passeggeri",
                "crew": "Equipaggio"
            }
        }
    },
    "smartData": {
        "No": "No.",
        "driverName": "Nome",
        "phone": "Telefono",
        "rating": "Valutazione",
        "completed": "Completato",
        "noShow": "No-show",
        "driverNoShow": "Assenza del conducente",
        "incident": "Incidente",
        "canceled": "Annullato dal pilota",
        "accepted": "Accettato",
        "reject": "Rifiuta",
        "ignore": "Ignora",
        "earning": "guadagno",
        "query": {
            "top20": "Top 20",
            "top50": "Top 50",
            "top100": "Top 100",
            "bottom20": "Ultimi 20",
            "bottom50": "Bottom 50",
            "bottom100": "Bottom 100"
        },
        "status": {
            "canceled": "Annullato dal pilota",
            "noShow": "No-show",
            "driverNoShow": "Assenza del conducente",
            "incident": "Incidente",
            "completed": "Completato",
            "earning": "guadagno",
            "reject": "Rifiuta",
            "ignore": "Ignora",
            "accepted": "Accettato"
        }
    },
    "Reject": "Assente",
    "Do not allow Driver to start reservat": "Affiliazione",
    "intercityRate": {
        "Delete_intercity_rate": "Elimina tariffa intercity",
        "edit_intercity_rate": "Modifica la tariffa intercity",
        "view_intercity_rate": "Visualizza tariffa intercity",
        "add_intercity_rate": "Aggiungi tariffa intercity",
        "Delete_confirm_intercity_rate": "Vuoi eliminare questo elemento?",
        "Update_intercity_rate_success": "La tariffa intercity è stata aggiornata con successo.",
        "Update_intercity_rate_fail": "Si sono verificati errori durante l'aggiornamento della tariffa intercity",
        "Created_intercity_rate_success": "La tariffa intercity è stata creata con successo",
        "Created_intercity_rate_fail": "Si sono verificati errori durante la creazione della tariffa intercity",
        "Update_intercity_rate_route_success": "Il percorso della tariffa intercity è stato aggiornato con successo",
        "Update_intercity_rate_route_fail": "Si sono verificati errori durante l'aggiornamento del percorso intercity",
        "Created_intercity_rate_route_success": "Il percorso della tariffa intercity è stato creato con successo",
        "Created_intercity_rate_route_fail": "Si sono verificati errori durante la creazione del percorso intercity",
        "Loading_intercity_rate_fail": "Si sono verificati errori durante il caricamento dei dettagli delle tariffe intercity",
        "Delete_intercity_rate_route_fail": "Si sono verificati errori durante l'eliminazione del percorso tariffario intercity",
        "Delete_intercity_rate_success": "La tariffa intercity è stata eliminata con successo.",
        "Delete_intercity_rate_fail": "Si sono verificati errori durante l'eliminazione della tariffa intercity"
    },
    "intercityRoute": {
        "alias": "Alias",
        "routeNameHint": "Per cambiare il nome della rotta, vai su Impostazioni > Zona > Intercity e modifica il nome delle zone cittadine di conseguenza.",
        "pricePerSeat": "Prezzo per posto (tasse escluse)",
        "distance": "Distanza",
        "duration": "Durata",
        "cancellationPenalty": "Importo della penale per posto",
        "noShow": "Pax/partner assente",
        "penalty": "Importo della penale per posto",
        "no_show_tooltip": "L'importo che il cliente sarà addebitato per posto. Oltre alla penale, il cliente pagherà tasse o spese tecniche se applicabili.",
        "firstLocation": "Prima posizione",
        "secondLocation": "Seconda posizione",
        "routeOneSetup": "Imposta percorso 1",
        "routetwoSetup": "Imposta percorso 2",
        "schedules": "Programmi",
        "date": "Data",
        "time": "Tempo",
        "editSchedule": "Modifica programma",
        "addSchedule": "Aggiungi programma",
        "requestTimeEnable": "Consentire al cliente di impostare l'orario della richiesta",
        "extraFee": "Commissione extra",
        "hideRouteEnable": "Nascondi questo percorso",
        "timeRange": "Intervallo di tempo",
        "workingTime": "Tempo di lavoro",
        "applyForOtherDays": "Richiedi per altri giorni",
        "limitSeatLuggage": "Limite posti / bagagli",
        "warningMinimumSeats": "Posti minimi richiesti",
        "warningMinimumSeatsHint": "Numero minimo di posti richiesti per effettuare un viaggio",
        "allowStartLessMinRequiredSeats": "Allow driver to start trip regardless of the minimum seat requirement",
        "allowStartLessMinRequiredSeatsHint": "Driver can start a trip even if requested seats less than minimum seat required",
        "freeLuggagePerSeat": "Bagaglio gratuito per posto",
        "freeLuggagePerSeatHint": "Number free of luggage included per seat",
        "allowToAddExtraLuggage": "Allow to add additional luggage",
        "allowToAddExtraLuggageHint": "Passenger can request to add more luggage",
        "feePerExtraLuggage": "Tariffa per bagaglio extra",
        "Delete_intercity_route": "Elimina percorso intercity",
        "Delete_confirm_intercity_route": "Vuoi eliminare questo percorso?",
        "Update_intercity_route_fail": "Intercity route has been updated successfully",
        "Update_intercity_route_success": "Il percorso intercity è stato aggiornato con successo",
        "created_intercity_route_success": "Il percorso intercity è stato creato con successo",
        "created_intercity_route_fail": "Si sono verificati errori durante la creazione del percorso intercity",
        "Delete_intercity_route_success": "Il percorso intercity è stato eliminato con successo",
        "Delete_intercity_route_fail": "Si sono verificati errori durante l'eliminazione della rotta intercity",
        "penalty_less_than_or_equal_to_price": "Si prega di inserire un valore minore o uguale al valore del prezzo per posto.",
        "scheduleTimeOverlap": "Il tempo di programmazione non deve sovrapporsi l'uno con l'altro.",
        "allows_adding_extra": "Consente di aggiungere un costo extra quando il cliente richiede un orario non programmato dalla flotta.",
        "this_is_to_limit_users": "Questo serve a limitare gli utenti (cioè cliente, autista, operatore) dalla creazione di nuove prenotazioni o viaggi su questo percorso. Le prenotazioni o i viaggi esistenti rimangono riservati."
    },
    "dayOfWeek": {
        "0": "Domenica",
        "1": "Lunedì",
        "2": "Martedì",
        "3": "Mercoledì",
        "4": "Giovedì",
        "5": "Venerdì",
        "6": "Sabato"
    },
    "intercityBooking": {
        "route": "Percorso",
        "departureDate": "Data di partenza",
        "departureTime": "Orario di partenza",
        "Departure": "Partenza",
        "Arrival": "Arrivo",
        "RefundFare": "Rimborso tariffa",
        "intercityZoneNote": "These zones are not operational zone. And they are used for setting intercity rate only.",
        "zoneNameHint": "Si prega di mantenere il nome della tua zona breve e chiaro in modo che i tuoi clienti possano cercare e selezionare facilmente.",
        "zoneUploadNote_2": "* Si raccomanda che la risoluzione dell'immagine sia 1095x360 e la dimensione del file sia inferiore a 5MB.",
        "Complete_booking": "Completa Prenotazione",
        "ConfirmCancel": "Conferma annullamento"
    },
    "deliveryRate": {
        "Delete_delivery_rate": "Elimina tariffa di consegna",
        "edit_delivery_rate": "Modifica il tasso di consegna",
        "view_delivery_rate": "Visualizza il tasso di consegna",
        "add_delivery_rate": "Aggiungi tariffa di consegna",
        "Delete_confirm_delivery_rate": "Vuoi eliminare questo elemento?",
        "Update_delivery_rate_success": "Il tasso di consegna è stato aggiornato con successo",
        "Update_delivery_rate_fail": "Si sono verificati errori durante l'aggiornamento della tariffa di consegna",
        "Created_delivery_rate_success": "Il tasso di consegna è stato creato con successo",
        "Created_delivery_rate_fail": "Si sono verificati errori durante la creazione della tariffa di consegna",
        "Update_delivery_rate_route_success": "Il percorso della tariffa di consegna è stato aggiornato con successo",
        "Update_delivery_rate_route_fail": "Si sono verificati errori durante l'aggiornamento del percorso di consegna",
        "Created_delivery_rate_route_success": "Il percorso della tariffa di consegna è stato creato con successo",
        "Created_delivery_rate_route_fail": "Si sono verificati errori durante la creazione del percorso di consegna",
        "Loading_delivery_rate_fail": "Si sono verificati errori durante il caricamento dei dettagli del tasso di consegna",
        "Delete_delivery_rate_route_fail": "Si sono verificati errori durante l'eliminazione del percorso della tariffa di consegna",
        "Delete_delivery_rate_success": "Il tasso di consegna è stato eliminato con successo",
        "Delete_delivery_rate_fail": "Si sono verificati errori durante l'eliminazione della tariffa di consegna",
        "distance_km": "Tariffa per km",
        "distance_mile": "Commissione per mille",
        "flat": "Tariffa fissa",
        "startingFee": "Quota di iscrizione",
        "feeFirstDistance": "Commissione prima distanza",
        "feeSecondDistance": "Commissione per distanza secondaria",
        "feeThirdDistance": "Commissione terza distanza",
        "feeAfterThirdDistance": "Commissione dopo la terza distanza",
        "feePerMinute": "Fare al minuto",
        "feeMinimum": "Commissione minima",
        "feeFirstStop": "Tariffa per la prima fermata",
        "feeExtraStop": "Tariffa per ogni fermata extra"
    },
    "aiAtlasSettings": {
        "title": "Atlas AI Chatbot",
        "titleDes": "Fai sapere ad Atlas della tua azienda e del tuo servizio",
        "information": "Informazioni sull'Atlas",
        "informationDes": "Ad esempio, aggiungi i dettagli dell'azienda come email, numero di telefono, indirizzo, ecc.",
        "updateSettingSuccess": "Impostazione di aggiornamento AI Atlas riuscita",
        "updateSettingFail": "Impostazione di aggiornamento AI Atlas non riuscita"
    },
    "pwaSettings": {
        "pwa": "PWA",
        "iconName": "Icona e nome",
        "logoBackgroundColor": "Logo, sfondo e colore",
        "longName": "Nome lungo",
        "shortName": "Nome breve",
        "icon192": "Icona sulla schermata principale (192x192)",
        "icon512": "Icona sulla schermata di avvio",
        "logo": "Logo (300x300)",
        "logoMenu": "Menu logo (300x300)",
        "backgroundImage": "Immagine di sfondo - Trasporto (1024x500)",
        "backgroundImageDelivery": "Immagine di sfondo - Consegna (1024x500)",
        "mainColor": "Colore principale",
        "secondaryColor": "Colore secondario",
        "showMainColor": "Mostra il colore principale invece dell'immagine di sfondo",
        "success": "L'impostazione PWA è stata aggiornata con successo",
        "failed": "Impossibile aggiornare le impostazioni PWA. Per favore riprova!",
        "errorUploadFileSize": "Le dimensioni richieste sono {0}x{0} px.",
        "hideWBInstallAppBtn": "Nascondi il pulsante di installazione dell'app",
        "enableBookNow": "Adesso",
        "enableGuestCheckout": "Checkout come ospite",
        "enableBookLater": "Più tardi",
        "enableHideRecipient": "Nascondi informazioni sul destinatario (Contenuto del pacco, Istruzioni per la consegna)",
        "pwaLink": "PWA per Passeggero",
        "partnerLink": "PWA per Partner",
        "pwaDriverLink": "PWA per Driver",
        "providerSignUp": "Link di registrazione per i conducenti",
        "AdsTracking": "Tracciamento Annunci",
        "googleId": "ID Tag di Google",
        "placeholdergoogleId": "Inserisci l'ID del Tag di Google",
        "metaId": "Meta Pixel ID",
        "placeholdermetaId": "Inserisci l'ID del Meta Pixel"
    },
    "emailConfig": {
        "emailServer": "Server di posta elettronica",
        "default": "Predefinito",
        "customized": "Personalizzato",
        "fromName": "Da nome",
        "email": "Da email",
        "replyTo": "Rispondi a",
        "userAuth": "Nome utente",
        "password": "Password",
        "smtpServer": "server SMTP",
        "port": "porta SMTP",
        "isAuthenticated": "Autenticato",
        "option": "Abilita Opzione",
        "none": "Nessuno",
        "tls": "TLS",
        "ssl": "SSL",
        "save": "Salva",
        "cancel": "Annulla",
        "success": "Aggiornamento del server email riuscito",
        "fail": "Errore nell'aggiornamento del server email",
        "loadFail": "Caricamento dei dettagli del server email non riuscito"
    },
    "driverFields": {
        "Load_fail": "",
        "Edit": "Modifica",
        "View": "Visualizza",
        "Cancel": "Annulla",
        "show": "Mostra",
        "hide": "Nascosto",
        "EDIT_DRIVER_FIELDS": "Modifica i campi del driver",
        "DETAIL_DRIVER_FIELDS": "Dettagli dei campi del driver",
        "ADD_DRIVER_FIELDS": "Aggiungi campi del conducente",
        "fieldKey": "Chiave dei campi",
        "fieldName": "Nome dei campi",
        "availableCC": "Disponibile nel Centro di Comando",
        "availableDrvSignUp": "Disponibile nella registrazione del conducente",
        "availableCompanyCar": "Auto aziendale - Trasporto conducenti",
        "deliveryCompany": "Auto aziendale - Corrieri",
        "availableIndividualCar": "Autovettura individuale - Trasportatori",
        "deliveryIndividual": "Auto individuale - Corrieri",
        "required": "Richiesto",
        "Update_fail": "Si sono verificati errori durante l'aggiornamento dei campi del driver",
        "Update_success": "I campi del driver sono stati aggiornati con successo",
        "FieldKey": "Chiave dei campi",
        "FieldName": "Nome dei campi (inglese americano)",
        "CommandCenter": "Disponibile nel Centro di Comando",
        "SignUp": "Disponibile nella registrazione del conducente",
        "CompanyTransport": "Auto Aziendale - Trasporto",
        "CompanyDelivery": "Auto Aziendale - Consegna",
        "IndividualTransport": "Auto Individuale - Trasporto",
        "IndividualDelivery": "Auto individuale - Consegna",
        "Require": "Richiesto",
        "Actions": "Azioni",
        "fieldType": "Tipo di Campi",
        "default": "Predefinito",
        "customized": "Personalizzato"
    },
    "driverDocument": {
        "Load_fail": "",
        "Edit": "Modifica",
        "View": "Visualizza",
        "Cancel": "Annulla",
        "show": "Mostra",
        "hide": "Nascosto",
        "EDIT_DRIVER_DOCUMENT": "Modifica Documento del Pilota",
        "DETAIL_DRIVER_DOCUMENT": "Documento Dettagli Driver",
        "ADD_DRIVER_DOCUMENT": "Aggiungi Documento del Conducente",
        "documentKey": "Chiave del documento",
        "documentName": "Nome del documento",
        "documentNameDetail": {
            "zh-HK": "Cinese tradizionale",
            "it-IT": "Italiano standard",
            "es-ES": "Spagnolo",
            "en-US": "inglese americano",
            "fr-FR": "Francese standard",
            "zh-CN": "Cinese semplificato",
            "id-ID": "Bahasa Indonesia",
            "vi-VN": "Vietnamita",
            "ur-PK": "Urdu (Repubblica Islamica del Pakistan)",
            "ms-MY": "Malaio (Malesia)",
            "ar-AR": "Arabo",
            "en-GB": "Inglese (Regno Unito)",
            "nb-NO": "Norvegese",
            "am-ET": "Amarico",
            "ro-RO": "Rumeno",
            "th-TH": "Thai",
            "ta-IN": "Tamil",
            "hi-IN": "Hindi",
            "te-IN": "Telugu",
            "ka-GE": "Georgiano",
            "ru-RU": "Russo",
            "kn-IN": "Kannada"
        },
        "isIndividual": "Auto aziendale - Trasporto conducenti",
        "deliveryCompany": "Auto aziendale - Corrieri",
        "isOwner": "Autista individuale - Autisti di trasporto",
        "deliveryIndividual": "Autista individuale - Corrieri",
        "availableCC": "Disponibile nel Centro di Comando",
        "availableDrvSignUp": "Disponibile nella registrazione del conducente",
        "isRequired": "Richiesto",
        "isExpiredDate": "Data di scadenza - Centro di comando",
        "expiredDateForDrvSignUp": "Data di scadenza - Registrazione del conducente",
        "requireExpiredDate": "Richiedi Data di Scadenza",
        "requireExpiredDateForDrvSignUp": "Richiedi Data di Scadenza",
        "requireDocumentId": "Richiedi ID Documento",
        "documentId": "ID Documento - Centro Comandi",
        "documentIdForDrvSignUp": "ID documento - Registrazione conducente",
        "Update_fail": "Si sono verificati errori durante l'aggiornamento del documento del driver",
        "Update_success": "Il documento del driver è stato aggiornato con successo",
        "DocumentKey": "Chiave del documento",
        "DocumentName": "Nome del Documento (Inglese Americano)",
        "CommandCenter": "Disponibile nel Centro Comandi",
        "SignUp": "Disponibile nella registrazione del conducente",
        "CompanyTransport": "Auto aziendale - Trasporto",
        "CompanyDelivery": "Auto Aziendale - Consegna",
        "IndividualTransport": "Auto Individuale - Trasporto",
        "IndividualDelivery": "Auto Individuale - Consegna",
        "Require": "Richiesto",
        "Actions": "Azioni"
    },
    "holidayTaxis": {
        "title": "Credenziali API di HolidayTaxis",
        "note": "Comunica con il team tecnico di HolidayTaxis per fornirti la chiave API per connetterti al loro sistema.",
        "apiKey": "chiave API",
        "placeHolderApiKey": "Inserisci la chiave API"
    },
    "trailNotes": {
        "maxLengthFiles": "Massimo 3 file per commento",
        "maxSizeFiles": "Massimo 10MB per file",
        "typeFiles": "Tipi di file supportati: pdf, doc, docx, csv, xls, xlsx, jpeg, jpg, png, webp, txt, note",
        "maxComments": "Massimo 20 commenti per prenotazione",
        "bookingActivity": "Attività di Prenotazione",
        "viewAll": "Visualizza tutto",
        "operator": "Operatore",
        "driver": "Driver",
        "passenger": "Cliente",
        "pHInput": "Aggiungi un nuovo commento. Puoi fare clic su salva per salvare la nota. Puoi anche trascinare e rilasciare più file qui.",
        "addFiles": "Aggiungi file",
        "save": "Salva",
        "inputNotes": "Si prega di inserire il testo",
        "successDeleteTrailNotes": "Elimina note del percorso con successo",
        "successCreateTrailNotes": "Crea note di tracciamento con successo",
        "deleteTrailNote": "Elimina una nota del sentiero",
        "msgDeleteTrailNote": "Sei sicuro di voler eliminare questo?"
    },
    "supplier": {
        "permissionRequired": "L'operatore deve selezionare un permesso",
        "offerDetail": "Dettaglio Offerta",
        "orderDetail": "Dettaglio Ordine",
        "bookingNumber": "Numero di prenotazione",
        "date": "Data",
        "pickupLocation": "Pick up Location",
        "dropoffLocation": "Luogo di consegna",
        "passenger": "Passeggero",
        "luggage": "Bagagli",
        "pickupService": "Servizio di Ritiro",
        "pickupSignage": "Segnaletica di Ritiro",
        "flightNumber": "Numero di Volo",
        "departure": "Partenza",
        "arrival": "Arrivo",
        "terminal": "Terminale",
        "gate": "Porta",
        "meetGreet": "Incontro e saluto",
        "specialRequests": "Richieste Speciali",
        "additionalServices": "Servizi Aggiuntivi",
        "price": "Prezzo",
        "prices": "Prezzi",
        "guest": "Ospite",
        "serviceClass": "Classe di Servizio",
        "distance": "Distanza",
        "duration": "Durata",
        "acceptOffer": "Accetta Offerta",
        "updateBooking": "Aggiorna Prenotazione",
        "package": "Pacchetto",
        "route": "Percorso",
        "assignedChauffer": "Chauffeur Assegnato",
        "assignedVehicle": "Veicolo Assegnato",
        "logs": "Registri",
        "link": "Collegamenti",
        "desLink": "Clicca per copiare il link",
        "trackLink": "Link di tracciamento",
        "driverLink": "Collegamento driver",
        "close": "Chiudi",
        "links": "Collegamenti",
        "linksDes": "Clicca per copiare il link",
        "status": "Stato",
        "rating": "Valutazione",
        "permissions": "Permessi",
        "permissionsNote": "Assegna diversi livelli di autorizzazione al tuo team. Puoi scegliere se i tuoi operatori hanno visibilità delle offerte aperte o solo delle assegnazioni già accettate.",
        "owner": "Proprietario",
        "ownerNote": "Accesso Completo",
        "manageUsers": "Gestisci Utenti",
        "manageUsersNote": "Aggiungi/rimuovi nuovi operatori",
        "manageDrivers": "Gestisci i Driver",
        "manageDriversNote": "Aggiungi/rimuovi driver",
        "manageVehicles": "Gestisci Veicoli",
        "manageVehiclesNote": "Aggiungi/rimuovi veicoli",
        "mapView": "Mappa in tempo reale",
        "mapViewNote": "Monitora i conducenti e i viaggi attivi in tempo reale sulla mappa.",
        "calendarView": "Visualizzazione Calendario",
        "calendarViewNote": "Visualizza il calendario di tutti i viaggi assegnati.",
        "bookingView": "Visualizzazione Prenotazioni",
        "bookingViewNote": "Visualizza e gestisci le prenotazioni attuali, assegna i conducenti e allocca i veicoli.",
        "offersView": "Visualizzazione Offerte",
        "offersViewNote": "Accetta nuove offerte di lavoro.",
        "pricing": "Prezzi",
        "pricingNote": "Visualizza i prezzi dei viaggi",
        "report": "Rapporti",
        "reportNote": "Visualizza report di prenotazione e finanziari",
        "reportExport": "Esporta Rapporti",
        "reportExportNote": "Esporta report in .csv",
        "userDetail": "Dettagli utente",
        "addOperator": "Aggiungi Operatore",
        "updateOperator": "Operatore di aggiornamento",
        "supplier": "Fornitore",
        "zone": "Zone",
        "emails": "Email",
        "email": "Email",
        "phoneNumber": "Numero di telefono",
        "Deactivate": "Disattivare",
        "Activate": "Attiva",
        "ALERT_SELECT_DEACTIVATE": "Seleziona il fornitore da disattivare",
        "ALERT_SELECT_ACTIVATE": "Seleziona il fornitore da attivare",
        "CONFIRM_DEACTIVATE_MULTI": "Vuoi disattivare questi fornitori?",
        "CONFIRM_ACTIVATE_MULTI": "Vuoi attivare questi fornitori?",
        "Update_supplier_user_status_success": "Lo stato del fornitore è stato aggiornato con successo",
        "Update_supplier_user_status_fail": "Si sono verificati errori durante l'aggiornamento dello stato del fornitore",
        "agent": "Agente",
        "Supplier": "Fornitore",
        "addSupplier": "Aggiungi Fornitore",
        "detailSupplier": "Dettagli Fornitore",
        "addUser": "Aggiungi Utente",
        "Add": "Aggiungi",
        "ContactInfo": "Informazioni di contatto",
        "policy": "Politica",
        "users": "Utenti",
        "setting": "Impostazione",
        "zones": "Zone",
        "actions": "Azioni",
        "companyName": "Nome dell'azienda",
        "corporationType": "Tipo di Corporazione",
        "country": "Paese",
        "nationality": "Nazionalità",
        "driverIC": "Driver IC",
        "ADMIN_INFORMATION": "Informazioni Amministrative",
        "firstName": "Nome",
        "lastName": "Cognome",
        "commissionValue": "Commissione della flotta",
        "commissionValueDes": "Imposta le commissioni che la flotta guadagna per ogni ordine completo.",
        "SupplierType": "Tipo di Fornitore",
        "SupplierTypeDes": "Seleziona un tipo di fornitore.",
        "paymentMethodsApplyDes": "Metodi di pagamento specifici per il lavoro che i fornitori possono elaborare:",
        "bookingSettings": "Impostazioni di prenotazione",
        "bookingSettingsDes": "Configura la visibilità del lavoro, i tempi di rilascio e i ritardi per operazioni efficienti dei fornitori.",
        "advanceBookingVisibilityTooltip": "Specifica quanti giorni prima i fornitori possono vedere gli ordini.",
        "delayBroadcastToolTip": "Imposta un tempo di ritardo rispetto all'orario di rilascio se impostato o all'inizio della giornata (00:00). Questo ritardo controlla quando i lavori diventano visibili ai fornitori dopo l'orario di rilascio iniziale.",
        "releaseTimeToolTip": "Imposta l'orario del giorno in cui i lavori vengono rilasciati ai fornitori, a partire dal primo giorno in cui possono vedere le prenotazioni. Assicurati che questo orario consenta ai fornitori di avere abbastanza tempo per prepararsi.",
        "otherSettings": "Altre impostazioni",
        "hideFare": "Autista - Nascondi sempre la tariffa",
        "hideFareDes": "Nascondi la tariffa per tutti i conducenti di questo fornitore.",
        "supplierJobRequired": "Accettazione del lavoro da parte del fornitore richiesta",
        "supplierJobRequiredDes": "I fornitori devono riconoscere e accettare i lavori prima di poter assegnare un conducente/un veicolo o permettere che il lavoro venga visualizzato dai conducenti nel mercato.",
        "supplierApproval": "Approvazione Fornitori/Veicoli",
        "supplierApprovalDes": "Consentire agli operatori dei fornitori di attivare conducenti e veicoli all'interno della loro flotta.",
        "emailsApply": "Notifiche Email",
        "emailsApplyDes": "Email per inviare nuovi lavori, aggiornamenti sulle prenotazioni.",
        "address": "Indirizzo",
        "zipCode": "Codice Postale",
        "city": "Città",
        "state": "Stato/Provincia",
        "tax": "Numero di identificazione fiscale",
        "businessRegistration": "Numero di registrazione dell'azienda",
        "vatNumber": "ID/Numero IVA",
        "mobile": "Mobile",
        "editOperator": "Modifica Operatore",
        "searchEmail": "Cerca Email",
        "acceptOfferSuccess": "Offerta accettata con successo",
        "acceptOfferFail": "Prenotazione non trovata o un altro fornitore ha accettato la prenotazione",
        "driverPayout": "Pagamento del conducente",
        "payout": "Pagamento",
        "totalPayout": "Pagamento totale",
        "totalPayoutDes": "Il pagamento totale include l'importo base del pagamento più eventuali commissioni aggiuntive che hai scelto di allocare ai tuoi fornitori.",
        "supplierPayout": "Supplier payout",
        "driverTip": "Consiglio per il conducente",
        "cancel": "Annulla",
        "save": "Salva",
        "activeSupplier": "Fornitore attivo",
        "userName": "Nome utente",
        "bookingCompletedView": "Prenotazioni Completate",
        "bookingCompletedViewNote": "Visualizza la cronologia di tutte le prenotazioni completate.",
        "driverEarning": "Guadagno del conducente",
        "payoutCurrency": "Valuta di pagamento",
        "payoutCurrencyDes": "Valuta da pagare al fornitore/autista",
        "autoCreatePayout": "Creazione automatica dei pagamenti",
        "autoCreatePayoutDes": "Imposta quando creare automaticamente un estratto conto di pagamento per i tuoi partner",
        "startDate": "Data di inizio",
        "frequency": "Frequenza",
        "daily": "Giornaliero",
        "weekly": "Settimanale",
        "biWeekly": "Bi-settimanale",
        "monthly": "Mensile",
        "commissionSupplier": "Commissione",
        "commissionSupplierDes": "Imposta le commissioni che il fornitore guadagna per ogni ordine completo.",
        "amount": "Importo fisso",
        "percent": "Percentuale",
        "commissionSupplierValue": "Valore della commissione di input",
        "payments": "Pagamenti",
        "paymentsDes": "Saldo da pagare a te ad ogni piano di pagamento",
        "ConnectWithStripe": "Collegati con Stripe",
        "viewStripeAccount": "Visualizza account Stripe",
        "viewBankInfo": "Visualizza informazioni bancarie",
        "AddBankInfo": "Aggiungi informazioni bancarie",
        "confirmChangeBalane": "Sei sicuro di voler cambiare il saldo del fornitore?",
        "changeBalaneSuccess": "Il saldo di cassa del fornitore è stato aggiornato con successo",
        "restrictedZoneAccess": "Accesso alla Zona Riservata",
        "restrictedZoneAccessDes": "Definire aree specifiche ad alta sicurezza o controllate—come basi militari o strutture dell'aeronautica—dove i prelievi o le consegne sono consentiti solo per conducenti autorizzati con accesso speciale o permessi.",
        "DrvSignUpLink": "Link di registrazione per autisti"
    },
    "vehicleLeadTime": {
        "vehicleLeadTime": "Politica sui Tempi di Consegna dei Veicoli",
        "customLocationLeadTime": "Tempo di consegna per posizione personalizzata",
        "leadTime": "Tempo di consegna",
        "ConfirmDelete": "Sei sicuro di voler eliminare questa polizza?",
        "Delete_success": "La politica è stata eliminata con successo",
        "Update_Policy_success": "La politica è stata aggiornata con successo",
        "Create_Policy_success": "La politica è stata creata con successo",
        "Update_Policy_fail": "Si sono verificati errori durante l'aggiornamento della policy",
        "Create_Policy_fail": "Si sono verificati errori durante la creazione della policy",
        "setDefaultSuccess": "La politica di tempo di consegna predefinita del veicolo è stata impostata con successo.",
        "setDefaultFail": "Si sono verificati errori durante la configurazione della politica predefinita",
        "Policies": "Politiche",
        "pricingPolicy": "Politica dei Prezzi",
        "customizeLeadTime": "Personalizza il Tempo di Consegna",
        "SelectVehiclePolicy": "Seleziona Politica di Tempo di Consegna del Veicolo"
    },
    "noResultFound": "Nessun risultato trovato",
    "invalidDate": "La data non è valida. Si prega di inserire la data nel formato mm/dd/yyyy.",
    "billingUsage": {
        "GSNTitle": "Portafoglio GSN",
        "GSNNote": "Le flotte ricaricano per inviare o ricevere lavori dalla rete.",
        "GSNPlatform": "Piattaforma",
        "GSNPlatformNote": "Monitoraggio di abbonamento e utilizzo prenotazioni. Fatturato alla fine del ciclo di fatturazione. Resta separato dal Portafoglio GSN.",
        "GSNPlatformLimit": "Fatturazione piattaforma",
        "GSNPlatformLimitNote": "Monitoraggio di abbonamento e utilizzo. Fatturato alla fine del ciclo di fatturazione. È separato dal Portafoglio GSN.",
        "usageBalanceNote": "Monitoraggio di abbonamento e utilizzo. Fatturato alla fine del ciclo di fatturazione. È separato dal Portafoglio GSN.",
        "usageBalanceNoteDate": "Abbonamento e utilizzo in sospeso",
        "usageBalanceNoteDateValue": "scadenza il %{date}.",
        "usageBalance": "Saldo utilizzo",
        "platformUsage": "Utilizzo piattaforma",
        "payoutBalance": "Saldo da incassare",
        "invoicePayoutBalanceTooltip": "Guadagni da prenotazioni di rete completate, disponibili per il prelievo. Se il saldo crediti è insufficiente, questo saldo può coprire le transazioni di rete.",
        "autoPayoutBalanceTooltip": "Questo saldo mostra quanto hai guadagnato sulla rete e puoi prelevare. Se il credito è basso, le commissioni possono essere dedotte automaticamente da qui.",
        "creditBalance": "Saldo crediti",
        "gsnCreditBalance": "Saldo crediti GSN",
        "totalBalance": "Saldo totale",
        "paid": "Completato",
        "failed": "Non riuscito",
        "processing": "In elaborazione",
        "pending": "In sospeso",
        "bookingDeduct": "GSN Farm-Out",
        "cancellationPenalty": "GSN cancellazione tardiva",
        "noShowPenalty": "GSN mancata presentazione",
        "withdraw": "Preleva",
        "bookingEarning": "GSN Farm-In",
        "booking": "Commissione piattaforma",
        "subscriptionFee": "Subscription Fee",
        "waived": "Waived*",
        "learnMore": "Scopri di più",
        "viewUsage": "View Usage",
        "productDiscovery": "Scoperta del Prodotto",
        "productDiscoveryDescription": "Esplora tutto ciò che puoi lanciare con GoodJourney. Scopri app per conducenti, strumenti di prenotazione web e altri prodotti per potenziare le tue operazioni.",
        "overview": "Panoramica",
        "paymentMethods": "Metodi di pagamento",
        "billingHistory": "Storico Fatturazione",
        "creditGrants": "Concessioni di credito",
        "transactionHistory": "Storico delle Transazioni",
        "getStartedDescription": "La tua guida tutto-in-uno per la piattaforma. Esplora tutorial passo-passo, FAQ e migliori pratiche per padroneggiare prenotazioni, spedizioni, pagamenti e altro ancora.",
        "getStartedButton": "Inizia",
        "walletOverview": "Panoramica del Wallet",
        "calculateTotal": "Totale = Credito + Contante",
        "autoRechargeOn": "Quando il tuo saldo credito raggiunge $0, passerai al piano gratuito. Abilita il ricarica automatica per mantenere automaticamente il tuo saldo credito rifornito.",
        "autoRechargeOff": "Suggerimento: Abilita il Ricarica Automatica per mantenere il tuo saldo sempre carico. Quando il tuo credito scende a $0, le nuove prenotazioni verranno messe in pausa fino a quando non aggiungi fondi.",
        "updateSettingsOn": "Aggiorna impostazioni",
        "updateSettingsOff": "Abilita ricarica automatica",
        "autoChargeTitle": "Impostazioni di ricarica automatica",
        "autoChargeTitleQuestion": "Vuoi impostare la ricarica automatica?",
        "autoChargeCbx": "Sì, ricarica automaticamente la mia carta quando il mio saldo di credito scende al di sotto di una soglia.",
        "crdBelow": "Quando il saldo del credito scende sotto",
        "crdBelowNote": "Enter an amount between $5 and $100",
        "backupTo": "Riporta il saldo del credito a",
        "backupToNote": "Enter an amount between $10 and $100",
        "greaterThan": "Il valore deve essere maggiore di {0}",
        "lessThan": "Il valore deve essere inferiore a {0}",
        "AddBalance": "Aggiungi al saldo di credito",
        "toAdd": "Importo da aggiungere",
        "confirm": "Conferma pagamento",
        "usageCredit": "Credito di Utilizzo Buon Viaggio",
        "estTotal": "Totale stimato",
        "topUpSuccess": "Ricarica riuscita",
        "topUpFailMessage": "Si sono verificati errori durante il caricamento del credito",
        "autoRechargeSuccess": "Le impostazioni di ricarica automatica sono state aggiornate con successo.",
        "autoRechargeFailMessage": "Si sono verificati errori durante l'aggiornamento delle impostazioni di ricarica automatica",
        "creditBalanceTooltip": "Il saldo prepagato copre i costi della piattaforma e l’utilizzo. Mantienilo ricaricato affinché il servizio funzioni senza interruzioni.",
        "gsnCreditBalanceTooltip": "Crediti prepagati per inviare e ricevere prenotazioni sulla rete. Mantieni un saldo sufficiente per continuare senza interruzioni.",
        "creditLineTitle": "Linea di credito",
        "creditLineTooltip": "Limite di credito per l’attività Good Journey Network. L’importo utilizzato è dedotto dal limite; il disponibile è il margine prima del pagamento.",
        "creditLineLimit": "Limite",
        "creditLineUsed": "Utilizzato",
        "creditLineAvailable": "Disponibile",
        "creditLineNextPaymentLead": "Prossimo pagamento automatico %{date}",
        "creditLineNextPaymentTail": "oppure quando il saldo raggiunge %{limitAmount}",
        "creditLineNextPaymentTailOnly": "Il pagamento è dovuto quando il saldo raggiunge %{limitAmount}",
        "creditLineMakePayment": "Effettua pagamento",
        "cashBalanceTooltip": "Questi sono i tuoi guadagni dai lavori completati sulla rete. Questo importo è disponibile per il prelievo. Se il tuo saldo di credito è basso, potrebbero essere addebitate anche delle commissioni da qui.",
        "systemTopUp": "Ricarica del Sistema",
        "gsnManualTopUp": "Ricarica Manuale",
        "gsnSystemTopUp": "Ricarica del Sistema",
        "autoTopUp": "Ricarica Automatica",
        "manualTopUp": "Ricarica Manuale",
        "subscription": "Abbonamento",
        "subscriptionOneTime": "Abbonamento una tantum",
        "subscriptionAddOn": "Abbonamento Aggiuntivo",
        "subscriptionAddOnOneTime": "Abbonamento Aggiuntivo Una Tantum",
        "booking": "Commissione di prenotazione",
        "addOn": "Add-On",
        "subscriptionEnded": "La tua abbonamento è scaduto. Seleziona un nuovo piano per continuare.",
        "continue": "Continua",
        "openGuide": "Apri guida",
        "amountMustBeGreaterThan": "L'importo deve essere maggiore di {0}",
        "amountMustBeLessThan": "L'importo deve essere inferiore a {0}",
        "billingAndUsage": "Fatturazione e Utilizzo",
        "manageSubscription": "Gestisci Abbonamento",
        "failedToOpenBillingUrl": "Impossibile aprire l'URL di fatturazione",
        "autoChargeAmountMustBeGreaterThanThreshold": "quando la ricarica automatica è abilitata, l'importo deve essere superiore alla soglia di ricarica (5)",
        "rechargeWillHappenImmediately": "La ricarica avverrà immediatamente",
        "rechargeWillHappenImmediatelyDescription": "Il tuo saldo credito è al di sotto della soglia di ricarica che hai impostato, quindi una ricarica avverrà immediatamente dopo aver salvato queste impostazioni.",
        "amountIsRequired": "È richiesto un importo",
        "selectPaymentMethod": "Seleziona un metodo di pagamento",
        "byContinuingYouAgree": "Continuando, accetti il nostro",
        "serviceCreditTerms": "termini di credito per il servizio",
        "paidCreditsNonRefundable": "I crediti pagati non sono rimborsabili e scadono un anno dalla data di acquisto.",
        "back": "Indietro",
        "cancel": "Annulla",
        "topUp": "Ricarica",
        "autoRechargeIs": "La ricarica automatica è",
        "on": "su",
        "off": "spento",
        "viewTransactions": "Visualizza Transazioni",
        "bankInfo": "Informazioni bancarie",
        "setupPayment": "Imposta pagamento",
        "bookingUsage": "Booking Usage",
        "overages": "Overages",
        "included": "included",
        "of": "of",
        "extra": "extra",
        "received": "Ricevuto",
        "state": "Stato",
        "active": "Attivo",
        "expired": "Scaduto",
        "balance": "Equilibrio",
        "expires": "Scade",
        "last7Days": "Ultimi 7 Giorni",
        "viewHistory": "Visualizza cronologia",
        "creditsListedHereWillBeRemoved": "I crediti elencati qui saranno rimossi dal saldo alla loro data di scadenza.",
        "recentTransactions": "Transazioni Recenti",
        "onlyPreviewShown": "Viene mostrata solo un'anteprima. Visualizza le transazioni per il registro completo.",
        "showingTransactionsPast12Months": "Visualizzazione delle transazioni negli ultimi 12 mesi",
        "filter": "Filtro",
        "export": "Esporta",
        "all": "Tutto",
        "date": "Data",
        "amount": "Importo",
        "addOns": "Componenti aggiuntivi",
        "edit": "Modifica",
        "usage": "Utilizzo",
        "usageThisCycle": "Utilizzo di questo ciclo",
        "requests": "richieste",
        "base": "Base",
        "overage": "Superamento",
        "per": "per",
        "endOfSubscription": "Fine dell'abbonamento",
        "fleetPlan": "Piano della flotta",
        "currentPlan": "Piano attuale",
        "billing": "Fatturazione",
        "startDate": "Data di inizio",
        "nextBillingDate": "Fine dell'abbonamento",
        "change": "Cambia",
        "getStarted": "Inizia",
        "oneTimeSetup": "Impostazione una tantum:",
        "fee": "Tariffa:",
        "overagePerRequest": "Overage",
        "overagePerRequestText": "su richiesta",
        "upToRequestsIncluded": "Fino a",
        "requestsIncluded": "richieste incluse",
        "subscribed": "Iscritto",
        "contactUs": "Contattaci",
        "enableOnlyWhatYouNeed": "Abilita solo ciò di cui hai bisogno. I prezzi si adeguano con il ciclo di fatturazione. Gli add-on basati sull'uso per eventuali eccedenze saranno detratti dal tuo portafoglio flotte.",
        "subscriptionSummary": "Riepilogo dell'abbonamento",
        "reviewAndUpdate": "Rivedi e aggiorna il tuo abbonamento.",
        "plan": "Piano",
        "ongoingTotal": "Totale in corso",
        "nextBillingCycle": "Prossimo Ciclo di Fatturazione",
        "cancelSubscription": "Annulla abbonamento",
        "areYouSureCancelSubscription": "Sei sicuro di voler annullare il tuo abbonamento? Continuerai ad avere accesso al servizio.",
        "until": "fino a",
        "resumeSubscription": "Riprendi Abbonamento",
        "no": "No",
        "yes": "Sì",
        "updateSubscription": "Aggiorna Abbonamento",
        "upgrade": "Upgrade",
        "from": "Da:",
        "totalDueToday": "Totale dovuto oggi",
        "howProrationWorks": "Come funziona la ripartizione",
        "prorationDescription": "Qualsiasi tempo non utilizzato dal tuo piano attuale o dagli add-on sarà accreditato sul nuovo piano. Gli add-on aggiunti a metà ciclo vengono addebitati solo per i giorni rimanenti nel periodo di fatturazione attuale.",
        "pleaseSelectPaymentMethod": "Si prega di selezionare un metodo di pagamento",
        "paymentConfirmedSuccessfully": "Pagamento confermato con successo",
        "failedToConfirmPayment": "Impossibile confermare il pagamento",
        "confirmPayment": "Confirm Payment",
        "failedToGetBillingPlan": "Impossibile ottenere il piano di fatturazione per codice paese",
        "failedToGetPreview": "Impossibile ottenere l'anteprima del piano tariffario",
        "failedToPreviewAddOns": "Impossibile visualizzare in anteprima i componenti aggiuntivi",
        "subscriptionCancelledSuccessfully": "Abbonamento annullato con successo",
        "failedToCancelSubscription": "Impossibile annullare l'abbonamento",
        "addOnChangedSuccessfully": "Add-on modificato con successo",
        "failedToChangedAddOn": "Impossibile modificare l'add-on",
        "failedToGetUsage": "Impossibile ottenere l'uso",
        "annual": "Annuale",
        "monthly": "Mensile",
        "currentPlanButton": "Piano attuale",
        "upgradeButton": "Upgrade",
        "save": "Salva",
        "expiresText": "Scade",
        "noExpiry": "Nessuna scadenza",
        "managePayment": "Gestisci Pagamento",
        "changePlan": "Change Plan",
        "addOns": "Componenti aggiuntivi",
        "viewUsage": "Visualizza utilizzo",
        "requestWithdrawal": "Richiedi prelievo",
        "withdraw": "Preleva",
        "withdrawalGsn": {
            "requestWithdrawal": "Richiedi prelievo",
            "reviewWithdrawal": "Rivedi prelievo",
            "payTo": "Paga a",
            "availableBalance": "Saldo disponibile ({currency})",
            "payoutBalance": "Saldo da incassare ({currency})",
            "payoutBalanceLabel": "Saldo da incassare",
            "amountOwedToPlatform": "Importo dovuto alla piattaforma",
            "availableToWithdraw": "Disponibile per il prelievo",
            "amountToWithdraw": "Importo da prelevare ({currency})",
            "minimumWithdrawal": "Prelievo minimo: {amount} {currency}",
            "minimumTransferAmount": "Importo minimo di trasferimento: {amount} {currency}",
            "noPayoutMethods": "Nessun metodo di pagamento",
            "review": "Rivedi",
            "payoutSpeed": "Velocità di pagamento",
            "normalPayout": "Pagamento standard",
            "instantPayout": "Pagamento istantaneo",
            "recommended": "Consigliato",
            "transferFeePercent": "Commissione di trasferimento {percent}%",
            "transferFee": "Commissione di trasferimento",
            "withdrawalAmount": "Importo del prelievo",
            "amountDeducted": "Importo detratto",
            "youWillReceive": "Riceverai",
            "totalToReceive": "Totale da ricevere",
            "confirmWithdrawal": "Conferma prelievo",
            "disclaimer": "I prelievi sono inviati in USD",
            "disclaimer1": "Le banche riceventi possono convertire i fondi nella valuta locale e applicare propri costi e tassi di cambio",
            "disclaimer2": "L'importo finale ricevuto può differire da quello inviato.",
            "requestSuccess": "Richiesta di prelievo inviata correttamente."
        },
        "addNewPaymentMethod": "Aggiungi nuovo metodo di pagamento",
        "warningCurrentBalance": "L'importo dovuto alla piattaforma supera il saldo da incassare attuale. Non puoi richiedere un prelievo in questo momento."
    },
    "signup": {
        "limitation": {
            "driver": "Driver",
            "vehicle": "Vehicle",
            "operator": "Operator",
            "drivers": "Drivers",
            "vehicles": "Vehicles",
            "operators": "Operators"
        },
        "language": "Lingua",
        "contactHeader": "Per eventuali problemi o domande, si prega di contattare",
        "stepAccountTitle": "Crea Account",
        "stepAccountDesc": "Per favore, fornisci il tuo nome utente e la tua password",
        "stepCompanyTitle": "Dettagli dell'azienda",
        "stepCompanyDesc": "Aggiungi il tuo logo, il tema dei colori e le informazioni sulla tua azienda.",
        "stepZoneTitle": "Zona Operativa",
        "stepZoneDesc": "Seleziona la tua città di operazione.",
        "stepPlanTitle": "Scegli un Piano",
        "stepPlanDesc": "Seleziona un piano di pagamento adatto a te.",
        "stepPlanCustom": "Il Tuo Piano Personalizzato",
        "stepPlanTitleCustom": "Rivedi Il Tuo Piano Personalizzato",
        "stepPlanDescCustom": "Un piano creato specificamente per la tua flotta.",
        "accountStepTitle": "Crea Account",
        "accountStepUsername": "Nome utente",
        "accountStepEmail": "Email",
        "accountStepChoosePassword": "Scegli Password",
        "accountStepConfirmPassword": "Conferma Password",
        "accountStepPasswordHint": "La password deve contenere almeno 8 caratteri, 1 lettera maiuscola e 1 carattere speciale.",
        "accountStepCreateAccount": "Crea Account",
        "accountStepAlreadyHaveAccount": "Hai già un account?",
        "accountStepCaptchaError": "Si prega di verificare il captcha",
        "accountStepGenericError": "Si è verificato un errore durante la creazione dell'account.",
        "accountStepSuccess": "Account creato con successo",
        "usernameRequired": "Il nome utente è obbligatorio",
        "usernameMinLength": "Il nome utente deve essere lungo almeno 3 caratteri",
        "usernameMaxLength": "Il nome utente deve essere inferiore a 20 caratteri",
        "usernamePattern": "Il nome utente deve iniziare con una lettera minuscola e può contenere solo lettere minuscole e numeri",
        "emailRequired": "È richiesta l'email",
        "emailInvalid": "L'email non è valida",
        "passwordRequired": "È richiesta una password",
        "passwordMinLength": "La password deve contenere almeno 8 caratteri",
        "passwordPattern": "La password deve contenere almeno 1 lettera maiuscola e 1 carattere speciale.",
        "confirmPasswordMismatch": "Le password non corrispondono",
        "companyStepTitle": "Dettagli dell'azienda",
        "companyStepAddLogo": "Aggiungi Logo",
        "companyStepColorTheme": "Tema Colore",
        "companyStepSelectThemeColor": "Seleziona il Colore del Tema",
        "companyStepFirstName": "Nome",
        "companyStepLastName": "Cognome",
        "companyStepPhone": "Telefono",
        "companyStepEmail": "Email",
        "companyStepCompanyName": "Nome dell'azienda",
        "companyStepFleetId": "ID Flotta",
        "companyStepCompanyAddress": "Indirizzo dell'azienda",
        "companyStepCompanyWebsite": "Sito Web dell'Azienda",
        "companyStepDriversNumber": "Quanti autisti ci sono nella tua flotta?",
        "companyStepVehiclesNumber": "Quanti veicoli ci sono nella tua flotta?",
        "companyStepContinue": "Continua",
        "companyStepGenericError": "Si è verificato un errore durante il salvataggio dell'azienda",
        "companyStepSuccess": "Azienda salvata con successo",
        "companyStepPhoneInvalid": "Per favore inserisci un numero di telefono valido",
        "companyNameRequired": "Il nome dell'azienda è obbligatorio",
        "fleetIdRequired": "FleetId è obbligatorio",
        "fleetIdPattern": "Deve avere da 4 a 30 caratteri, deve iniziare con una lettera minuscola e può contenere solo lettere minuscole e numeri",
        "zoneStepTitle": "Imposta Area di Operazione",
        "zoneStepDescription": "Questa è la tua zona operativa iniziale. Per future espansioni, sentiti libero di",
        "zoneStepSearchAddress": "Cerca un indirizzo",
        "zoneStepLatitude": "Latitudine",
        "zoneStepLongitude": "Longitudine",
        "zoneStepRadius": "Quanto lontano ti allontanerai dalla tua zona centrale?",
        "zoneStepRadiusDescription": "Distanza massima dal punto centrale.",
        "zoneStepContinue": "Continua",
        "zoneStepGenericError": "Si è verificato un errore durante il salvataggio della zona",
        "zoneStepSuccess": "Zone salvate con successo",
        "zoneStepInvalidCoordinates": "la latitudine e la longitudine non sono valide",
        "latitudeRequired": "La latitudine è obbligatoria",
        "latitudeDecimalPlaces": "La latitudine può avere al massimo 10 cifre decimali.",
        "latitudeRange": "La latitudine deve essere compresa tra -90 e 90 gradi.",
        "longitudeRequired": "La longitudine è richiesta",
        "longitudeDecimalPlaces": "La longitudine può avere al massimo 10 decimali.",
        "longitudeRange": "La longitudine deve essere compresa tra -180 e 180 gradi",
        "radiusRequired": "Il raggio è obbligatorio",
        "radiusMinError": "Il raggio deve essere di almeno {0} km.",
        "radiusMaxError": "Il raggio non può superare i {0} km",
        "contactUs": "contattaci",
        "planTitle": "Scegli Piano",
        "planDescription": "Scegli un piano che si adatta alle tue esigenze. Aggiorna o annulla in qualsiasi momento. Nessun costo nascosto, mai.",
        "planDescriptionCustom": "Un piano creato specificamente per la tua flotta.",
        "billingMonthly": "Mensile",
        "billingAnnual": "Annuale",
        "saveBadge": "Risparmia il 20%",
        "popularBadge": "PIÙ POPOLARE",
        "customPricing": "Personalizzato",
        "periodAnnual": "Annuale",
        "periodMonthly": "Mensile",
        "bonusCredits": "Bonus {0} Crediti Una Tantum",
        "savePercentage": "Risparmia {0}%",
        "oneTimeSetupFee": "Tariffa di Configurazione Una Tantum",
        "waived": "Waived*",
        "planFeatures": {
            "feePerBooking39": "3,9% per prenotazione",
            "feePerBooking29": "2,9% per prenotazione",
            "feePerBooking": "{0} per prenotazione aggiuntiva",
            "freeBookingPerMonth": "{0} prenotazioni GRATUITE al mese",
            "unlimitedUsers": "Utenti Illimitati",
            "commandCenterAdminDashboard": "Pannello di controllo dell'amministratore del centro comandi",
            "nativeDriverApp": "App del Driver Nativo",
            "webDriverApp": "App Web Driver",
            "customerBookingLink": "Link di Prenotazione Cliente",
            "plusEverythingInStartup": "Inoltre tutto in Startup",
            "corporateManagement": "Gestione Aziendale",
            "invoicingManagement": "Gestione della Fatturazione",
            "driverPayoutManagement": "Gestione dei Pagamenti per i Conducenti",
            "promotionManagement": "Gestione delle promozioni",
            "plusEverythingInPro": "Inoltre tutto in Pro",
            "tierDiscountPricing": "Prezzi con Sconto a Livelli",
            "customFeatureDevelopment": "Sviluppo di Funzionalità Personalizzate",
            "unlimitedOperators": "Operatori Illimitati",
            "unlimitedDrivers": "Autisti Illimitati",
            "unlimitedVehicles": "Veicoli Illimitati"
        },
        "planDescriptions": {
            "enterprise": "Enterprise include fatturazione personalizzata, onboarding dedicato, Prezzi Scontati a Livelli e Sviluppo Funzionalità Personalizzate per adattarsi perfettamente al tuo flusso di lavoro specifico."
        },
        "limitedNotes": "(*) Promozione esclusiva a tempo limitato",
        "unlimitedText": "Illimitato",
        "volumeDiscount": "Sconto per volume",
        "letsTalkButton": "Parliamo!",
        "buildingStepTitle": "Costruendo la tua flotta...",
        "congratulationsTitle": "Congratulazioni! Il tuo account è pronto",
        "congratulationsDescription": "Accedi al tuo pannello di amministrazione qui.",
        "congratulationsViewDashboard": "Visualizza Dashboard",
        "congratulationsContact": "Domande? Contattaci a",
        "fleetIdDescription": "Scegli un codice breve e semplice per la tua flotta — facile da condividere e ricordare.",
        "fleetIdPlaceholder": "ad es.goodjourney",
        "firstNameRequired": "Il nome è obbligatorio",
        "logIn": "Accedi",
        "instead": "invece.",
        "submittingData": "Inviando dati...",
        "upload": "Carica",
        "phoneNumberPlaceholder": "+1 Numero di telefono",
        "km": "KM",
        "selectPlan": "Seleziona Piano",
        "upgrade": "Upgrade",
        "goodJourney": "Buon Viaggio",
        "loading": "Caricamento...",
        "lastNameRequired": "Il cognome è obbligatorio",
        "agreeToTerms": "Continuando, riconosci di aver letto e accetti",
        "termsOfService": "Termini di Servizio",
        "privacyPolicy": "Informativa sulla privacy",
        "and": "e",
        "refresh": "Aggiorna",
        "takingTooLong": "Sta impiegando troppo tempo?"
    },
    "addonTemplate": {
        "Addon_Template": "Add-On Template",
        "Add_On_Template": "Add-On Template",
        "Create_addon_template_success": "Add-on template has been created successfully",
        "Create_addon_template_fail": "The errors occurred while creating add-on template",
        "Update_addon_template_success": "Add-on template has been updated successfully",
        "Update_addon_template_fail": "The errors occurred while updating add-on template",
        "Update_template_success": "Template has been updated successfully",
        "Update_template_fail": "The errors occurred while updating template",
        "Edit_Template": "Edit Template",
        "New_Template": "New Template",
        "Enter_Add_On_Template_Name": "Enter Add-On Template Name*",
        "Confirm_Delete": "Confirm Delete",
        "Confirm_Delete_Message": "Are you sure you want to delete this template? Deleting this template will unlink from all the partners/corp it links to",
        "Delete_success": "Template has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting template",
        "Set_Default": "Set as Default",
        "Confirm_Set_Default_Message": "Are you sure you want to set this Add-On as default?",
        "Set_Default_Success": "Add-on template has been set as default successfully",
        "Set_Default_Fail": "The errors occurred while setting add-on template as default",
        "Clone_addon_template": "Clone Add-On Template"
    },
    "addonService": {
        "Additional_Service": "Additional Service",
        "Service_Name": "Service Name",
        "Description": "Description",
        "desPlaceholder": "Brief description of the service",
        "namePlaceholder": "e.g. Meet & Greet, Local-E Sim, GST Tax",
        "Who_pays_for_this_add_on": "Who pays for this add-on?",
        "customer": "Customer",
        "driver": "Driver",
        "fleet": "Fleet",
        "Required": "Required",
        "Apply_Tax": "Apply Tax",
        "Itemize": "Itemize",
        "Attribute": "Attribute",
        "Fee_Type": "Fee Type",
        "feeType.amount": "Amount",
        "feeType.percentageSubtotal": "Percentage of Subtotal",
        "feeType.percentageTotal": "Percentage of Total",
        "feeType.custom": "Custom (Driver Input)",
        "Unit_Settings": "Unit Settings",
        "unit.none": "None",
        "unit.perDay": "per day",
        "unit.eachTime": "each time",
        "unit.perPerson": "per person",
        "Maximum_Quantity": "Maximum Quantity",
        "Maximum_Quantity_Value": "Maximum Quantity Value",
        "How_much_will_the_fleet_make": "How much will the fleet make for this add-on?",
        "Fleet_Commission": "Fleet Commission",
        "Percentage": "Percentage",
        "Amount": "Amount",
        "Currency": "Currency",
        "Unlimited": "Unlimited",
        "Limited": "Limited",
        "Vehicle_Type": "Vehicle Type",
        "Service_Type": "Service Type",
        "Meeting_Zone": "Meeting Zone",
        "Trip_Context": "Trip Context",
        "Trip_Context_Value": {
            "departure": "Departure",
            "arrival": "Arrival"
        },
        "Operation_Zone": "Operation Zone",
        "Restricted_Zone": "Restricted Zone",
        "User_Type": "User Type",
        "Price_Unit": "Price Unit",
        "Info": "Info",
        "Rules": "Rules",
        "Basic_Information": "Basic Information",
        "Delete": "Delete",
        "Delete_addon_service": "Are you sure you want to delete this add-on service?",
        "Delete_success": "Add-on service has been deleted successfully",
        "Delete_fail": "The errors occurred while deleting add-on service",
        "Create_addon_service_success": "Add-on service has been created successfully",
        "Create_addon_service_fail": "The errors occurred while creating add-on service",
        "Update_addon_service_success": "Add-on service has been updated successfully",
        "Update_addon_service_fail": "The errors occurred while updating add-on service",
        "Please_save_template_first": "Please save the template first before adding services",
        "Attribute_Tooltip": "Travel Attribute: Used to map this add-on to its corresponding standardized service key across connected OTAs (e.g., CHILD_SEAT, MEET_GREET).",
        "feeType": {
            "amount": "Amount",
            "percentageSubtotal": "Percentage of Subtotal",
            "percentageTotal": "Percentage of Total",
            "custom": "Custom (Driver Input)"
        },
        "unit": {
            "none": "None",
            "perDay": "Per day (Charge per day)",
            "eachTime": "Each time (Charge per ride)",
            "perPerson": "Per person (Charge per person)",
            "each": "Each (Charge per quantity)"
        },
        "none": "None",
        "perDay": "Per day",
        "eachTime": "Each time",
        "perPerson": "Per person",
        "each": "Each",
        "Unit_Settings_Title": "Unit Settings",
        "Itemize_Tooltip": "Itemize: This will list the add-on as a separate line item in the fare breakdown. If this is disabled, it will be under additional services.",
        "Booking_Channel": "Booking Channel",
        "pointToPoint": "Point To Point",
        "fromAirport": "From Airport",
        "toAirport": "To Airport",
        "hourly": "Hourly",
        "roundTrip": "Round Trip",
        "ADD_ON_BOOKING_CHANNEL_VALUE": {
            "PWA": "Web App",
            "passenger": "Customer App",
            "API": "API",
            "CC": "Command Center",
            "partner": "Partner App",
            "CarHailing": "Street Hailing",
            "streetSharing": "Street Sharing"
        },
        "Select_Attribute": "Select Attribute",
        "allowNoteInput": "Driver Input: Notes or Receipts",
        "allowNoteInputTooltip": "Allows drivers to submit notes and upload supporting photos or receipts for this service at the end of the trip (e.g. parking fees, tolls, additional charges).",
        "isDriverCapability": "Driver Capability",
        "Driver_Capability_Tooltip": "Exposes this service as a selectable capability in the driver profile. Used for driver profiling and booking-to-driver matching.",
        "isVehicleAttribute": "Vehicle Attribute",
        "Vehicle_Attribute_Tooltip": "Exposes this service as a selectable attribute in the vehicle profile. Used for vehicle profiling and booking matching.",
        "linkAtr": "Link attributes to a specific driver.",
        "addOnServicePolicy": "Add-On Policy",
        "selectAddonTemplate": "Select Add-on Template"
    }
};
